import { OwnUpGridContainer, OwnUpGridWrapper, IconLink, CHARCOAL_90, OwnUpHeadlineBook, OwnUpNavLink, OwnUpThemeProvider, ownUpDarkTheme, OwnUpGridItem, OwnUpDetail, OwnUpGridOffset, OwnUpIcon as OwnUpIcon$1, OwnUpSmallSubheadlineMedium, OwnUpFillButtonSecondary, OwnUpLogoWithTextLink, OwnUpNavButtonLarge, OwnUpNavButtonMedium, OwnUpNavButtonSmall, OwnUpFillButtonPrimary, OwnUpNavMenuModal, OwnUpNavBar, OwnUpIconButton, OwnUpOverline, MANGO_40, PINE_100, WHITE_100, CHARCOAL_100, ALOE_100, SAGE_100, OwnUpFillAccordion, MINT_100, OwnUpBody, OwnUpTooltip, OwnUpUnderlineTooltipTrigger, OwnUpFloatingModal, FOG_20, OwnUpSmallBody, OwnUpSmallBodyMedium, OwnUpNumberInput, OwnUpTextInput, OwnUpMenuItem, OwnUpDropdown, FOG_100, Z_INDICES, CACTUS_100, MANGO_100, BERRY_100, OwnUpLargeBodyMedium, CHARCOAL_5, OwnUpBodyMedium, OwnUpDefaultErrorNotification, MOSS_50, APRICOT_10, BERRY_10, ownUpWhiteTheme, OwnUpExtraSmallHeadlineMedium, MOSS_100, SLATE_100 } from '@rategravity/own-up-component-library';
import { ArrowLeftIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/arrow-left';
import * as React from 'react';
import React__default, { useState, useEffect, Fragment as Fragment$3, useRef, useCallback, useReducer, createContext, useContext, createElement, useMemo, useLayoutEffect } from 'react';
import styled, { css as css$1 } from 'styled-components';
import { ArrowRightIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/arrow-right';
import { ScreenSize, colors as colors$1, createOwnUpStyle, fonts, createOwnUpComponent, OwnUpBox, OwnUpIcon, OwnUpHeader, OwnUpText, zIndex as zIndex$1, OwnUpStyledIcon } from '@rategravity/own-up-component-library-legacy';
import { Link as Link$1 } from 'gatsby';
import * as t$2 from 'type-shift';
import { OwnUpLogoNoBackdropWithText, CancelX, OwnUpLogo, OwnUpLogoNoBackdrop, OwnUpWordmark } from '@rategravity/own-up-component-library-legacy/components/images/icons/svgs';
import { shallowEqual } from 'reakit-utils/shallowEqual';
import { flatten as flatten$1 } from 'reakit-utils/flatten';
import { isObject as isObject$1 } from 'reakit-utils/isObject';
import { useIsomorphicEffect } from 'reakit-utils/useIsomorphicEffect';
import { isUA } from 'reakit-utils/dom';
import { useSealedState } from 'reakit-utils/useSealedState';
import { getDocument } from 'reakit-utils/getDocument';
import { applyState } from 'reakit-utils/applyState';
import { removeItemFromArray } from 'reakit-utils/removeItemFromArray';
import { createComponent } from 'reakit-system/createComponent';
import { createHook } from 'reakit-system/createHook';
import { useForkRef } from 'reakit-utils/useForkRef';
import { isButton } from 'reakit-utils/isButton';
import { useLiveRef } from 'reakit-utils/useLiveRef';
import { isSelfTarget } from 'reakit-utils/isSelfTarget';
import { hasFocusWithin } from 'reakit-utils/hasFocusWithin';
import { isPortalEvent } from 'reakit-utils/isPortalEvent';
import { isFocusable, getFirstTabbableIn, getLastTabbableIn, isTabbable } from 'reakit-utils/tabbable';
import { useUpdateEffect } from 'reakit-utils/useUpdateEffect';
import { useCreateElement } from 'reakit-system/useCreateElement';
import { fireBlurEvent } from 'reakit-utils/fireBlurEvent';
import { fireKeyboardEvent } from 'reakit-utils/fireKeyboardEvent';
import { canUseDOM } from 'reakit-utils/canUseDOM';
import { getNextActiveElementOnBlur } from 'reakit-utils/getNextActiveElementOnBlur';
import { ensureFocus } from 'reakit-utils/ensureFocus';
import { createPortal } from 'react-dom';
import { closest } from 'reakit-utils/closest';
import { getActiveElement } from 'reakit-utils/getActiveElement';
import { contains as contains$1 } from 'reakit-utils/contains';
import { isEmpty } from 'reakit-utils/isEmpty';
import { MenuIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/menu';
import assign from 'object-assign';
import { useTrackingInstance } from '@rategravity/1pt-lib';
import { SplitContext, SplitFactory, SplitTreatments } from '@splitsoftware/splitio-react';
import crypto from 'crypto';
import util from 'util';
import { createPAndICostModel, computeMaxPresentValue, computeCostModels } from '@ownup/fin-lib';
import { ChevronDownIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/chevron-down';
import { ChevronUpIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/chevron-up';
import { DollarIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/dollar';
import { PercentIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/standard-icons/percent';
import { MicroQuestionIcon } from '@rategravity/own-up-component-library/icon-library/system-icons/micro-icons/question';
import SliderComponent from 'rc-slider';
import { ErrorDarkIcon } from '@rategravity/own-up-component-library/icon-library/notification-icons/error-dark';
import { SuccessDarkIcon } from '@rategravity/own-up-component-library/icon-library/notification-icons/success-dark';
import { WarningDarkIcon } from '@rategravity/own-up-component-library/icon-library/notification-icons/warning-dark';
import { PieChart, Pie, Cell, Sector, ResponsiveContainer, LineChart, XAxis, YAxis, Tooltip, Line } from 'recharts';

function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

var _templateObject$T, _templateObject2$w, _templateObject3$o, _templateObject4$9, _templateObject5$6;
const BreadCrumbsContainer = styled(OwnUpGridContainer)(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  width: 100%;\n  background-color: ", ";\n  padding: ", ";\n"])), props => props.backgroundColor ? props.backgroundColor : 'transparent', props => props.padding ? props.padding : '0px');
const BreadcrumbsNav = styled.nav(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n  li:not(:first-child)::before {\n    content: '/';\n    margin: 0 0.5rem;\n    color: #00769b;\n    align-items: end;\n  }\n\n  a {\n    text-decoration: none;\n    transition: color 0.2s;\n  }\n"])));
const BreadcrumbsList = styled.ul(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n"])));
const BreadcrumbItem = styled.li(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: end;\n"])));
const Link = styled.a(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.underlineLinkColors.linkFontColor;
});

const homeUrl = 'https://www.ownup.com/';
const BreadCrumbs = _ref => {
  let {
    breadCrumbs,
    backgroundColor = 'transparent',
    padding = '0px'
  } = _ref;
  return /*#__PURE__*/React__default.createElement(BreadCrumbsContainer, {
    variant: "slim",
    backgroundColor: backgroundColor,
    padding: padding
  }, /*#__PURE__*/React__default.createElement(OwnUpGridWrapper, null, /*#__PURE__*/React__default.createElement(BreadcrumbsNav, null, /*#__PURE__*/React__default.createElement(BreadcrumbsList, null, /*#__PURE__*/React__default.createElement(BreadcrumbItem, {
    key: 0
  }, /*#__PURE__*/React__default.createElement(IconLink, {
    link: homeUrl,
    component: Link,
    to: homeUrl,
    iconPlacement: "left",
    icon: /*#__PURE__*/React__default.createElement(ArrowLeftIcon, null)
  }, "Home")), breadCrumbs === null || breadCrumbs === void 0 ? void 0 : breadCrumbs.map((crumb, index) => crumb !== null && crumb !== void 0 && crumb.title ? /*#__PURE__*/React__default.createElement(BreadcrumbItem, {
    key: index
  }, index < breadCrumbs.length - 1 ? /*#__PURE__*/React__default.createElement(IconLink, {
    link: crumb.path,
    component: Link,
    to: crumb.path,
    iconPlacement: "left",
    icon: /*#__PURE__*/React__default.createElement(React__default.Fragment, null)
  }, crumb.title) : /*#__PURE__*/React__default.createElement("span", null, crumb.title)) : null)))));
};

const FHEOLogo = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.9563 14.0656V10.0623C30.9134 10.008 30.8645 9.95869 30.8105 9.91528C30.3711 9.61757 29.9303 9.32169 29.4896 9.02587L29.4894 9.02573C29.2444 8.8613 28.9995 8.69689 28.7548 8.5322L25.8198 6.55652L24.3032 5.53607L21.2909 3.50843L18.389 1.55486L16.8425 0.511192C16.6338 0.370783 16.425 0.229268 16.2184 0.0855426C16.1502 0.0320166 16.066 0.00292969 15.9793 0.00292969C15.8926 0.00292969 15.8084 0.0320166 15.7401 0.0855426C14.757 0.741522 13.7739 1.40119 12.7908 2.06454C12.1118 2.5193 11.4332 2.97443 10.7549 3.42993L8.60977 4.86719L6.48336 6.2956L4.33818 7.73286L2.21509 9.15906C1.81006 9.43325 1.40503 9.7078 1 9.98272V14.0159H2.96513V15.5128V16.9855V25.8821C2.98118 25.8864 2.99707 25.8908 3.01278 25.8953C3.0544 25.9071 3.09485 25.9185 3.13414 25.9241C3.18268 25.9274 3.2314 25.9274 3.27995 25.9241C6.36701 25.9197 9.4548 25.9197 12.5433 25.9241C17.9582 25.9322 23.3731 25.9407 28.788 25.9496H28.9603C28.9792 25.9452 28.9976 25.9393 29.0155 25.9319C29.0167 25.913 29.0186 25.8932 29.0205 25.8729L29.0205 25.8729C29.024 25.8362 29.0277 25.7978 29.0277 25.7594V23.0806V14.2602C29.0277 14.2289 29.0297 14.1975 29.0318 14.165C29.0341 14.1298 29.0365 14.0931 29.0365 14.0535C29.0581 14.0518 29.0782 14.0498 29.0973 14.0478C29.13 14.0444 29.1597 14.0413 29.1889 14.0413H30.7873C30.8442 14.0451 30.9007 14.0532 30.9563 14.0656ZM15.9373 5.21608L15.9588 5.20329L25.7745 11.7782V21.8611H6.23813C6.23686 21.8406 6.23539 21.8207 6.23396 21.8012C6.23044 21.7533 6.22709 21.7077 6.22709 21.6621V12.2646C6.22709 12.2219 6.22795 12.1791 6.22881 12.1363C6.23053 12.0509 6.23224 11.9657 6.22709 11.881C6.22271 11.835 6.23202 11.7887 6.25383 11.748C6.27565 11.7073 6.309 11.674 6.3497 11.6522C7.24592 11.0537 8.1414 10.4537 9.03615 9.85226L11.0245 8.51561L12.9023 7.25193L14.9702 5.86221L15.8042 5.29726C15.8433 5.2718 15.8833 5.24807 15.9373 5.21608ZM15.6197 31.9429H16.0063L16.024 31.913C15.9599 31.8159 15.9 31.7159 15.84 31.6158C15.6548 31.3069 15.4694 30.9975 15.1624 30.7721C15.4717 30.7069 15.7412 30.5974 15.8252 30.279C15.8755 30.1264 15.874 29.9615 15.8209 29.8099C15.7677 29.6583 15.6659 29.5286 15.5314 29.441C15.2579 29.3528 14.9712 29.3127 14.6841 29.3227C14.5524 29.3251 14.4204 29.3247 14.2891 29.3243H14.2889C14.1274 29.3238 13.967 29.3233 13.8092 29.3282C13.7595 29.4951 13.7684 31.8423 13.8092 31.9396H14.1263V30.7975C14.325 30.7739 14.5261 30.7776 14.7239 30.8086C14.7753 30.8216 14.823 30.8466 14.8631 30.8815C15.0159 31.0161 15.1471 31.1735 15.2519 31.3481C15.3321 31.4847 15.4165 31.6187 15.5007 31.7526L15.5007 31.7527L15.5007 31.7527L15.5007 31.7527L15.5007 31.7527L15.5007 31.7527L15.5008 31.7527L15.5008 31.7528L15.5008 31.7528L15.5008 31.7528L15.5008 31.7528L15.5008 31.7528L15.5008 31.7528L15.5008 31.7529L15.5008 31.7529L15.5008 31.7529L15.5008 31.7529L15.5008 31.7529L15.5009 31.7529L15.5009 31.753L15.5009 31.753L15.5009 31.753L15.5009 31.753L15.5009 31.753L15.5009 31.7531L15.5011 31.7533C15.5408 31.8165 15.5805 31.8796 15.6197 31.9429ZM15.1392 30.4692C14.8049 30.5012 14.4683 30.5012 14.134 30.4692L14.1329 29.6422C14.1755 29.6336 14.2187 29.6281 14.2621 29.6256L14.2994 29.6247C14.5157 29.6194 14.733 29.6141 14.9492 29.6256C15.0582 29.6332 15.1648 29.6605 15.264 29.7063C15.3417 29.7342 15.4071 29.7886 15.4487 29.86C15.4904 29.9314 15.5055 30.0151 15.4916 30.0966C15.4817 30.1887 15.4418 30.2751 15.3782 30.3424C15.3145 30.4097 15.2306 30.4542 15.1392 30.4692ZM23.2704 31.9451H22.939L22.2762 30.9501L22.2224 30.8692C22.0192 30.5637 21.8136 30.2547 21.5792 29.9551V31.9451H21.2688V29.3393H21.6002L22.9478 31.3293L22.9765 31.3238V29.3337H23.2648C23.3046 29.4332 23.3145 31.776 23.2704 31.9451ZM4.22554 31.9816L4.22557 31.9816L4.22559 31.9816L4.22561 31.9816L4.22564 31.9816L4.22566 31.9816L4.22568 31.9816H4.2257C4.26886 31.9875 4.31196 31.9935 4.35474 32.0004C4.40548 31.9929 4.45602 31.9897 4.50612 31.9866H4.50614H4.50615C4.61965 31.9794 4.73095 31.9723 4.83746 31.9163L4.86551 31.9019C5.07727 31.7931 5.28892 31.6843 5.40635 31.462C5.7046 30.8915 5.72227 30.332 5.35443 29.7859C5.2745 29.6641 5.17003 29.5604 5.04772 29.4814C4.92541 29.4024 4.78795 29.3498 4.64416 29.3271C4.41509 29.2839 4.17898 29.2968 3.95597 29.3647C3.77969 29.4164 3.61908 29.5114 3.4887 29.6409C3.35831 29.7704 3.26226 29.9305 3.20925 30.1065C3.12645 30.3246 3.09543 30.559 3.11863 30.7911C3.14182 31.0233 3.2186 31.2469 3.34291 31.4443C3.40454 31.5621 3.48951 31.666 3.59264 31.7499C3.69577 31.8337 3.81488 31.8956 3.94272 31.9318C4.03534 31.9554 4.13057 31.9685 4.22554 31.9816ZM3.54947 31.1093C3.51148 30.956 3.48526 30.8 3.47104 30.6427H3.47325C3.46367 30.423 3.51489 30.2049 3.62127 30.0125C3.93278 29.5438 4.49503 29.4376 4.95787 29.829C5.05318 29.9153 5.12944 30.0205 5.18175 30.138C5.23406 30.2554 5.26127 30.3825 5.26164 30.5112C5.28086 30.7365 5.24875 30.9633 5.16775 31.1745C5.11995 31.2879 5.04881 31.39 4.95897 31.4741C4.727 31.7063 4.43649 31.7306 4.14707 31.6709C4.00555 31.6412 3.87492 31.5731 3.76951 31.474C3.6641 31.375 3.58797 31.2488 3.54947 31.1093ZM12.0672 31.9761C11.823 32.0114 11.5746 31.9512 11.3735 31.808C11.1737 31.6818 11.0236 31.4904 10.9483 31.2663C10.879 31.0942 10.8358 30.9127 10.8201 30.7279C10.808 30.2182 10.9471 29.7583 11.4089 29.4741C11.6372 29.3346 11.9051 29.2744 12.1711 29.3028C12.3521 29.3167 12.5279 29.3702 12.6861 29.4594C12.8443 29.5485 12.9811 29.6713 13.0868 29.8191C13.1929 29.983 13.2616 30.1684 13.2879 30.3619C13.3679 30.7464 13.2971 31.147 13.0901 31.4808C12.9288 31.7549 12.6648 31.8854 12.3776 31.9705C12.275 31.9878 12.1704 31.9896 12.0672 31.9761ZM11.1835 30.6228V30.8141C11.1913 31.2431 11.558 31.7505 12.0672 31.6908C12.0937 31.6886 12.1203 31.6886 12.1468 31.6908C12.4616 31.7052 12.6648 31.5272 12.8195 31.2818C12.9741 31.0363 12.9775 30.7677 12.9576 30.499C12.9211 30.0247 12.6671 29.7074 12.1788 29.6145C11.9968 29.5883 11.8113 29.6223 11.6504 29.7113C11.4895 29.8003 11.362 29.9395 11.2874 30.1076C11.2123 30.2671 11.1766 30.4423 11.1835 30.6184V30.6228ZM8.84616 31.9396V30.9047C8.87719 30.9024 8.90356 30.9001 8.92715 30.898L8.92725 30.898L8.92736 30.898L8.9278 30.898C8.96017 30.8951 8.9873 30.8928 9.01406 30.8915H9.56638C9.76021 30.8855 9.95124 30.8435 10.1297 30.7677C10.1839 30.7475 10.2313 30.7127 10.2667 30.667C10.413 30.5044 10.492 30.2922 10.4876 30.0734C10.4889 29.9604 10.4633 29.8488 10.4129 29.7477C10.3626 29.6466 10.289 29.5589 10.1982 29.4918C10.0135 29.377 9.7992 29.319 9.58184 29.3249C9.37642 29.3182 9.17051 29.3204 8.96444 29.3227C8.86134 29.3238 8.7582 29.3249 8.65506 29.3249C8.61027 29.3272 8.56565 29.332 8.5214 29.3392C8.47942 29.5183 8.49157 31.8478 8.53245 31.9396H8.84616ZM8.87819 30.5543C8.83885 30.2576 8.83588 29.9572 8.86936 29.6599C8.90467 29.6528 8.94051 29.6488 8.97651 29.6477C9.24461 29.6453 9.51265 29.6567 9.77957 29.682C9.85257 29.6949 9.92115 29.726 9.979 29.7724C10.0368 29.8188 10.0821 29.879 10.1106 29.9475C10.1391 30.016 10.1499 30.0905 10.1421 30.1643C10.1342 30.2381 10.1079 30.3087 10.0657 30.3696C10.0296 30.4261 9.98086 30.4732 9.92332 30.5074C9.86577 30.5416 9.80103 30.5618 9.73428 30.5664C9.55537 30.5738 9.37204 30.5714 9.18855 30.5689L9.18825 30.5689C9.09654 30.5677 9.0048 30.5664 8.91354 30.5664C8.90112 30.5646 8.88915 30.5604 8.87819 30.5543ZM6.41487 31.9429H6.07465V29.3415C6.12023 29.3323 6.16635 29.326 6.21272 29.3227C6.3157 29.3227 6.41869 29.3217 6.52163 29.3207L6.5221 29.3207H6.52222C6.72826 29.3187 6.93413 29.3168 7.1395 29.3227C7.3781 29.3315 7.61781 29.358 7.80228 29.5316C7.87406 29.5896 7.93281 29.6622 7.97469 29.7445C8.01656 29.8268 8.04062 29.917 8.0453 30.0092C8.06424 30.2136 8.00937 30.4179 7.89065 30.5852C7.82276 30.688 7.72119 30.7638 7.60345 30.7997C7.40173 30.8636 7.19087 30.8939 6.97933 30.8893H6.55626C6.51318 30.8893 6.4701 30.8893 6.40493 30.8981L6.41487 31.9429ZM6.41487 30.5487C6.43577 30.5578 6.45763 30.5645 6.48004 30.5686C6.56985 30.5686 6.65966 30.5701 6.74943 30.5716L6.74965 30.5716H6.74969H6.74973H6.74976H6.7498H6.74983H6.74987H6.7499H6.74994H6.74998H6.75001H6.75005H6.75008H6.75012H6.75015H6.75019H6.75023H6.75026H6.7503H6.75033C6.92967 30.5745 7.10884 30.5775 7.28752 30.5686C7.35984 30.5655 7.43035 30.5451 7.49319 30.5091C7.55602 30.4732 7.60936 30.4227 7.64874 30.3619C7.81001 30.1109 7.6642 29.7196 7.37148 29.6831C7.06505 29.6584 6.75752 29.6502 6.45022 29.6588C6.44485 29.6588 6.44002 29.663 6.43203 29.67C6.4285 29.6732 6.42436 29.6768 6.41929 29.6809L6.41487 30.5487ZM18.9612 29.3359H18.6353L18.6343 29.3586C18.6314 29.4202 18.6292 29.4677 18.6331 29.5161C18.6331 29.665 18.6324 29.8144 18.6317 29.9638C18.6302 30.2625 18.6287 30.5613 18.6331 30.8561C18.6311 31.0281 18.6504 31.1996 18.6906 31.3669C18.7745 31.6731 18.9491 31.9141 19.2926 31.9595C19.4023 31.9749 19.5138 31.9765 19.6254 31.9782C19.6902 31.9792 19.755 31.9801 19.8195 31.9838C20.0061 31.9837 20.1878 31.9245 20.3387 31.8146C20.4559 31.7474 20.5434 31.6385 20.5839 31.5095C20.6331 31.3403 20.6624 31.1659 20.6712 30.9899C20.6771 30.6539 20.6751 30.3218 20.6731 29.9897V29.9894C20.6722 29.8234 20.6712 29.6573 20.6712 29.4907C20.6712 29.4549 20.6672 29.4185 20.6629 29.3784L20.659 29.3415H20.3332C20.3319 29.3688 20.3304 29.3935 20.3289 29.4166L20.3289 29.4167C20.3265 29.4553 20.3243 29.4897 20.3243 29.525V31.0496C20.3221 31.2773 20.2658 31.4918 20.0349 31.6024C19.953 31.6449 19.863 31.6694 19.7709 31.6742C19.6139 31.6858 19.456 31.6674 19.3059 31.6201C19.2011 31.5746 19.113 31.4978 19.0537 31.4002C18.9943 31.3026 18.9666 31.189 18.9745 31.075V29.5106C18.9745 29.4711 18.9705 29.4317 18.9663 29.389L18.9663 29.3889C18.9645 29.3718 18.9628 29.3542 18.9612 29.3359ZM7.10858 28.5952L7.48747 28.7953L7.39247 28.9965C7.27858 28.9442 7.16792 28.8851 7.06108 28.8196C7.02004 28.7874 6.97093 28.767 6.91912 28.7608C6.8673 28.7545 6.81477 28.7626 6.76725 28.7842C6.59238 28.8552 6.40209 28.8794 6.21503 28.8546C6.02797 28.8298 5.85056 28.7568 5.70019 28.6427C5.60471 28.5705 5.52443 28.48 5.46396 28.3766C5.40349 28.2732 5.36402 28.1589 5.34781 28.0402C5.30968 27.8367 5.30968 27.6279 5.34781 27.4244C5.38424 27.2159 5.47751 27.0215 5.61734 26.8627C5.71038 26.7624 5.82297 26.6822 5.94817 26.627C6.07336 26.5719 6.20851 26.543 6.34529 26.5421C6.56521 26.5323 6.78255 26.5928 6.96584 26.7149C7.14913 26.8369 7.28888 27.0141 7.36486 27.2209C7.45456 27.4711 7.47405 27.741 7.42119 28.0015C7.3792 28.2264 7.27023 28.4334 7.10858 28.5952ZM6.87551 28.4139C6.97241 28.3283 7.0426 28.2166 7.07765 28.0921C7.11973 27.934 7.13246 27.7695 7.11521 27.6068C7.09864 27.1469 6.87109 26.8804 6.4668 26.8185C6.34721 26.7927 6.22282 26.8005 6.1074 26.8411C5.99198 26.8817 5.89004 26.9535 5.81286 27.0485C5.59966 27.3204 5.57094 27.6389 5.6317 27.9672C5.6502 28.0668 5.68294 28.1633 5.72891 28.2536C5.85594 28.499 6.08681 28.5852 6.34087 28.6051C6.51173 28.6215 6.53141 28.6056 6.62386 28.5311L6.62807 28.5277L6.38064 28.4238L6.45686 28.2502C6.58834 28.2319 6.68074 28.2924 6.77053 28.3512C6.80521 28.3739 6.8395 28.3963 6.87551 28.4139ZM26.1634 26.5786V28.2967L26.1258 28.3133C25.7451 27.7339 25.3669 27.1572 24.9914 26.583H24.6942C24.6522 26.7323 24.6589 28.7124 24.7008 28.8152H24.9604V27.1181L24.9914 27.1115L26.1137 28.8097H26.4252C26.4671 28.6582 26.4594 26.6792 26.4185 26.5786H26.1634ZM28.6366 28.3663V27.9528L27.9948 27.9429V27.6853C28.2849 27.6739 28.5701 27.679 28.8649 27.6842H28.8649H28.8649H28.8649H28.8649H28.8649H28.865H28.865H28.865H28.865H28.865H28.865H28.8651H28.8651H28.8651H28.8651L28.9271 27.6853V28.5134C28.7772 28.6433 28.603 28.7421 28.4146 28.8041C28.2138 28.8598 28.0039 28.8753 27.7971 28.8495C27.6257 28.839 27.4604 28.782 27.3189 28.6846C27.1775 28.5872 27.0651 28.4531 26.994 28.2967C26.9053 28.1129 26.8599 27.9112 26.8613 27.7071C26.8626 27.503 26.9107 27.3019 27.0018 27.1192C27.0614 26.9833 27.1527 26.8635 27.268 26.7701C27.3833 26.6766 27.5193 26.6121 27.6646 26.5819C27.8274 26.5395 27.9976 26.5331 28.1632 26.5633C28.3288 26.5934 28.4859 26.6594 28.6234 26.7566C28.6975 26.8091 28.7588 26.8778 28.8026 26.9575C28.8464 27.0371 28.8716 27.1257 28.8763 27.2165L28.6311 27.2795C28.6131 27.256 28.5979 27.2304 28.5858 27.2033C28.5228 26.9667 28.3461 26.8639 28.1263 26.8185C27.9541 26.7799 27.7738 26.8013 27.6155 26.8794C27.4571 26.9574 27.3302 27.0873 27.2558 27.2475C27.1934 27.3849 27.1594 27.5335 27.156 27.6844C27.1526 27.8353 27.1798 27.9853 27.236 28.1253C27.3652 28.4437 27.6027 28.5797 27.9385 28.5841C28.0635 28.5962 28.1896 28.5832 28.3095 28.5458C28.4294 28.5084 28.5406 28.4474 28.6366 28.3663ZM17.2016 28.4891C17.417 28.7212 17.6765 28.8804 18.0157 28.8639C18.1296 28.8541 18.2428 28.8375 18.3548 28.8141C18.4852 28.7802 18.6067 28.7184 18.7108 28.6329C18.815 28.5474 18.8993 28.4402 18.9579 28.3188C19.0697 28.1027 19.1168 27.859 19.0938 27.6168C19.0859 27.5287 19.073 27.4413 19.0551 27.3547C19.0256 27.1469 18.9201 26.9574 18.7591 26.8229C18.5006 26.6262 18.22 26.4957 17.8754 26.5631C17.4777 26.6416 17.1784 26.8285 17.0359 27.2342C16.9685 27.4351 16.9425 27.6476 16.9596 27.8589C16.9634 28.0909 17.0491 28.3142 17.2016 28.4891ZM18.4175 28.4991C18.2974 28.5746 18.1574 28.6123 18.0157 28.6074H18.0179C17.8314 28.6072 17.6518 28.537 17.5146 28.4107C17.3773 28.2844 17.2924 28.1111 17.2767 27.9252C17.2397 27.6674 17.278 27.4044 17.3871 27.1679C17.462 27.04 17.5743 26.9382 17.7088 26.8763C17.8434 26.8144 17.9937 26.7954 18.1394 26.8218C18.2864 26.8511 18.4232 26.9186 18.5359 27.0175C18.6671 27.151 18.7486 27.3254 18.7668 27.5117C18.8074 27.7385 18.7805 27.9723 18.6895 28.1839C18.6324 28.3138 18.5376 28.4236 18.4175 28.4991ZM3.35285 26.5764H4.93799V26.8152C4.72329 26.8367 4.5073 26.8423 4.29178 26.8318H3.66435C3.61509 27.0577 3.61246 27.2914 3.65662 27.5184H4.85845V27.7749C4.83081 27.7749 4.80404 27.7789 4.77783 27.7828H4.77782H4.7778C4.7527 27.7866 4.72812 27.7903 4.7038 27.7903H3.80243C3.76717 27.7903 3.73243 27.7934 3.69438 27.7967C3.67641 27.7983 3.65769 27.8 3.63784 27.8014V28.5488H4.9899V28.7854C4.89159 28.8263 3.49756 28.8351 3.35837 28.7964C3.32523 28.7035 3.3164 26.7444 3.35285 26.5764ZM15.1083 27.7748H16.2328C16.2452 27.9455 16.2434 28.1142 16.2416 28.2821V28.2821V28.2821V28.2821V28.2822V28.2822V28.2822V28.2822V28.2822V28.2822V28.2823V28.2823V28.2823C16.2398 28.4592 16.2379 28.635 16.2527 28.8108H16.5123C16.5553 28.6427 16.5432 26.6748 16.5023 26.5819H16.2394V27.483H15.1171C15.1004 27.3338 15.1029 27.1862 15.1053 27.0397V27.0397C15.1079 26.8856 15.1104 26.7328 15.0906 26.5808H14.8078C14.7647 26.75 14.7769 28.7168 14.8178 28.8108H15.1083V27.7748ZM23.3344 27.2221H23.0804C23.0644 27.1921 23.0508 27.1615 23.0372 27.1312L23.0372 27.1311C22.9982 27.0437 22.9604 26.9589 22.8727 26.9014C22.6772 26.7732 22.2894 26.7842 22.1215 26.9313C22.0782 26.9621 22.0447 27.0048 22.0251 27.0542C22.0055 27.1037 22.0006 27.1577 22.0111 27.2099C22.025 27.2622 22.0529 27.3097 22.0919 27.3473C22.1308 27.385 22.1793 27.4112 22.232 27.4233C22.4529 27.4841 22.6827 27.5449 22.9102 27.5979C23.1654 27.6577 23.3963 27.9053 23.4051 28.1375C23.4233 28.2862 23.3857 28.4364 23.2996 28.5589C23.2135 28.6815 23.085 28.7677 22.939 28.8008C22.6653 28.8795 22.3742 28.8737 22.1039 28.7842C21.8399 28.7069 21.662 28.4526 21.6532 28.1109H21.8984C21.9149 28.1332 21.9286 28.1573 21.9393 28.1828C21.9695 28.3018 22.0404 28.4064 22.1397 28.4786C22.239 28.5507 22.3604 28.5857 22.4828 28.5775L22.5223 28.5777L22.5426 28.578C22.6847 28.5796 22.8249 28.5813 22.9566 28.4979C23.1323 28.3873 23.2052 28.185 23.0318 28.0114C22.924 27.9027 22.7843 27.8674 22.644 27.832C22.6175 27.8253 22.5909 27.8185 22.5645 27.8113C22.3525 27.7707 22.1475 27.6996 21.9558 27.6002C21.683 27.4321 21.662 27.0131 21.8564 26.7964C21.9311 26.7153 22.0244 26.6534 22.1282 26.6162C22.3861 26.5153 22.6731 26.5181 22.929 26.6239C23.0297 26.6588 23.1198 26.7189 23.1907 26.7984C23.2617 26.8779 23.3111 26.9743 23.3344 27.0783C23.3395 27.1261 23.3395 27.1743 23.3344 27.2221ZM8.14471 26.5764H7.85088C7.84843 26.6004 7.84577 26.6214 7.84337 26.6403L7.84337 26.6403C7.84035 26.664 7.83775 26.6845 7.83652 26.7035C7.83652 26.8318 7.83493 26.9601 7.83333 27.0884C7.83014 27.3447 7.82695 27.6009 7.83652 27.8567C7.83168 28.0595 7.86581 28.2615 7.93704 28.4515C7.97251 28.5445 8.03092 28.627 8.10682 28.6914C8.18272 28.7558 8.27365 28.7999 8.37116 28.8196C8.5497 28.8482 8.73068 28.8586 8.91132 28.8506C9.05824 28.8493 9.20057 28.7992 9.31595 28.7081C9.43132 28.6171 9.51319 28.4902 9.54869 28.3475C9.58621 28.1802 9.6062 28.0094 9.60834 27.8379C9.61276 27.5903 9.61129 27.3431 9.60981 27.0959L9.60981 27.0955C9.60908 26.9719 9.60834 26.8483 9.60834 26.7245C9.60569 26.6764 9.60052 26.6284 9.59288 26.5808H9.30015C9.29868 26.6021 9.29697 26.6219 9.29535 26.6407V26.6408L9.29534 26.6408L9.29533 26.641C9.29205 26.6789 9.2891 26.7131 9.2891 26.7478C9.2891 26.8821 9.29008 27.0166 9.29106 27.1514C9.29303 27.4215 9.295 27.6925 9.2891 27.9639C9.27968 28.0904 9.25596 28.2154 9.21841 28.3365C9.17422 28.5101 9.03504 28.5642 8.87818 28.5786C8.76806 28.5908 8.65692 28.5908 8.5468 28.5786C8.48055 28.5769 8.41618 28.5563 8.36134 28.519C8.30651 28.4818 8.26352 28.4295 8.2375 28.3685C8.19278 28.2543 8.16596 28.1339 8.15797 28.0114V26.7389C8.15797 26.7138 8.15488 26.689 8.15168 26.6633C8.14826 26.6358 8.14471 26.6073 8.14471 26.5764ZM11.9424 28.8141H11.6033C11.5205 28.593 11.4387 28.3719 11.3548 28.1419H10.4214C10.3407 28.363 10.2601 28.5841 10.1761 28.8052H9.86462L10.7019 26.5697H11.0455L11.9424 28.8141ZM10.8831 26.8904H10.8588C10.7417 27.2154 10.6257 27.5405 10.5031 27.8854H11.2377L11.2314 27.8676C11.1122 27.5302 10.9982 27.2076 10.8831 26.8904ZM19.7543 26.5742H19.4892C19.4859 26.6146 19.4821 26.6497 19.4784 26.6839L19.4784 26.6841L19.4749 26.7164L19.4716 26.75C19.4716 26.8817 19.4704 27.0124 19.4693 27.1426V27.1427C19.4671 27.4016 19.4649 27.6585 19.4716 27.9175C19.4763 28.076 19.5 28.2334 19.5422 28.3862C19.5717 28.5005 19.6343 28.6036 19.7221 28.6823C19.81 28.761 19.9193 28.8119 20.036 28.8285C20.1891 28.8484 20.3434 28.8573 20.4977 28.855C20.5938 28.8567 20.6893 28.8389 20.7783 28.8026C20.8673 28.7664 20.9481 28.7126 21.0158 28.6443C21.0835 28.576 21.1367 28.4948 21.1722 28.4054C21.2077 28.316 21.2248 28.2204 21.2224 28.1242V26.7312C21.2205 26.6827 21.2161 26.6343 21.2091 26.5863H20.9363C20.9286 26.6549 20.9286 26.7068 20.9286 26.7588C20.9286 26.8926 20.9295 27.0269 20.9305 27.1616C20.9325 27.4318 20.9345 27.7034 20.9286 27.9749C20.924 28.0933 20.9017 28.2104 20.8623 28.3221C20.8414 28.4021 20.7929 28.4721 20.7254 28.5197C20.6578 28.5672 20.5756 28.5893 20.4933 28.5819H20.215C20.1128 28.5769 20.0156 28.5365 19.9399 28.4678C19.8642 28.399 19.8146 28.3061 19.7996 28.2049C19.7809 28.0519 19.7709 27.898 19.7698 27.7439V26.7356C19.7675 26.6815 19.7624 26.6277 19.7543 26.5742ZM28.1948 31.9429H27.8634C27.8617 31.9239 27.8598 31.9062 27.858 31.8892C27.8539 31.8507 27.8501 31.8161 27.8501 31.7793C27.8501 31.6952 27.8495 31.6112 27.8489 31.5272V31.527C27.8477 31.359 27.8465 31.191 27.8501 31.0231C27.8533 30.9081 27.8183 30.7954 27.7507 30.7024C27.5326 30.3816 27.318 30.058 27.1031 29.7338L26.9344 29.4797C26.9153 29.4517 26.8978 29.4226 26.8755 29.3853L26.8471 29.3381H27.2647L28.0379 30.5454C28.2167 30.2699 28.3954 29.9954 28.5749 29.7198L28.8255 29.3348H29.2199L29.1812 29.3979L29.1812 29.398L29.1811 29.398L29.181 29.3982L29.181 29.3983C29.147 29.4539 29.1176 29.5022 29.0851 29.5493C28.8396 29.9067 28.595 30.2604 28.3471 30.619L28.3459 30.6207L28.2809 30.7146C28.2182 30.8004 28.1859 30.9047 28.1893 31.0109V31.7848C28.198 31.8159 28.197 31.8493 28.1958 31.8907L28.1952 31.9107C28.195 31.9209 28.1948 31.9316 28.1948 31.9429ZM17.0679 31.9429H17.4169V29.6455H18.2443V29.3403H16.2052V29.6543H17.0679V31.9429ZM25.5514 29.6477H24.7152V29.3227H26.7532V29.64H25.9005C25.8941 29.7951 25.8951 29.9433 25.896 30.0891V30.0892V30.0892V30.0893V30.0893V30.0893C25.8966 30.1982 25.8973 30.3057 25.8949 30.4139C25.8913 30.5827 25.8925 30.7505 25.8937 30.9183C25.8943 31.0022 25.8949 31.0861 25.8949 31.1701V31.9385H25.5514V29.6477ZM13.5585 28.7853V28.5642C13.3845 28.5514 13.2136 28.5526 13.0434 28.5539H13.0434H13.0433H13.0433H13.0433H13.0433H13.0432H13.0432H13.0432C12.8471 28.5553 12.6519 28.5567 12.4539 28.5366V27.8732V27.2243V26.5753H12.1865C12.1468 26.7102 12.1501 28.6892 12.1865 28.7997C12.329 28.8373 13.4546 28.8285 13.5585 28.7853ZM24.2778 31.9429H23.9309V29.3403H24.2789L24.2778 31.9429ZM24.1408 26.5764H23.8713C23.8359 26.7511 23.8448 28.7046 23.879 28.8064H24.1518C24.1861 28.6361 24.1773 26.687 24.1408 26.5764ZM21.1539 20.0026H10.8643C10.8278 19.892 10.819 15.9219 10.851 15.7704C10.9471 15.7306 21.0048 15.7218 21.1484 15.7605C21.1826 15.8578 21.1903 19.8301 21.1539 20.0026ZM10.8378 15.0673H21.1495L21.1528 14.8683C21.1439 13.5696 21.1347 12.2701 21.1252 10.97C21.1224 10.9248 21.1172 10.8798 21.1097 10.8351C20.9517 10.7865 10.9195 10.7953 10.8245 10.8351C10.7914 10.9921 10.8013 14.9567 10.8378 15.0673Z",
  fill: "white"
}));

const OwnUpContrastLogo = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "192",
  height: "49",
  viewBox: "0 0 192 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("g", {
  clipPath: "url(#clip0_2004_4878)"
}, /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44 17.9352C44 8.55555 50.9981 2 58.9407 2C66.5648 2 73.8833 8.27593 73.8833 17.9352C73.8833 27.8352 66.1315 33.7926 58.9407 33.7926C51.4519 33.7926 44 27.5833 44 17.9352ZM50.4333 17.9204C50.4333 24.0611 54.6815 28.013 58.9407 28.013C63.0352 28.013 67.4481 24.2204 67.4481 17.9204C67.4481 11.7759 63.2815 7.77963 58.9407 7.77963C54.4185 7.77963 50.4333 11.9519 50.4333 17.9204ZM158.428 21.8796V2H151.993V21.8648C151.993 25.9056 148.744 28.013 145.865 28.013C142.985 28.013 139.7 25.813 139.7 21.8648V3.33333C139.7 2.97971 139.56 2.64057 139.309 2.39052C139.059 2.14048 138.72 2 138.367 2H133.259V21.8796C133.259 29.237 139.741 33.7926 145.865 33.7926C151.989 33.7926 158.428 29.1944 158.428 21.8796ZM166.781 21.8074C166.771 20.9504 166.932 20.0999 167.255 19.3059C167.578 18.5119 168.056 17.7903 168.661 17.1834C169.266 16.5765 169.986 16.0965 170.779 15.7715C171.573 15.4465 172.423 15.283 173.28 15.2907C176.596 15.2907 179.78 17.8574 179.78 21.8074C179.78 25.8537 176.407 28.2889 173.28 28.2889C170.022 28.2889 166.781 25.7519 166.781 21.8074ZM173.28 33.4333C180.152 33.4333 185.872 28.5537 185.872 21.8778C185.872 15.6204 180.454 10.1482 173.28 10.1482C170.766 10.1678 168.33 11.0247 166.357 12.5833C166.248 12.103 165.979 11.6741 165.594 11.3664C165.209 11.0586 164.732 10.8903 164.239 10.8889H160.872V42H166.739V31.2778C166.739 31.2778 169.176 33.4333 173.28 33.4333ZM120.839 15.6315C118.502 15.6315 116.489 17.5019 116.489 21.1574V33.1111H110.622V10.8889H113.531C114.022 10.889 114.498 11.055 114.882 11.3599C115.267 11.6649 115.537 12.0908 115.648 12.5685C117.181 11.0337 119.257 10.1641 121.426 10.1482C127.693 10.1482 131.056 14.0333 131.056 21.1574V33.1111H126.524C126.17 33.1111 125.831 32.9706 125.581 32.7206C125.331 32.4705 125.191 32.1314 125.191 31.7778V21.1574C125.191 17.7056 123.517 15.6315 120.839 15.6315ZM96.874 33.111H101.874L108.376 10.8888H102.222L98.7666 24.8239L94.7296 10.8888H88.4888L84.6944 24.8239L81.1388 11.861C81.061 11.5794 80.893 11.331 80.6605 11.1541C80.4281 10.9771 80.144 10.8813 79.8518 10.8813H74.7648L81.3685 33.1036H87.4611L91.7537 18.4054L95.5888 32.1369C95.6676 32.4172 95.8358 32.664 96.0678 32.8399C96.2998 33.0157 96.5829 33.1109 96.874 33.111Z",
  fill: "white"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M1.10896 10.4926C0.745228 10.7571 0.530029 11.1797 0.530029 11.6295V20.7794C0.530029 21.3538 1.18174 21.6857 1.64632 21.3478L15.9934 10.9136L30.3404 21.3478C30.805 21.6857 31.4567 21.3538 31.4567 20.7794V11.6295C31.4567 11.1797 31.2415 10.7571 30.8778 10.4926L16.8202 0.268871C16.3273 -0.0896234 15.6595 -0.0896239 15.1665 0.268871L1.10896 10.4926Z",
  fill: "white"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20.9135 25.6741V32H11.0732V25.6741C11.0732 22.9568 13.276 20.7539 15.9934 20.7539C18.7107 20.7539 20.9135 22.9568 20.9135 25.6741Z",
  fill: "white"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M191.5 13.1499C191.5 14.5306 190.381 15.6499 189 15.6499C187.619 15.6499 186.5 14.5306 186.5 13.1499C186.5 11.7692 187.619 10.6499 189 10.6499C190.381 10.6499 191.5 11.7692 191.5 13.1499ZM192 13.1499C192 14.8068 190.657 16.1499 189 16.1499C187.343 16.1499 186 14.8068 186 13.1499C186 11.493 187.343 10.1499 189 10.1499C190.657 10.1499 192 11.493 192 13.1499ZM189.076 11.73H188V14.586H188.6V13.534H189.032H189.096C189.117 13.5313 189.139 13.53 189.16 13.53L189.66 14.586H190.32L189.724 13.394C189.879 13.314 189.993 13.2073 190.068 13.074C190.143 12.9406 190.18 12.7833 190.18 12.602C190.18 12.434 190.144 12.2846 190.072 12.154C190 12.0206 189.883 11.9166 189.72 11.842C189.56 11.7673 189.345 11.73 189.076 11.73ZM189.464 12.942C189.392 13.014 189.257 13.05 189.06 13.05H188.6V12.218H189.036C189.239 12.218 189.379 12.2526 189.456 12.322C189.533 12.3886 189.572 12.4886 189.572 12.622C189.572 12.7606 189.536 12.8673 189.464 12.942Z",
  fill: "white"
})), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("clipPath", {
  id: "clip0_2004_4878"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "192",
  height: "42",
  fill: "white"
}))));

const breakpoints = {
  [ScreenSize.xsmall]: 375,
  [ScreenSize.small]: 640,
  [ScreenSize.medium]: 1024,
  [ScreenSize.large]: Number.POSITIVE_INFINITY
};

const colors = {
  ...colors$1,
  AQUA: '#F2FBFB',
  BACKGROUND_GREY: '#E5E5E5',
  CLASSIC_BLUE: '#4800E6',
  ERROR_LIGHT: '#FFEDEA',
  GREY_LIGHT_1: '#DAE0E0',
  GREY_1: '#515456',
  GREY_2: '#8B8B8B',
  GREY_3: '#DAE0E0',
  MINT: '#8FF4BD',
  MINT_1: '#D9FDE9',
  NIMBUS_2: '#436564',
  PALE_BLUE: '#F2FBFB',
  PALE_GREEN: '#F4FCF8',
  PRIMARY_SHADOW: '#143F3D04',
  PALE_YELLOW: '#FFF4CE',
  PALE_ORANGE: '#FFE0A4',
  DARK_1: '#11171D'
};

/**
 * Styling that will underpin (most of) the "buttons". Some properties will are assigned 'unset', in order to remove the defaults that come in from the component library.
 */
const ButtonStyle = createOwnUpStyle({
  ...fonts.GRAPHIK_MEDIUM,
  fontFamily: "'Graphik-Medium', 'Arial', 'sans-serif'",
  backgroundColor: 'transparent',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderRadius: '25px',
  boxSizing: 'border-box',
  fontSize: '15px',
  height: 'unset',
  letterSpacing: 2,
  lineHeight: 1.2,
  minWidth: 'unset',
  paddingTop: 0,
  textAlign: 'center',
  textTransform: 'unset',
  transition: '0.7s',
  // Most buttons have a hover state.
  whiteSpace: 'unset',
  width: '100%'
});

/**
 * Styling for the 'Get Started' button that appears in the header on small screens when the user scrolls down.
 */
const ScrollingCTAButtonStyle = createOwnUpStyle({
  ...ButtonStyle,
  backgroundColor: colors.CLASSIC_BLUE,
  border: 'unset',
  color: colors.WHITE,
  transition: 'unset',
  animation: 'fadeIn 1s',
  fontSize: '12px',
  padding: '12px 24px',
  maxWidth: '150px',
  '@keyframes fadeIn': {
    from: {
      opacity: 0
    },
    to: {
      opacity: 1
    }
  }
});
const ScrollingCTAButton = createOwnUpComponent(OwnUpBox, ScrollingCTAButtonStyle);

/**
 * Styling for the 'Get Started' button that appears in the menu that slides in from the header on small screens.
 */
const SlideOutMenuButtonStyle = createOwnUpStyle({
  ...ButtonStyle,
  borderColor: colors.LOGO_BACKDROP,
  color: colors.LOGO_BACKDROP,
  fontSize: '19px',
  letterSpacing: 'normal',
  padding: '10px 30px',
  ':hover': {
    backgroundColor: colors.LOGO_BACKDROP,
    borderColor: colors.LOGO_BACKDROP,
    color: colors.GREY_FOOTER
  }
});
const SlideOutMenuButton = createOwnUpComponent(OwnUpBox, SlideOutMenuButtonStyle);

/**
 * Styling for the button that appears in the header on large screens.
 */
const DesktopHeaderButtonStyle = createOwnUpStyle({
  ...ButtonStyle,
  borderColor: colors.PRIMARY,
  color: colors.PRIMARY,
  fontSize: '17px',
  letterSpacing: '0.1px',
  lineHeight: '17px',
  padding: '10px 30px',
  ':hover': {
    backgroundColor: colors.PRIMARY,
    color: colors.WHITE
  }
});
const DesktopHeaderButton = createOwnUpComponent(OwnUpBox, DesktopHeaderButtonStyle);
const GetStartedFloatStyle = createOwnUpStyle({
  ...ButtonStyle,
  borderColor: colors.PALE_YELLOW,
  backgroundColor: colors.PALE_YELLOW,
  color: colors.DARK_1,
  fontSize: '16px',
  borderRadius: '8px',
  letterSpacing: '0.1px',
  width: '257px',
  lineHeight: '24px',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  padding: '16px 30px',
  marginLeft: '24px',
  ':hover': {
    backgroundColor: colors.PALE_ORANGE,
    color: colors.DARK_1
  },
  '& path': {
    fill: 'rgba(62, 109, 106, 1)!important'
  },
  boxShadow: '2px 3px 8px 0px rgba(32, 29, 29, 0.25)',
  variants: {
    xsmall: {
      width: '220px',
      margin: '0 auto'
    }
  }
});
const GetStartedFloatButton = createOwnUpComponent(OwnUpBox, GetStartedFloatStyle);

/**
 * Styling for the Get Started button that appears in the ShopCTA.
 */
const ShopCTAButtonStyle = createOwnUpStyle({
  ...ButtonStyle,
  borderColor: colors.BLUE,
  color: colors.BLUE,
  borderRadius: '100px',
  lineHeight: '32px',
  padding: '12px',
  ':hover': {
    backgroundColor: colors.BLUE,
    color: colors.AQUA
  }
});
const ShopCTAButton = createOwnUpComponent(OwnUpBox, ShopCTAButtonStyle);

// Styling for wrapping an interactive element (e.g., an icon) in a button without carrying over any of the CSS-imposed defaults.
const TrueButtonWrapperStyle = createOwnUpStyle({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0
});
const TrueButtonWrapper = createOwnUpComponent('button', TrueButtonWrapperStyle);

const HomePageLink = _ref => {
  let {
    mainSite,
    www,
    children,
    id,
    trackingEvent,
    style
  } = _ref;
  const link = mainSite ? '/' : www;
  const props = {
    style: {
      textDecoration: 'none',
      ...style
    },
    id,
    onClick: () => {
      if (trackingEvent) {
        const {
          hook,
          name,
          properties = {}
        } = trackingEvent;
        hook.track(name, properties);
      }
    }
  };
  return mainSite ? /*#__PURE__*/React__default.createElement(Link$1, _extends$1({}, props, {
    to: link,
    "aria-label": "Own Up Home Page"
  }), children) : /*#__PURE__*/React__default.createElement("a", _extends$1({
    href: link
  }, props, {
    "aria-label": "Own Up Home Page"
  }), children);
};
const GetStartedLink = _ref2 => {
  let {
    onboarding,
    url,
    children,
    label,
    trackingEvent,
    style,
    ...props
  } = _ref2;
  const destination = url ? url : "".concat(onboarding, "/");
  return /*#__PURE__*/React__default.createElement("a", _extends$1({
    style: {
      textDecoration: 'none',
      ...style
    },
    href: destination,
    "aria-label": label || 'Get Started With Own Up!',
    onClick: () => {
      if (trackingEvent) {
        const {
          hook,
          name,
          properties = {}
        } = trackingEvent;
        hook.track(name, properties);
      }
    }
  }, props), children);
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || commonjsGlobal || Function('return this')();

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

var documentAll$2 = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll$2 == 'undefined' && documentAll$2 !== undefined;

var documentAll_1 = {
  all: documentAll$2,
  IS_HTMLDDA: IS_HTMLDDA
};

var documentAll$1 = documentAll_1.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable = documentAll_1.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll$1;
} : function (argument) {
  return typeof argument == 'function';
};

var documentAll = documentAll_1.all;

var isObject = documentAll_1.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};

var document$1 = global$1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS$1 ? document$1.createElement(it) : {};
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`


var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var functionBindNative = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var FunctionPrototype$2 = Function.prototype;
var call$2 = FunctionPrototype$2.call;
var uncurryThisWithBind = functionBindNative && FunctionPrototype$2.bind.bind(call$2, call$2);

var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$2.apply(fn, arguments);
  };
};

var toString$2 = functionUncurryThis({}.toString);
var stringSlice$4 = functionUncurryThis(''.slice);

var classofRaw = function (it) {
  return stringSlice$4(toString$2(it), 8, -1);
};

var $Object$4 = Object;
var split = functionUncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined = function (it) {
  return it === null || it === undefined;
};

var $TypeError$b = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError$b("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$4 = Object.defineProperty;

var defineGlobalProperty = function (key, value) {
  try {
    defineProperty$4(global$1, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store$1 = global$1[SHARED] || defineGlobalProperty(SHARED, {});

var sharedStore = store$1;

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.31.0',
  mode: 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.31.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});
});

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return $Object$3(requireObjectCoercible(argument));
};

var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};

var id = 0;
var postfix = Math.random();
var toString$1 = functionUncurryThis(1.0.toString);

var uid = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$1(++id + postfix, 36);
};

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var process$1 = global$1.process;
var Deno = global$1.Deno;
var versions = process$1 && process$1.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */

var $String$4 = global$1.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$4(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */

var useSymbolAsUid = symbolConstructorDetection
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var Symbol$1 = global$1.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name)
      ? Symbol$1[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var $String$3 = String;
var $TypeError$a = TypeError;

// `Assert: Type(argument) is Object`
var anObject = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError$a($String$3(argument) + ' is not an object');
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var call$1 = Function.prototype.call;

var functionCall = functionBindNative ? call$1.bind(call$1) : function () {
  return call$1.apply(call$1, arguments);
};

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$1[namespace]) : global$1[namespace] && global$1[namespace][method];
};

var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

var $Object$2 = Object;

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$2(it));
};

var $String$2 = String;

var tryToString = function (argument) {
  try {
    return $String$2(argument);
  } catch (error) {
    return 'Object';
  }
};

var $TypeError$9 = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError$9(tryToString(argument) + ' is not a function');
};

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};

var $TypeError$8 = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
  throw $TypeError$8("Can't convert object to primitive value");
};

var $TypeError$7 = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = functionCall(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError$7("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$1 = function (argument) {
  var key = toPrimitive$1(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var $TypeError$6 = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f$8 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey$1(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey$1(P);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$6('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f$8
};

var ceil = Math.ceil;
var floor$4 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$4 : ceil)(n);
};

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : mathTrunc(number);
};

var max$3 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max$3(integer + length, 0) : min$3(integer, length);
};

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min$2(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike = function (obj) {
  return toLength(obj.length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var hiddenKeys$1 = {};

var indexOf$1 = arrayIncludes.indexOf;


var push$2 = functionUncurryThis([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$2(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$2(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var f$7 = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
  return O;
};

var objectDefineProperties = {
	f: f$7
};

var html = getBuiltIn('document', 'documentElement');

var keys$2 = shared('keys');

var sharedKey = function (key) {
  return keys$2[key] || (keys$2[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */

var GT = '>';
var LT = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$1[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
};

var defineProperty$3 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$3(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var WeakMap$1 = global$1.WeakMap;

var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$1.TypeError;
var WeakMap = global$1.WeakMap;
var set$1, get$1, has$2;

var enforce = function (it) {
  return has$2(it) ? get$1(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get$1(it)).type !== TYPE) {
      throw TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (weakMapBasicDetection || sharedStore.state) {
  var store = sharedStore.state || (sharedStore.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return store.get(it) || {};
  };
  has$2 = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys$1[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwnProperty_1(it, STATE)) throw TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
  };
  has$2 = function (it) {
    return hasOwnProperty_1(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get$1,
  has: has$2,
  enforce: enforce,
  getterFor: getterFor
};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$2 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$6 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$2(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$6
};

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$5 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey$1(P);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$5
};

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwnProperty_1(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!descriptors || (descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var functionToString = functionUncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(sharedStore.inspectSource)) {
  sharedStore.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var makeBuiltIn_1 = createCommonjsModule(function (module) {
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;



var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = functionUncurryThis(''.slice);
var replace = functionUncurryThis(''.replace);
var join = functionUncurryThis([].join);

var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwnProperty_1(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (descriptors) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
      if (descriptors) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwnProperty_1(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');
});

var defineBuiltIn = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn_1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else objectDefineProperty.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys);
};

var objectGetOwnPropertyNames = {
	f: f$4
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$3 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$3
};

var concat$1 = functionUncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? concat$1(keys, getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source, exceptions) {
  var keys = ownKeys$1(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$1;
  } else if (STATIC) {
    target = global$1[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype$2 = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwnProperty_1(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype$2 : null;
};

var ITERATOR$5 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$5].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype$2[ITERATOR$5])) {
  defineBuiltIn(IteratorPrototype$2, ITERATOR$5, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$2 = objectDefineProperty.f;



var TO_STRING_TAG$4 = wellKnownSymbol('toStringTag');

var setToStringTag = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwnProperty_1(target, TO_STRING_TAG$4)) {
    defineProperty$2(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return functionUncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var $String$1 = String;
var $TypeError$5 = TypeError;

var aPossiblePrototype = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError$5("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = functionUncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var PROPER_FUNCTION_NAME$1 = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  iteratorCreateConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR$4])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR$4, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME$1) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return functionCall(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$4] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR$4, defaultIterator, { name: DEFAULT });
  }
  iterators[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject = function (value, done) {
  return { value: value, done: done };
};

var defineProperty$1 = objectDefineProperty.f;





var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = internalState.set;
var getInternalState$2 = internalState.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = iteratorDefine(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  if (kind == 'keys') return createIterResultObject(index, false);
  if (kind == 'values') return createIterResultObject(target[index], false);
  return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = iterators.Arguments = iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (descriptors && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var ITERATOR$3 = wellKnownSymbol('iterator');
var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
var ArrayValues = es_array_iterator.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$3] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR$3, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$3] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG$3]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG$3, COLLECTION_NAME);
    }
    if (domIterables[COLLECTION_NAME]) for (var METHOD_NAME in es_array_iterator) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== es_array_iterator[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, es_array_iterator[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = es_array_iterator[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in domIterables) {
  handlePrototype(global$1[COLLECTION_NAME] && global$1[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(domTokenListPrototype, 'DOMTokenList');

var _templateObject$S;
const StickyContainerInner = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 16px;\n  left: 24px;\n  right: 24px;\n  z-index: 10;\n"])));
const StickyContainer = _ref => {
  let {
    children,
    offset = 100
  } = _ref;
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  if (scrollPosition < offset) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(StickyContainerInner, null, children);
};

var _templateObject$R, _templateObject2$v, _templateObject3$n, _templateObject4$8, _templateObject5$5, _templateObject6$2, _templateObject7$2, _templateObject8$1, _templateObject9$1, _templateObject10$1;
const Section$2 = styled.footer(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  ", " {\n    padding: ", ";\n  }\n\n  ", " {\n    padding: ", ";\n  }\n\n  ", " {\n    padding: ", ";\n  }\n"])), CHARCOAL_90, _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.text.primary;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.down('sm');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(4, 0);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoints.only('md');
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(3, 0);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.breakpoints.up('lg');
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(3, 0);
});
styled(OwnUpHeadlineBook)(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n  ", " {\n    padding-top: ", "px;\n  }\n"])), _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.breakpoints.down('md');
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.spacing(4);
});
const LogosContainer = styled.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: space-between;\n  height: 100%;\n"])));
styled.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n  ", " {\n    display: none;\n  }\n\n  display: flex;\n  align-items: center;\n  padding-right: ", "px;\n"])), _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.breakpoints.down('md');
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.spacing(8);
});
const OwnUpLogoSmallScreenContainer = styled.div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n  ", " {\n    display: none;\n  }\n"])), _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.breakpoints.up('lg');
});
const SocialButtonsContainer = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", "px;\n"])), _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.spacing(2);
});
const SocialButton = styled.a(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  height: 40px;\n\n  ", " {\n    padding-top: ", "px;\n    padding-bottom: ", "px;\n  }\n"])), _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.breakpoints.down('md');
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.spacing(4);
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.spacing(6);
});
const LinksContainer = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: ", "px;\n\n  // Desired spacing is spacing-4; md screens have a grid padding of spacing-3\n  // and sm/xs have a grid padding of spacing-2 so subtract that off\n  ", " {\n    padding-top: ", "px;\n  }\n\n  ", " {\n    padding-top: ", "px;\n  }\n"])), _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.spacing(1.5);
}, _ref18 => {
  let {
    theme
  } = _ref18;
  return theme.breakpoints.only('md');
}, _ref19 => {
  let {
    theme
  } = _ref19;
  return theme.spacing(1);
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return theme.breakpoints.down('sm');
}, _ref21 => {
  let {
    theme
  } = _ref21;
  return theme.spacing(2);
});
const FheoAndCopyrightContainer = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", "px;\n  padding-top: ", "px;\n"])), _ref22 => {
  let {
    theme
  } = _ref22;
  return theme.spacing(2);
}, _ref23 => {
  let {
    theme
  } = _ref23;
  return theme.spacing(3);
});
const Splitter = styled.hr(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  border-color: rgba(255, 255, 255, 0.31);\n"])));

const FacebookLogo = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "white",
  fillOpacity: "0.1"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M23.941 21.0485L24.4369 17.8155H21.335V15.7176C21.335 14.8331 21.7683 13.9709 23.1577 13.9709H24.568V11.2184C24.568 11.2184 23.2881 11 22.0643 11C19.5096 11 17.8398 12.5483 17.8398 15.3515V17.8155H15V21.0485H17.8398V28.8641C18.4093 28.9535 18.9928 29 19.5874 29C20.182 29 20.7655 28.9535 21.335 28.8641V21.0485H23.941Z",
  fill: "white"
}));

const InstagramLogo = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "white",
  fillOpacity: "0.1"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M20.004 15.385C17.4495 15.385 15.389 17.4455 15.389 20C15.389 22.5545 17.4495 24.615 20.004 24.615C22.5585 24.615 24.619 22.5545 24.619 20C24.619 17.4455 22.5585 15.385 20.004 15.385ZM20.004 23.0003C18.3532 23.0003 17.0037 21.6548 17.0037 20C17.0037 18.3452 18.3492 16.9997 20.004 16.9997C21.6588 16.9997 23.0044 18.3452 23.0044 20C23.0044 21.6548 21.6548 23.0003 20.004 23.0003V23.0003ZM25.8842 15.1963C25.8842 15.7947 25.4022 16.2727 24.8078 16.2727C24.2093 16.2727 23.7314 15.7907 23.7314 15.1963C23.7314 14.6018 24.2133 14.1198 24.8078 14.1198C25.4022 14.1198 25.8842 14.6018 25.8842 15.1963ZM28.9408 16.2887C28.8725 14.8468 28.5431 13.5696 27.4868 12.5172C26.4345 11.4649 25.1572 11.1356 23.7153 11.0633C22.2292 10.9789 17.7749 10.9789 16.2887 11.0633C14.8508 11.1315 13.5736 11.4609 12.5172 12.5132C11.4609 13.5655 11.1356 14.8428 11.0633 16.2847C10.9789 17.7708 10.9789 22.2251 11.0633 23.7113C11.1315 25.1532 11.4609 26.4304 12.5172 27.4828C13.5736 28.5351 14.8468 28.8644 16.2887 28.9367C17.7749 29.0211 22.2292 29.0211 23.7153 28.9367C25.1572 28.8685 26.4345 28.5391 27.4868 27.4828C28.5391 26.4304 28.8685 25.1532 28.9408 23.7113C29.0251 22.2251 29.0251 17.7749 28.9408 16.2887V16.2887ZM27.0209 25.3058C26.7076 26.093 26.1011 26.6995 25.3098 27.0168C24.125 27.4868 21.3134 27.3783 20.004 27.3783C18.6946 27.3783 15.8791 27.4828 14.6982 27.0168C13.911 26.7036 13.3045 26.0971 12.9872 25.3058C12.5172 24.1209 12.6257 21.3094 12.6257 20C12.6257 18.6906 12.5213 15.875 12.9872 14.6942C13.3005 13.907 13.907 13.3005 14.6982 12.9832C15.8831 12.5132 18.6946 12.6217 20.004 12.6217C21.3134 12.6217 24.129 12.5172 25.3098 12.9832C26.0971 13.2964 26.7036 13.9029 27.0209 14.6942C27.4908 15.8791 27.3824 18.6906 27.3824 20C27.3824 21.3094 27.4908 24.125 27.0209 25.3058Z",
  fill: "white"
}));

const LinkedinLogo = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "white",
  fillOpacity: "0.1"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M14.94 13C14.9397 13.5305 14.7288 14.0391 14.3535 14.4139C13.9782 14.7888 13.4694 14.9993 12.939 14.999C12.4086 14.9988 11.9 14.7878 11.5251 14.4125C11.1502 14.0373 10.9397 13.5285 10.94 12.998C10.9403 12.4676 11.1512 11.959 11.5265 11.5841C11.9018 11.2092 12.4106 10.9988 12.941 10.999C13.4714 10.9993 13.98 11.2103 14.3549 11.5855C14.7298 11.9608 14.9403 12.4696 14.94 13ZM15 16.48H11V29H15V16.48ZM21.32 16.48H17.34V29H21.28V22.43C21.28 18.77 26.05 18.43 26.05 22.43V29H30V21.07C30 14.9 22.94 15.13 21.28 18.16L21.32 16.48Z",
  fill: "white"
}));

const TwitterLogo = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "white",
  fillOpacity: "0.1"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M16 10H9L17.26 21.014L9.45 30H12.1L18.488 22.651L24 30H31L22.392 18.522L29.8 10H27.15L21.164 16.886L16 10ZM25 28L13 12H15L27 28H25Z",
  fill: "white"
}));

/**
 * Builds media queries to insert into a style definition based on defined breakpoints.
 * @param variant the screen size(s) to which the given style should be applied; can be a single variant or an array of variants.
 * @param style the style to apply
 * @returns
 */
const buildMediaQueries = (variant, style) => {
  if (typeof variant === 'object') {
    return variant.reduce((acc, curr) => {
      return {
        ...acc,
        ...buildMediaQueries(curr, style)
      };
    }, {});
  } else {
    switch (variant) {
      case 'xsmall':
        return {
          ["@media (max-width: ".concat(breakpoints[0], "px)")]: style
        };
      case 'small':
        return {
          ["@media (min-width: calc(".concat(breakpoints[0], "px + 1px)) and (max-width: ").concat(breakpoints[1], "px)")]: style
        };
      case 'medium':
        return {
          ["@media (min-width: calc(".concat(breakpoints[1], "px + 1px)) and (max-width: ").concat(breakpoints[2], "px)")]: style
        };
      case 'large':
        return {
          ["@media (min-width: calc(".concat(breakpoints[2], "px + 1px))")]: style
        };
      case 'smallAndDown':
        return {
          ["@media (max-width: ".concat(breakpoints[1], "px)")]: style
        };
      case 'mediumAndDown':
        return {
          ["@media (max-width: ".concat(breakpoints[2], "px)")]: style
        };
      case 'smallAndUp':
        return {
          ["@media (min-width: calc(".concat(breakpoints[1], "px + 1px))")]: style
        };
      case 'mediumAndUp':
        return {
          ["@media (min-width: calc(".concat(breakpoints[2], "px + 1px))")]: style
        };
      default:
        return style;
    }
  }
};

/**
 * Types for items in the navigation menu.
 */

/**
 * Types for specific links.
 */
const WWW_PROD = 'https://www.ownup.com';
const WWW_STAGING = 'https://www-ownup-staging.netlify.app';
const ONBOARDING_PROD = 'https://onboarding.ownup.com';
const ONBOARDING_STAGING = 'https://staging.onboarding.ownup.com';

const onboardingConverter = t$2.oneOf([ONBOARDING_PROD, ONBOARDING_STAGING]).or(() => ONBOARDING_PROD);
const wwwConverter = t$2.oneOf([WWW_PROD, WWW_STAGING]).or(() => WWW_PROD);

const getPrimaryLinks = _ref => {
  let {
    mainSite,
    www,
    page
  } = _ref;
  const baseUrl = mainSite ? '' : www;
  const external = !mainSite;
  const menuItems = [{
    name: 'About',
    link: "".concat(baseUrl, "/about/"),
    external
  }, {
    name: 'How It Works',
    link: "".concat(baseUrl, "/how-it-works"),
    external
  }, {
    name: 'Resources',
    content: [{
      name: 'Learning Center',
      link: "".concat(baseUrl, "/learn/")
    }, {
      name: 'Affordability Calculator',
      link: "".concat(baseUrl, "/calculators/affordability/")
    }, {
      name: 'Rate Range Finder',
      link: "".concat(baseUrl, "/rate-comparison/")
    }, {
      name: 'For Realtors',
      link: "".concat(baseUrl, "/real-estate/")
    }]
  }, {
    name: 'Reviews',
    link: "".concat(baseUrl, "/reviews/"),
    external
  }, {
    name: 'FAQ',
    link: "".concat(baseUrl, "/faq/"),
    external
  }];

  // If the page matches a default link, that link should instead be a fake anchor.
  menuItems.forEach(menuItem => {
    if (menuItem.content) {
      menuItem.content.forEach(contentItem => {
        if (page !== '/' && contentItem.link.includes(page || '')) {
          contentItem.link = '#';
        }
      });
    } else {
      if (page !== '/' && menuItem.link.includes(page || '')) {
        menuItem.link = '#';
      }
    }
  });
  return menuItems;
};

const getSecondaryLinks = _ref => {
  let {
    mainSite,
    newFooter,
    www
  } = _ref;
  const baseUrl = mainSite ? '' : www;
  const external = !mainSite;
  const links = [{
    name: 'Licensing',
    link: "".concat(baseUrl, "/licensing/"),
    external
  }, {
    name: 'Terms & Conditions',
    link: "".concat(baseUrl, "/terms-conditions/"),
    external
  }, {
    name: 'Privacy',
    link: "".concat(baseUrl, "/privacy/"),
    external
  }];
  if (!newFooter) {
    links.push({
      name: 'Jobs',
      link: 'https://apply.workable.com/own-up/',
      external: true
    });
  }
  // Adding in the array here to keep the Mortgage Rate Comparison page link at the end.
  links.push({
    name: 'Mortgage Rate Comparison',
    link: "".concat(baseUrl, "/rate-comparison/mortgage-rate-compare/"),
    external
  });
  return links;
};

const Icon = _ref => {
  let {
    icon
  } = _ref;
  return /*#__PURE__*/React__default.createElement(OwnUpIcon, {
    icon: icon,
    color: "white",
    style: {
      fontSize: '36px',
      marginTop: '-18px'
    }
  });
};
const getSocialLinks = _ref2 => {
  let {
    newFooter
  } = _ref2;
  return [{
    name: /*#__PURE__*/React__default.createElement(Icon, {
      icon: "Twitter"
    }),
    link: 'https://twitter.com/weareownup/',
    label: 'twitter',
    external: true
  }, {
    name: /*#__PURE__*/React__default.createElement(Icon, {
      icon: "Instagram"
    }),
    link: 'https://www.instagram.com/weareownup/',
    label: 'instagram',
    external: true
  }, {
    name: /*#__PURE__*/React__default.createElement(Icon, {
      icon: "FacebookLogoNoCircle"
    }),
    link: 'https://www.facebook.com/weareownup/',
    label: 'facebook',
    external: true
  }, ...(!newFooter ? [{
    name: /*#__PURE__*/React__default.createElement(Icon, {
      icon: "Pinterest"
    }),
    link: 'https://www.pinterest.com/weareownup/',
    label: 'pinterest',
    external: true
  }] : [])];
};

// Normalize link destination against whether or not we're on the main site.
const normalizeElement = function (element, www) {
  let isMainSite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return isMainSite ? element : {
    ...element,
    link: "".concat(element.link[0] === '/' ? www : '').concat(element.link)
  };
};

// Facilitate use of Gatsby's Link for relative links.
const composeLink = function (link, trackingInstance) {
  let onModal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const onClick = () => trackingInstance.track("Click ".concat(link.title), {
    'page-location': "navigation-".concat(onModal ? 'modal' : 'bar')
  });
  return link.link[0] === '/' ? {
    ...link,
    onClick,
    component: Link$1,
    to: link.link
  } : {
    ...link,
    onClick,
    href: link.link
  };
};

// for tests
const dummyTrackingEvent = {
  hook: {
    track: (event, properties) => console.log("Dummy tracking event: ".concat(event), properties)
  },
  name: 'test event',
  properties: {}
};

/**
 * Combine two tracking events
 * The `properties` property is treated specially: the two properties objects
 * are themselves (shallowly) merged, instead of allowing one to overwrite
 * the other completely
 *
 * @param eventDefaults - a tracking event; may contain a hook but it will be overridden
 * @param event - a tracking event; must contain at least a hook
 * @type MergeTrackingEvents
 */
const mergeTrackingEvents = (eventDefaults, event) => {
  const properties = {
    ...eventDefaults.properties,
    ...event.properties
  };
  return {
    ...eventDefaults,
    ...event,
    properties
  };
};

const links = [{
  link: '/licensing/',
  title: 'Licensing'
}, {
  link: '/terms-conditions/',
  title: 'Terms & Conditions'
}, {
  link: '/privacy/',
  title: 'Privacy'
}, {
  link: 'https://apply.workable.com/own-up/',
  title: 'Jobs'
}, {
  link: '/rate-comparison/mortgage-rates/',
  title: 'Compare Current Mortgage Rates'
}, {
  link: '/refinance/',
  title: 'Cash-Out Refinance Calculator'
}];
const social = [{
  platform: 'Twitter',
  icon: /*#__PURE__*/React__default.createElement(TwitterLogo, null)
}, {
  platform: 'Instagram',
  icon: /*#__PURE__*/React__default.createElement(InstagramLogo, null)
}, {
  platform: 'Facebook',
  icon: /*#__PURE__*/React__default.createElement(FacebookLogo, null)
}, {
  platform: 'Linkedin',
  icon: /*#__PURE__*/React__default.createElement(LinkedinLogo, null)
}];
const linkedinProfile = 'https://www.linkedin.com/company/own-up/';
const FooterLinks = _ref => {
  let {
    www,
    trackingInstance,
    isMainSite = false
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, links.map((link, index) => {
    const normalizedLink = normalizeElement(link, www, isMainSite);
    const props = composeLink(normalizedLink, trackingInstance);
    return /*#__PURE__*/React__default.createElement(OwnUpNavLink, _extends$1({
      size: "small"
    }, props, {
      key: index
    }), link.title);
  }));
};
const SocialLinks = _ref2 => {
  let {
    trackingInstance
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, social.map((_ref3, index) => {
    let {
      platform,
      icon
    } = _ref3;
    const props = {
      href: platform === 'Linkedin' ? linkedinProfile : "https://".concat(platform.toLowerCase(), ".com/weareownup/"),
      'aria-label': platform,
      onClick: () => {
        trackingInstance.track("Click ".concat(platform), {
          'page-location': 'footer'
        });
      }
    };
    return /*#__PURE__*/React__default.createElement(SocialButton, _extends$1({}, props, {
      key: index
    }), icon);
  }));
};

var _templateObject$Q;
const HeadlineAndLogo = _ref => {
  let {
    trackingInstance
  } = _ref;
  return /*#__PURE__*/React__default.createElement(LogosContainer, null, /*#__PURE__*/React__default.createElement(OwnUpContrastLogo, null), /*#__PURE__*/React__default.createElement(SocialButtonsContainer, null, /*#__PURE__*/React__default.createElement(SocialLinks, {
    trackingInstance: trackingInstance
  })));
};
const DetailLink = styled.a(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n  color: inherit;\n"])));
const LegalText = _ref2 => {
  let {
    legalText
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(FheoAndCopyrightContainer, null, /*#__PURE__*/React__default.createElement(OwnUpDetail, null, legalText));
};
const LinksAndLegal = _ref3 => {
  let {
    www,
    onboarding,
    trackingInstance,
    isMainSite = false,
    legalText,
    showCTA = true
  } = _ref3;
  const year = new Date().getFullYear();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showCTA && /*#__PURE__*/React__default.createElement(OwnUpLogoSmallScreenContainer, null, /*#__PURE__*/React__default.createElement(StickyContainer, null, /*#__PURE__*/React__default.createElement(GetStartedLink, {
    onboarding: onboarding,
    label: "Click discover CTA"
  }, /*#__PURE__*/React__default.createElement(GetStartedFloatButton, null, "Get started \xA0", /*#__PURE__*/React__default.createElement(ArrowRightIcon, null))))), /*#__PURE__*/React__default.createElement(LinksContainer, null, /*#__PURE__*/React__default.createElement(FooterLinks, {
    www: www,
    trackingInstance: trackingInstance,
    isMainSite: isMainSite
  })), /*#__PURE__*/React__default.createElement(Splitter, null), /*#__PURE__*/React__default.createElement(FheoAndCopyrightContainer, null, /*#__PURE__*/React__default.createElement(FHEOLogo, null), /*#__PURE__*/React__default.createElement(OwnUpDetail, null, "\xA9 RateGravity Inc. DBA Own Up. All rights reserved. 2012-", year, " ", /*#__PURE__*/React__default.createElement("br", null), "NMLS:\xA0#1450805\xA0\xB7", ' ', /*#__PURE__*/React__default.createElement(DetailLink, {
    href: "https://www.nmlsconsumeraccess.org/",
    target: "_blank"
  }, "NMLS\xA0Consumer\xA0Access"))), legalText && /*#__PURE__*/React__default.createElement(LegalText, {
    legalText: legalText
  }));
};

// StylesProvider needed to handle MUI style injection due to MUI Link
// https://v4.mui.com/guides/interoperability/\#style-library-interoperability
const Footer = _ref4 => {
  let {
    www,
    onboarding,
    trackingInstance,
    isMainSite = false,
    legalText,
    showCTA = true
  } = _ref4;
  return /*#__PURE__*/React__default.createElement(OwnUpThemeProvider, {
    theme: ownUpDarkTheme
  }, /*#__PURE__*/React__default.createElement(Section$2, {
    "aria-label": "footer"
  }, /*#__PURE__*/React__default.createElement(OwnUpGridWrapper, null, /*#__PURE__*/React__default.createElement(OwnUpGridContainer, {
    variant: "legacy"
  }, /*#__PURE__*/React__default.createElement(OwnUpGridItem, {
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React__default.createElement(HeadlineAndLogo, {
    trackingInstance: trackingInstance
  })), /*#__PURE__*/React__default.createElement(OwnUpGridItem, {
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React__default.createElement(LinksAndLegal, {
    www: www,
    onboarding: onboarding,
    isMainSite: isMainSite,
    trackingInstance: trackingInstance,
    legalText: legalText,
    showCTA: showCTA
  }))))));
};

var img$3 = "data:image/svg+xml,%3csvg viewBox='0 0 288 305' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect width='288' height='305' fill='url(%23pattern0)'/%3e%3cdefs%3e%3cpattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'%3e%3cuse xlink:href='%23image0' transform='scale(0.00347222 0.00327869)'/%3e%3c/pattern%3e%3cimage id='image0' xlink:href='data:image/png%3bbase64%2ciVBORw0KGgoAAAANSUhEUgAAASAAAAExCAYAAADcCX%2b%2bAAAZhUlEQVR4Xu2cUZLkRo5EpSv15cZ2DzBjc%2bpZK/WmpppNEg4EnEEynn4TgQAfHE5kVpv%2b/PHjx3/%2b4D8IQAACEwj8iQFNoM6VEIDAXwQwIIQAAQhMI4ABTUP/7Iv/8a9//vUA//6f/332g1D9VAIY0FT8z7v8YzzbyjGi5/XyDhVjQHfowkNqODKfT/mY0EMaeaMyMaAbNeOupUTGwzZ0187dvy4M6P49mlph1nzYhqa263GXY0CPa9k1BVeNh23omv685RYM6C2dbHyOLvNhG2psyktTYUAvbWzlsbqNh22o0oW1zmBAa/X78Gnd5sM2hND2CGBAi%2bviKuNhG1pcaAePjwEtrItZ5sM2tLDoNo%2bOAS2ohdnGwza0oOjYgGj6F4G7mQ/b0Nq6ZANapP93NR62oUUEyAa0bqOfYj5sQ%2btplA3oxT1/mvGwDb1YjGxAazX36ebDNrSGXtmAXtbntxgP29DLhMkG9P6GvtV82Ibeq102oBf09u3Gwzb0ApGyAb2ziauZD9vQu3TMBvTQfq5qPGxDDxUsG9B7Gof5/NpL/l/Uz9U2G9CDeofxHDcLE3qQkL%2bVigE9pG%2bYj9YojEjjdJcoDOgunTioA%2bPJNwgTyjObdQIDmkVeuBfzESCdhGBEY/yuOI0BXUE5eQfGkwSGCfUBuzgTBnQx8Og6zCciVPucbajGzX0KA3ITFvNjPCKogTBMaACe6SgGZAKbSYv5ZGiNx2JE4wy7MmBAXSQLeTCeArSmI5hQE8jBNBjQIMDqccynSq73HEbUyzObDQPKEhuMx3gGARqOY0IGqGJKDEgE1RGG%2bXRQ9OXAiHxsjzJjQBcwx3gugNx0BSbUBFJMgwGJoKphmE%2bV3NxzGNE1/DEgE2eMxwT2wrSYkB82BmRgjPkYoE5MiRH54GNAjWwxnkaYN0uFCXkaggE1ccV8mkDePA1G1NsgDGiQJ8YzCPCBxzGhvqZhQAMsMZ8BeC84ihGNNxEDKjDEeArQXnoEExprLAaU5If5JIEtEo4R1RqNAYncMB4R1MJhmFC%2b%2bRiQwAzzESAR8jcBjEgXAwZ0wgrj0YVE5K8EMCFNERjQASfMRxMQUecEMKJzPhjQhg/Gg6V0E8CEjoliQN/YYD766H2GCmZ5ZvqJ90diQH/88QdDlBP69o0OP50f29CvrJY3IIanb3hg2cdSz/TsyGUNiGHJCVd9c8NV56oy1TM%2bL3JJA2JIdKFWhwTGfsb6DfeNXMqAGIqcEKvm87kF3jrvUdb6TfeKXMaAGAZdeN3DAPt57PWb50S%2b3oAQf05Y3ebDNpTj/xXt6kG%2bEv%2bJVxsQ5qML6CrR05P79USvqD/ylQaEyHNCucp82IZyfVlhG3qdAWE%2bOZFfbT6YUK4/n%2bhZfapVq596jQFhPHrT7/RmpW96395oQq8wIESsi/hO5sM2lOvbG7ehRxsQxpMT8N3foPRT7%2bfde6k%2byWMNCLGqLf4Z9xTB0td39vXoqR5nQAh0DYHSZ73PT3m57D3RowwIUeqifNLWc/RU9Pv9/X6EASHE9wvx7Anpv97/p21DtzcgxKeL7w1bD9tQrt9H0U8xotsaEMaTE%2bJTBJd7qt%2bj0YVO8AmauKUBITJdZG/eetiGcjrYi767Cd3KgDCenODuLq7c0%2bSj0YvO7K5auY0BISZdTCtuPWxDOX08ZRuabkAYT05Yd32T5Z6iPxod6UzvpKGpBoRodNGw9cSs0FPM6BNxFxOaYkAIRRcKxpNj9RWNvnRms43ocgNCHLo4MJ8cq%2b/R6ExnN9OELjMgBKELAuPJsTqLRnc6yxlGdIkBIQJdBJhPjpUSjf4USj9jrjYhqwHReL3xM5qfq%2b750ehR7%2bFVRmQzIJqtNxvzybEaiUaXOr0rTKjdgGiw3uBP5BWNzlf13hNoNNdbpz5bDYjG3qexuUrWjEavet9dJtRiQDRSbyRbT56V8wTazdHtNqJhA6KBcxuYu53oIwLoWNdGpwmVDYiG6Q1j68mzmnECTeeodxhRyYBo1PWNyt1I9AgB9K3TGzWhlAHRGL0xbD15Vnc6gdZz3agakWxANOSahuRuIdpNAN3rhCsmFBoQDdAbwNaTZ/WEE8xArksZIzo1IMD7wOcyE30HAsyD3gXVhHYNCNA6aLaePKsnn2A2ct2LjOg3AwJwL%2bBcNqKfQoA50Tt1ZkJ/GxBAdaBsPXlWbzzBzOS6umdEfxkQIMdB5jIQ/SYCzI/eza0JYUA6u78io%2b%2b0yXSEv4QAJqQ1EgPSOP0WhfEUwS12DCM6bzgGVBgIzKcAbeEjmNBx8zGgxGBgPAlYhP5GACP6XRQYkDgomI8IirBTApjQr3gwoGBgMB4cxUEAI/pJFQM6URfm4xg9cn4IYEIY0OE0XG0%2biPEexkTfr%2b0DG9CG99UC5G14reCj2%2bh/RKj3cwzoG89Z4vsqgQ2oV9jVbGigSq52DgO6yb9mxoBqAu4%2bNdOAVtyGlzegOwiODajbRur50EOdXeXksgZ0F6Gt%2bNarCPWqM%2bjiKtI/71nSgO4mMjaga0V/dhvauLYXSxnQHcXFBnSt4KPb0EhEqPfzZQzozsJiA%2boV9Ug2dDJCL3/29QZ0d0GxAeVF6zyBXpx0f8/9agN6ipjYgK4V/dN%2bAzqq9w3/dAMDuon23yCmm6AcKoOX1hC%2b9GEMKI3McwAD8nDNZsWAssTG4jGgMX5tpzGgNpRDiTCgIXzpwxhQGpnnAAbk4ZrNigFliY3FY0Bj/NpOY0BtKIcSYUBD%2bNKHMaA0Ms8BDMjDNZsVA8oSG4vHgMb4tZ3GgNpQDiXCgIbwpQ9jQGlkngMYkIdrNisGlCU2Fo8BjfFrO40BtaEcSoQBDeFLH8aA0sg8BzAgD9dsVgwoS2wsHgMa49d2GgNqQzmUCAMawpc%2bjAGlkXkOYEAertmsGFCW2Fg8BjTGr%2b00BtSGcigRBjSEL30YA0oj8xzAgDxcs1kxoCyxsXgMaIxf22kMqA3lUCIMaAhf%2bjAGlEbmOYABebhms2JAWWJj8RjQGL%2b20xhQG8qhRBjQEL70YQwojcxzAAPycM1mxYCyxMbiMaAxfm2nMaA2lEOJMKAhfOnDGFAamecABuThms2KAWWJjcXvGtBYyl9PzxwsxNTZyTVyoRmtzy5Of/748eM/WglaFAZ0f05ahWtEuQbLQe%2bNs4UBOZQi5JwpJqG8ZUIwIK3VLk4YkMa/PQoDakdaSugarFIxwaGZmnFxwoAcShFyzhSTUN4yIa7BcgCcqRkXJwzIoRQh50wxCeUtE%2bIaLAfAmZpxccKAHEoRcs4Uk1DeMiGuwXIAnKkZFycMyKEUIedMMQnlLRPiGiwHwJmacXHCgBxKEXLOFJNQ3jIhrsFyAJypGRcnDMihFHJCwEAAAxKgvhGS8NiEQMBO4I2zxQZklw0XQKCHAAYkcHwjJOGxCYGAncAbZ4sNyC4bLoBADwEMSOD4RkjCYxMCATuBN84WG5BdNlxwRwKfYXb9ednxzBiQQPWNkITHTofM5JQu9sUHMCCtuS5ObEAa//YoDKgdaSmha7BKxQSHZmrGxQkDcihFyDlTTEJ5y4S4BssBcKZmXJwwIIdShJwzxSSUt0yIa7AcAGdqxsUJA3IoRcg5U0xCecuEuAbLAXCmZlycMCCHUoScM8UklLdMiGuwHABnasbFCQNyKEXIOVNMQnnLhLgGywFwpmZcnDAgh1KEnDPFJJS3TIhrsBwAZ2rGxQkDcihFyDlTTEJ5y4S4BssBcKZmXJwwIIdShJwzxSSUt0yIa7AcAGdqxsUJA3IoRcg5U0xCecuEuAbLAXCmZlycMCCHUoScM8UklLdMiGuwHABnasbFCQNyKEXIOVNMQnnLhLgGywFwpmZcnDAgh1KEnDPFJJS3TIhrsBwAZ2rGxQkDcihFyDlTTEJ5y4S4BssBcKZmXJwwIIdShJwzxSSUt0yIa7AcAGdqxsUJA3IoRcg5U0xCecuEuAbLAXCmZlycMCCHUoScM8UklLdMiGuwHABnasbFCQNyKEXIOVNMQnnLhLgGywFwpmZcnDAgh1KEnDPFJJS3TIhrsBwAZ2rGxQkDcihFyDlTTEJ5y4S4BssBcKZmXJwwIIdShJwzxSSUt0yIa7AcAGdqxsUJA3IoRcg5U0xCecuEuAbLAXCmZlycMCCHUoScM8UklLdMiGuwHABnasbFCQNyKEXIOVNMQnnLhLgGywFwpmZcnDAgh1KEnDPFJJS3TIhrsBwAZ2rGxQkDcihFyDlTTEJ5y4S4BssBcKZmXJwwIIdShJwzxSSUt0yIa7AcAGdqxsUJA3IoRcg5U0xCecuEuAbLAXCmZlycMCCHUoScM8UklLdMiGuwHABnasbFCQNyKEXIOVNMQnnLhLgGywFwpmZcnDAgh1KEnDPFJJS3TIhrsBwAZ2rGxQkDcihFyDlTTEJ5y4S4BssBcKZmXJwwIIdShJwzxSSUt0yIa7AcAGdqxsUJA3IoRcg5U0xCecuEuAbLAXCmZlycMCCHUoScM8UklLdMiGuwHABnasbFCQNyKEXIOVNMQnnLhLgGywFwpmZcnDAgh1KEnDPFJJS3TIhrsBwAZ2rGxQkDcihFyDlTTEJ5y4S4BssBcKZmXJwwIIdShJwzxSSUt0yIa7AcAGdqxsUJA3IohZwQMBDAgASob4QkPDYhELATeONssQHZZcMFEOghgAEJHN8ISXhsQiBgJ/DG2WIDssuGCyDQQwADEji%2bEZLw2IRAwE7gjbPFBmSXDRdAoIcABiRwfCMk4bEJgYCdwBtniw3ILhsugEAPAQxI4PhGSMJjEwIBO4E3zhYbkF02XACBHgIYkMDxjZCExyYEAnYCb5wtNiC7bLgAAj0EMCCB4xshCY9NCATsBN44W2xAdtlwAQR6CGBAAsc3QhIemxAI2Am8cbbYgOyy4QII9BDAgASOMyEJ5RECAQgUCPB/RCxA4wgEINBDAAPq4UgWCECgQAADKkDjCAQg0EMAA%2brhSBYIQKBAAAMqQOMIBCDQQwAD6uFIFghAoEAAAypA4wgEINBDAAPq4UgWCECgQAADKkDjCAQg0EMAA%2brhSBYIQKBAAAMqQOMIBCDQQwAD6uFIFghAoEAAAypA4wgEINBDAAPq4UgWCECgQAADKkDjCAQg0EMAA%2brhSBYIQKBAAAMqQOMIBCDQQwAD6uFIFghAoEAAAypA4wgEINBDAAPq4UgWCECgQAADKkDjCAQg0EMAA%2brhSBYIQKBAAAMqQOMIBCDQQwAD6uFIFghAoEAAAypA4wgEINBDAAPq4UgWCECgQAADKkDjCAQg0EMAA%2brhSBYIQKBAAAMqQOMIBCDQQwAD6uFIFghAoEAAAypA4wgEINBDAAPq4UgWCECgQAADKkDjCAQg0EMAA%2brhSBYIQKBAAAMqQOMIBCDQQwAD6uFIFghAoEAAAypA4wgEINBDAAPq4UgWCECgQOAxBlR4No5AAAKLEvjzx48f/1n02XlsCEBgMgEMaHIDuB4CKxPAgFbuPs8OgckEMKDJDeB6CKxMAANaufs8OwQmE7Ab0D/%2b9c/yI2b%2b9Ld3T/W8%2b9z3Wt13ZeF/anPXdaYL991fTDI9iDQc1RvdFX1%2b1MNKr7bPvs0dPUtWT1H8ow0oEsb3h4/Ajorg667ojk89V94VCWD7eUXUmefp7FnWSL4/q1JzV63RXdt7sjrKxiuaUHMquc5iLjOg7gc6EsfnnuxGFIkkegupBpStKzs0o4KYZUB365tiCkqMYpJqnurLImOkmZf2qNa%2bzj/SgDINU2MxoJ9ychpQhvHsvqm1KnFRTPWlpPQqkzsT22E%2bjzSgqJnVTcWV92iDqXz3rtaYEYsi6qM38dkWWKldMaFK3mgryeaM4jOfZzYQpVfR3XvaqJzJaOx77KM2oFEwZw2r5s6c24tVRPRpWOauqiAy9WTqquSNjEL5vPJCqnAe0db2PpVVFFd5ji1T9aeFqt4woP8n19Gs6HeuMwNSGl2tMSOOSNSVN%2bZo3SPDfZUBnTGOnv/IgCJNRL2KPh%2bpOaOps9glDWivsZFIKkI%2b%2b/q196NrxcC6hLDdZqJajp5t71yVrbJhVXOfnfv%2bWWQCCv%2boxuqLyWHMyvN0xmBAF21ARyKMxJkZ9A5hVN6a7mFW87tMc9SEoh5XtYEBCYrfvk2EI3%2bFvOFNqppHJFBlE1C5RnHVfn3ybvvWsU3MMKCv5zlikTG6bZ6MriNdYECRmk%2baGB09E3JWAHtG0JU/EsmIALeMlLsirtHnTgOq9m2WAZ2Z0HeO0XNFfas%2bn2JAmdqOtBHliDR19vljvoJFTVQhHDWtml85d2WMyuEozvkVrCrk6oCesVB6snf%2bzKCPni%2b6q/o5BiSovSLozuE42iKu2oAqG0VVyEI7wpBKvxwG0f311bVNKl8xqwYTffVWDOgrx5nxK/qsvjhCsT3tX0JHjYwe2DEoUU1Kg/fqzvxWED135nMMKEPrZ2xkQhmNZF4%2bHQYUvewjA8vT%2bvXEY76CbRtdcWXVgDLQM%2bLKNAsD%2bi8ttW%2bqJrrzRdrMaEQxoI8%2bMSBhoipvVJcrq8LrMqBIeNmvBdl8Qnt%2bC6n0K6or%2bjyqU%2b1bhwF9NxM13xUGtHdH1Kvo8zPuoz2Levr5/JUb0B74aE2ORFQxxUoTu4dNFcInriLa6Dmjz0cHIVtzVE/0%2bV69I33L3LfV8dnLMpM3%2bzLM6uoo/lEGpJjEXoO2D6%2bsucrbL2pwdjCi54vu6xBFd81bY%2bvaLr8/a4bLHV9EI/VHPDO5q0xHdHeZAVWKVIxCfQN87o%2bMJdOwkbde5a2vmKtqttFGF3GqiFUZ/q0JRwOWNTilhuqWcVRrpKno87PtJOKjPO9RL9WZqcz258wjDWhPpAoEZai6hjwrKmWgu2pTzE9hlR3%2bSt/UOrrZVPJdZUDRprzX387nUWZNjXmsAVXEnHF0pWHKhqYO0Nlb7pNDqenOG9CeYZ0JNctO5aPmVfNFuopeRtHnkaFc/TyquShxdgNSirgqJruOXlUX90BgVQJLGVBldV1VGDw3BK4gsJwBXQGVOyAAAY0ABqRxIgoCEDAQwIAMUEkJAQhoBKYYUPTXBfVX/exfVb4jUe%2bIat3DrOY%2balF0ZyV/lPOoFuWuam6FXeUvRN/zRuc7/jAR3RH99tjJT2GqWcPPqA4%2bZ/ddakAV0FcNgPIn9UzjPrFK/Xc1UlXMlb6qhqcM91lfovOZf3SovDAUHW1jOvl91fiVv8M4OnJEM3OZAY1AjoZ4JHe0FTlzb5szctdVjD4CP9oyIsFFn58NZ/SMe7kxoJ9URtlVc0T9vsSAMm%2bZoyE8A1hxarUmZ%2b5oiPee%2bcykVEaqGCu9qJjAyAYTCbxiQNlhi%2b7YfpVR%2be9txpmzFe0ebeOZe6OefP98igEpD6MaxLa53eLpaqJqDmr9GT6dA6DWd2SuSu%2b7zirPXTX0bI2KSR0NbtdZtXcjms%2bYz1es3YBGH0aB33WHsnFUB0j5bUAVyNnmpNyTfQZlkF1bjNL/kbvfbkDZF/ToLN3KgEbFo66go9DO6nTmHh1slU/HPSMcRnQwclZ57r3nyt6pxCsxjg1oWQMaEey2EVHzRu%2baZUCjdWNA8fu2op1sX6I7FCMc2eJiCtqf07PPrdwbxdi%2bgnU/zFNNQq278rUo8zuEMiTqEGS/Ko7cPXJWGfwjnWbuVWKVGNcGtPei2uvhSI2R0Rx9jgFt/rFV9G80MkZxZsJXGrQyiJGARsQ566zy3GqP1D8iOH6DG%2bF39JLaGlC3HiM9fT6/xIAyQ1t5C4zAi85Gnyv1fmK%2bc6jmVe6LfkzP9GNbZ3b7UUxA3bwydatfT1UDOntuxSCUmGpv1WHf9uL7M43Ul7l/G7usAamDVTEKJXclrzqo0Xo9IhiHCajP5bg76kP0uWqwIwM%2bcnaP7TZfd/6Mvl5pQBkAe9vJ2dralVsRduauKN%2beKWbyVzYfdQu5swEpBqMMsBJzxQa015NoBrI6ycQvb0DRW3VkcNXfDUaG%2b0hQ0W9ZikgiNkoOZYCfZEDRdnnn34CiF2tXv1VdfMW90oA6QUabRQb2mQBGa47qVN/AUZ7K86p3K18XsvdHd6vPq/5W9BQDGn0xZPtwFH%2bJAXW/4aO3%2b%2bgwO43iKPdozZlBi%2b5Sh1IVYVTb3Teg6Kuk8nxKzJVfwTAgVb3C/5Oke2BWN6CtOEdfIDOHL7o7q529fNEdo8Ou5E%2bM09%2bhrryZWh6xAUUiiT7PANnGXpU72kqiZ4jEFH0eff0ZMaHK3XtbR6WG6O5sf/fiozswoGP12gxoFHrmq0pWRNEwX7UBdTFyDUAXV6U%2b5evHHQxor2fK8ykxCoPRF1VmrjJzUo29zIAq4lG/CnQNinMLcIpLEbcS43r%2b6t17W1BmAJV7q9rZnvvUyo/QOSuyGtDoG14VhxqXQ/Mz2pl7dMAyfJVhdJnkyN3VHqh9U%2bO2bDCgyjT9fsZuQF0COtugqiJSEDpz7xlQ9CY9WqGjDXPEBEYZjNx9xCjzb6xc2tkzITYgZar%2bG3OJAe2ZUK7M8/%2bn7eiAnNXizK2%2bVRVW0VeTURMY4TB696h%2bMmYVcYx6hgEpap1gQBURqWIYGY4IlzP33t1Hq/1RnRVG6pnqsJ2dq95d0U%2b0FVa388oWOmLCI2fVl%2btIX6IZOvv8sg3orGl7BWaAOE3CmVsVxyif7aBl2FaGbUSQ0dmMQVefM6rhLZ%2b7jC3D5/8AM8tBtmBxXUIAAAAASUVORK5CYII='/%3e%3c/defs%3e%3c/svg%3e";

/**
 * Generates internal and external links, given a styling object.
 */
const getStyledNavLinks = style => [createOwnUpComponent('a', style), createOwnUpComponent(Link$1, style)];
/**
 * Returns an internal or external link.
 *
 * @remarks The `styledNavLinks` param ideally takes the tuple object
 * returned by `getStyledNavLinks`. Flexible generation of the
 * internal and external links was decoupled from this function component.
 * This eliminates redundant computation.
 */
const StyledNavLink = _ref => {
  let {
    styledNavLinks,
    variant,
    children,
    external,
    label,
    link,
    keyValue,
    ...props
  } = _ref;
  const ExternalLink = styledNavLinks[0]; // anchor element
  const InternalLink = styledNavLinks[1]; // Gatsby Link element

  return external ? /*#__PURE__*/React__default.createElement(ExternalLink, {
    href: link,
    key: keyValue,
    variant,
    props,
    "aria-label": label
  }, children) : /*#__PURE__*/React__default.createElement(InternalLink, {
    to: link,
    key: keyValue,
    variant,
    props,
    "aria-label": label
  }, children);
};

var _templateObject$P, _templateObject2$u, _templateObject3$m;
const PageTitleStyle = createOwnUpStyle({
  fontSize: '54px',
  marginBottom: '45px',
  variants: {
    medium: {
      fontSize: '40px'
    },
    small: {
      fontSize: '40px'
    },
    xsmall: {
      fontSize: '36px'
    }
  }
});
const PageTitle = createOwnUpComponent(OwnUpHeader, PageTitleStyle);
const SectionHeaderStyle = createOwnUpStyle({
  fontFamily: "'TiemposHeadline-Medium', 'Palatino', 'Times New Roman', 'serif'",
  fontSize: '52px',
  letterSpacing: '2px',
  lineHeight: '1.275em',
  variants: {
    medium: {
      fontSize: '40px'
    },
    small: {
      fontSize: '40px'
    },
    xsmall: {
      fontSize: '36px'
    }
  }
});
const SectionHeader = createOwnUpComponent(OwnUpHeader, SectionHeaderStyle);
const AltSectionHeaderStyle = createOwnUpStyle({
  fontFamily: "'TiemposHeadline-Medium', 'Palatino', 'Times New Roman', 'serif'",
  fontSize: '40px',
  letterSpacing: '2px',
  lineHeight: '1.3em',
  variants: {
    mediumAndDown: {
      fontSize: '26px'
    }
  }
});
const AltSectionHeader = createOwnUpComponent(OwnUpHeader, AltSectionHeaderStyle);
const ResponsiveSectionHeaderStyle = createOwnUpStyle({
  ...SectionHeaderStyle,
  variants: {
    medium: {
      fontSize: '40px',
      textAlign: 'center'
    },
    small: {
      fontSize: '40px',
      textAlign: 'center'
    },
    xsmall: {
      fontSize: '32px',
      textAlign: 'center'
    }
  }
});
const ResponsiveSectionHeader = createOwnUpComponent(OwnUpHeader, ResponsiveSectionHeaderStyle);
const PrimaryTextStyle = createOwnUpStyle({
  ...fonts.GRAPHIK_REGULAR,
  display: 'block',
  fontFamily: "'Graphik-Regular', 'Arial', 'sans-serif'",
  fontSize: '19px',
  fontWeight: 100,
  lineHeight: '1.6em'
});
const PrimaryText = createOwnUpComponent(OwnUpText, PrimaryTextStyle);
const BoldPrimaryTextStyle = createOwnUpStyle({
  ...PrimaryTextStyle,
  ...fonts.GRAPHIK_SEMIBOLD
});
const BoldPrimaryText = createOwnUpComponent(OwnUpText, BoldPrimaryTextStyle);
const ResponsivePrimaryTextStyle = createOwnUpStyle({
  ...PrimaryTextStyle,
  variants: {
    mediumAndDown: {
      textAlign: 'center'
    }
  }
});
const ResponsivePrimaryText = createOwnUpComponent(OwnUpText, ResponsivePrimaryTextStyle);
const CatchphraseBaseStyle = css$1(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  font-family: 'TiemposHeadline-Medium';\n  font-style: normal;\n  font-stretch: normal;\n  color: ", ";\n  font-weight: 500;\n  font-size: 21px;\n  line-height: 1.3em;\n  text-align: center;\n"])), colors.PRIMARY);
const Catchphrase = styled(OwnUpText)(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), CatchphraseBaseStyle, buildMediaQueries('mediumAndDown', {
  fontSize: '26px'
}));
const ResponsiveCatchphrase = styled(OwnUpText)(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), CatchphraseBaseStyle, buildMediaQueries('mediumAndDown', {
  display: 'block'
}));
const HighlightStyle = createOwnUpStyle({
  color: 'unset',
  // Enable inheritance from parent.
  backgroundColor: colors.MINT
});
const Highlight = createOwnUpComponent('mark', HighlightStyle);
const HighlightAltStyle = createOwnUpStyle({
  color: 'unset',
  // Enable inheritance from parent.
  backgroundColor: colors.MINT_1
});
const HighlightAlt = createOwnUpComponent('mark', HighlightAltStyle);
const ErrorTextStyle = createOwnUpStyle({
  color: 'red',
  padding: '0 10px',
  display: 'block',
  variants: {
    smallAndDown: {
      paddingBottom: '20px'
    }
  }
});
const ErrorText = createOwnUpComponent(OwnUpText, ErrorTextStyle);
const LightHeaderStyle = createOwnUpStyle({
  fontSize: '16px',
  ...fonts.GRAPHIK_MEDIUM,
  fontFamily: "'Graphik-Medium', 'Arial', 'sans-serif'",
  color: colors.GREY_2,
  variants: {
    footer: {
      fontSize: '13px',
      lineHeight: '146.1%',
      fontWeight: 500,
      textTransform: 'uppercase',
      letterSpacing: '3px',
      color: colors.PRIMARY_DISABLED,
      variants: {
        mediumAndDown: {
          letterSpacing: '0.1em',
          fontSize: '14px',
          fontWeight: 600
        }
      }
    }
  }
});
const LightHeader = createOwnUpComponent(OwnUpHeader, LightHeaderStyle);

const UnderlinedLinkStyle = _ref => {
  let {
    color
  } = _ref;
  return createOwnUpStyle({
    ...fonts.GRAPHIK_MEDIUM,
    cursor: 'pointer',
    position: 'relative',
    width: '100%',
    height: 'auto',
    fontFamily: "'Graphik-Medium', 'Arial', 'sans-serif'",
    color,
    backgroundImage: "linear-gradient(".concat(color, ", ").concat(color, ")"),
    textDecoration: 'none',
    backgroundPosition: '0% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '0% 2px',
    transition: 'background-size 0.3s ease-in-out',
    ':hover, :focus': {
      backgroundSize: '100% 2px'
    }
  });
};

// takes a color prop for the text and underline
const UnderlinedLink = createOwnUpComponent('a', UnderlinedLinkStyle);

// takes a color prop for the text and underline
// Styled version of Gatsby's Link API
const UnderlinedLinkInternal = createOwnUpComponent(Link$1, UnderlinedLinkStyle);

const SubheadingStyle = createOwnUpStyle({
  fontSize: '36px',
  lineHeight: '50px',
  fontFamily: "'TiemposHeadline-regular', 'Palatino', 'Times New Roman', 'serif'",
  letterSpacing: '.5px',
  marginBottom: 'unset',
  variants: {
    mediumAndDown: {
      fontSize: '32px',
      lineHeight: '40px'
    }
  }
});
const SubheadingText = createOwnUpComponent(OwnUpHeader, SubheadingStyle);

// h2, smaller than h1, serif
const Subheading = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(SubheadingText, {
    level: 2
  }, children);
};
const SubheadingSansStyle = createOwnUpStyle({
  fontSize: '20px',
  ...fonts.GRAPHIK_MEDIUM,
  lineHeight: '28px',
  letterSpacing: '.005em',
  marginBottom: 'unset',
  textAlign: 'center',
  variants: {
    smallAndDown: {
      fontSize: '18px',
      lineHeight: '24px'
    }
  }
});
const SubheadingSansText = createOwnUpComponent(OwnUpHeader, SubheadingSansStyle);

// h3, smallest header, sanf serif
const SubheadingSans = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(SubheadingSansText, {
    level: 3
  }, children);
};
const ParagraphStyle = createOwnUpStyle({
  fontSize: '16px',
  ...fonts.GRAPHIK_REGULAR,
  lineHeight: '24px',
  letterSpacing: '.002em',
  color: colors.NIMBUS_2
});
const ParagraphText = createOwnUpComponent(OwnUpText, ParagraphStyle);
const ParagraphTwoStyle = createOwnUpStyle({
  ...ParagraphStyle,
  fontSize: '18px',
  color: colors.PRIMARY,
  variants: {
    mediumAndDown: {
      fontSize: '16px'
    }
  }
});
const ParagraphTwoText = createOwnUpComponent(OwnUpText, ParagraphTwoStyle);

var _templateObject$O, _templateObject2$t, _templateObject3$l, _templateObject4$7, _templateObject5$4;
const FooterWrapper = styled('footer')(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: ", ";\n  ", "\n  ", "\n"])), colors.GREY_FOOTER, buildMediaQueries('large', {
  height: '300px'
}), buildMediaQueries('mediumAndDown', {
  paddingBottom: '20px',
  flexDirection: 'column'
}));
const PanelWrapper = styled(OwnUpBox)(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n  display: flex;\n  align-self: center;\n  box-sizing: border-box;\n  height: 100%;\n  width: 34vw;\n  ", "\n  ", "\n"])), buildMediaQueries('large', {
  flexDirection: 'column',
  padding: '70px'
}), buildMediaQueries('mediumAndDown', {
  width: '100%',
  padding: '45px 40px 0px'
}));
const PanelContentWrapper = styled(OwnUpBox)(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n  align-self: center;\n  display: block;\n"])));
const NavLinksWrapperSocial = styled(OwnUpBox)(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n  display: inline;\n  font-size: 36px;\n  align-items: stretch;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
const NavLinksWrapperFooter = styled(OwnUpBox)(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  margin-bottom: 17px;\n"])));
const NavLinksStyle$1 = createOwnUpStyle({
  ...fonts.GRAPHIK_REGULAR,
  fontFamily: "'Graphik-Regular', 'Arial', 'sans-serif'",
  textDecoration: 'none',
  marginBottom: '5px',
  marginRight: '30px',
  fontSize: '17px',
  lineHeight: '24.84px',
  fontWeight: 400,
  textAlign: 'left',
  whiteSpace: 'nowrap',
  color: colors.WHITE,
  transition: '0.7s',
  '& svg': {
    fontSize: '36px'
  },
  ':hover': {
    color: colors.LOGO_BACKDROP
  },
  variants: {
    mediumAndDown: {
      marginRight: '25px',
      marginBottom: '15px',
      marginLeft: 0,
      fontSize: '15px',
      lineHeight: '21.91px'
    },
    small: {
      whiteSpace: 'normal'
    }
  }
});
const StyledNavLinks$1 = getStyledNavLinks(NavLinksStyle$1);

const CenterPanel = _ref => {
  let {
    secondary
  } = _ref;
  return /*#__PURE__*/React__default.createElement(PanelWrapper, null, /*#__PURE__*/React__default.createElement(PanelContentWrapper, null, /*#__PURE__*/React__default.createElement(LightHeader, {
    variant: "footer"
  }, "Legal"), /*#__PURE__*/React__default.createElement(NavLinksWrapperFooter, null, secondary.map((_ref2, i) => {
    let {
      name,
      ...props
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(StyledNavLink, _extends$1({}, props, {
      styledNavLinks: StyledNavLinks$1,
      keyValue: i,
      key: i
    }), name);
  })), /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.hud.gov/program_offices/fair_housing_equal_opp",
    "aria-label": "Equal Housing Opportunity"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "equal-housing-opportunity-svg",
    src: img$3,
    alt: "Equal Housing Opportunity Logo",
    height: 35
  }))));
};

const TaglineStyle = createOwnUpStyle({
  marginBottom: '20px',
  fontSize: '24px',
  lineHeight: '139.6%',
  ...fonts.GRAPHIK_MEDIUM,
  fontFamily: "'Graphik-Medium', 'Arial', 'sans-serif'",
  fontWeight: 500,
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: colors.WHITE,
  variants: {
    mediumAndDown: {
      marginBottom: '10px',
      fontSize: '20px'
    },
    xsmall: {
      whiteSpace: 'normal'
    }
  }
});
const ContactInfoStyle = createOwnUpStyle({
  paddingBottom: '5px',
  fontSize: '17px',
  ...fonts.GRAPHIK_REGULAR,
  fontFamily: "'Graphik-Regular', 'Arial', 'sans-serif'",
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: colors.WHITE,
  variants: {
    mediumAndDown: {
      paddingRight: 0,
      fontSize: '15px'
    },
    xsmall: {
      whiteSpace: 'normal'
    }
  }
});
const TagLine = createOwnUpComponent('div', TaglineStyle);
const ContactInfo = createOwnUpComponent('div', ContactInfoStyle);
const ContactUsText = () => /*#__PURE__*/React__default.createElement(TagLine, null, "Questions? Let's talk.");
const LeftPanel = () => /*#__PURE__*/React__default.createElement(PanelWrapper, null, /*#__PURE__*/React__default.createElement(PanelContentWrapper, null, /*#__PURE__*/React__default.createElement(LightHeader, {
  variant: "footer"
}, "Contact"), /*#__PURE__*/React__default.createElement(ContactUsText, null), /*#__PURE__*/React__default.createElement(ContactInfo, null, "hello@ownup.com"), /*#__PURE__*/React__default.createElement(ContactInfo, null, "(844) 947-2848")));

const RightPanel = _ref => {
  let {
    social
  } = _ref;
  return /*#__PURE__*/React__default.createElement(PanelWrapper, null, /*#__PURE__*/React__default.createElement(PanelContentWrapper, null, /*#__PURE__*/React__default.createElement(LightHeader, {
    variant: "footer"
  }, "Follow Us"), /*#__PURE__*/React__default.createElement(NavLinksWrapperSocial, null, social.map((_ref2, i) => {
    let {
      name,
      ...props
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(StyledNavLink, _extends$1({}, props, {
      styledNavLinks: StyledNavLinks$1,
      keyValue: i,
      key: i
    }), name);
  }))));
};

const LandingFooter = _ref => {
  let {
    mainSite,
    www
  } = _ref;
  const secondary = getSecondaryLinks({
    mainSite,
    newFooter: true,
    www
  });
  const social = getSocialLinks({
    newFooter: true
  });
  return /*#__PURE__*/React__default.createElement(FooterWrapper, null, /*#__PURE__*/React__default.createElement(LeftPanel, null), /*#__PURE__*/React__default.createElement(CenterPanel, {
    secondary: secondary
  }), /*#__PURE__*/React__default.createElement(RightPanel, {
    social: social
  }));
};

// Some footer components are being used in other projects.
const FooterLandingExternalNavLink = StyledNavLinks$1[0];
const FooterLandingInternalNavLink = StyledNavLinks$1[1];

const FieldStyle = createOwnUpStyle({
  width: '100vw'
});
const Field = createOwnUpComponent(OwnUpBox, FieldStyle);

/**
 *
 * @param backgroundColor sets background color for the entire field
 *
 * @param desktopMaxWidth sets width of the field
 *
 * @param mobileLateralGutter sets margins for mobile screens
 *
 * @param allowMarginZero overrides declared margins with 0
 */
const FullWidthField = _ref => {
  let {
    backgroundColor,
    desktopMaxWidth,
    mobileLateralGutter,
    allowMarginZero,
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Field, {
    style: {
      backgroundColor,
      margin: allowMarginZero ? 0 : "0 min(calc((".concat(desktopMaxWidth, "px - 100vw) / 2), -").concat(mobileLateralGutter, "px)")
    }
  }, children);
};

/**
 * Sometimes there is a mismatch in the server-side
 * rendering and the expectation from React after rehydration.
 * (ex: when using portals)
 *
 * In these cases, it is possible to defer rendering
 * of the component causing the mismatch. Please note that
 * this will eliminate the benefit of pre-rendering
 * for dynamic content, so this wrapper should be used judiciously.
 */
const DeferRender = _ref => {
  let {
    children
  } = _ref;
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Fragment$3, null, children);
};

var _templateObject$N, _templateObject2$s, _templateObject3$k;
const NavBarWrapperBaseStyle = css$1(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: auto;\n"])), colors.PRIMARY);
const NavBarWrapperLarge = styled('nav')(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  ", "\n  max-width: 96%;\n  height: 180px;\n"])), NavBarWrapperBaseStyle);
const NavBarWrapperSmall = styled('nav')(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n  ", "\n  height: 64px;\n  padding: 16px;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: ", ";\n  width: 100%;\n  box-sizing: border-box;\n  border-bottom: 1px solid ", ";\n"])), NavBarWrapperBaseStyle, zIndex$1.AppHeader, colors.GREY);
const NavLinksWrapperStyle = createOwnUpStyle({
  display: 'flex',
  alignItems: 'center',
  variants: {
    horizontal: {
      width: '850px',
      justifyContent: 'space-between'
    },
    vertical: {
      flexDirection: 'column',
      margin: 'auto',
      alignSelf: 'center'
    }
  }
});
const NavLinksWrapper = createOwnUpComponent(OwnUpBox, NavLinksWrapperStyle);

/** Style for NavLink when it has been interacted with
 *  (e.g., it's in focus, or the mouse is hovering over it,
 *  or it's a button for a menu, and the menu is open).
 */
const ActiveLinkStyle = {
  color: colors.LOGO_BACKDROP,
  '& svg > path': {
    transition: 'fill 0.7s',
    fill: colors.LOGO_BACKDROP
  }
};
const NavLinksStyle = createOwnUpStyle({
  ...fonts.GRAPHIK_MEDIUM,
  fontFamily: "'Graphik-Medium', 'Arial', 'sans-serif'",
  textDecoration: 'none',
  textAlign: 'center',
  variants: {
    main: {
      color: colors.PRIMARY,
      fontSize: '17px',
      transition: '0.7s',
      '& svg > path': {
        transition: 'fill 0.7s',
        fill: colors.PRIMARY
      },
      ':hover, :focus': ActiveLinkStyle,
      variants: {
        open: ActiveLinkStyle
      }
    },
    currentPage: {
      ...ActiveLinkStyle,
      lineHeight: 1.5,
      backgroundImage: "linear-gradient(".concat(colors.LOGO_BACKDROP, ", ").concat(colors.LOGO_BACKDROP, ")"),
      backgroundPosition: '0% 100%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 3px',
      animation: 'underline 0.3s ease-in-out',
      '@keyframes underline': {
        from: {
          backgroundSize: '0% 3px'
        },
        to: {
          backgroundSize: '100% 3px'
        }
      }
    },
    primary: {
      color: colors.WHITE,
      fontSize: '19px',
      margin: '0 auto 40px',
      transition: '0.7s',
      '& svg > path': {
        transition: 'fill 0.7s',
        fill: colors.WHITE
      },
      ':hover, :focus': ActiveLinkStyle,
      variants: {
        open: ActiveLinkStyle
      }
    },
    secondary: {
      color: colors.WHITE,
      fontSize: 19,
      marginBottom: 25,
      textTransform: 'uppercase',
      letterSpacing: '5px',
      textAlign: 'left',
      lineHeight: '2',
      transition: '0.7s',
      ':hover': {
        color: colors.LOGO_BACKDROP
      },
      variants: {
        mediumAndDown: {
          fontSize: 14
        }
      }
    }
  }
});
const StyledNavLinks = getStyledNavLinks(NavLinksStyle);
const StyledNavButton = createOwnUpComponent('button', {
  ...NavLinksStyle,
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0
});

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

/**
 * Logs `messages` to the console using `console.warn` based on a `condition`.
 *
 * @example
 * import { warning } from "reakit-warning";
 *
 * warning(true, "a", "b"); // console.warn("a", "\n", "b")
 * warning(false, "a", "b"); // does nothing
 */

function warning$1(condition) {
  if (process.env.NODE_ENV !== "production") {
    var _console;

    if (!condition) return;

    for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      messages[_key - 1] = arguments[_key];
    }

    var warns = flatten$1(messages.map(function (message) {
      return [message, "\n"];
    })); // eslint-disable-next-line no-console

    (_console = console).warn.apply(_console, warns.slice(0, -1)); // Throwing an error and catching it immediately to improve debugging
    // A consumer can use 'pause on caught exceptions'
    // https://github.com/facebook/react/issues/4216


    try {
      throw Error(warns.join(""));
    } catch (x) {// do nothing
    }
  }
}

function isRefObject(ref) {
  return isObject$1(ref) && "current" in ref;
}
/**
 * Logs `messages` to the console using `console.warn` based on a `condition`.
 * This should be used inside components.
 */


function useWarning(condition) {
  for (var _len = arguments.length, messages = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    messages[_key - 1] = arguments[_key];
  }

  if (process.env.NODE_ENV !== "production") {
    useEffect(function () {
      process.env.NODE_ENV !== "production" ? warning$1.apply(void 0, [condition].concat(messages.map(function (message) {
        return isRefObject(message) ? message.current : message;
      }))) : void 0;
    }, [condition]);
  }
}

// Automatically generated
var ROLE_KEYS = ["unstable_system"];

var useRole = createHook({
  name: "Role",
  keys: ROLE_KEYS,
  propsAreEqual: function propsAreEqual(prev, next) {
    var prevSystem = prev.unstable_system,
        prevProps = _objectWithoutPropertiesLoose$1(prev, ["unstable_system"]);

    var nextSystem = next.unstable_system,
        nextProps = _objectWithoutPropertiesLoose$1(next, ["unstable_system"]);

    if (prevSystem !== nextSystem && !shallowEqual(prevSystem, nextSystem)) {
      return false;
    }

    return shallowEqual(prevProps, nextProps);
  }
});
createComponent({
  as: "div",
  useHook: useRole
});

// Automatically generated
var TABBABLE_KEYS = ["disabled", "focusable"];

var isSafariOrFirefoxOnMac = isUA("Mac") && !isUA("Chrome") && (isUA("Safari") || isUA("Firefox"));

function focusIfNeeded(element) {
  if (!hasFocusWithin(element) && isFocusable(element)) {
    element.focus();
  }
}

function isNativeTabbable(element) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"].includes(element.tagName);
}

function supportsDisabledAttribute(element) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(element.tagName);
}

function getTabIndex(trulyDisabled, nativeTabbable, supportsDisabled, htmlTabIndex) {
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) {
      // Anchor, audio and video tags don't support the `disabled` attribute.
      // We must pass tabIndex={-1} so they don't receive focus on tab.
      return -1;
    } // Elements that support the `disabled` attribute don't need tabIndex.


    return undefined;
  }

  if (nativeTabbable) {
    // If the element is enabled and it's natively tabbable, we don't need to
    // specify a tabIndex attribute unless it's explicitly set by the user.
    return htmlTabIndex;
  } // If the element is enabled and is not natively tabbable, we have to
  // fallback tabIndex={0}.


  return htmlTabIndex || 0;
}

function useDisableEvent(htmlEventRef, disabled) {
  return useCallback(function (event) {
    var _htmlEventRef$current;

    (_htmlEventRef$current = htmlEventRef.current) === null || _htmlEventRef$current === void 0 ? void 0 : _htmlEventRef$current.call(htmlEventRef, event);
    if (event.defaultPrevented) return;

    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, [htmlEventRef, disabled]);
}

var useTabbable = createHook({
  name: "Tabbable",
  compose: useRole,
  keys: TABBABLE_KEYS,
  useOptions: function useOptions(options, _ref) {
    var disabled = _ref.disabled;
    return _objectSpread2({
      disabled: disabled
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlRef = _ref2.ref,
        htmlTabIndex = _ref2.tabIndex,
        htmlOnClickCapture = _ref2.onClickCapture,
        htmlOnMouseDownCapture = _ref2.onMouseDownCapture,
        htmlOnMouseDown = _ref2.onMouseDown,
        htmlOnKeyPressCapture = _ref2.onKeyPressCapture,
        htmlStyle = _ref2.style,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref2, ["ref", "tabIndex", "onClickCapture", "onMouseDownCapture", "onMouseDown", "onKeyPressCapture", "style"]);

    var ref = useRef(null);
    var onClickCaptureRef = useLiveRef(htmlOnClickCapture);
    var onMouseDownCaptureRef = useLiveRef(htmlOnMouseDownCapture);
    var onMouseDownRef = useLiveRef(htmlOnMouseDown);
    var onKeyPressCaptureRef = useLiveRef(htmlOnKeyPressCapture);
    var trulyDisabled = !!options.disabled && !options.focusable;

    var _React$useState = useState(true),
        nativeTabbable = _React$useState[0],
        setNativeTabbable = _React$useState[1];

    var _React$useState2 = useState(true),
        supportsDisabled = _React$useState2[0],
        setSupportsDisabled = _React$useState2[1];

    var style = options.disabled ? _objectSpread2({
      pointerEvents: "none"
    }, htmlStyle) : htmlStyle;
    useIsomorphicEffect(function () {
      var tabbable = ref.current;

      if (!tabbable) {
        process.env.NODE_ENV !== "production" ? warning$1(true, "Can't determine if the element is a native tabbable element because `ref` wasn't passed to the component.", "See https://reakit.io/docs/tabbable") : void 0;
        return;
      }

      if (!isNativeTabbable(tabbable)) {
        setNativeTabbable(false);
      }

      if (!supportsDisabledAttribute(tabbable)) {
        setSupportsDisabled(false);
      }
    }, []);
    var onClickCapture = useDisableEvent(onClickCaptureRef, options.disabled);
    var onMouseDownCapture = useDisableEvent(onMouseDownCaptureRef, options.disabled);
    var onKeyPressCapture = useDisableEvent(onKeyPressCaptureRef, options.disabled);
    var onMouseDown = useCallback(function (event) {
      var _onMouseDownRef$curre;

      (_onMouseDownRef$curre = onMouseDownRef.current) === null || _onMouseDownRef$curre === void 0 ? void 0 : _onMouseDownRef$curre.call(onMouseDownRef, event);
      var element = event.currentTarget;
      if (event.defaultPrevented) return; // Safari and Firefox on MacOS don't focus on buttons on mouse down
      // like other browsers/platforms. Instead, they focus on the closest
      // focusable ancestor element, which is ultimately the body element. So
      // we make sure to give focus to the tabbable element on mouse down so
      // it works consistently across browsers.

      if (!isSafariOrFirefoxOnMac) return;
      if (isPortalEvent(event)) return;
      if (!isButton(element)) return; // We can't focus right away after on mouse down, otherwise it would
      // prevent drag events from happening. So we schedule the focus to the
      // next animation frame.

      var raf = requestAnimationFrame(function () {
        element.removeEventListener("mouseup", focusImmediately, true);
        focusIfNeeded(element);
      }); // If mouseUp happens before the next animation frame (which is common
      // on touch screens or by just tapping the trackpad on MacBook's), we
      // cancel the animation frame and immediately focus on the element.

      var focusImmediately = function focusImmediately() {
        cancelAnimationFrame(raf);
        focusIfNeeded(element);
      }; // By listening to the event in the capture phase, we make sure the
      // focus event is fired before the onMouseUp and onMouseUpCapture React
      // events, which is aligned with the default browser behavior.


      element.addEventListener("mouseup", focusImmediately, {
        once: true,
        capture: true
      });
    }, []);
    return _objectSpread2({
      ref: useForkRef(ref, htmlRef),
      style: style,
      tabIndex: getTabIndex(trulyDisabled, nativeTabbable, supportsDisabled, htmlTabIndex),
      disabled: trulyDisabled && supportsDisabled ? true : undefined,
      "aria-disabled": options.disabled ? true : undefined,
      onClickCapture: onClickCapture,
      onMouseDownCapture: onMouseDownCapture,
      onMouseDown: onMouseDown,
      onKeyPressCapture: onKeyPressCapture
    }, htmlProps);
  }
});
createComponent({
  as: "div",
  useHook: useTabbable
});

// Automatically generated
var CLICKABLE_KEYS = ["unstable_clickOnEnter", "unstable_clickOnSpace"];

function isNativeClick(event) {
  var element = event.currentTarget;
  if (!event.isTrusted) return false; // istanbul ignore next: can't test trusted events yet

  return isButton(element) || element.tagName === "INPUT" || element.tagName === "TEXTAREA" || element.tagName === "A" || element.tagName === "SELECT";
}

var useClickable = createHook({
  name: "Clickable",
  compose: useTabbable,
  keys: CLICKABLE_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$unstable_clickOn = _ref.unstable_clickOnEnter,
        unstable_clickOnEnter = _ref$unstable_clickOn === void 0 ? true : _ref$unstable_clickOn,
        _ref$unstable_clickOn2 = _ref.unstable_clickOnSpace,
        unstable_clickOnSpace = _ref$unstable_clickOn2 === void 0 ? true : _ref$unstable_clickOn2,
        options = _objectWithoutPropertiesLoose$1(_ref, ["unstable_clickOnEnter", "unstable_clickOnSpace"]);

    return _objectSpread2({
      unstable_clickOnEnter: unstable_clickOnEnter,
      unstable_clickOnSpace: unstable_clickOnSpace
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlOnKeyDown = _ref2.onKeyDown,
        htmlOnKeyUp = _ref2.onKeyUp,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref2, ["onKeyDown", "onKeyUp"]);

    var _React$useState = useState(false),
        active = _React$useState[0],
        setActive = _React$useState[1];

    var onKeyDownRef = useLiveRef(htmlOnKeyDown);
    var onKeyUpRef = useLiveRef(htmlOnKeyUp);
    var onKeyDown = useCallback(function (event) {
      var _onKeyDownRef$current;

      (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
      if (event.defaultPrevented) return;
      if (options.disabled) return;
      if (event.metaKey) return;
      if (!isSelfTarget(event)) return;
      var isEnter = options.unstable_clickOnEnter && event.key === "Enter";
      var isSpace = options.unstable_clickOnSpace && event.key === " ";

      if (isEnter || isSpace) {
        if (isNativeClick(event)) return;
        event.preventDefault();

        if (isEnter) {
          event.currentTarget.click();
        } else if (isSpace) {
          setActive(true);
        }
      }
    }, [options.disabled, options.unstable_clickOnEnter, options.unstable_clickOnSpace]);
    var onKeyUp = useCallback(function (event) {
      var _onKeyUpRef$current;

      (_onKeyUpRef$current = onKeyUpRef.current) === null || _onKeyUpRef$current === void 0 ? void 0 : _onKeyUpRef$current.call(onKeyUpRef, event);
      if (event.defaultPrevented) return;
      if (options.disabled) return;
      if (event.metaKey) return;
      var isSpace = options.unstable_clickOnSpace && event.key === " ";

      if (active && isSpace) {
        setActive(false);
        event.currentTarget.click();
      }
    }, [options.disabled, options.unstable_clickOnSpace, active]);
    return _objectSpread2({
      "data-active": active || undefined,
      onKeyDown: onKeyDown,
      onKeyUp: onKeyUp
    }, htmlProps);
  }
});
createComponent({
  as: "button",
  memo: true,
  useHook: useClickable
});

// Automatically generated
var BUTTON_KEYS = [];

var useButton = createHook({
  name: "Button",
  compose: useClickable,
  keys: BUTTON_KEYS,
  useProps: function useProps(_, _ref) {
    var htmlRef = _ref.ref,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["ref"]);

    var ref = useRef(null);

    var _React$useState = useState(undefined),
        role = _React$useState[0],
        setRole = _React$useState[1];

    var _React$useState2 = useState("button"),
        type = _React$useState2[0],
        setType = _React$useState2[1];

    useEffect(function () {
      var element = ref.current;

      if (!element) {
        process.env.NODE_ENV !== "production" ? warning$1(true, "Can't determine whether the element is a native button because `ref` wasn't passed to the component", "See https://reakit.io/docs/button") : void 0;
        return;
      }

      if (!isButton(element)) {
        if (element.tagName !== "A") {
          setRole("button");
        }

        setType(undefined);
      }
    }, []);
    return _objectSpread2({
      ref: useForkRef(ref, htmlRef),
      role: role,
      type: type
    }, htmlProps);
  }
});
createComponent({
  as: "button",
  memo: true,
  useHook: useButton
});

function groupItems(items) {
  var groups = [[]];

  var _loop = function _loop() {
    var item = _step.value;
    var group = groups.find(function (g) {
      return !g[0] || g[0].groupId === item.groupId;
    });

    if (group) {
      group.push(item);
    } else {
      groups.push([item]);
    }
  };

  for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
    _loop();
  }

  return groups;
}

function flatten(grid) {
  var flattened = [];

  for (var _iterator = _createForOfIteratorHelperLoose(grid), _step; !(_step = _iterator()).done;) {
    var row = _step.value;
    flattened.push.apply(flattened, row);
  }

  return flattened;
}

function reverse$1(array) {
  return array.slice().reverse();
}

function findFirstEnabledItem(items, excludeId) {
  if (excludeId) {
    return items.find(function (item) {
      return !item.disabled && item.id !== excludeId;
    });
  }

  return items.find(function (item) {
    return !item.disabled;
  });
}

function getCurrentId(options, passedId) {
  var _findFirstEnabledItem;

  if (passedId || passedId === null) {
    return passedId;
  }

  if (options.currentId || options.currentId === null) {
    return options.currentId;
  }

  return (_findFirstEnabledItem = findFirstEnabledItem(options.items || [])) === null || _findFirstEnabledItem === void 0 ? void 0 : _findFirstEnabledItem.id;
}

function findEnabledItemById(items, id) {
  if (!id) return undefined;
  return items === null || items === void 0 ? void 0 : items.find(function (item) {
    return item.id === id && !item.disabled;
  });
}

// Automatically generated
var COMPOSITE_STATE_KEYS = ["baseId", "unstable_idCountRef", "setBaseId", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget"];
var COMPOSITE_KEYS = COMPOSITE_STATE_KEYS;

function userFocus(element) {
  element.userFocus = true;
  element.focus();
  element.userFocus = false;
}

var isIE11 = canUseDOM && "msCrypto" in window;

function canProxyKeyboardEvent(event) {
  if (!isSelfTarget(event)) return false;
  if (event.metaKey) return false;
  if (event.key === "Tab") return false;
  return true;
}

function useKeyboardEventProxy(virtual, currentItem, htmlEventHandler) {
  var eventHandlerRef = useLiveRef(htmlEventHandler);
  return useCallback(function (event) {
    var _eventHandlerRef$curr;

    (_eventHandlerRef$curr = eventHandlerRef.current) === null || _eventHandlerRef$curr === void 0 ? void 0 : _eventHandlerRef$curr.call(eventHandlerRef, event);
    if (event.defaultPrevented) return;

    if (virtual && canProxyKeyboardEvent(event)) {
      var currentElement = currentItem === null || currentItem === void 0 ? void 0 : currentItem.ref.current;

      if (currentElement) {
        if (!fireKeyboardEvent(currentElement, event.type, event)) {
          event.preventDefault();
        } // The event will be triggered on the composite item and then
        // propagated up to this composite element again, so we can pretend
        // that it wasn't called on this component in the first place.


        if (event.currentTarget.contains(currentElement)) {
          event.stopPropagation();
        }
      }
    }
  }, [virtual, currentItem]);
} // istanbul ignore next


function useActiveElementRef(elementRef) {
  var activeElementRef = useRef(null);
  useEffect(function () {
    var document = getDocument(elementRef.current);

    var onFocus = function onFocus(event) {
      var target = event.target;
      activeElementRef.current = target;
    };

    document.addEventListener("focus", onFocus, true);
    return function () {
      document.removeEventListener("focus", onFocus, true);
    };
  }, []);
  return activeElementRef;
}

function findFirstEnabledItemInTheLastRow(items) {
  return findFirstEnabledItem(flatten(reverse$1(groupItems(items))));
}

function isItem(items, element) {
  return items === null || items === void 0 ? void 0 : items.some(function (item) {
    return !!element && item.ref.current === element;
  });
}

function useScheduleUserFocus(currentItem) {
  var currentItemRef = useLiveRef(currentItem);

  var _React$useReducer = useReducer(function (n) {
    return n + 1;
  }, 0),
      scheduled = _React$useReducer[0],
      schedule = _React$useReducer[1];

  useEffect(function () {
    var _currentItemRef$curre;

    var currentElement = (_currentItemRef$curre = currentItemRef.current) === null || _currentItemRef$curre === void 0 ? void 0 : _currentItemRef$curre.ref.current;

    if (scheduled && currentElement) {
      userFocus(currentElement);
    }
  }, [scheduled]);
  return schedule;
}

var useComposite = createHook({
  name: "Composite",
  compose: [useTabbable],
  keys: COMPOSITE_KEYS,
  useOptions: function useOptions(options) {
    return _objectSpread2(_objectSpread2({}, options), {}, {
      currentId: getCurrentId(options)
    });
  },
  useProps: function useProps(options, _ref) {
    var htmlRef = _ref.ref,
        htmlOnFocusCapture = _ref.onFocusCapture,
        htmlOnFocus = _ref.onFocus,
        htmlOnBlurCapture = _ref.onBlurCapture,
        htmlOnKeyDown = _ref.onKeyDown,
        htmlOnKeyDownCapture = _ref.onKeyDownCapture,
        htmlOnKeyUpCapture = _ref.onKeyUpCapture,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["ref", "onFocusCapture", "onFocus", "onBlurCapture", "onKeyDown", "onKeyDownCapture", "onKeyUpCapture"]);

    var ref = useRef(null);
    var currentItem = findEnabledItemById(options.items, options.currentId);
    var previousElementRef = useRef(null);
    var onFocusCaptureRef = useLiveRef(htmlOnFocusCapture);
    var onFocusRef = useLiveRef(htmlOnFocus);
    var onBlurCaptureRef = useLiveRef(htmlOnBlurCapture);
    var onKeyDownRef = useLiveRef(htmlOnKeyDown);
    var scheduleUserFocus = useScheduleUserFocus(currentItem); // IE 11 doesn't support event.relatedTarget, so we use the active element
    // ref instead.

    var activeElementRef = isIE11 ? useActiveElementRef(ref) : undefined;
    useEffect(function () {
      var element = ref.current;

      if (options.unstable_moves && !currentItem) {
        process.env.NODE_ENV !== "production" ? warning$1(!element, "Can't focus composite component because `ref` wasn't passed to component.", "See https://reakit.io/docs/composite") : void 0; // If composite.move(null) has been called, the composite container
        // will receive focus.

        element === null || element === void 0 ? void 0 : element.focus();
      }
    }, [options.unstable_moves, currentItem]);
    var onKeyDownCapture = useKeyboardEventProxy(options.unstable_virtual, currentItem, htmlOnKeyDownCapture);
    var onKeyUpCapture = useKeyboardEventProxy(options.unstable_virtual, currentItem, htmlOnKeyUpCapture);
    var onFocusCapture = useCallback(function (event) {
      var _onFocusCaptureRef$cu;

      (_onFocusCaptureRef$cu = onFocusCaptureRef.current) === null || _onFocusCaptureRef$cu === void 0 ? void 0 : _onFocusCaptureRef$cu.call(onFocusCaptureRef, event);
      if (event.defaultPrevented) return;
      if (!options.unstable_virtual) return; // IE11 doesn't support event.relatedTarget, so we use the active
      // element ref instead.

      var previousActiveElement = (activeElementRef === null || activeElementRef === void 0 ? void 0 : activeElementRef.current) || event.relatedTarget;
      var previousActiveElementWasItem = isItem(options.items, previousActiveElement);

      if (isSelfTarget(event) && previousActiveElementWasItem) {
        // Composite has been focused as a result of an item receiving focus.
        // The composite item will move focus back to the composite
        // container. In this case, we don't want to propagate this
        // additional event nor call the onFocus handler passed to
        // <Composite onFocus={...} />.
        event.stopPropagation(); // We keep track of the previous active item element so we can
        // manually fire a blur event on it later when the focus is moved to
        // another item on the onBlurCapture event below.

        previousElementRef.current = previousActiveElement;
      }
    }, [options.unstable_virtual, options.items]);
    var onFocus = useCallback(function (event) {
      var _onFocusRef$current;

      (_onFocusRef$current = onFocusRef.current) === null || _onFocusRef$current === void 0 ? void 0 : _onFocusRef$current.call(onFocusRef, event);
      if (event.defaultPrevented) return;

      if (options.unstable_virtual) {
        if (isSelfTarget(event)) {
          // This means that the composite element has been focused while the
          // composite item has not. For example, by clicking on the
          // composite element without touching any item, or by tabbing into
          // the composite element. In this case, we want to trigger focus on
          // the item, just like it would happen with roving tabindex.
          // When it receives focus, the composite item will put focus back
          // on the composite element, in which case hasItemWithFocus will be
          // true.
          scheduleUserFocus();
        }
      } else if (isSelfTarget(event)) {
        var _options$setCurrentId;

        // When the roving tabindex composite gets intentionally focused (for
        // example, by clicking directly on it, and not on an item), we make
        // sure to set the current id to null (which means the composite
        // itself is focused).
        (_options$setCurrentId = options.setCurrentId) === null || _options$setCurrentId === void 0 ? void 0 : _options$setCurrentId.call(options, null);
      }
    }, [options.unstable_virtual, options.setCurrentId]);
    var onBlurCapture = useCallback(function (event) {
      var _onBlurCaptureRef$cur;

      (_onBlurCaptureRef$cur = onBlurCaptureRef.current) === null || _onBlurCaptureRef$cur === void 0 ? void 0 : _onBlurCaptureRef$cur.call(onBlurCaptureRef, event);
      if (event.defaultPrevented) return;
      if (!options.unstable_virtual) return; // When virtual is set to true, we move focus from the composite
      // container (this component) to the composite item that is being
      // selected. Then we move focus back to the composite container. This
      // is so we can provide the same API as the roving tabindex method,
      // which means people can attach onFocus/onBlur handlers on the
      // CompositeItem component regardless of whether it's virtual or not.
      // This sequence of blurring and focusing items and composite may be
      // confusing, so we ignore intermediate focus and blurs by stopping its
      // propagation and not calling the passed onBlur handler (htmlOnBlur).

      var currentElement = (currentItem === null || currentItem === void 0 ? void 0 : currentItem.ref.current) || null;
      var nextActiveElement = getNextActiveElementOnBlur(event);
      var nextActiveElementIsItem = isItem(options.items, nextActiveElement);

      if (isSelfTarget(event) && nextActiveElementIsItem) {
        // This is an intermediate blur event: blurring the composite
        // container to focus an item (nextActiveElement).
        if (nextActiveElement === currentElement) {
          // The next active element will be the same as the current item in
          // the state in two scenarios:
          //   - Moving focus with keyboard: the state is updated before the
          // blur event is triggered, so here the current item is already
          // pointing to the next active element.
          //   - Clicking on the current active item with a pointer: this
          // will trigger blur on the composite element and then the next
          // active element will be the same as the current item. Clicking on
          // an item other than the current one doesn't end up here as the
          // currentItem state will be updated only after it.
          if (previousElementRef.current && previousElementRef.current !== nextActiveElement) {
            // If there's a previous active item and it's not a click action,
            // then we fire a blur event on it so it will work just like if
            // it had DOM focus before (like when using roving tabindex).
            fireBlurEvent(previousElementRef.current, event);
          }
        } else if (currentElement) {
          // This will be true when the next active element is not the
          // current element, but there's a current item. This will only
          // happen when clicking with a pointer on a different item, when
          // there's already an item selected, in which case currentElement
          // is the item that is getting blurred, and nextActiveElement is
          // the item that is being clicked.
          fireBlurEvent(currentElement, event);
        } // We want to ignore intermediate blur events, so we stop its
        // propagation and return early so onFocus will not be called.


        event.stopPropagation();
      } else {
        var targetIsItem = isItem(options.items, event.target);

        if (!targetIsItem && currentElement) {
          // If target is not a composite item, it may be the composite
          // element itself (isSelfTarget) or a tabbable element inside the
          // composite widget. This may be triggered by clicking outside the
          // composite widget or by tabbing out of it. In either cases we
          // want to fire a blur event on the current item.
          fireBlurEvent(currentElement, event);
        }
      }
    }, [options.unstable_virtual, options.items, currentItem]);
    var onKeyDown = useCallback(function (event) {
      var _onKeyDownRef$current, _options$groups;

      (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
      if (event.defaultPrevented) return;
      if (options.currentId !== null) return;
      if (!isSelfTarget(event)) return;
      var isVertical = options.orientation !== "horizontal";
      var isHorizontal = options.orientation !== "vertical";
      var isGrid = !!((_options$groups = options.groups) !== null && _options$groups !== void 0 && _options$groups.length);

      var up = function up() {
        if (isGrid) {
          var item = findFirstEnabledItemInTheLastRow(options.items);

          if (item !== null && item !== void 0 && item.id) {
            var _options$move;

            (_options$move = options.move) === null || _options$move === void 0 ? void 0 : _options$move.call(options, item.id);
          }
        } else {
          var _options$last;

          (_options$last = options.last) === null || _options$last === void 0 ? void 0 : _options$last.call(options);
        }
      };

      var keyMap = {
        ArrowUp: (isGrid || isVertical) && up,
        ArrowRight: (isGrid || isHorizontal) && options.first,
        ArrowDown: (isGrid || isVertical) && options.first,
        ArrowLeft: (isGrid || isHorizontal) && options.last,
        Home: options.first,
        End: options.last,
        PageUp: options.first,
        PageDown: options.last
      };
      var action = keyMap[event.key];

      if (action) {
        event.preventDefault();
        action();
      }
    }, [options.currentId, options.orientation, options.groups, options.items, options.move, options.last, options.first]);
    return _objectSpread2({
      ref: useForkRef(ref, htmlRef),
      id: options.baseId,
      onFocus: onFocus,
      onFocusCapture: onFocusCapture,
      onBlurCapture: onBlurCapture,
      onKeyDownCapture: onKeyDownCapture,
      onKeyDown: onKeyDown,
      onKeyUpCapture: onKeyUpCapture,
      "aria-activedescendant": options.unstable_virtual ? (currentItem === null || currentItem === void 0 ? void 0 : currentItem.id) || undefined : undefined
    }, htmlProps);
  },
  useComposeProps: function useComposeProps(options, htmlProps) {
    htmlProps = useRole(options, htmlProps, true);
    var tabbableHTMLProps = useTabbable(options, htmlProps, true);

    if (options.unstable_virtual || options.currentId === null) {
      // Composite will only be tabbable by default if the focus is managed
      // using aria-activedescendant, which requires DOM focus on the container
      // element (the composite)
      return _objectSpread2({
        tabIndex: 0
      }, tabbableHTMLProps);
    }

    return _objectSpread2(_objectSpread2({}, htmlProps), {}, {
      ref: tabbableHTMLProps.ref
    });
  }
});
createComponent({
  as: "div",
  useHook: useComposite,
  useCreateElement: function useCreateElement$1(type, props, children) {
    process.env.NODE_ENV !== "production" ? useWarning(!props["aria-label"] && !props["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/composite") : void 0;
    return useCreateElement(type, props, children);
  }
});

var defaultPrefix = "id";
function generateRandomString(prefix) {
  if (prefix === void 0) {
    prefix = defaultPrefix;
  }

  return "" + (prefix ? prefix + "-" : "") + Math.random().toString(32).substr(2, 6);
}

var unstable_IdContext = /*#__PURE__*/createContext(generateRandomString);

function unstable_useIdState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      initialBaseId = _useSealedState.baseId;

  var generateId = useContext(unstable_IdContext);
  var idCountRef = useRef(0);

  var _React$useState = useState(function () {
    return initialBaseId || generateId();
  }),
      baseId = _React$useState[0],
      setBaseId = _React$useState[1];

  return {
    baseId: baseId,
    setBaseId: setBaseId,
    unstable_idCountRef: idCountRef
  };
}

function isElementPreceding(element1, element2) {
  return Boolean(element2.compareDocumentPosition(element1) & Node.DOCUMENT_POSITION_PRECEDING);
}

function findDOMIndex(items, item) {
  return items.findIndex(function (currentItem) {
    if (!currentItem.ref.current || !item.ref.current) {
      return false;
    }

    return isElementPreceding(item.ref.current, currentItem.ref.current);
  });
}

function getMaxLength(rows) {
  var maxLength = 0;

  for (var _iterator = _createForOfIteratorHelperLoose(rows), _step; !(_step = _iterator()).done;) {
    var length = _step.value.length;

    if (length > maxLength) {
      maxLength = length;
    }
  }

  return maxLength;
}

/**
 * Turns [row1, row1, row2, row2] into [row1, row2, row1, row2]
 */

function verticalizeItems(items) {
  var groups = groupItems(items);
  var maxLength = getMaxLength(groups);
  var verticalized = [];

  for (var i = 0; i < maxLength; i += 1) {
    for (var _iterator = _createForOfIteratorHelperLoose(groups), _step; !(_step = _iterator()).done;) {
      var group = _step.value;

      if (group[i]) {
        verticalized.push(_objectSpread2(_objectSpread2({}, group[i]), {}, {
          // If there's no groupId, it means that it's not a grid composite,
          // but a single row instead. So, instead of verticalizing it, that
          // is, assigning a different groupId based on the column index, we
          // keep it undefined so they will be part of the same group.
          // It's useful when using up/down on one-dimensional composites.
          groupId: group[i].groupId ? "" + i : undefined
        }));
      }
    }
  }

  return verticalized;
}

function createEmptyItem(groupId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    ref: {
      current: null
    },
    groupId: groupId
  };
}
/**
 * Turns [[row1, row1], [row2]] into [[row1, row1], [row2, row2]]
 */


function fillGroups(groups, currentId, shift) {
  var maxLength = getMaxLength(groups);

  for (var _iterator = _createForOfIteratorHelperLoose(groups), _step; !(_step = _iterator()).done;) {
    var group = _step.value;

    for (var i = 0; i < maxLength; i += 1) {
      var item = group[i];

      if (!item || shift && item.disabled) {
        var isFrist = i === 0;
        var previousItem = isFrist && shift ? findFirstEnabledItem(group) : group[i - 1];
        group[i] = previousItem && currentId !== (previousItem === null || previousItem === void 0 ? void 0 : previousItem.id) && shift ? previousItem : createEmptyItem(previousItem === null || previousItem === void 0 ? void 0 : previousItem.groupId);
      }
    }
  }

  return groups;
}

var nullItem = {
  id: null,
  ref: {
    current: null
  }
};
function placeItemsAfter(items, id, shouldInsertNullItem) {
  var index = items.findIndex(function (item) {
    return item.id === id;
  });
  return [].concat(items.slice(index + 1), shouldInsertNullItem ? [nullItem] : [], items.slice(0, index));
}

function getItemsInGroup(items, groupId) {
  return items.filter(function (item) {
    return item.groupId === groupId;
  });
}

var map = {
  horizontal: "vertical",
  vertical: "horizontal"
};
function getOppositeOrientation(orientation) {
  return orientation && map[orientation];
}

function addItemAtIndex(array, item, index) {
  if (!(index in array)) {
    return [].concat(array, [item]);
  }

  return [].concat(array.slice(0, index), [item], array.slice(index));
}

function sortBasedOnDOMPosition(items) {
  var pairs = items.map(function (item, index) {
    return [index, item];
  });
  var isOrderDifferent = false;
  pairs.sort(function (_ref, _ref2) {
    var indexA = _ref[0],
        a = _ref[1];
    var indexB = _ref2[0],
        b = _ref2[1];
    var elementA = a.ref.current;
    var elementB = b.ref.current;
    if (!elementA || !elementB) return 0; // a before b

    if (isElementPreceding(elementA, elementB)) {
      if (indexA > indexB) {
        isOrderDifferent = true;
      }

      return -1;
    } // a after b


    if (indexA < indexB) {
      isOrderDifferent = true;
    }

    return 1;
  });

  if (isOrderDifferent) {
    return pairs.map(function (_ref3) {
      _ref3[0];
          var item = _ref3[1];
      return item;
    });
  }

  return items;
}

function setItemsBasedOnDOMPosition(items, setItems) {
  var sortedItems = sortBasedOnDOMPosition(items);

  if (items !== sortedItems) {
    setItems(sortedItems);
  }
}

function getCommonParent(items) {
  var _firstItem$ref$curren;

  var firstItem = items[0],
      nextItems = items.slice(1);
  var parentElement = firstItem === null || firstItem === void 0 ? void 0 : (_firstItem$ref$curren = firstItem.ref.current) === null || _firstItem$ref$curren === void 0 ? void 0 : _firstItem$ref$curren.parentElement;

  var _loop = function _loop() {
    var parent = parentElement;

    if (nextItems.every(function (item) {
      return parent.contains(item.ref.current);
    })) {
      return {
        v: parentElement
      };
    }

    parentElement = parentElement.parentElement;
  };

  while (parentElement) {
    var _ret = _loop();

    if (typeof _ret === "object") return _ret.v;
  }

  return getDocument(parentElement).body;
} // istanbul ignore next: JSDOM doesn't support IntersectionObverser
// See https://github.com/jsdom/jsdom/issues/2032


function useIntersectionObserver(items, setItems) {
  var previousItems = useRef([]);
  useEffect(function () {
    var callback = function callback() {
      var hasPreviousItems = !!previousItems.current.length; // We don't want to sort items if items have been just registered.

      if (hasPreviousItems) {
        setItemsBasedOnDOMPosition(items, setItems);
      }

      previousItems.current = items;
    };

    var root = getCommonParent(items);
    var observer = new IntersectionObserver(callback, {
      root: root
    });

    for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
      var item = _step.value;

      if (item.ref.current) {
        observer.observe(item.ref.current);
      }
    }

    return function () {
      observer.disconnect();
    };
  }, [items]);
}

function useTimeoutObserver(items, setItems) {
  useEffect(function () {
    var callback = function callback() {
      return setItemsBasedOnDOMPosition(items, setItems);
    };

    var timeout = setTimeout(callback, 250);
    return function () {
      return clearTimeout(timeout);
    };
  });
}

function useSortBasedOnDOMPosition(items, setItems) {
  if (typeof IntersectionObserver === "function") {
    useIntersectionObserver(items, setItems);
  } else {
    useTimeoutObserver(items, setItems);
  }
}

function reducer(state, action) {
  var virtual = state.unstable_virtual,
      rtl = state.rtl,
      orientation = state.orientation,
      items = state.items,
      groups = state.groups,
      currentId = state.currentId,
      loop = state.loop,
      wrap = state.wrap,
      pastIds = state.pastIds,
      shift = state.shift,
      moves = state.unstable_moves,
      includesBaseElement = state.unstable_includesBaseElement,
      initialVirtual = state.initialVirtual,
      initialRTL = state.initialRTL,
      initialOrientation = state.initialOrientation,
      initialCurrentId = state.initialCurrentId,
      initialLoop = state.initialLoop,
      initialWrap = state.initialWrap,
      initialShift = state.initialShift,
      hasSetCurrentId = state.hasSetCurrentId;

  switch (action.type) {
    case "registerGroup":
      {
        var _group = action.group; // If there are no groups yet, just add it as the first one

        if (groups.length === 0) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            groups: [_group]
          });
        } // Finds the group index based on DOM position


        var index = findDOMIndex(groups, _group);
        return _objectSpread2(_objectSpread2({}, state), {}, {
          groups: addItemAtIndex(groups, _group, index)
        });
      }

    case "unregisterGroup":
      {
        var _id = action.id;
        var nextGroups = groups.filter(function (group) {
          return group.id !== _id;
        }); // The group isn't registered, so do nothing

        if (nextGroups.length === groups.length) {
          return state;
        }

        return _objectSpread2(_objectSpread2({}, state), {}, {
          groups: nextGroups
        });
      }

    case "registerItem":
      {
        var _item = action.item; // Finds the item group based on the DOM hierarchy

        var _group2 = groups.find(function (r) {
          var _r$ref$current;

          return (_r$ref$current = r.ref.current) === null || _r$ref$current === void 0 ? void 0 : _r$ref$current.contains(_item.ref.current);
        }); // Group will be null if it's a one-dimensional composite


        var nextItem = _objectSpread2({
          groupId: _group2 === null || _group2 === void 0 ? void 0 : _group2.id
        }, _item);

        var _index = findDOMIndex(items, nextItem);

        var nextState = _objectSpread2(_objectSpread2({}, state), {}, {
          items: addItemAtIndex(items, nextItem, _index)
        });

        if (!hasSetCurrentId && !moves && initialCurrentId === undefined) {
          var _findFirstEnabledItem;

          // Sets currentId to the first enabled item. This runs whenever an item
          // is registered because the first enabled item may be registered
          // asynchronously.
          return _objectSpread2(_objectSpread2({}, nextState), {}, {
            currentId: (_findFirstEnabledItem = findFirstEnabledItem(nextState.items)) === null || _findFirstEnabledItem === void 0 ? void 0 : _findFirstEnabledItem.id
          });
        }

        return nextState;
      }

    case "unregisterItem":
      {
        var _id2 = action.id;
        var nextItems = items.filter(function (item) {
          return item.id !== _id2;
        }); // The item isn't registered, so do nothing

        if (nextItems.length === items.length) {
          return state;
        } // Filters out the item that is being removed from the pastIds list


        var nextPastIds = pastIds.filter(function (pastId) {
          return pastId !== _id2;
        });

        var _nextState = _objectSpread2(_objectSpread2({}, state), {}, {
          pastIds: nextPastIds,
          items: nextItems
        }); // If the current item is the item that is being removed, focus pastId


        if (currentId && currentId === _id2) {
          var nextId = includesBaseElement ? null : getCurrentId(_objectSpread2(_objectSpread2({}, _nextState), {}, {
            currentId: nextPastIds[0]
          }));
          return _objectSpread2(_objectSpread2({}, _nextState), {}, {
            currentId: nextId
          });
        }

        return _nextState;
      }

    case "move":
      {
        var _id3 = action.id; // move() does nothing

        if (_id3 === undefined) {
          return state;
        } // Removes the current item and the item that is receiving focus from the
        // pastIds list


        var filteredPastIds = pastIds.filter(function (pastId) {
          return pastId !== currentId && pastId !== _id3;
        }); // If there's a currentId, add it to the pastIds list so it can be focused
        // if the new item gets removed or disabled

        var _nextPastIds = currentId ? [currentId].concat(filteredPastIds) : filteredPastIds;

        var _nextState2 = _objectSpread2(_objectSpread2({}, state), {}, {
          pastIds: _nextPastIds
        }); // move(null) will focus the composite element itself, not an item


        if (_id3 === null) {
          return _objectSpread2(_objectSpread2({}, _nextState2), {}, {
            unstable_moves: moves + 1,
            currentId: getCurrentId(_nextState2, _id3)
          });
        }

        var _item2 = findEnabledItemById(items, _id3);

        return _objectSpread2(_objectSpread2({}, _nextState2), {}, {
          unstable_moves: _item2 ? moves + 1 : moves,
          currentId: getCurrentId(_nextState2, _item2 === null || _item2 === void 0 ? void 0 : _item2.id)
        });
      }

    case "next":
      {
        // If there's no item focused, we just move the first one
        if (currentId == null) {
          return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
            type: "first"
          }));
        } // RTL doesn't make sense on vertical navigation


        var isHorizontal = orientation !== "vertical";
        var isRTL = rtl && isHorizontal;
        var allItems = isRTL ? reverse$1(items) : items;
        var currentItem = allItems.find(function (item) {
          return item.id === currentId;
        }); // If there's no item focused, we just move the first one

        if (!currentItem) {
          return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
            type: "first"
          }));
        }

        var isGrid = !!currentItem.groupId;
        var currentIndex = allItems.indexOf(currentItem);

        var _nextItems = allItems.slice(currentIndex + 1);

        var nextItemsInGroup = getItemsInGroup(_nextItems, currentItem.groupId); // Home, End

        if (action.allTheWay) {
          // We reverse so we can get the last enabled item in the group. If it's
          // RTL, nextItems and nextItemsInGroup are already reversed and don't
          // have the items before the current one anymore. So we have to get
          // items in group again with allItems.
          var _nextItem2 = findFirstEnabledItem(isRTL ? getItemsInGroup(allItems, currentItem.groupId) : reverse$1(nextItemsInGroup));

          return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
            type: "move",
            id: _nextItem2 === null || _nextItem2 === void 0 ? void 0 : _nextItem2.id
          }));
        }

        var oppositeOrientation = getOppositeOrientation( // If it's a grid and orientation is not set, it's a next/previous
        // call, which is inherently horizontal. up/down will call next with
        // orientation set to vertical by default (see below on up/down cases).
        isGrid ? orientation || "horizontal" : orientation);
        var canLoop = loop && loop !== oppositeOrientation;
        var canWrap = isGrid && wrap && wrap !== oppositeOrientation;
        var hasNullItem = // `previous` and `up` will set action.hasNullItem, but when calling
        // next directly, hasNullItem will only be true if it's not a grid and
        // loop is set to true, which means that pressing right or down keys on
        // grids will never focus the composite element. On one-dimensional
        // composites that don't loop, pressing right or down keys also doesn't
        // focus the composite element.
        action.hasNullItem || !isGrid && canLoop && includesBaseElement;

        if (canLoop) {
          var loopItems = canWrap && !hasNullItem ? allItems : getItemsInGroup(allItems, currentItem.groupId); // Turns [0, 1, current, 3, 4] into [3, 4, 0, 1]

          var sortedItems = placeItemsAfter(loopItems, currentId, hasNullItem);

          var _nextItem3 = findFirstEnabledItem(sortedItems, currentId);

          return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
            type: "move",
            id: _nextItem3 === null || _nextItem3 === void 0 ? void 0 : _nextItem3.id
          }));
        }

        if (canWrap) {
          var _nextItem4 = findFirstEnabledItem( // We can use nextItems, which contains all the next items, including
          // items from other groups, to wrap between groups. However, if there
          // is a null item (the composite element), we'll only use the next
          // items in the group. So moving next from the last item will focus
          // the composite element (null). On grid composites, horizontal
          // navigation never focuses the composite element, only vertical.
          hasNullItem ? nextItemsInGroup : _nextItems, currentId);

          var _nextId = hasNullItem ? (_nextItem4 === null || _nextItem4 === void 0 ? void 0 : _nextItem4.id) || null : _nextItem4 === null || _nextItem4 === void 0 ? void 0 : _nextItem4.id;

          return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
            type: "move",
            id: _nextId
          }));
        }

        var _nextItem = findFirstEnabledItem(nextItemsInGroup, currentId);

        if (!_nextItem && hasNullItem) {
          return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
            type: "move",
            id: null
          }));
        }

        return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
          type: "move",
          id: _nextItem === null || _nextItem === void 0 ? void 0 : _nextItem.id
        }));
      }

    case "previous":
      {
        // If currentId is initially set to null, the composite element will be
        // focusable while navigating with arrow keys. But, if it's a grid, we
        // don't want to focus the composite element with horizontal navigation.
        var _isGrid = !!groups.length;

        var _hasNullItem = !_isGrid && includesBaseElement;

        var _nextState3 = reducer(_objectSpread2(_objectSpread2({}, state), {}, {
          items: reverse$1(items)
        }), _objectSpread2(_objectSpread2({}, action), {}, {
          type: "next",
          hasNullItem: _hasNullItem
        }));

        return _objectSpread2(_objectSpread2({}, _nextState3), {}, {
          items: items
        });
      }

    case "down":
      {
        var shouldShift = shift && !action.allTheWay; // First, we make sure groups have the same number of items by filling it
        // with disabled fake items. Then, we reorganize the items list so
        // [1-1, 1-2, 2-1, 2-2] becomes [1-1, 2-1, 1-2, 2-2].

        var verticalItems = verticalizeItems(flatten(fillGroups(groupItems(items), currentId, shouldShift)));

        var _canLoop = loop && loop !== "horizontal"; // Pressing down arrow key will only focus the composite element if loop
        // is true or vertical.


        var _hasNullItem2 = _canLoop && includesBaseElement;

        var _nextState4 = reducer(_objectSpread2(_objectSpread2({}, state), {}, {
          orientation: "vertical",
          items: verticalItems
        }), _objectSpread2(_objectSpread2({}, action), {}, {
          type: "next",
          hasNullItem: _hasNullItem2
        }));

        return _objectSpread2(_objectSpread2({}, _nextState4), {}, {
          orientation: orientation,
          items: items
        });
      }

    case "up":
      {
        var _shouldShift = shift && !action.allTheWay;

        var _verticalItems = verticalizeItems(reverse$1(flatten(fillGroups(groupItems(items), currentId, _shouldShift)))); // If currentId is initially set to null, we'll always focus the
        // composite element when the up arrow key is pressed in the first row.


        var _hasNullItem3 = includesBaseElement;

        var _nextState5 = reducer(_objectSpread2(_objectSpread2({}, state), {}, {
          orientation: "vertical",
          items: _verticalItems
        }), _objectSpread2(_objectSpread2({}, action), {}, {
          type: "next",
          hasNullItem: _hasNullItem3
        }));

        return _objectSpread2(_objectSpread2({}, _nextState5), {}, {
          orientation: orientation,
          items: items
        });
      }

    case "first":
      {
        var firstItem = findFirstEnabledItem(items);
        return reducer(state, _objectSpread2(_objectSpread2({}, action), {}, {
          type: "move",
          id: firstItem === null || firstItem === void 0 ? void 0 : firstItem.id
        }));
      }

    case "last":
      {
        var _nextState6 = reducer(_objectSpread2(_objectSpread2({}, state), {}, {
          items: reverse$1(items)
        }), _objectSpread2(_objectSpread2({}, action), {}, {
          type: "first"
        }));

        return _objectSpread2(_objectSpread2({}, _nextState6), {}, {
          items: items
        });
      }

    case "sort":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          items: sortBasedOnDOMPosition(items),
          groups: sortBasedOnDOMPosition(groups)
        });
      }

    case "setVirtual":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        unstable_virtual: applyState(action.virtual, virtual)
      });

    case "setRTL":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        rtl: applyState(action.rtl, rtl)
      });

    case "setOrientation":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        orientation: applyState(action.orientation, orientation)
      });

    case "setCurrentId":
      {
        var nextCurrentId = getCurrentId(_objectSpread2(_objectSpread2({}, state), {}, {
          currentId: applyState(action.currentId, currentId)
        }));
        return _objectSpread2(_objectSpread2({}, state), {}, {
          currentId: nextCurrentId,
          hasSetCurrentId: true
        });
      }

    case "setLoop":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        loop: applyState(action.loop, loop)
      });

    case "setWrap":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        wrap: applyState(action.wrap, wrap)
      });

    case "setShift":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        shift: applyState(action.shift, shift)
      });

    case "setIncludesBaseElement":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          unstable_includesBaseElement: applyState(action.includesBaseElement, includesBaseElement)
        });
      }

    case "reset":
      return _objectSpread2(_objectSpread2({}, state), {}, {
        unstable_virtual: initialVirtual,
        rtl: initialRTL,
        orientation: initialOrientation,
        currentId: getCurrentId(_objectSpread2(_objectSpread2({}, state), {}, {
          currentId: initialCurrentId
        })),
        loop: initialLoop,
        wrap: initialWrap,
        shift: initialShift,
        unstable_moves: 0,
        pastIds: []
      });

    case "setItems":
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          items: action.items
        });
      }

    default:
      throw new Error();
  }
}

function useAction(fn) {
  return useCallback(fn, []);
}

function useIsUnmountedRef() {
  var isUnmountedRef = useRef(false);
  useIsomorphicEffect(function () {
    return function () {
      isUnmountedRef.current = true;
    };
  }, []);
  return isUnmountedRef;
}

function useCompositeState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$unsta = _useSealedState.unstable_virtual,
      virtual = _useSealedState$unsta === void 0 ? false : _useSealedState$unsta,
      _useSealedState$rtl = _useSealedState.rtl,
      rtl = _useSealedState$rtl === void 0 ? false : _useSealedState$rtl,
      orientation = _useSealedState.orientation,
      currentId = _useSealedState.currentId,
      _useSealedState$loop = _useSealedState.loop,
      loop = _useSealedState$loop === void 0 ? false : _useSealedState$loop,
      _useSealedState$wrap = _useSealedState.wrap,
      wrap = _useSealedState$wrap === void 0 ? false : _useSealedState$wrap,
      _useSealedState$shift = _useSealedState.shift,
      shift = _useSealedState$shift === void 0 ? false : _useSealedState$shift,
      unstable_includesBaseElement = _useSealedState.unstable_includesBaseElement,
      sealed = _objectWithoutPropertiesLoose$1(_useSealedState, ["unstable_virtual", "rtl", "orientation", "currentId", "loop", "wrap", "shift", "unstable_includesBaseElement"]);

  var idState = unstable_useIdState(sealed);

  var _React$useReducer = useReducer(reducer, {
    unstable_virtual: virtual,
    rtl: rtl,
    orientation: orientation,
    items: [],
    groups: [],
    currentId: currentId,
    loop: loop,
    wrap: wrap,
    shift: shift,
    unstable_moves: 0,
    pastIds: [],
    unstable_includesBaseElement: unstable_includesBaseElement != null ? unstable_includesBaseElement : currentId === null,
    initialVirtual: virtual,
    initialRTL: rtl,
    initialOrientation: orientation,
    initialCurrentId: currentId,
    initialLoop: loop,
    initialWrap: wrap,
    initialShift: shift
  }),
      _React$useReducer$ = _React$useReducer[0];
      _React$useReducer$.pastIds;
      _React$useReducer$.initialVirtual;
      _React$useReducer$.initialRTL;
      _React$useReducer$.initialOrientation;
      _React$useReducer$.initialCurrentId;
      _React$useReducer$.initialLoop;
      _React$useReducer$.initialWrap;
      _React$useReducer$.initialShift;
      _React$useReducer$.hasSetCurrentId;
      var state = _objectWithoutPropertiesLoose$1(_React$useReducer$, ["pastIds", "initialVirtual", "initialRTL", "initialOrientation", "initialCurrentId", "initialLoop", "initialWrap", "initialShift", "hasSetCurrentId"]),
      dispatch = _React$useReducer[1];

  var _React$useState = useState(false),
      hasActiveWidget = _React$useState[0],
      setHasActiveWidget = _React$useState[1]; // register/unregister may be called when this component is unmounted. We
  // store the unmounted state here so we don't update the state if it's true.
  // This only happens in a very specific situation.
  // See https://github.com/reakit/reakit/issues/650


  var isUnmountedRef = useIsUnmountedRef();
  var setItems = useCallback(function (items) {
    return dispatch({
      type: "setItems",
      items: items
    });
  }, []);
  useSortBasedOnDOMPosition(state.items, setItems);
  return _objectSpread2(_objectSpread2(_objectSpread2({}, idState), state), {}, {
    unstable_hasActiveWidget: hasActiveWidget,
    unstable_setHasActiveWidget: setHasActiveWidget,
    registerItem: useAction(function (item) {
      if (isUnmountedRef.current) return;
      dispatch({
        type: "registerItem",
        item: item
      });
    }),
    unregisterItem: useAction(function (id) {
      if (isUnmountedRef.current) return;
      dispatch({
        type: "unregisterItem",
        id: id
      });
    }),
    registerGroup: useAction(function (group) {
      if (isUnmountedRef.current) return;
      dispatch({
        type: "registerGroup",
        group: group
      });
    }),
    unregisterGroup: useAction(function (id) {
      if (isUnmountedRef.current) return;
      dispatch({
        type: "unregisterGroup",
        id: id
      });
    }),
    move: useAction(function (id) {
      return dispatch({
        type: "move",
        id: id
      });
    }),
    next: useAction(function (allTheWay) {
      return dispatch({
        type: "next",
        allTheWay: allTheWay
      });
    }),
    previous: useAction(function (allTheWay) {
      return dispatch({
        type: "previous",
        allTheWay: allTheWay
      });
    }),
    up: useAction(function (allTheWay) {
      return dispatch({
        type: "up",
        allTheWay: allTheWay
      });
    }),
    down: useAction(function (allTheWay) {
      return dispatch({
        type: "down",
        allTheWay: allTheWay
      });
    }),
    first: useAction(function () {
      return dispatch({
        type: "first"
      });
    }),
    last: useAction(function () {
      return dispatch({
        type: "last"
      });
    }),
    sort: useAction(function () {
      return dispatch({
        type: "sort"
      });
    }),
    unstable_setVirtual: useAction(function (value) {
      return dispatch({
        type: "setVirtual",
        virtual: value
      });
    }),
    setRTL: useAction(function (value) {
      return dispatch({
        type: "setRTL",
        rtl: value
      });
    }),
    setOrientation: useAction(function (value) {
      return dispatch({
        type: "setOrientation",
        orientation: value
      });
    }),
    setCurrentId: useAction(function (value) {
      return dispatch({
        type: "setCurrentId",
        currentId: value
      });
    }),
    setLoop: useAction(function (value) {
      return dispatch({
        type: "setLoop",
        loop: value
      });
    }),
    setWrap: useAction(function (value) {
      return dispatch({
        type: "setWrap",
        wrap: value
      });
    }),
    setShift: useAction(function (value) {
      return dispatch({
        type: "setShift",
        shift: value
      });
    }),
    unstable_setIncludesBaseElement: useAction(function (value) {
      return dispatch({
        type: "setIncludesBaseElement",
        includesBaseElement: value
      });
    }),
    reset: useAction(function () {
      return dispatch({
        type: "reset"
      });
    })
  });
}

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$3(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles$1(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$2 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles$1,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max$2 = Math.max;
var min$1 = Math.min;
var round$1 = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round$1(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round$1(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement$3(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$3(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return max$2(min, min$1(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round$1(x * dpr) / dpr || 0,
    y: round$1(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$2(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$2(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max$2(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$3(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement$3(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$3(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$2(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$2(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$3(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$1(min, tetherMin) : min, offset, tether ? max$2(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round$1(rect.width) / element.offsetWidth || 1;
  var scaleY = round$1(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$3(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$2, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

function useLastValue(value) {
  var lastValue = useRef(null);
  useIsomorphicEffect(function () {
    lastValue.current = value;
  }, [value]);
  return lastValue;
}

function useDisclosureState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$visib = _useSealedState.visible,
      initialVisible = _useSealedState$visib === void 0 ? false : _useSealedState$visib,
      _useSealedState$anima = _useSealedState.animated,
      initialAnimated = _useSealedState$anima === void 0 ? false : _useSealedState$anima,
      sealed = _objectWithoutPropertiesLoose$1(_useSealedState, ["visible", "animated"]);

  var id = unstable_useIdState(sealed);

  var _React$useState = useState(initialVisible),
      visible = _React$useState[0],
      setVisible = _React$useState[1];

  var _React$useState2 = useState(initialAnimated),
      animated = _React$useState2[0],
      setAnimated = _React$useState2[1];

  var _React$useState3 = useState(false),
      animating = _React$useState3[0],
      setAnimating = _React$useState3[1];

  var lastVisible = useLastValue(visible);
  var visibleHasChanged = lastVisible.current != null && lastVisible.current !== visible;

  if (animated && !animating && visibleHasChanged) {
    // Sets animating to true when when visible is updated
    setAnimating(true);
  }

  useEffect(function () {
    if (typeof animated === "number" && animating) {
      var timeout = setTimeout(function () {
        return setAnimating(false);
      }, animated);
      return function () {
        clearTimeout(timeout);
      };
    }

    if (animated && animating && process.env.NODE_ENV === "development") {
      var _timeout = setTimeout(function () {
        process.env.NODE_ENV !== "production" ? warning$1(animating, "It's been 8 seconds but stopAnimation has not been called. Does the disclousure element have a CSS transition?") : void 0;
      }, 8000);

      return function () {
        clearTimeout(_timeout);
      };
    }

    return function () {};
  }, [animated, animating]);
  var show = useCallback(function () {
    return setVisible(true);
  }, []);
  var hide = useCallback(function () {
    return setVisible(false);
  }, []);
  var toggle = useCallback(function () {
    return setVisible(function (v) {
      return !v;
    });
  }, []);
  var stopAnimation = useCallback(function () {
    return setAnimating(false);
  }, []);
  return _objectSpread2(_objectSpread2({}, id), {}, {
    visible: visible,
    animated: animated,
    animating: animating,
    show: show,
    hide: hide,
    toggle: toggle,
    setVisible: setVisible,
    setAnimated: setAnimated,
    stopAnimation: stopAnimation
  });
}

function useDialogState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$modal = _useSealedState.modal,
      initialModal = _useSealedState$modal === void 0 ? true : _useSealedState$modal,
      sealed = _objectWithoutPropertiesLoose$1(_useSealedState, ["modal"]);

  var disclosure = useDisclosureState(sealed);

  var _React$useState = useState(initialModal),
      modal = _React$useState[0],
      setModal = _React$useState[1];

  var disclosureRef = useRef(null);
  return _objectSpread2(_objectSpread2({}, disclosure), {}, {
    modal: modal,
    setModal: setModal,
    unstable_disclosureRef: disclosureRef
  });
}

var isSafari = isUA("Mac") && !isUA("Chrome") && isUA("Safari");

function applyStyles(styles) {
  return function (prevStyles) {
    if (styles && !shallowEqual(prevStyles, styles)) {
      return styles;
    }

    return prevStyles;
  };
}

function usePopoverState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$gutte = _useSealedState.gutter,
      gutter = _useSealedState$gutte === void 0 ? 12 : _useSealedState$gutte,
      _useSealedState$place = _useSealedState.placement,
      sealedPlacement = _useSealedState$place === void 0 ? "bottom" : _useSealedState$place,
      _useSealedState$unsta = _useSealedState.unstable_flip,
      flip = _useSealedState$unsta === void 0 ? true : _useSealedState$unsta,
      sealedOffset = _useSealedState.unstable_offset,
      _useSealedState$unsta2 = _useSealedState.unstable_preventOverflow,
      preventOverflow = _useSealedState$unsta2 === void 0 ? true : _useSealedState$unsta2,
      _useSealedState$unsta3 = _useSealedState.unstable_fixed,
      fixed = _useSealedState$unsta3 === void 0 ? false : _useSealedState$unsta3,
      _useSealedState$modal = _useSealedState.modal,
      modal = _useSealedState$modal === void 0 ? false : _useSealedState$modal,
      sealed = _objectWithoutPropertiesLoose$1(_useSealedState, ["gutter", "placement", "unstable_flip", "unstable_offset", "unstable_preventOverflow", "unstable_fixed", "modal"]);

  var popper = useRef(null);
  var referenceRef = useRef(null);
  var popoverRef = useRef(null);
  var arrowRef = useRef(null);

  var _React$useState = useState(sealedPlacement),
      originalPlacement = _React$useState[0],
      place = _React$useState[1];

  var _React$useState2 = useState(sealedPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  var _React$useState3 = useState(sealedOffset || [0, gutter]),
      offset = _React$useState3[0];

  var _React$useState4 = useState({
    position: "fixed",
    left: "100%",
    top: "100%"
  }),
      popoverStyles = _React$useState4[0],
      setPopoverStyles = _React$useState4[1];

  var _React$useState5 = useState({}),
      arrowStyles = _React$useState5[0],
      setArrowStyles = _React$useState5[1];

  var dialog = useDialogState(_objectSpread2({
    modal: modal
  }, sealed));
  var update = useCallback(function () {
    if (popper.current) {
      popper.current.forceUpdate();
      return true;
    }

    return false;
  }, []);
  var updateState = useCallback(function (state) {
    if (state.placement) {
      setPlacement(state.placement);
    }

    if (state.styles) {
      setPopoverStyles(applyStyles(state.styles.popper));

      if (arrowRef.current) {
        setArrowStyles(applyStyles(state.styles.arrow));
      }
    }
  }, []);
  useIsomorphicEffect(function () {
    if (referenceRef.current && popoverRef.current) {
      popper.current = createPopper(referenceRef.current, popoverRef.current, {
        // https://popper.js.org/docs/v2/constructors/#options
        placement: originalPlacement,
        strategy: fixed ? "fixed" : "absolute",
        // Safari needs styles to be applied in the first render, otherwise
        // hovering over the popover when it gets visible for the first time
        // will change its dimensions unexpectedly.
        onFirstUpdate: isSafari ? updateState : undefined,
        modifiers: [{
          // https://popper.js.org/docs/v2/modifiers/event-listeners/
          name: "eventListeners",
          enabled: dialog.visible
        }, {
          // https://popper.js.org/docs/v2/modifiers/apply-styles/
          name: "applyStyles",
          enabled: false
        }, {
          // https://popper.js.org/docs/v2/modifiers/flip/
          name: "flip",
          enabled: flip,
          options: {
            padding: 8
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/offset/
          name: "offset",
          options: {
            offset: offset
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/prevent-overflow/
          name: "preventOverflow",
          enabled: preventOverflow,
          options: {
            tetherOffset: function tetherOffset() {
              var _arrowRef$current;

              return ((_arrowRef$current = arrowRef.current) === null || _arrowRef$current === void 0 ? void 0 : _arrowRef$current.clientWidth) || 0;
            }
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/arrow/
          name: "arrow",
          enabled: !!arrowRef.current,
          options: {
            element: arrowRef.current
          }
        }, {
          // https://popper.js.org/docs/v2/modifiers/#custom-modifiers
          name: "updateState",
          phase: "write",
          requires: ["computeStyles"],
          enabled: dialog.visible && process.env.NODE_ENV !== "test",
          fn: function fn(_ref) {
            var state = _ref.state;
            return updateState(state);
          }
        }]
      });
    }

    return function () {
      if (popper.current) {
        popper.current.destroy();
        popper.current = null;
      }
    };
  }, [originalPlacement, fixed, dialog.visible, flip, offset, preventOverflow]); // Ensure that the popover will be correctly positioned with an additional
  // update.

  useEffect(function () {
    if (!dialog.visible) return undefined;
    var id = window.requestAnimationFrame(function () {
      var _popper$current;

      (_popper$current = popper.current) === null || _popper$current === void 0 ? void 0 : _popper$current.forceUpdate();
    });
    return function () {
      window.cancelAnimationFrame(id);
    };
  }, [dialog.visible]);
  return _objectSpread2(_objectSpread2({}, dialog), {}, {
    unstable_referenceRef: referenceRef,
    unstable_popoverRef: popoverRef,
    unstable_arrowRef: arrowRef,
    unstable_popoverStyles: popoverStyles,
    unstable_arrowStyles: arrowStyles,
    unstable_update: update,
    unstable_originalPlacement: originalPlacement,
    placement: placement,
    place: place
  });
}

// Automatically generated
var DISCLOSURE_STATE_KEYS = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation"];
var DISCLOSURE_KEYS = DISCLOSURE_STATE_KEYS;
var DISCLOSURE_CONTENT_KEYS = DISCLOSURE_KEYS;

var useDisclosureContent = createHook({
  name: "DisclosureContent",
  compose: useRole,
  keys: DISCLOSURE_CONTENT_KEYS,
  useProps: function useProps(options, _ref) {
    var htmlOnTransitionEnd = _ref.onTransitionEnd,
        htmlOnAnimationEnd = _ref.onAnimationEnd,
        htmlStyle = _ref.style,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["onTransitionEnd", "onAnimationEnd", "style"]);

    var animating = options.animated && options.animating;

    var _React$useState = useState(null),
        transition = _React$useState[0],
        setTransition = _React$useState[1];

    var hidden = !options.visible && !animating;
    var style = hidden ? _objectSpread2({
      display: "none"
    }, htmlStyle) : htmlStyle;
    var onTransitionEndRef = useLiveRef(htmlOnTransitionEnd);
    var onAnimationEndRef = useLiveRef(htmlOnAnimationEnd);
    var raf = useRef(0);
    useEffect(function () {
      if (!options.animated) return undefined; // Double RAF is needed so the browser has enough time to paint the
      // default styles before processing the `data-enter` attribute. Otherwise
      // it wouldn't be considered a transition.
      // See https://github.com/reakit/reakit/issues/643

      raf.current = window.requestAnimationFrame(function () {
        raf.current = window.requestAnimationFrame(function () {
          if (options.visible) {
            setTransition("enter");
          } else if (animating) {
            setTransition("leave");
          } else {
            setTransition(null);
          }
        });
      });
      return function () {
        return window.cancelAnimationFrame(raf.current);
      };
    }, [options.animated, options.visible, animating]);
    var onEnd = useCallback(function (event) {
      if (!isSelfTarget(event)) return;
      if (!animating) return; // Ignores number animated

      if (options.animated === true) {
        var _options$stopAnimatio;

        (_options$stopAnimatio = options.stopAnimation) === null || _options$stopAnimatio === void 0 ? void 0 : _options$stopAnimatio.call(options);
      }
    }, [options.animated, animating, options.stopAnimation]);
    var onTransitionEnd = useCallback(function (event) {
      var _onTransitionEndRef$c;

      (_onTransitionEndRef$c = onTransitionEndRef.current) === null || _onTransitionEndRef$c === void 0 ? void 0 : _onTransitionEndRef$c.call(onTransitionEndRef, event);
      onEnd(event);
    }, [onEnd]);
    var onAnimationEnd = useCallback(function (event) {
      var _onAnimationEndRef$cu;

      (_onAnimationEndRef$cu = onAnimationEndRef.current) === null || _onAnimationEndRef$cu === void 0 ? void 0 : _onAnimationEndRef$cu.call(onAnimationEndRef, event);
      onEnd(event);
    }, [onEnd]);
    return _objectSpread2({
      id: options.baseId,
      "data-enter": transition === "enter" ? "" : undefined,
      "data-leave": transition === "leave" ? "" : undefined,
      onTransitionEnd: onTransitionEnd,
      onAnimationEnd: onAnimationEnd,
      hidden: hidden,
      style: style
    }, htmlProps);
  }
});
createComponent({
  as: "div",
  useHook: useDisclosureContent
});

function getBodyElement() {
  return canUseDOM ? document.body : null;
}

var PortalContext = /*#__PURE__*/createContext(getBodyElement());
function Portal$3(_ref) {
  var children = _ref.children;
  // if it's a nested portal, context is the parent portal
  // otherwise it's document.body
  // https://github.com/reakit/reakit/issues/513
  var context = useContext(PortalContext) || getBodyElement();

  var _React$useState = useState(function () {
    if (canUseDOM) {
      var element = document.createElement("div");
      element.className = Portal$3.__className;
      return element;
    } // ssr


    return null;
  }),
      hostNode = _React$useState[0];

  useIsomorphicEffect(function () {
    if (!hostNode || !context) return undefined;
    context.appendChild(hostNode);
    return function () {
      context.removeChild(hostNode);
    };
  }, [hostNode, context]);

  if (hostNode) {
    return /*#__PURE__*/createPortal( /*#__PURE__*/createElement(PortalContext.Provider, {
      value: hostNode
    }, children), hostNode);
  } // ssr


  return null;
}
Portal$3.__className = "__reakit-portal";
Portal$3.__selector = "." + Portal$3.__className;

var MenuContext = /*#__PURE__*/createContext(null);
function useMenuContext(menuRef, role, options) {
  var orphan = "unstable_orphan" in options && options.unstable_orphan;
  var parent = useContext(MenuContext);

  var _React$useState = useState([]),
      children = _React$useState[0],
      setChildren = _React$useState[1];

  var _ref = parent || {},
      addChildToParent = _ref.addChild,
      removeChildFromParent = _ref.removeChild;

  var addChild = useCallback(function (ref) {
    return setChildren(function (refs) {
      return [].concat(refs, [ref]);
    });
  }, []);
  var removeChild = useCallback(function (ref) {
    return setChildren(function (refs) {
      return removeItemFromArray(refs, ref);
    });
  }, []); // If it's a nested menu, add it to parent

  useEffect(function () {
    if (!addChildToParent || orphan) return undefined;
    addChildToParent(menuRef);
    return function () {
      removeChildFromParent === null || removeChildFromParent === void 0 ? void 0 : removeChildFromParent(menuRef);
    };
  }, [menuRef, addChildToParent, removeChildFromParent, orphan]);
  var providerValue = useMemo(function () {
    return {
      orientation: options.orientation,
      next: options.next,
      previous: options.previous,
      ref: menuRef,
      role: role,
      parent: parent,
      children: children,
      addChild: addChild,
      removeChild: removeChild
    };
  }, [options.orientation, options.next, options.previous, menuRef, role, parent, children, addChild, removeChild]);
  var wrapElement = useCallback(function (element) {
    return /*#__PURE__*/createElement(MenuContext.Provider, {
      value: providerValue
    }, element);
  }, [providerValue]);
  return wrapElement;
}

function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray$1(locks), [lock]);

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};

var DialogBackdropContext = /*#__PURE__*/createContext(undefined);

// Automatically generated
var DIALOG_STATE_KEYS = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal"];
var DIALOG_KEYS = [].concat(DIALOG_STATE_KEYS, ["hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_initialFocusRef", "unstable_finalFocusRef", "unstable_orphan", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide"]);
var DIALOG_BACKDROP_KEYS = DIALOG_STATE_KEYS;
var DIALOG_DISCLOSURE_KEYS = DIALOG_BACKDROP_KEYS;

function useDisclosureRef(dialogRef, options) {
  var ref = useRef(null);
  var animating = !!(options.animated && options.animating);
  useEffect(function () {
    if (options.visible || animating) return undefined; // We get the last focused element before the dialog opens, so we can move
    // focus back to it when the dialog closes.

    var onFocus = function onFocus(event) {
      var target = event.target;

      if ("focus" in target) {
        ref.current = target;

        if (options.unstable_disclosureRef) {
          options.unstable_disclosureRef.current = target;
        }
      }
    };

    var document = getDocument(dialogRef.current);
    document.addEventListener("focusin", onFocus);
    return function () {
      return document.removeEventListener("focusin", onFocus);
    };
  }, [options.visible, animating, options.unstable_disclosureRef, dialogRef]);
  useEffect(function () {
    var _options$unstable_dis;

    if (!options.visible || animating) return undefined; // Safari and Firefox on MacOS don't focus on buttons on mouse down.
    // Instead, they focus on the closest focusable parent (ultimately, the
    // body element). This works around that by preventing that behavior and
    // forcing focus on the disclosure button. Otherwise, we wouldn't be able
    // to close the dialog by clicking again on the disclosure.

    var onMouseDown = function onMouseDown(event) {
      var element = event.currentTarget;
      if (!isButton(element)) return;
      event.preventDefault();
      element.focus();
    };

    var disclosure = ((_options$unstable_dis = options.unstable_disclosureRef) === null || _options$unstable_dis === void 0 ? void 0 : _options$unstable_dis.current) || ref.current;
    disclosure === null || disclosure === void 0 ? void 0 : disclosure.addEventListener("mousedown", onMouseDown);
    return function () {
      return disclosure === null || disclosure === void 0 ? void 0 : disclosure.removeEventListener("mousedown", onMouseDown);
    };
  }, [options.visible, animating, options.unstable_disclosureRef]);
  return options.unstable_disclosureRef || ref;
}

function usePreventBodyScroll(targetRef, options) {
  var shouldPrevent = Boolean(options.preventBodyScroll && options.visible);
  useEffect(function () {
    var element = targetRef.current;
    if (!element || !shouldPrevent) return undefined;
    disableBodyScroll(element, {
      reserveScrollBarGap: true
    });
    return function () {
      return enableBodyScroll(element);
    };
  }, [targetRef, shouldPrevent]);
}

function useFocusOnShow(dialogRef, nestedDialogs, options) {
  var initialFocusRef = options.unstable_initialFocusRef;
  var shouldFocus = options.visible && options.unstable_autoFocusOnShow;
  var animating = !!(options.animated && options.animating);
  useUpdateEffect(function () {
    var dialog = dialogRef.current;
    process.env.NODE_ENV !== "production" ? warning$1(!!shouldFocus && !dialog, "[reakit/Dialog]", "Can't set initial focus on dialog because `ref` wasn't passed to the dialog element.", "See https://reakit.io/docs/dialog") : void 0;
    if (!shouldFocus) return;
    if (!dialog) return;
    if (animating) return; // If there're nested open dialogs, let them handle focus

    if (nestedDialogs.some(function (child) {
      return child.current && !child.current.hidden;
    })) {
      return;
    }

    if (initialFocusRef !== null && initialFocusRef !== void 0 && initialFocusRef.current) {
      initialFocusRef.current.focus({
        preventScroll: true
      });
    } else {
      var tabbable = getFirstTabbableIn(dialog, true);

      var isActive = function isActive() {
        return hasFocusWithin(dialog);
      };

      if (tabbable) {
        ensureFocus(tabbable, {
          preventScroll: true,
          isActive: isActive
        });
      } else {
        ensureFocus(dialog, {
          preventScroll: true,
          isActive: isActive
        });
        process.env.NODE_ENV !== "production" ? warning$1(dialog.tabIndex === undefined || dialog.tabIndex < 0, "It's recommended to have at least one tabbable element inside dialog. The dialog element has been automatically focused.", "If this is the intended behavior, pass `tabIndex={0}` to the dialog element to disable this warning.", "See https://reakit.io/docs/dialog/#initial-focus", dialog) : void 0;
      }
    }
  }, [dialogRef, shouldFocus, animating, nestedDialogs, initialFocusRef]);
}

function usePortalRef(dialogRef, options) {
  var portalRef = useRef(null);
  useEffect(function () {
    var dialog = dialogRef.current;
    if (!dialog || !options.visible) return;
    portalRef.current = closest(dialog, Portal$3.__selector);
  }, [dialogRef, options.visible]);
  return portalRef;
}

function removeFromDOM(element) {
  if (element.parentNode == null) return;
  element.parentNode.removeChild(element);
}

var focusTrapClassName = "__reakit-focus-trap";
function isFocusTrap(element) {
  var _element$classList;

  return (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.contains(focusTrapClassName);
}
function useFocusTrap(dialogRef, visibleModals, options) {
  var portalRef = usePortalRef(dialogRef, options);
  var shouldTrap = options.visible && options.modal;
  var beforeElement = useRef(null);
  var afterElement = useRef(null); // Create before and after elements
  // https://github.com/w3c/aria-practices/issues/545

  useEffect(function () {
    if (!shouldTrap) return undefined;
    var portal = portalRef.current;

    if (!portal) {
      process.env.NODE_ENV !== "production" ? warning$1(true, "Can't trap focus within modal dialog because either `ref` wasn't passed to component or the component wasn't rendered within a portal", "See https://reakit.io/docs/dialog") : void 0;
      return undefined;
    }

    if (!beforeElement.current) {
      var document = getDocument(portal);
      beforeElement.current = document.createElement("div");
      beforeElement.current.className = focusTrapClassName;
      beforeElement.current.tabIndex = 0;
      beforeElement.current.style.position = "fixed";
      beforeElement.current.setAttribute("aria-hidden", "true");
    }

    if (!afterElement.current) {
      afterElement.current = beforeElement.current.cloneNode();
    }

    portal.insertAdjacentElement("beforebegin", beforeElement.current);
    portal.insertAdjacentElement("afterend", afterElement.current);
    return function () {
      if (beforeElement.current) removeFromDOM(beforeElement.current);
      if (afterElement.current) removeFromDOM(afterElement.current);
    };
  }, [portalRef, shouldTrap]); // Focus trap

  useEffect(function () {
    var before = beforeElement.current;
    var after = afterElement.current;
    if (!shouldTrap || !before || !after) return undefined;

    var handleFocus = function handleFocus(event) {
      var dialog = dialogRef.current;
      if (!dialog || visibleModals.length) return;
      event.preventDefault();
      var isAfter = event.target === after;
      var tabbable = isAfter ? getFirstTabbableIn(dialog) : getLastTabbableIn(dialog);

      if (tabbable) {
        tabbable.focus();
      } else {
        // fallback to dialog
        dialog.focus();
      }
    };

    before.addEventListener("focus", handleFocus);
    after.addEventListener("focus", handleFocus);
    return function () {
      before.removeEventListener("focus", handleFocus);
      after.removeEventListener("focus", handleFocus);
    };
  }, [dialogRef, visibleModals, shouldTrap]);
}

function hidByFocusingAnotherElement(dialogRef) {
  var dialog = dialogRef.current;
  if (!dialog) return false;
  var activeElement = getActiveElement(dialog);
  if (!activeElement) return false;
  if (contains$1(dialog, activeElement)) return false;
  if (isTabbable(activeElement)) return true;
  if (activeElement.getAttribute("data-dialog") === "true") return true;
  return false;
}

function useFocusOnHide(dialogRef, disclosureRef, options) {
  var shouldFocus = options.unstable_autoFocusOnHide && !options.visible;
  var animating = !!(options.animated && options.animating);
  useUpdateEffect(function () {
    var _options$unstable_fin;

    if (!shouldFocus) return;
    if (animating) return; // Hide was triggered by a click/focus on a tabbable element outside
    // the dialog or on another dialog. We won't change focus then.

    if (hidByFocusingAnotherElement(dialogRef)) {
      return;
    }

    var finalFocusEl = ((_options$unstable_fin = options.unstable_finalFocusRef) === null || _options$unstable_fin === void 0 ? void 0 : _options$unstable_fin.current) || disclosureRef.current;

    if (finalFocusEl) {
      if (finalFocusEl.id) {
        var document = getDocument(finalFocusEl);
        var compositeElement = document.querySelector("[aria-activedescendant='" + finalFocusEl.id + "']");

        if (compositeElement) {
          ensureFocus(compositeElement);
          return;
        }
      }

      ensureFocus(finalFocusEl);
      return;
    }

    process.env.NODE_ENV !== "production" ? warning$1(true, "Can't return focus after closing dialog. Either render a disclosure component or provide a `unstable_finalFocusRef` prop.", "See https://reakit.io/docs/dialog", dialogRef.current) : void 0;
  }, [shouldFocus, animating, dialogRef, disclosureRef]);
}

var DialogContext = /*#__PURE__*/createContext({});
function useNestedDialogs(dialogRef, options) {
  var context = useContext(DialogContext);

  var _React$useState = useState([]),
      dialogs = _React$useState[0],
      setDialogs = _React$useState[1];

  var _React$useState2 = useState(dialogs),
      visibleModals = _React$useState2[0],
      setVisibleModals = _React$useState2[1];

  var addDialog = useCallback(function (ref) {
    var _context$addDialog;

    (_context$addDialog = context.addDialog) === null || _context$addDialog === void 0 ? void 0 : _context$addDialog.call(context, ref);
    setDialogs(function (prevDialogs) {
      return [].concat(prevDialogs, [ref]);
    });
  }, [context.addDialog]);
  var removeDialog = useCallback(function (ref) {
    var _context$removeDialog;

    (_context$removeDialog = context.removeDialog) === null || _context$removeDialog === void 0 ? void 0 : _context$removeDialog.call(context, ref);
    setDialogs(function (prevDialogs) {
      return removeItemFromArray(prevDialogs, ref);
    });
  }, [context.removeDialog]);
  var showDialog = useCallback(function (ref) {
    var _context$showDialog;

    (_context$showDialog = context.showDialog) === null || _context$showDialog === void 0 ? void 0 : _context$showDialog.call(context, ref);
    setVisibleModals(function (prevDialogs) {
      return [].concat(prevDialogs, [ref]);
    });
  }, [context.showDialog]);
  var hideDialog = useCallback(function (ref) {
    var _context$hideDialog;

    (_context$hideDialog = context.hideDialog) === null || _context$hideDialog === void 0 ? void 0 : _context$hideDialog.call(context, ref);
    setVisibleModals(function (prevDialogs) {
      return removeItemFromArray(prevDialogs, ref);
    });
  }, [context.hideDialog]); // If it's a nested dialog, add it to context

  useEffect(function () {
    var _context$addDialog2;

    if (options.unstable_orphan) return undefined;
    (_context$addDialog2 = context.addDialog) === null || _context$addDialog2 === void 0 ? void 0 : _context$addDialog2.call(context, dialogRef);
    return function () {
      var _context$removeDialog2;

      (_context$removeDialog2 = context.removeDialog) === null || _context$removeDialog2 === void 0 ? void 0 : _context$removeDialog2.call(context, dialogRef);
    };
  }, [options.unstable_orphan, context.addDialog, dialogRef, context.removeDialog]);
  useEffect(function () {
    var _context$showDialog2;

    if (options.unstable_orphan) return undefined;
    if (!options.modal) return undefined;
    if (!options.visible) return undefined;
    (_context$showDialog2 = context.showDialog) === null || _context$showDialog2 === void 0 ? void 0 : _context$showDialog2.call(context, dialogRef);
    return function () {
      var _context$hideDialog2;

      (_context$hideDialog2 = context.hideDialog) === null || _context$hideDialog2 === void 0 ? void 0 : _context$hideDialog2.call(context, dialogRef);
    };
  }, [options.unstable_orphan, options.modal, options.visible, context.showDialog, dialogRef, context.hideDialog]); // Close all nested dialogs when parent dialog closes

  useEffect(function () {
    if (context.visible === false && options.visible && !options.unstable_orphan) {
      var _options$hide;

      (_options$hide = options.hide) === null || _options$hide === void 0 ? void 0 : _options$hide.call(options);
    }
  }, [context.visible, options.visible, options.hide, options.unstable_orphan]); // Provider

  var providerValue = useMemo(function () {
    return {
      visible: options.visible,
      addDialog: addDialog,
      removeDialog: removeDialog,
      showDialog: showDialog,
      hideDialog: hideDialog
    };
  }, [options.visible, addDialog, removeDialog, showDialog, hideDialog]);
  var wrap = useCallback(function (element) {
    return /*#__PURE__*/createElement(DialogContext.Provider, {
      value: providerValue
    }, element);
  }, [providerValue]);
  return {
    dialogs: dialogs,
    visibleModals: visibleModals,
    wrap: wrap
  };
}

function dialogContains(target) {
  return function (dialogRef) {
    var dialog = dialogRef.current;
    if (!dialog) return false;
    if (contains$1(dialog, target)) return true;
    var document = getDocument(dialog);
    var backdrop = document.querySelector("[data-dialog-ref=\"" + dialog.id + "\"]");

    if (backdrop) {
      return contains$1(backdrop, target);
    }

    return false;
  };
}

function isDisclosure(target, disclosure) {
  return contains$1(disclosure, target);
}

function isInDocument(target) {
  var document = getDocument(target);

  if (target.tagName === "HTML") {
    return true;
  }

  return contains$1(document.body, target);
}

function useEventListenerOutside(containerRef, disclosureRef, nestedDialogs, eventType, listener, shouldListen, capture) {
  var listenerRef = useLiveRef(listener);
  useEffect(function () {
    if (!shouldListen) return undefined;

    var onEvent = function onEvent(event) {
      if (!listenerRef.current) return;
      var container = containerRef.current;
      var disclosure = disclosureRef.current;
      var target = event.target;

      if (!container) {
        process.env.NODE_ENV !== "production" ? warning$1(true, "Can't detect events outside dialog because `ref` wasn't passed to component.", "See https://reakit.io/docs/dialog") : void 0;
        return;
      } // When an element is unmounted right after it receives focus, the focus
      // event is triggered after that, when the element isn't part of the
      // current document anymore. So we ignore it.


      if (!isInDocument(target)) return; // Event inside dialog

      if (contains$1(container, target)) return; // Event on disclosure

      if (disclosure && isDisclosure(target, disclosure)) return; // Event inside a nested dialog or focus trap

      if (isFocusTrap(target) || nestedDialogs.some(dialogContains(target))) {
        return;
      }

      listenerRef.current(event);
    };

    var document = getDocument(containerRef.current);
    document.addEventListener(eventType, onEvent, capture);
    return function () {
      return document.removeEventListener(eventType, onEvent, capture);
    };
  }, [containerRef, disclosureRef, nestedDialogs, eventType, shouldListen, listenerRef]);
}

function useMouseDownRef(dialogRef, options) {
  var mouseDownRef = useRef();
  useEffect(function () {
    if (!options.visible) return undefined;
    if (!options.hideOnClickOutside) return undefined;
    var document = getDocument(dialogRef.current);

    var onMouseDown = function onMouseDown(event) {
      mouseDownRef.current = event.target;
    };

    document.addEventListener("mousedown", onMouseDown);
    return function () {
      return document.removeEventListener("mousedown", onMouseDown);
    };
  }, [options.visible, options.hideOnClickOutside, dialogRef]);
  return mouseDownRef;
}

function useHideOnClickOutside(dialogRef, disclosureRef, nestedDialogs, options) {
  var mouseDownRef = useMouseDownRef(dialogRef, options);
  useEventListenerOutside(dialogRef, disclosureRef, nestedDialogs, "click", function (event) {
    // Make sure the element that has been clicked is the same that last
    // triggered the mousedown event. This prevents the dialog from closing
    // by dragging the cursor (for example, selecting some text inside the
    // dialog and releasing the mouse outside of it).
    if (mouseDownRef.current === event.target) {
      var _options$hide;

      (_options$hide = options.hide) === null || _options$hide === void 0 ? void 0 : _options$hide.call(options);
    }
  }, options.visible && options.hideOnClickOutside);
  useEventListenerOutside(dialogRef, disclosureRef, nestedDialogs, "focusin", function (event) {
    var document = getDocument(dialogRef.current); // Fix for https://github.com/reakit/reakit/issues/619
    // On IE11, calling element.blur() triggers the focus event on
    // document.body, so we make sure to ignore it as well.

    if (event.target !== document && event.target !== document.body) {
      var _options$hide2;

      (_options$hide2 = options.hide) === null || _options$hide2 === void 0 ? void 0 : _options$hide2.call(options);
    }
  }, options.visible && options.hideOnClickOutside);
}

function useDisableHoverOutside(portalRef, nestedDialogs, options) {
  var useEvent = function useEvent(eventType) {
    return useEventListenerOutside(portalRef, {
      current: null
    }, nestedDialogs, eventType, function (event) {
      event.stopPropagation();
      event.preventDefault();
    }, options.visible && options.modal, true);
  };

  useEvent("mouseover");
  useEvent("mousemove");
  useEvent("mouseout");
}

/**
 * When the focused child gets removed from the DOM, we make sure to move focus
 * to the dialog.
 */
function useFocusOnChildUnmount(dialogRef, options) {
  useEffect(function () {
    var dialog = dialogRef.current;
    if (!options.visible || !dialog) return undefined;
    var observer = new MutationObserver(function (mutations) {
      var target = mutations[0].target; // If target is not this dialog, then this observer was triggered by a
      // nested dialog, so we just ignore it here and let the nested dialog
      // handle it there.

      if (target !== dialog) return;
      var document = getDocument(dialog);
      var activeElement = getActiveElement(dialog); // We can check if the current focused element is the document body. On
      // IE 11, it's an empty object when the current document is in a frame or
      // iframe.

      if (activeElement === document.body || isEmpty(activeElement)) {
        dialog.focus();
      }
    });
    observer.observe(dialog, {
      childList: true,
      subtree: true
    });
    return function () {
      observer.disconnect();
    };
  }, [options.visible, dialogRef]);
}

function isActualElement(element) {
  return element && element.tagName && element.tagName !== "HTML" && element !== getDocument(element).body;
}

function useFocusOnBlur(dialogRef, options) {
  var _React$useReducer = useReducer(function (n) {
    return n + 1;
  }, 0),
      blurred = _React$useReducer[0],
      scheduleFocus = _React$useReducer[1];

  useIsomorphicEffect(function () {
    var dialog = dialogRef.current;
    if (!options.visible) return;
    if (!blurred) return; // After blur, if the active element isn't an actual element, this probably
    // means that element.blur() was called on an element inside the dialog.
    // In this case, the browser will automatically focus the body element.
    // So we move focus back to the dialog.

    if (!isActualElement(getActiveElement(dialog))) {
      process.env.NODE_ENV !== "production" ? warning$1(!dialog, "Can't focus dialog after a nested element got blurred because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog") : void 0;
      dialog === null || dialog === void 0 ? void 0 : dialog.focus();
    }
  }, [blurred, dialogRef]);
  var onBlur = useCallback(function (event) {
    if (!options.visible) return;
    var nextActiveElement = getNextActiveElementOnBlur(event);

    if (!isActualElement(nextActiveElement)) {
      scheduleFocus();
    }
  }, [options.visible]);
  return onBlur;
}

var useDialog = createHook({
  name: "Dialog",
  compose: useDisclosureContent,
  keys: DIALOG_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$modal = _ref.modal,
        modal = _ref$modal === void 0 ? true : _ref$modal,
        _ref$hideOnEsc = _ref.hideOnEsc,
        hideOnEsc = _ref$hideOnEsc === void 0 ? true : _ref$hideOnEsc,
        _ref$hideOnClickOutsi = _ref.hideOnClickOutside,
        hideOnClickOutside = _ref$hideOnClickOutsi === void 0 ? true : _ref$hideOnClickOutsi,
        _ref$preventBodyScrol = _ref.preventBodyScroll,
        preventBodyScroll = _ref$preventBodyScrol === void 0 ? modal : _ref$preventBodyScrol,
        _ref$unstable_autoFoc = _ref.unstable_autoFocusOnShow,
        unstable_autoFocusOnShow = _ref$unstable_autoFoc === void 0 ? true : _ref$unstable_autoFoc,
        _ref$unstable_autoFoc2 = _ref.unstable_autoFocusOnHide,
        unstable_autoFocusOnHide = _ref$unstable_autoFoc2 === void 0 ? true : _ref$unstable_autoFoc2,
        unstable_orphan = _ref.unstable_orphan,
        options = _objectWithoutPropertiesLoose$1(_ref, ["modal", "hideOnEsc", "hideOnClickOutside", "preventBodyScroll", "unstable_autoFocusOnShow", "unstable_autoFocusOnHide", "unstable_orphan"]);

    return _objectSpread2({
      modal: modal,
      hideOnEsc: hideOnEsc,
      hideOnClickOutside: hideOnClickOutside,
      preventBodyScroll: modal && preventBodyScroll,
      unstable_autoFocusOnShow: unstable_autoFocusOnShow,
      unstable_autoFocusOnHide: unstable_autoFocusOnHide,
      unstable_orphan: modal && unstable_orphan
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlRef = _ref2.ref,
        htmlOnKeyDown = _ref2.onKeyDown,
        htmlOnBlur = _ref2.onBlur,
        htmlWrapElement = _ref2.wrapElement,
        tabIndex = _ref2.tabIndex,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref2, ["ref", "onKeyDown", "onBlur", "wrapElement", "tabIndex"]);

    var dialog = useRef(null);
    var backdrop = useContext(DialogBackdropContext);
    var hasBackdrop = backdrop && backdrop === options.baseId;
    var disclosure = useDisclosureRef(dialog, options);
    var onKeyDownRef = useLiveRef(htmlOnKeyDown);
    var onBlurRef = useLiveRef(htmlOnBlur);
    var focusOnBlur = useFocusOnBlur(dialog, options);

    var _useNestedDialogs = useNestedDialogs(dialog, options),
        dialogs = _useNestedDialogs.dialogs,
        visibleModals = _useNestedDialogs.visibleModals,
        wrap = _useNestedDialogs.wrap; // VoiceOver/Safari accepts only one `aria-modal` container, so if there
    // are visible child modals, then we don't want to set aria-modal on the
    // parent modal (this component).


    var modal = options.modal && !visibleModals.length ? true : undefined;
    usePreventBodyScroll(dialog, options);
    useFocusTrap(dialog, visibleModals, options);
    useFocusOnChildUnmount(dialog, options);
    useFocusOnShow(dialog, dialogs, options);
    useFocusOnHide(dialog, disclosure, options);
    useHideOnClickOutside(dialog, disclosure, dialogs, options);
    useDisableHoverOutside(dialog, dialogs, options);
    var onKeyDown = useCallback(function (event) {
      var _onKeyDownRef$current;

      (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
      if (event.defaultPrevented) return;
      if (event.key !== "Escape") return;
      if (!options.hideOnEsc) return;

      if (!options.hide) {
        process.env.NODE_ENV !== "production" ? warning$1(true, "`hideOnEsc` prop is truthy, but `hide` prop wasn't provided.", "See https://reakit.io/docs/dialog", dialog.current) : void 0;
        return;
      }

      event.stopPropagation();
      options.hide();
    }, [options.hideOnEsc, options.hide]);
    var onBlur = useCallback(function (event) {
      var _onBlurRef$current;

      (_onBlurRef$current = onBlurRef.current) === null || _onBlurRef$current === void 0 ? void 0 : _onBlurRef$current.call(onBlurRef, event);
      focusOnBlur(event);
    }, [focusOnBlur]);
    var wrapElement = useCallback(function (element) {
      element = wrap(element);

      if (options.modal && !hasBackdrop) {
        element = /*#__PURE__*/createElement(Portal$3, null, element);
      }

      if (htmlWrapElement) {
        element = htmlWrapElement(element);
      }

      return (
        /*#__PURE__*/
        // Prevents Menu > Dialog > Menu to behave as a sub menu
        createElement(MenuContext.Provider, {
          value: null
        }, element)
      );
    }, [wrap, options.modal, hasBackdrop, htmlWrapElement]);
    return _objectSpread2({
      ref: useForkRef(dialog, htmlRef),
      role: "dialog",
      tabIndex: tabIndex != null ? tabIndex : -1,
      "aria-modal": modal,
      "data-dialog": true,
      onKeyDown: onKeyDown,
      onBlur: onBlur,
      wrapElement: wrapElement
    }, htmlProps);
  }
});
var Dialog = createComponent({
  as: "div",
  useHook: useDialog,
  useCreateElement: function useCreateElement$1(type, props, children) {
    process.env.NODE_ENV !== "production" ? useWarning(!props["aria-label"] && !props["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/dialog") : void 0;
    return useCreateElement(type, props, children);
  }
});

// Automatically generated
var POPOVER_STATE_KEYS = ["baseId", "unstable_idCountRef", "visible", "animated", "animating", "setBaseId", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"];
var POPOVER_KEYS = POPOVER_STATE_KEYS;
var POPOVER_BACKDROP_KEYS = POPOVER_KEYS;
var POPOVER_DISCLOSURE_KEYS = POPOVER_BACKDROP_KEYS;

var usePopover = createHook({
  name: "Popover",
  compose: useDialog,
  keys: POPOVER_KEYS,
  useOptions: function useOptions(_ref) {
    var _ref$modal = _ref.modal,
        modal = _ref$modal === void 0 ? false : _ref$modal,
        options = _objectWithoutPropertiesLoose$1(_ref, ["modal"]);

    return _objectSpread2({
      modal: modal
    }, options);
  },
  useProps: function useProps(options, _ref2) {
    var htmlRef = _ref2.ref,
        htmlStyle = _ref2.style,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref2, ["ref", "style"]);

    return _objectSpread2({
      ref: useForkRef(options.unstable_popoverRef, htmlRef),
      style: _objectSpread2(_objectSpread2({}, options.unstable_popoverStyles), htmlStyle)
    }, htmlProps);
  }
});
createComponent({
  as: "div",
  useHook: usePopover,
  useCreateElement: function useCreateElement$1(type, props, children) {
    process.env.NODE_ENV !== "production" ? useWarning(!props["aria-label"] && !props["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/popover") : void 0;
    return useCreateElement(type, props, children);
  }
});

var useDisclosure = createHook({
  name: "Disclosure",
  compose: useButton,
  keys: DISCLOSURE_KEYS,
  useProps: function useProps(options, _ref) {
    var htmlOnClick = _ref.onClick,
        ariaControls = _ref["aria-controls"],
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["onClick", "aria-controls"]);

    var onClickRef = useLiveRef(htmlOnClick);
    var controls = ariaControls ? ariaControls + " " + options.baseId : options.baseId;
    var onClick = useCallback(function (event) {
      var _onClickRef$current, _options$toggle;

      (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 ? void 0 : _onClickRef$current.call(onClickRef, event);
      if (event.defaultPrevented) return;
      (_options$toggle = options.toggle) === null || _options$toggle === void 0 ? void 0 : _options$toggle.call(options);
    }, [options.toggle]);
    return _objectSpread2({
      "aria-expanded": !!options.visible,
      "aria-controls": controls,
      onClick: onClick
    }, htmlProps);
  }
});
createComponent({
  as: "button",
  memo: true,
  useHook: useDisclosure
});

var useDialogDisclosure = createHook({
  name: "DialogDisclosure",
  compose: useDisclosure,
  keys: DIALOG_DISCLOSURE_KEYS,
  useProps: function useProps(options, _ref) {
    var htmlRef = _ref.ref,
        htmlOnClick = _ref.onClick,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["ref", "onClick"]);

    var ref = useRef(null);
    var onClickRef = useLiveRef(htmlOnClick);

    var _React$useState = useState(false),
        expanded = _React$useState[0],
        setExpanded = _React$useState[1];

    var disclosureRef = options.unstable_disclosureRef; // aria-expanded may be used for styling purposes, so we useLayoutEffect

    useIsomorphicEffect(function () {
      var element = ref.current;
      process.env.NODE_ENV !== "production" ? warning$1(!element, "Can't determine whether the element is the current disclosure because `ref` wasn't passed to the component", "See https://reakit.io/docs/dialog") : void 0;

      if (disclosureRef && !disclosureRef.current) {
        disclosureRef.current = element;
      }

      var isCurrentDisclosure = !(disclosureRef !== null && disclosureRef !== void 0 && disclosureRef.current) || disclosureRef.current === element;
      setExpanded(!!options.visible && isCurrentDisclosure);
    }, [options.visible, disclosureRef]);
    var onClick = useCallback(function (event) {
      var _onClickRef$current;

      (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 ? void 0 : _onClickRef$current.call(onClickRef, event);
      if (event.defaultPrevented) return;

      if (disclosureRef) {
        disclosureRef.current = event.currentTarget;
      }
    }, [disclosureRef]);
    return _objectSpread2({
      ref: useForkRef(ref, htmlRef),
      "aria-haspopup": "dialog",
      "aria-expanded": expanded,
      onClick: onClick
    }, htmlProps);
  }
});
var DialogDisclosure = createComponent({
  as: "button",
  memo: true,
  useHook: useDialogDisclosure
});

// Automatically generated
var MENU_BAR_STATE_KEYS = ["baseId", "unstable_idCountRef", "unstable_virtual", "rtl", "orientation", "items", "groups", "currentId", "loop", "wrap", "shift", "unstable_moves", "unstable_hasActiveWidget", "unstable_includesBaseElement", "unstable_values", "setBaseId", "registerItem", "unregisterItem", "registerGroup", "unregisterGroup", "move", "next", "previous", "up", "down", "first", "last", "sort", "unstable_setVirtual", "setRTL", "setOrientation", "setCurrentId", "setLoop", "setWrap", "setShift", "reset", "unstable_setIncludesBaseElement", "unstable_setHasActiveWidget", "unstable_setValue"];
var MENU_STATE_KEYS = [].concat(MENU_BAR_STATE_KEYS, ["visible", "animated", "animating", "show", "hide", "toggle", "setVisible", "setAnimated", "stopAnimation", "modal", "unstable_disclosureRef", "setModal", "unstable_referenceRef", "unstable_popoverRef", "unstable_arrowRef", "unstable_popoverStyles", "unstable_arrowStyles", "unstable_originalPlacement", "unstable_update", "placement", "place"]);
var MENU_KEYS = MENU_STATE_KEYS;
var MENU_ARROW_KEYS = MENU_KEYS;
var MENU_BAR_KEYS = MENU_ARROW_KEYS;
var MENU_BUTTON_KEYS = MENU_BAR_KEYS;

function useShortcuts(menuRef, _ref, timeout) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      move = _ref.move;

  if (timeout === void 0) {
    timeout = 500;
  }

  var _React$useState = useState(""),
      keys = _React$useState[0],
      setKeys = _React$useState[1];

  useEffect(function () {
    if (!keys) return undefined;
    var timeoutId = setTimeout(function () {
      return setKeys("");
    }, timeout);
    var stop = items.find(function (s) {
      return Boolean(s.ref.current && s.ref.current.textContent && s.ref.current.textContent.toLowerCase().startsWith(keys));
    });

    if (stop) {
      move(stop.id);
    }

    return function () {
      return clearTimeout(timeoutId);
    };
  }, [keys, items, move, timeout]);
  useEffect(function () {
    var menu = menuRef.current;
    if (!menu) return undefined;

    var onKeyDown = function onKeyDown(event) {
      var _target$getAttribute;

      if (event.key.length > 1) return;
      if (event.shiftKey) return;
      if (event.metaKey) return;
      if (event.ctrlKey) return;
      if (event.altKey) return;
      var target = event.target;
      var role = (_target$getAttribute = target.getAttribute) === null || _target$getAttribute === void 0 ? void 0 : _target$getAttribute.call(target, "role");
      var targetIsMenu = target === menu;
      var targetIsMenuItem = role && role.indexOf("menuitem") !== -1 && closest(target, "[role=menu],[role=menubar]") === menu;
      if (!targetIsMenu && !targetIsMenuItem) return;

      if (/^[a-z0-9_-]$/i.test(event.key)) {
        event.stopPropagation();
        event.preventDefault();
        setKeys(function (k) {
          return "" + k + event.key;
        });
      }
    }; // https://github.com/facebook/react/issues/11387#issuecomment-524113945


    menu.addEventListener("keydown", onKeyDown);
    return function () {
      return menu.removeEventListener("keydown", onKeyDown);
    };
  }, [menuRef, setKeys]);
}

var useMenuBar = createHook({
  name: "MenuBar",
  compose: useComposite,
  keys: MENU_BAR_KEYS,
  useProps: function useProps(options, _ref) {
    var htmlRef = _ref.ref,
        htmlWrapElement = _ref.wrapElement,
        _ref$role = _ref.role,
        role = _ref$role === void 0 ? "menubar" : _ref$role,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["ref", "wrapElement", "role"]);

    var ref = useRef(null);
    var wrap = useMenuContext(ref, role, options);
    useShortcuts(ref, options);
    var wrapElement = useCallback(function (element) {
      element = wrap(element);

      if (htmlWrapElement) {
        return htmlWrapElement(element);
      }

      return element;
    }, [wrap, htmlWrapElement]);
    return _objectSpread2({
      ref: useForkRef(ref, htmlRef),
      role: role,
      "aria-orientation": options.orientation,
      wrapElement: wrapElement
    }, htmlProps);
  }
});
createComponent({
  as: "div",
  useHook: useMenuBar,
  useCreateElement: function useCreateElement$1(type, props, children) {
    process.env.NODE_ENV !== "production" ? useWarning(!props["aria-label"] && !props["aria-labelledby"] && props.role !== "menubar", "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu") : void 0;
    return useCreateElement(type, props, children);
  }
});

function usePlacementDir(placement) {
  return useMemo(function () {
    var _placement$split;

    return placement === null || placement === void 0 ? void 0 : (_placement$split = placement.split("-")) === null || _placement$split === void 0 ? void 0 : _placement$split[0];
  }, [placement]);
}

var useMenu = createHook({
  name: "Menu",
  compose: [useMenuBar, usePopover],
  keys: MENU_KEYS,
  useOptions: function useOptions(options) {
    var parent = useContext(MenuContext);
    var parentIsMenuBar = (parent === null || parent === void 0 ? void 0 : parent.role) === "menubar";
    return _objectSpread2(_objectSpread2({
      unstable_autoFocusOnHide: !parentIsMenuBar,
      modal: false
    }, options), {}, {
      // will be handled by MenuButton
      unstable_autoFocusOnShow: false,
      // will be handled differently from usePopover/useDialog
      hideOnEsc: false
    });
  },
  useProps: function useProps(options, _ref) {
    var htmlOnKeyDown = _ref.onKeyDown,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["onKeyDown"]);

    var onKeyDownRef = useLiveRef(htmlOnKeyDown);
    var parent = useContext(MenuContext);
    var hasParent = !!parent;
    var ancestorMenuBar = parent;

    while (ancestorMenuBar && ancestorMenuBar.role !== "menubar") {
      ancestorMenuBar = ancestorMenuBar.parent;
    }

    var _ref2 = ancestorMenuBar || {},
        next = _ref2.next,
        previous = _ref2.previous,
        orientation = _ref2.orientation;

    var ancestorIsHorizontal = orientation === "horizontal";
    var dir = usePlacementDir(options.placement);
    var onKeyDown = useCallback(function (event) {
      var _onKeyDownRef$current;

      (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
      if (event.defaultPrevented) return;

      if (event.key === "Escape") {
        var _options$hide;

        if (!hasParent) {
          // On Esc, only stop propagation if there's no parent menu.
          // Otherwise, pressing Esc should close all menus
          event.stopPropagation();
        }

        (_options$hide = options.hide) === null || _options$hide === void 0 ? void 0 : _options$hide.call(options);
      } else if (hasParent && !isPortalEvent(event)) {
        // Moves to the next menu button in a horizontal menu bar or close
        // the menu if it's a sub menu
        var ArrowRight = ancestorIsHorizontal && dir !== "left" ? next : dir === "left" && options.hide;
        var ArrowLeft = ancestorIsHorizontal && dir !== "right" ? previous : dir === "right" && options.hide;
        var keyMap = {
          ArrowRight: ArrowRight,
          ArrowLeft: ArrowLeft
        };
        var action = keyMap[event.key];

        if (action) {
          event.preventDefault();

          if (hasParent) {
            event.stopPropagation();
          }

          action();
        }
      }
    }, [hasParent, ancestorIsHorizontal, next, previous, dir, options.hide]);
    return _objectSpread2({
      role: "menu",
      onKeyDown: onKeyDown
    }, htmlProps);
  }
});
var Menu$1 = createComponent({
  as: "div",
  useHook: useMenu,
  useCreateElement: function useCreateElement$1(type, props, children) {
    process.env.NODE_ENV !== "production" ? useWarning(!props["aria-label"] && !props["aria-labelledby"], "You should provide either `aria-label` or `aria-labelledby` props.", "See https://reakit.io/docs/menu") : void 0;
    return useCreateElement(type, props, children);
  }
});

function useMenuBarState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var _useSealedState = useSealedState(initialState),
      _useSealedState$orien = _useSealedState.orientation,
      orientation = _useSealedState$orien === void 0 ? "horizontal" : _useSealedState$orien,
      _useSealedState$unsta = _useSealedState.unstable_values,
      initialValues = _useSealedState$unsta === void 0 ? {} : _useSealedState$unsta,
      sealed = _objectWithoutPropertiesLoose$1(_useSealedState, ["orientation", "unstable_values"]);

  var _React$useState = useState(initialValues),
      values = _React$useState[0],
      setValues = _React$useState[1];

  var composite = useCompositeState(_objectSpread2(_objectSpread2({}, sealed), {}, {
    orientation: orientation
  }));
  return _objectSpread2(_objectSpread2({}, composite), {}, {
    unstable_values: values,
    unstable_setValue: useCallback(function (name, value) {
      setValues(function (vals) {
        var _objectSpread2$1;

        return _objectSpread2(_objectSpread2({}, vals), {}, (_objectSpread2$1 = {}, _objectSpread2$1[name] = typeof value === "function" ? value(vals) : value, _objectSpread2$1));
      });
    }, [])
  });
}

var usePopoverDisclosure = createHook({
  name: "PopoverDisclosure",
  compose: useDialogDisclosure,
  keys: POPOVER_DISCLOSURE_KEYS,
  useProps: function useProps(options, _ref) {
    var htmlRef = _ref.ref,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["ref"]);

    return _objectSpread2({
      ref: useForkRef(options.unstable_referenceRef, htmlRef)
    }, htmlProps);
  }
});
createComponent({
  as: "button",
  memo: true,
  useHook: usePopoverDisclosure
});

function findVisibleSubmenu(submenus) {
  var visibleSubmenu = submenus === null || submenus === void 0 ? void 0 : submenus.find(function (submenu) {
    return submenu.current && !submenu.current.hidden;
  });
  return visibleSubmenu === null || visibleSubmenu === void 0 ? void 0 : visibleSubmenu.current;
}

var noop$1 = function noop() {};

var useMenuButton = createHook({
  name: "MenuButton",
  compose: usePopoverDisclosure,
  keys: MENU_BUTTON_KEYS,
  propsAreEqual: function propsAreEqual(prev, next) {
    prev.unstable_popoverStyles;
        prev.unstable_arrowStyles;
        prev.currentId;
        prev.unstable_moves;
        var prevProps = _objectWithoutPropertiesLoose$1(prev, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);

    next.unstable_popoverStyles;
        next.unstable_arrowStyles;
        next.currentId;
        next.unstable_moves;
        var nextProps = _objectWithoutPropertiesLoose$1(next, ["unstable_popoverStyles", "unstable_arrowStyles", "currentId", "unstable_moves"]);

    return usePopoverDisclosure.unstable_propsAreEqual(prevProps, nextProps);
  },
  useProps: function useProps(options, _ref) {
    var htmlRef = _ref.ref,
        htmlOnClick = _ref.onClick,
        htmlOnKeyDown = _ref.onKeyDown,
        htmlOnFocus = _ref.onFocus,
        htmlOnMouseEnter = _ref.onMouseEnter,
        htmlOnMouseDown = _ref.onMouseDown,
        htmlProps = _objectWithoutPropertiesLoose$1(_ref, ["ref", "onClick", "onKeyDown", "onFocus", "onMouseEnter", "onMouseDown"]);

    var parent = useContext(MenuContext);
    var ref = useRef(null);
    var hasPressedMouse = useRef(false);

    var _options$placement$sp = options.placement.split("-"),
        dir = _options$placement$sp[0];

    var hasParent = !!parent;
    var parentIsMenuBar = (parent === null || parent === void 0 ? void 0 : parent.role) === "menubar";
    var disabled = options.disabled || htmlProps["aria-disabled"];
    var onClickRef = useLiveRef(htmlOnClick);
    var onKeyDownRef = useLiveRef(htmlOnKeyDown);
    var onFocusRef = useLiveRef(htmlOnFocus);
    var onMouseEnterRef = useLiveRef(htmlOnMouseEnter);
    var onMouseDownRef = useLiveRef(htmlOnMouseDown);
    var onKeyDown = useCallback(function (event) {
      var _onKeyDownRef$current;

      if (event.key === "Escape") {
        var _options$hide;

        // Doesn't prevent default on Escape, otherwise we can't close
        // dialogs when MenuButton is focused
        (_options$hide = options.hide) === null || _options$hide === void 0 ? void 0 : _options$hide.call(options);
      } else if (!disabled) {
        // setTimeout prevents scroll jump
        var first = options.first && function () {
          return setTimeout(options.first);
        };

        var last = options.last && function () {
          return setTimeout(options.last);
        };

        var keyMap = {
          Enter: first,
          " ": first,
          ArrowUp: (dir === "top" || dir === "bottom") && last,
          ArrowRight: dir === "right" && first,
          ArrowDown: (dir === "bottom" || dir === "top") && first,
          ArrowLeft: dir === "left" && first
        };
        var action = keyMap[event.key];

        if (action) {
          var _options$show;

          event.preventDefault();
          event.stopPropagation();
          (_options$show = options.show) === null || _options$show === void 0 ? void 0 : _options$show.call(options);
          action();
          return;
        }
      }

      (_onKeyDownRef$current = onKeyDownRef.current) === null || _onKeyDownRef$current === void 0 ? void 0 : _onKeyDownRef$current.call(onKeyDownRef, event);
    }, [disabled, options.hide, options.first, options.last, dir, options.show]);
    var onMouseEnter = useCallback(function (event) {
      var _onMouseEnterRef$curr;

      (_onMouseEnterRef$curr = onMouseEnterRef.current) === null || _onMouseEnterRef$curr === void 0 ? void 0 : _onMouseEnterRef$curr.call(onMouseEnterRef, event);
      if (event.defaultPrevented) return; // MenuButton's don't do anything on mouse over when they aren't
      // cointained within a Menu/MenuBar

      if (!parent) return;
      var element = event.currentTarget;

      if (parentIsMenuBar) {
        // if MenuButton is an item inside a MenuBar, it'll only open
        // if there's already another sibling expanded MenuButton
        if (findVisibleSubmenu(parent.children)) {
          element.focus();
        }
      } else {
        // If it's in a Menu, open after a short delay
        // TODO: Make the delay a prop?
        setTimeout(function () {
          if (hasFocusWithin(element)) {
            var _options$show2;

            (_options$show2 = options.show) === null || _options$show2 === void 0 ? void 0 : _options$show2.call(options);
          }
        }, 200);
      }
    }, [parent, parentIsMenuBar, options.show]);
    var onMouseDown = useCallback(function (event) {
      var _onMouseDownRef$curre;

      // When in menu bar, the menu button can be activated either by focus
      // or click, but we don't want both to trigger sequentially.
      // Otherwise, onClick would toggle (hide) the menu right after it got
      // shown on focus.
      // This is also useful so we know if the menu button has been clicked
      // using mouse or keyboard. On mouse click, we don't automatically
      // focus the first menu item.
      hasPressedMouse.current = true;
      (_onMouseDownRef$curre = onMouseDownRef.current) === null || _onMouseDownRef$curre === void 0 ? void 0 : _onMouseDownRef$curre.call(onMouseDownRef, event);
    }, []);
    var onFocus = useCallback(function (event) {
      var _onFocusRef$current;

      (_onFocusRef$current = onFocusRef.current) === null || _onFocusRef$current === void 0 ? void 0 : _onFocusRef$current.call(onFocusRef, event);
      if (event.defaultPrevented) return;
      if (disabled) return;

      if (parentIsMenuBar && !hasPressedMouse.current) {
        var _options$show3;

        (_options$show3 = options.show) === null || _options$show3 === void 0 ? void 0 : _options$show3.call(options);
      }
    }, [parentIsMenuBar, disabled, options.show]); // If disclosure is rendered as a menu bar item, it's toggable
    // That is, you can click on the expanded disclosure to close its menu.

    var onClick = useCallback(function (event) {
      var _onClickRef$current;

      (_onClickRef$current = onClickRef.current) === null || _onClickRef$current === void 0 ? void 0 : _onClickRef$current.call(onClickRef, event);
      if (event.defaultPrevented) return; // If menu button is a menu item inside a menu (not menu bar), you
      // can't close it by clicking on it again.

      if (hasParent && !parentIsMenuBar) {
        var _options$show4;

        (_options$show4 = options.show) === null || _options$show4 === void 0 ? void 0 : _options$show4.call(options);
      } else {
        var _options$toggle;

        // Otherwise, if menu button is a menu bar item or an orphan menu
        // button, it's toggable.
        (_options$toggle = options.toggle) === null || _options$toggle === void 0 ? void 0 : _options$toggle.call(options); // Focus the menu popover when it's opened with mouse click.

        if (hasPressedMouse.current && !parentIsMenuBar && !options.visible) {
          var _options$move;

          (_options$move = options.move) === null || _options$move === void 0 ? void 0 : _options$move.call(options, null);
        }
      }

      hasPressedMouse.current = false;
    }, [hasParent, parentIsMenuBar, options.show, options.toggle, options.visible, options.move]);
    return _objectSpread2({
      ref: useForkRef(ref, htmlRef),
      "aria-haspopup": "menu",
      onKeyDown: onKeyDown,
      onMouseEnter: onMouseEnter,
      onMouseDown: onMouseDown,
      onFocus: onFocus,
      onClick: onClick
    }, htmlProps);
  },
  useComposeOptions: function useComposeOptions(options) {
    return _objectSpread2(_objectSpread2({}, options), {}, {
      // Toggling is handled by MenuButton
      toggle: noop$1
    });
  }
});
var MenuButton = createComponent({
  as: "button",
  memo: true,
  useHook: useMenuButton
});

function useMenuState(initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  var parent = useContext(MenuContext);

  var _useSealedState = useSealedState(initialState),
      _useSealedState$orien = _useSealedState.orientation,
      orientation = _useSealedState$orien === void 0 ? "vertical" : _useSealedState$orien,
      _useSealedState$gutte = _useSealedState.gutter,
      gutter = _useSealedState$gutte === void 0 ? 0 : _useSealedState$gutte,
      sealed = _objectWithoutPropertiesLoose$1(_useSealedState, ["orientation", "gutter"]);

  var placement = sealed.placement || (parent && parent.orientation === "vertical" ? "right-start" : "bottom-start");
  var menuBar = useMenuBarState(_objectSpread2(_objectSpread2({}, sealed), {}, {
    orientation: orientation
  }));
  var popover = usePopoverState(_objectSpread2(_objectSpread2({}, sealed), {}, {
    placement: placement,
    gutter: gutter
  }));
  useEffect(function () {
    if (!popover.visible) {
      menuBar.reset();
    }
  }, [popover.visible, menuBar.reset]);
  return _objectSpread2(_objectSpread2({}, menuBar), popover);
}

const MenuArrowSVG = () => /*#__PURE__*/React__default.createElement("svg", {
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M11.3136 5.65685L5.65674 11.3137L-0.000115871 5.65685H11.3136Z",
  fill: "#43EE91"
}));

const NavSubMenuContentStyle = createOwnUpStyle({
  display: 'flex',
  alignContent: 'space-between',
  alignItems: 'flex-start',
  backgroundColor: colors.WHITE,
  borderRadius: '3px',
  boxShadow: '0px 4px 16px rgba(68, 68, 68, 0.08)',
  flexDirection: 'column',
  padding: '2em',
  paddingBottom: '1em',
  variants: {
    main: {
      marginTop: '1em',
      minWidth: '12em'
    },
    slideOut: {
      alignItems: 'center',
      backgroundColor: 'inherit',
      marginBottom: '1em',
      padding: 0,
      position: 'relative'
    }
  }
});
const NavSubMenuContent = createOwnUpComponent(OwnUpBox, NavSubMenuContentStyle);
const NavSubMenuLinkWrapperStyle = createOwnUpStyle({
  display: 'flex',
  variants: {
    main: {
      marginBottom: '1em'
    },
    slideOut: {
      marginTop: '1em',
      marginBottom: '-40px'
    }
  }
});
const NavSubMenuLinkWrapper = createOwnUpComponent(OwnUpBox, NavSubMenuLinkWrapperStyle);
const MenuArrowWrapperStyle = createOwnUpStyle({
  height: '12px',
  width: '12px',
  display: 'inline-block',
  marginLeft: '10px'
});
const MenuArrowWrapper = createOwnUpComponent(OwnUpBox, MenuArrowWrapperStyle);
const MenuArrow = () => /*#__PURE__*/React__default.createElement(MenuArrowWrapper, null, /*#__PURE__*/React__default.createElement(MenuArrowSVG, null));

// eslint-disable-next-line max-lines-per-function
const SubMenu = _ref => {
  let {
    content,
    linkVariant,
    menuVariant,
    name,
    page,
    isSlideOutMenu,
    ...props
  } = _ref;
  const menu = useMenuState({
    orientation: 'vertical',
    modal: false
  });
  const showMenu = menu.show;
  const hideMenu = menu.hide;
  let containsCurrentPage;
  const items = content.map((item, i) => {
    containsCurrentPage = false; // Reset the default value.
    const currentLinkVariant = [...linkVariant];

    // SubMenu
    if ('content' in item) {
      const {
        name,
        content
      } = item;
      return /*#__PURE__*/React__default.createElement(SubMenu, _extends$1({}, props, {
        name: name,
        content: content,
        linkVariant: linkVariant,
        menuVariant: menuVariant,
        page: page,
        key: i
      }));
    }

    // Link
    if (item.link.includes('#') && !isSlideOutMenu) {
      containsCurrentPage = true;
      currentLinkVariant.push('currentPage');
    }
    return /*#__PURE__*/React__default.createElement(NavSubMenuLinkWrapper, {
      variant: menuVariant,
      key: i
    }, /*#__PURE__*/React__default.createElement(StyledNavLink, {
      variant: currentLinkVariant,
      styledNavLinks: StyledNavLinks,
      link: item.link,
      external: item.external
    }, item.name));
  });

  // Only open the menu on hover in the large version of the header.
  const menuEvents = isSlideOutMenu ? {} : {
    onMouseEnter: showMenu,
    onMouseLeave: hideMenu
  };
  const menuStyle = isSlideOutMenu ? {
    position: 'relative',
    transform: 'none',
    outline: 'none',
    margin: '-40px auto 0'
  } : {};
  return /*#__PURE__*/React__default.createElement("div", _extends$1({
    style: {
      display: 'grid'
    }
  }, menuEvents), /*#__PURE__*/React__default.createElement(MenuButton, _extends$1({}, menu, {
    as: StyledNavButton,
    variant: [...menuVariant, menu.visible ? 'open' : null, containsCurrentPage ? 'currentPage' : null]
  }), name, /*#__PURE__*/React__default.createElement(MenuArrow, null)), /*#__PURE__*/React__default.createElement(Menu$1, _extends$1({}, menu, {
    hideOnClickOutside: true,
    style: menuStyle,
    "aria-label": name
  }), /*#__PURE__*/React__default.createElement(NavSubMenuContent, {
    tabIndex: "-1",
    variant: menuVariant
  }, items)));
};

const Menu = _ref => {
  let {
    content,
    linkVariant,
    menuVariant,
    page,
    isSlideOutMenu
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, content.map((item, i) => {
    const currentLinkVariant = [...linkVariant];

    // SubMenu
    if ('content' in item) {
      return /*#__PURE__*/React__default.createElement(SubMenu, {
        key: i,
        name: item.name,
        content: item.content,
        linkVariant: linkVariant,
        menuVariant: menuVariant,
        page: page,
        isSlideOutMenu: isSlideOutMenu
      });
    }

    // Link
    if (item.link.includes('#') && !isSlideOutMenu) {
      currentLinkVariant.push('currentPage');
    }
    return /*#__PURE__*/React__default.createElement(StyledNavLink, _extends$1({}, item, {
      styledNavLinks: StyledNavLinks,
      keyValue: i,
      key: i,
      variant: currentLinkVariant
    }), item.name);
  }));
};

const VerticalLineStyle = createOwnUpStyle({
  width: '1px',
  height: '30px',
  backgroundColor: colors.GREY_3,
  border: "0 none"
});
const VerticalLine = createOwnUpComponent(OwnUpBox, VerticalLineStyle);
// eslint-disable-next-line max-lines-per-function
const LargeHeader = _ref => {
  let {
    primary,
    page,
    href,
    mainSite,
    www,
    onboarding,
    trackingEvent
  } = _ref;
  return /*#__PURE__*/React__default.createElement(NavBarWrapperLarge, {
    "aria-label": "desktop navigation"
  }, /*#__PURE__*/React__default.createElement(HomePageLink, {
    mainSite: mainSite,
    www: www
  }, /*#__PURE__*/React__default.createElement(OwnUpStyledIcon, {
    style: {
      height: '53px',
      marginRight: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(OwnUpLogoNoBackdropWithText, null))), /*#__PURE__*/React__default.createElement(NavLinksWrapper, {
    variant: "horizontal"
  }, /*#__PURE__*/React__default.createElement(Menu, {
    content: primary,
    linkVariant: ['main'],
    menuVariant: ['main'],
    page: page
  }), /*#__PURE__*/React__default.createElement(VerticalLine, null), /*#__PURE__*/React__default.createElement(GetStartedLink, _extends$1({
    onboarding: onboarding
  }, trackingEvent ? {
    trackingEvent: mergeTrackingEvents({
      name: 'Click discover CTA',
      properties: {
        'page-location': 'navigation-desktop',
        url: href
      }
    }, trackingEvent)
  } : {}), /*#__PURE__*/React__default.createElement(DesktopHeaderButton, null, "Get Started"))));
};

const HorizontalLineStyle = createOwnUpStyle({
  border: "0 none",
  height: '1px',
  backgroundColor: colors.GREY_1,
  variants: {
    header: {
      margin: '50px 0px 30px',
      width: '90vw'
    },
    footer: {
      margin: '20px 0px 40px',
      width: '50vw'
    },
    faqShort: {
      backgroundColor: colors.GREY_LIGHT_1,
      width: '154px',
      marginLeft: '30px'
    },
    faqLong: {
      backgroundColor: colors.LOGO_BACKDROP,
      margin: '50px 0'
    }
  }
});
const HorizontalLine = createOwnUpComponent('hr', HorizontalLineStyle);

var _templateObject$M, _templateObject2$r, _templateObject3$j, _templateObject4$6, _templateObject5$3;
const IconWrapper = styled('button')(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  cursor: pointer;\n  height: 24px;\n  width: 24px;\n  position: absolute;\n  top: 24px;\n  left: 24px;\n"])));
const MenuContainer = styled(Dialog)(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  display: flex;\n  max-width: 100vw;\n  padding: 16px;\n  margin: auto;\n  white-space: nowrap;\n  overflow: auto;\n  background-color: ", ";\n  z-index: ", ";\n  transition: opacity 0.25s ease-in-out, transform 0.25s ease-in-out;\n  opacity: 0;\n  transform: translateX(100%);\n  width: 100%;\n  &[data-enter] {\n    opacity: 1;\n    transform: translateX(0);\n  }\n"])), colors.GREY_FOOTER, zIndex$1.ModalWindow);
styled(OwnUpBox)(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
styled(OwnUpBox)(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  padding-right: 6px;\n  width: 28px;\n"])));
const SlideOutNavMenuToggleButtonWrapper = styled(DialogDisclosure)(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n"])));

const useModalController = () => {
  const state = useDialogState({
    animated: true
  });
  return {
    show: state.show,
    hide: state.hide,
    toggle: state.toggle,
    state
  };
};
// eslint-disable-next-line max-lines-per-function
const SlideOutNavMenu = _ref => {
  let {
    modalController,
    navLinks: {
      primary,
      secondary
    },
    href,
    onboarding,
    trackingEvent
  } = _ref;
  return /*#__PURE__*/React__default.createElement(MenuContainer, _extends$1({
    hideOnClickOutside: true,
    preventBodyScroll: true,
    "aria-label": "Menu"
  }, modalController.state), /*#__PURE__*/React__default.createElement(IconWrapper, {
    onClick: () => modalController.hide(),
    "aria-label": "close"
  }, /*#__PURE__*/React__default.createElement(OwnUpStyledIcon, {
    style: {
      height: '24px',
      width: '24px',
      position: 'absolute',
      top: 0,
      left: 0,
      strokeWidth: 2
    }
  }, /*#__PURE__*/React__default.createElement(CancelX, null))), /*#__PURE__*/React__default.createElement(NavLinksWrapper, {
    variant: "vertical"
  }, /*#__PURE__*/React__default.createElement(OwnUpStyledIcon, {
    style: {
      height: '63px',
      paddingBottom: '40px'
    }
  }, /*#__PURE__*/React__default.createElement(OwnUpLogo, null)), /*#__PURE__*/React__default.createElement(Menu, {
    content: primary,
    menuVariant: ['primary', 'slideOut'],
    linkVariant: ['primary'],
    page: href,
    isSlideOutMenu: true
  }), /*#__PURE__*/React__default.createElement(GetStartedLink, _extends$1({
    onboarding: onboarding
  }, trackingEvent ? {
    trackingEvent: mergeTrackingEvents({
      name: 'Click discover CTA',
      properties: {
        'page-location': 'navigation-mobile',
        url: href
      }
    }, trackingEvent)
  } : {}), /*#__PURE__*/React__default.createElement(SlideOutMenuButton, null, "Get Started")), /*#__PURE__*/React__default.createElement(HorizontalLine, {
    variant: "header"
  }), secondary.map((_ref2, i) => {
    let {
      name,
      link,
      external
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(StyledNavLink, {
      styledNavLinks: StyledNavLinks,
      variant: "secondary",
      keyValue: i,
      key: i,
      link: link,
      external: external
    }, name);
  })));
};
const SlideOutNavMenuToggleButton = _ref3 => {
  let {
    modalController,
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(SlideOutNavMenuToggleButtonWrapper, _extends$1({
    onClick: () => {
      modalController.toggle();
    }
  }, props, {
    "aria-label": "menu button"
  }), children);
};

// support SSR by checking if window exists
const domReady = typeof window !== 'undefined';
const getScrollPosition = () => domReady ? {
  x: window.scrollX,
  y: window.scrollY
} : {
  x: 0,
  y: 0
};
/**
 * A hook that gets the horizontal and vertical scroll position from the window object.
 *
 * @param effect The callback to execute once the scroll position is retrieved. Useful for setting
 * state on the component based on scroll position.
 */
function useScrollPosition(effect) {
  useLayoutEffect(() => {
    const handleScroll = () => effect(getScrollPosition());
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });
}

const useSessionStorage = (key, initialValue) => {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = typeof window !== 'undefined' ? window.sessionStorage.getItem(key) : undefined;
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.error(error);
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that
  // persists the new value to sessionStorage.
  const setValue = value => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.error(error);
    }
  };
  return [storedValue, setValue];
};

const CenterOwnUpButton = _ref => {
  let {
    mainSite,
    www
  } = _ref;
  return /*#__PURE__*/React__default.createElement(HomePageLink, {
    mainSite: mainSite,
    www: www
  }, /*#__PURE__*/React__default.createElement(OwnUpStyledIcon, {
    style: {
      height: '36px'
    }
  }, /*#__PURE__*/React__default.createElement(OwnUpWordmark, null)));
};
const ScrollingCTA = _ref2 => {
  let {
    mainSite,
    www,
    onboarding,
    trackingEvent,
    href
  } = _ref2;
  const [scrolled, setScrolled] = useState(false);
  useScrollPosition(position => {
    const isScrolled = Math.abs(position.y) > 103;
    if (isScrolled !== scrolled) {
      setScrolled(isScrolled);
    }
  });
  return scrolled ? /*#__PURE__*/React__default.createElement(GetStartedLink, _extends$1({
    onboarding: onboarding
  }, trackingEvent ? {
    trackingEvent: mergeTrackingEvents({
      name: 'Click discover CTA',
      properties: {
        'page-location': 'navigation-mobile',
        url: href
      }
    }, trackingEvent)
  } : {}), /*#__PURE__*/React__default.createElement(ScrollingCTAButton, null, "GET STARTED")) : /*#__PURE__*/React__default.createElement(CenterOwnUpButton, {
    mainSite: mainSite,
    www: www
  });
};
const SmallHeader = _ref3 => {
  let {
    href,
    www,
    onboarding,
    mainSite,
    modalController,
    showScrollingCTA,
    trackingEvent
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(NavBarWrapperSmall, {
    "aria-label": "mobile navigation"
  }, /*#__PURE__*/React__default.createElement(HomePageLink, {
    mainSite: mainSite,
    www: www
  }, /*#__PURE__*/React__default.createElement(OwnUpStyledIcon, {
    style: {
      height: '36px'
    }
  }, /*#__PURE__*/React__default.createElement(OwnUpLogoNoBackdrop, null))), showScrollingCTA ? /*#__PURE__*/React__default.createElement(ScrollingCTA, {
    mainSite: mainSite,
    www: www,
    onboarding: onboarding,
    trackingEvent: trackingEvent,
    href: href
  }) : /*#__PURE__*/React__default.createElement(CenterOwnUpButton, {
    mainSite: mainSite,
    www: www
  }), /*#__PURE__*/React__default.createElement(SlideOutNavMenuToggleButton, {
    modalController: modalController,
    "aria-label": "menu button"
  }, /*#__PURE__*/React__default.createElement(OwnUpIcon, {
    icon: "Hamburger",
    style: {
      fontSize: '24px'
    }
  })));
};

var _templateObject$L, _templateObject2$q;
const LargeHeaderWrapper = styled('div')(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  ", "\n"])), buildMediaQueries('mediumAndDown', {
  display: 'none'
}));
const SmallHeaderWrapper = styled('div')(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n  ", "\n"])), buildMediaQueries('large', {
  display: 'none'
}));

// eslint-disable-next-line max-lines-per-function
const Header = _ref => {
  let {
    page,
    href,
    mainSite,
    www,
    onboarding,
    trackingEvent,
    showScrollingCTA
  } = _ref;
  const modalController = useModalController();
  const primary = getPrimaryLinks({
    mainSite,
    www,
    page
  });
  const secondary = getSecondaryLinks({
    mainSite,
    www
  });
  const slideOutNavMenuProps = {
    navLinks: {
      primary,
      secondary
    },
    modalController,
    href,
    onboarding,
    trackingEvent
  };
  const smallHeaderProps = {
    href,
    www,
    onboarding,
    mainSite,
    modalController,
    trackingEvent,
    showScrollingCTA
  };
  const largeHeaderProps = {
    primary,
    page,
    href,
    mainSite,
    www,
    onboarding,
    trackingEvent
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DeferRender, null, /*#__PURE__*/React__default.createElement(SlideOutNavMenu, slideOutNavMenuProps)), /*#__PURE__*/React__default.createElement(SmallHeaderWrapper, null, /*#__PURE__*/React__default.createElement(SmallHeader, smallHeaderProps)), /*#__PURE__*/React__default.createElement(LargeHeaderWrapper, null, /*#__PURE__*/React__default.createElement(LargeHeader, largeHeaderProps)));
};

var _templateObject$K, _templateObject2$p, _templateObject3$i;
const IconMultipleSection = styled.section(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: ", ";\n  ", " {\n    padding: ", ";\n  }\n  ", " {\n    padding: ", ";\n  }\n  ", " {\n    padding: ", ";\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.text.primary;
}, _ref2 => {
  var _theme$backgroundColo;
  let {
    theme
  } = _ref2;
  return (_theme$backgroundColo = theme.backgroundColors.secondaryTheme) === null || _theme$backgroundColo === void 0 ? void 0 : _theme$backgroundColo.backgroundColor;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.breakpoints.up('xs');
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(6, 0);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.breakpoints.up('md');
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(8, 0);
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.breakpoints.up('lg');
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.spacing(10, 0);
});
const IconMultipleHeadline = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n  ", " {\n    padding-top: ", ";\n  }\n  ", " {\n    padding-top: ", ";\n  }\n  text-align: center;\n"])), _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.breakpoints.up('xs');
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return "".concat(theme.spacing(2.5), "px");
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.breakpoints.up('lg');
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return "".concat(theme.spacing(3), "px");
});
const IconMultipleBody = styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  ", " {\n    padding: ", "};\n  }\n  text-align: center;\n"])), _ref13 => {
  let {
    theme
  } = _ref13;
  return "".concat(theme.spacing(2), "px");
}, _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.breakpoints.down('sm');
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.spacing(2, 0, 3);
});

const IconMultiple = _ref => {
  let {
    ariaLabel,
    valueProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(IconMultipleSection, {
    "aria-label": ariaLabel
  }, /*#__PURE__*/React__default.createElement(OwnUpGridWrapper, null, /*#__PURE__*/React__default.createElement(OwnUpGridContainer, {
    variant: "legacy"
  }, valueProps.map((_ref2, key) => {
    let {
      icon,
      header,
      body
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(OwnUpGridItem, {
      md: 4,
      xs: 12,
      key: ariaLabel + '-' + key
    }, /*#__PURE__*/React__default.createElement(OwnUpGridContainer, {
      variant: "legacy"
    }, /*#__PURE__*/React__default.createElement(OwnUpGridOffset, {
      lg: 1,
      md: 0,
      sm: 1,
      xs: 0
    }), /*#__PURE__*/React__default.createElement(OwnUpGridItem, {
      lg: 10,
      md: 12,
      sm: 10,
      xs: 12
    }, /*#__PURE__*/React__default.createElement(OwnUpIcon$1, {
      icon: icon,
      style: {
        justifyContent: 'center'
      },
      height: "64px"
    }), /*#__PURE__*/React__default.createElement(IconMultipleHeadline, null, /*#__PURE__*/React__default.createElement(OwnUpSmallSubheadlineMedium, {
      variant: 'h2'
    }, header)), /*#__PURE__*/React__default.createElement(IconMultipleBody, null, body)), /*#__PURE__*/React__default.createElement(OwnUpGridOffset, {
      lg: 1,
      md: 0,
      sm: 1,
      xs: 0
    })));
  }))));
};

var _templateObject$J, _templateObject2$o, _templateObject3$h;
const SectionStyle = _ref => {
  let {
    rowOnMedium,
    styleOverride
  } = _ref;
  const {
    variants,
    ...restStyleOverride
  } = styleOverride || {};
  return createOwnUpStyle({
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    variants: {
      medium: {
        flexDirection: rowOnMedium ? 'row' : 'column'
      },
      smallAndDown: {
        flexDirection: 'column'
      },
      ...variants
    },
    ...restStyleOverride
  });
};
const Section$1 = createOwnUpComponent('section', SectionStyle);
const BackgroundImageStyle = _ref2 => {
  let {
    styleOverride
  } = _ref2;
  const {
    variants,
    ...restStyleOverride
  } = styleOverride || {};
  return createOwnUpStyle({
    width: '50%',
    backgroundPosition: '50%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    variants: {
      mediumAndDown: {
        width: '90%'
      },
      smallAndDown: {
        backgroundSize: 'cover'
      },
      ...variants
    },
    ...restStyleOverride
  });
};
const BackgroundImage = createOwnUpComponent(OwnUpBox, BackgroundImageStyle);
const ImageWrapperWithBackgroundStyle = _ref3 => {
  let {
    styleOverride
  } = _ref3;
  const {
    variants,
    ...restStyleOverride
  } = styleOverride || {};
  return createOwnUpStyle({
    padding: '70px 40px',
    variants: {
      smallAndDown: {
        padding: '50px 0px'
      },
      ...variants
    },
    ...restStyleOverride
  });
};
const ImageWrapperWithBackground = createOwnUpComponent(OwnUpBox, ImageWrapperWithBackgroundStyle);
const ImageWrapperStyle$1 = _ref4 => {
  let {
    styleOverride
  } = _ref4;
  const {
    variants,
    ...restStyleOverride
  } = styleOverride || {};
  return createOwnUpStyle({
    width: '50%',
    variants: {
      mediumAndDown: {
        width: '100%',
        marginBottom: '22px'
      },
      ...variants
    },
    ...restStyleOverride
  });
};
const ImageWrapper$1 = createOwnUpComponent(OwnUpBox, ImageWrapperStyle$1);
const ContentWrapperStyle = _ref5 => {
  let {
    backgroundImage,
    styleOverride
  } = _ref5;
  const {
    variants,
    ...restStyleOverride
  } = styleOverride || {};
  return createOwnUpStyle({
    width: '50%',
    marginLeft: '50px',
    variants: {
      mediumAndDown: {
        width: backgroundImage ? '90%' : '100%',
        marginLeft: 0
      },
      ...variants
    },
    ...restStyleOverride
  });
};
const ContentWrapper = createOwnUpComponent('div', ContentWrapperStyle);
const TextStyle = createOwnUpStyle({
  display: 'block',
  marginBottom: '30px',
  width: '100%',
  fontSize: '23px',
  variants: {
    mediumAndDown: {
      textAlign: 'center'
    },
    smallAndDown: {
      fontSize: '16px'
    }
  }
});
const Text = createOwnUpComponent(OwnUpText, TextStyle);
const DesktopImageWithContentWrapper = styled('div')(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  ", "\n"])), buildMediaQueries('mediumAndDown', {
  display: 'none'
}));
const DesktopImageWithContent = _ref6 => {
  let {
    children,
    Img,
    backgroundImage,
    contentStyle,
    imagePosition
  } = _ref6;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, imagePosition === 'left' ? /*#__PURE__*/React__default.createElement(Img, null) : null, /*#__PURE__*/React__default.createElement(ContentWrapper, {
    backgroundImage: backgroundImage,
    styleOverride: contentStyle
  }, children), imagePosition === 'right' ? /*#__PURE__*/React__default.createElement(Img, null) : null);
};
const TabletImageWithContentWrapper = styled('div')(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n  ", "\n"])), buildMediaQueries(['large', 'smallAndDown'], {
  display: 'none'
}));
const MobileImageWithContentWrapper = styled('div')(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n  ", "\n"])), buildMediaQueries(['large', 'medium'], {
  display: 'none'
}));
const MobileImageWithContent = _ref7 => {
  let {
    children,
    Img,
    backgroundImage,
    contentStyle,
    imagePosition,
    flipImageOnMobile
  } = _ref7;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, imagePosition === 'left' && !flipImageOnMobile || imagePosition === 'right' && flipImageOnMobile ? /*#__PURE__*/React__default.createElement(Img, null) : null, /*#__PURE__*/React__default.createElement(ContentWrapper, {
    backgroundImage: backgroundImage,
    styleOverride: contentStyle
  }, children), imagePosition === 'right' && !flipImageOnMobile || imagePosition === 'left' && flipImageOnMobile ? /*#__PURE__*/React__default.createElement(Img, null) : null);
};
/**
 *
 * @param backgroundImage sets background image for Image prop
 * @param Image the image as a JSX.Element
 * @param imagePosition places the image to the left or right of children
 * @param label sets aria label for section
 * @param flipImageOnMobile forces image to sit on top of content in mobile views
 * @param rowOnMedium keeps image and content in a row on medium screens instead of defaulted column
 * @param imageStyle applies css directly to image
 * @param sectionStyle applies css directly to section tag
 * @param contentStyle applies css directly to non image content
 * @param imagePadding applies padding around the main image, which controls how large the background image appears
 *
 * @returns JSX.Element
 */
// eslint-disable-next-line max-lines-per-function
const ImageWithContent = _ref8 => {
  let {
    backgroundImage,
    Image,
    imagePosition = 'left',
    label,
    flipImageOnMobile,
    rowOnMedium,
    imageStyle,
    sectionStyle,
    contentStyle,
    imagePadding,
    children
  } = _ref8;
  const style = {
    backgroundImage: "url(".concat(backgroundImage, ")"),
    ...imageStyle
  };
  const Img = () => backgroundImage ? /*#__PURE__*/React__default.createElement(BackgroundImage, {
    styleOverride: style
  }, /*#__PURE__*/React__default.createElement(ImageWrapperWithBackground, {
    styleOverride: imagePadding
  }, Image)) : /*#__PURE__*/React__default.createElement(ImageWrapper$1, {
    styleOverride: imageStyle
  }, Image);
  const SectionWithProps = _ref9 => {
    let {
      children,
      size
    } = _ref9;
    return /*#__PURE__*/React__default.createElement(Section$1, {
      "aria-label": "".concat(label, "-").concat(size),
      rowOnMedium: rowOnMedium,
      styleOverride: sectionStyle
    }, children);
  };
  const NonMobileContent = _ref10 => {
    let {
      size
    } = _ref10;
    return /*#__PURE__*/React__default.createElement(SectionWithProps, {
      size: size
    }, /*#__PURE__*/React__default.createElement(DesktopImageWithContent, {
      Img: Img,
      imagePosition: imagePosition,
      backgroundImage: backgroundImage,
      contentStyle: contentStyle
    }, children));
  };
  const MobileContent = () => /*#__PURE__*/React__default.createElement(SectionWithProps, {
    size: "mobile"
  }, /*#__PURE__*/React__default.createElement(MobileImageWithContent, {
    Img: Img,
    imagePosition: imagePosition,
    backgroundImage: backgroundImage,
    contentStyle: contentStyle,
    flipImageOnMobile: flipImageOnMobile
  }, children));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(DesktopImageWithContentWrapper, null, /*#__PURE__*/React__default.createElement(NonMobileContent, {
    size: "desktop"
  })), /*#__PURE__*/React__default.createElement(TabletImageWithContentWrapper, null, /*#__PURE__*/React__default.createElement(NonMobileContent, {
    size: "tablet"
  })), /*#__PURE__*/React__default.createElement(MobileImageWithContentWrapper, null, /*#__PURE__*/React__default.createElement(MobileContent, null)));
};

var _templateObject$I, _templateObject2$n, _templateObject3$g, _templateObject4$5, _templateObject5$2, _templateObject6$1, _templateObject7$1;
const FullWidthGridItem = styled(OwnUpGridItem)(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  display: flex;\n  align-content: center;\n  justify-content: space-between;\n  ", " {\n    padding: 0 !important;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.down(325);
});
const LinksSection = styled.div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", "px;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(5);
});
const FullNavLinks = styled.div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", "px;\n  flex-direction: row;\n  height: 100%;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n\n  ", " {\n    display: none;\n  }\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(5);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(1.5);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(1.5);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.breakpoints.down('lg');
});
const ButtonsSection = styled.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", "px;\n  flex-direction: row;\n  align-items: center;\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(5);
});
const FullNavButtons = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: ", "px;\n  flex-direction: row;\n  justify-content: end;\n  align-content: center;\n  align-items: center;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  ", " {\n    display: none;\n  }\n"])), _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.spacing(5);
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.spacing(1.5);
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.spacing(1.5);
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.breakpoints.down('lg');
});
const CondensedNavButtons = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: end;\n  ", " {\n    display: none;\n  }\n"])), _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.breakpoints.up('xl');
});
const Button = styled(OwnUpFillButtonSecondary)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  margin-right: 8px;\n  p {\n    margin: 8px !important;\n  }\n"])));

const subMenuItems = [{
  title: 'Learning Center',
  link: '/learn/',
  description: 'The know-how you need to navigate home financing.',
  linkText: 'Explore our learning center'
}, {
  title: 'Affordability Calculator',
  link: '/calculators/affordability/',
  description: 'Learn how much home you can afford, and the next steps to take in the process.',
  linkText: 'Affordability calculator'
}, {
  title: 'Rate Range Finder',
  link: '/rate-comparison/',
  description: 'Get the range of rates for your borrowing scenario across thousands of lenders.',
  linkText: 'Find your rate range'
}, {
  title: 'For Realtors',
  link: '/real-estate/',
  description: 'Learn how Own Up can save your clients time and money.',
  linkText: 'Learn more'
}];
const navElements = [{
  link: '/how-it-works/',
  title: 'How it works'
}, {
  link: '/about/',
  title: 'About'
}, {
  name: 'Resources',
  drawerItems: subMenuItems
}, {
  link: '/reviews/',
  title: 'Reviews'
}, {
  link: '/faq/',
  title: 'FAQ'
}];
const isNavLink = item => {
  return item.link !== undefined;
};

// Facilitate use of Gatsby's Link for submenu items with relative links.
const composeSubMenuItem = function (item, trackingInstance) {
  let onModal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const onClick = () => trackingInstance.track("Click ".concat(item.title), {
    'page-location': "navigation-".concat(onModal ? 'modal' : 'bar')
  });
  return item.link[0] === '/' ? {
    ...item,
    linkProps: {
      component: Link$1,
      to: item.link,
      onClick
    }
  } : {
    ...item,
    linkProps: {
      onClick
    }
  };
};
const composeNavigationElements = function (navElements, www, trackingInstance) {
  let isMainSite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  let onModal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return navElements.map(element => {
    if (isNavLink(element)) {
      const normalizedElement = normalizeElement(element, www, isMainSite);
      return composeLink(normalizedElement, trackingInstance, onModal);
    }
    return {
      name: element.name,
      drawerItems: element.drawerItems.map(item => {
        const normalizedItem = normalizeElement(item, www, isMainSite);
        return composeSubMenuItem(normalizedItem, trackingInstance, onModal);
      })
    };
  });
};
const getNavButton = size => {
  switch (size) {
    case 'small':
      return OwnUpNavButtonSmall;
    case 'medium':
      return OwnUpNavButtonMedium;
    case 'large':
      return OwnUpNavButtonLarge;
  }
};
const NavItems = _ref => {
  let {
    size,
    www,
    trackingInstance,
    isMainSite = false,
    onModal = false
  } = _ref;
  const NavButton = getNavButton(size);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, composeNavigationElements(navElements, www, trackingInstance, isMainSite, onModal).map((element, index) => {
    if (isNavLink(element)) {
      const {
        title,
        ...linkProps
      } = element;
      return /*#__PURE__*/React__default.createElement(OwnUpNavLink, _extends$1({
        size: size,
        key: index
      }, linkProps), title);
    }
    const {
      name,
      ...props
    } = element;
    return /*#__PURE__*/React__default.createElement(NavButton, _extends$1({
      key: index,
      name: name,
      onModal: onModal
    }, props, {
      onClick: () => trackingInstance.track("Click ".concat(name), {
        'page-location': "navigation-".concat(onModal ? 'modal' : 'bar')
      }),
      style: {
        margin: '0 -40px',
        padding: '0 40px'
      }
    }), name);
  }));
};
const getStartedButtonProps = onboarding => ({
  href: "".concat(onboarding)
});
const GetStartedButtonDesktop = _ref2 => {
  let {
    onboarding,
    trackingInstance,
    id
  } = _ref2;
  const props = getStartedButtonProps(onboarding);
  return /*#__PURE__*/React__default.createElement(OwnUpFillButtonSecondary, _extends$1({}, props, {
    onClick: () => {
      trackingInstance.track('Click discover CTA', {
        'page-location': 'navigation-bar'
      });
    },
    id: id,
    iconPosition: "right",
    icon: /*#__PURE__*/React__default.createElement(ArrowRightIcon, null)
  }), "Get started");
};
const GetStartedButtonMobile = _ref3 => {
  let {
    onboarding,
    trackingInstance,
    id
  } = _ref3;
  const props = getStartedButtonProps(onboarding);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Check if the scroll position is greater than 0
      setIsScrolled(window.scrollY > 0);
    };

    // Add the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isScrolled && /*#__PURE__*/React__default.createElement(Button, _extends$1({}, props, {
    onClick: () => {
      trackingInstance.track('Click discover CTA', {
        'page-location': 'navigation-bar'
      });
    },
    id: id
  }), "Get started"));
};
const OwnUpHomeButton = _ref4 => {
  let {
    www,
    trackingInstance,
    isMainSite = false
  } = _ref4;
  const props = isMainSite ? {
    component: Link$1,
    to: '/'
  } : {
    href: www
  };
  return /*#__PURE__*/React__default.createElement(OwnUpLogoWithTextLink, _extends$1({}, props, {
    onClick: () => trackingInstance.track('Click Home', {
      'page-location': 'navigation-bar'
    })
  }));
};

var _templateObject$H, _templateObject2$m;
const DesktopDisplay = styled.div(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", "px;\n\n  ", " {\n    display: none;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(4);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.down('md');
});
const NavItemsDesktop = _ref3 => {
  let {
    www,
    trackingInstance,
    isMainSite = false
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(DesktopDisplay, null, /*#__PURE__*/React__default.createElement(NavItems, {
    size: "medium",
    www: www,
    isMainSite: isMainSite,
    onModal: true,
    trackingInstance: trackingInstance
  }));
};
const MobileDisplay = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", "px;\n\n  ", " {\n    display: none;\n  }\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(4);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.breakpoints.up('lg');
});
const NavItemsMobile = _ref6 => {
  let {
    www,
    trackingInstance,
    isMainSite = false
  } = _ref6;
  return /*#__PURE__*/React__default.createElement(MobileDisplay, null, /*#__PURE__*/React__default.createElement(NavItems, {
    size: "large",
    www: www,
    isMainSite: isMainSite,
    onModal: true,
    trackingInstance: trackingInstance
  }));
};
const navButtons = _ref7 => {
  let {
    onboarding,
    trackingInstance
  } = _ref7;
  return [/*#__PURE__*/React__default.createElement(OwnUpFillButtonPrimary, _extends$1({
    key: "get-started"
  }, getStartedButtonProps(onboarding), {
    onClick: () => {
      trackingInstance.track('Click discover CTA', {
        'page-location': 'navigation-modal'
      });
    },
    iconPosition: "right"
  }), "Get started")];
};

const NavModal = _ref => {
  let {
    open,
    setOpenModal,
    www,
    onboarding,
    trackingInstance,
    isMainSite = false
  } = _ref;
  const homepageProps = isMainSite ? {
    href: '/',
    component: Link$1,
    to: '/'
  } : {
    href: www
  };
  return /*#__PURE__*/React__default.createElement(OwnUpNavMenuModal, {
    open: open,
    onClose: () => setOpenModal(false),
    buttons: navButtons({
      onboarding,
      trackingInstance
    }),
    homepageLinkProps: homepageProps
  }, /*#__PURE__*/React__default.createElement(NavItemsDesktop, {
    www: www,
    trackingInstance: trackingInstance,
    isMainSite: isMainSite
  }), /*#__PURE__*/React__default.createElement(NavItemsMobile, {
    www: www,
    trackingInstance: trackingInstance,
    isMainSite: isMainSite
  }));
};

const getStartedButtonId = 'get_started_header';
const NavBar = _ref => {
  let {
    www,
    onboarding,
    trackingInstance,
    isMainSite = false
  } = _ref;
  const [openModal, setOpenModal] = useState(false);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpNavBar, null, /*#__PURE__*/React__default.createElement(FullWidthGridItem, {
    xs: true
  }, /*#__PURE__*/React__default.createElement(LinksSection, null, /*#__PURE__*/React__default.createElement(OwnUpHomeButton, {
    isMainSite: isMainSite,
    www: www,
    trackingInstance: trackingInstance
  }), /*#__PURE__*/React__default.createElement(FullNavLinks, null, /*#__PURE__*/React__default.createElement(NavItems, {
    size: "small",
    www: www,
    isMainSite: isMainSite,
    trackingInstance: trackingInstance
  }))), /*#__PURE__*/React__default.createElement(ButtonsSection, null, /*#__PURE__*/React__default.createElement(FullNavButtons, null, /*#__PURE__*/React__default.createElement(GetStartedButtonDesktop, {
    id: getStartedButtonId,
    onboarding: onboarding,
    trackingInstance: trackingInstance
  })), /*#__PURE__*/React__default.createElement(CondensedNavButtons, null, /*#__PURE__*/React__default.createElement(GetStartedButtonMobile, {
    id: getStartedButtonId,
    onboarding: onboarding,
    trackingInstance: trackingInstance
  }), /*#__PURE__*/React__default.createElement(OwnUpIconButton, {
    icon: /*#__PURE__*/React__default.createElement(MenuIcon, null),
    name: "navigation menu",
    size: 2.5,
    onClick: () => {
      trackingInstance.track('Click open navigation modal', {
        'page-location': 'navigation-bar'
      });
      setOpenModal(true);
    }
  }))))), /*#__PURE__*/React__default.createElement(NavModal, {
    open: openModal,
    setOpenModal,
    www,
    onboarding,
    isMainSite,
    trackingInstance
  }));
};

var _templateObject$G;
const OverlineText = styled(OwnUpOverline)(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  border-radius: 4px;\n  padding: ", ";\n  text-transform: uppercase;\n  white-space: nowrap;\n  width: fit-content;\n"])), MANGO_40, _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(0.5, 1, 0, 1);
});

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2="function"===typeof Symbol&&Symbol.for,c$2=b$2?Symbol.for("react.element"):60103,d$2=b$2?Symbol.for("react.portal"):60106,e$2=b$2?Symbol.for("react.fragment"):60107,f$2=b$2?Symbol.for("react.strict_mode"):60108,g$2=b$2?Symbol.for("react.profiler"):60114,h$2=b$2?Symbol.for("react.provider"):60109,k$2=b$2?Symbol.for("react.context"):60110,l$2=b$2?Symbol.for("react.async_mode"):60111,m$2=b$2?Symbol.for("react.concurrent_mode"):60111,n$2=b$2?Symbol.for("react.forward_ref"):60112,p$2=b$2?Symbol.for("react.suspense"):60113,q$2=b$2?
Symbol.for("react.suspense_list"):60120,r$3=b$2?Symbol.for("react.memo"):60115,t$1=b$2?Symbol.for("react.lazy"):60116,v$2=b$2?Symbol.for("react.block"):60121,w$2=b$2?Symbol.for("react.fundamental"):60117,x$2=b$2?Symbol.for("react.responder"):60118,y$2=b$2?Symbol.for("react.scope"):60119;
function z$2(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$2:switch(a=a.type,a){case l$2:case m$2:case e$2:case g$2:case f$2:case p$2:return a;default:switch(a=a&&a.$$typeof,a){case k$2:case n$2:case t$1:case r$3:case h$2:return a;default:return u}}case d$2:return u}}}function A$2(a){return z$2(a)===m$2}var AsyncMode$1=l$2;var ConcurrentMode$1=m$2;var ContextConsumer$2=k$2;var ContextProvider$2=h$2;var Element$3=c$2;var ForwardRef$2=n$2;var Fragment$2=e$2;var Lazy$2=t$1;var Memo$2=r$3;var Portal$2=d$2;
var Profiler$2=g$2;var StrictMode$2=f$2;var Suspense$2=p$2;var isAsyncMode$2=function(a){return A$2(a)||z$2(a)===l$2};var isConcurrentMode$2=A$2;var isContextConsumer$2=function(a){return z$2(a)===k$2};var isContextProvider$2=function(a){return z$2(a)===h$2};var isElement$2=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$2};var isForwardRef$2=function(a){return z$2(a)===n$2};var isFragment$2=function(a){return z$2(a)===e$2};var isLazy$2=function(a){return z$2(a)===t$1};
var isMemo$2=function(a){return z$2(a)===r$3};var isPortal$2=function(a){return z$2(a)===d$2};var isProfiler$2=function(a){return z$2(a)===g$2};var isStrictMode$2=function(a){return z$2(a)===f$2};var isSuspense$2=function(a){return z$2(a)===p$2};
var isValidElementType$2=function(a){return "string"===typeof a||"function"===typeof a||a===e$2||a===m$2||a===g$2||a===f$2||a===p$2||a===q$2||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r$3||a.$$typeof===h$2||a.$$typeof===k$2||a.$$typeof===n$2||a.$$typeof===w$2||a.$$typeof===x$2||a.$$typeof===y$2||a.$$typeof===v$2)};var typeOf$2=z$2;

var reactIs_production_min$2 = {
	AsyncMode: AsyncMode$1,
	ConcurrentMode: ConcurrentMode$1,
	ContextConsumer: ContextConsumer$2,
	ContextProvider: ContextProvider$2,
	Element: Element$3,
	ForwardRef: ForwardRef$2,
	Fragment: Fragment$2,
	Lazy: Lazy$2,
	Memo: Memo$2,
	Portal: Portal$2,
	Profiler: Profiler$2,
	StrictMode: StrictMode$2,
	Suspense: Suspense$2,
	isAsyncMode: isAsyncMode$2,
	isConcurrentMode: isConcurrentMode$2,
	isContextConsumer: isContextConsumer$2,
	isContextProvider: isContextProvider$2,
	isElement: isElement$2,
	isForwardRef: isForwardRef$2,
	isFragment: isFragment$2,
	isLazy: isLazy$2,
	isMemo: isMemo$2,
	isPortal: isPortal$2,
	isProfiler: isProfiler$2,
	isStrictMode: isStrictMode$2,
	isSuspense: isSuspense$2,
	isValidElementType: isValidElementType$2,
	typeOf: typeOf$2
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development$2 = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs$2 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$2;
} else {
  module.exports = reactIs_development$2;
}
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */








var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$2.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$2;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

var PropTypes = propTypes;

function r$2(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r$2(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r$2(e))&&(n&&(n+=" "),n+=t);return n}

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function isPlainObject(item) {
  return item && _typeof$1(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

function toPrimitive(t, r) {
  if ("object" != _typeof$1(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof$1(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof$1(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends({}, propTypes, _defineProperty({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1=60103,c$1=60106,d$1=60107,e$1=60108,f$1=60114,g$1=60109,h$1=60110,k$1=60112,l$1=60113,m$1=60120,n$1=60115,p$1=60116,q$1=60121,r$1=60122,u=60117,v$1=60129,w$1=60131;
if("function"===typeof Symbol&&Symbol.for){var x$1=Symbol.for;b$1=x$1("react.element");c$1=x$1("react.portal");d$1=x$1("react.fragment");e$1=x$1("react.strict_mode");f$1=x$1("react.profiler");g$1=x$1("react.provider");h$1=x$1("react.context");k$1=x$1("react.forward_ref");l$1=x$1("react.suspense");m$1=x$1("react.suspense_list");n$1=x$1("react.memo");p$1=x$1("react.lazy");q$1=x$1("react.block");r$1=x$1("react.server.block");u=x$1("react.fundamental");v$1=x$1("react.debug_trace_mode");w$1=x$1("react.legacy_hidden");}
function y$1(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$1:switch(a=a.type,a){case d$1:case f$1:case e$1:case l$1:case m$1:return a;default:switch(a=a&&a.$$typeof,a){case h$1:case k$1:case p$1:case n$1:case g$1:return a;default:return t}}case c$1:return t}}}var z$1=g$1,A$1=b$1,B=k$1,C=d$1,D=p$1,E=n$1,F=c$1,G=f$1,H=e$1,I=l$1;var ContextConsumer$1=h$1;var ContextProvider$1=z$1;var Element$2=A$1;var ForwardRef$1=B;var Fragment$1=C;var Lazy$1=D;var Memo$1=E;var Portal$1=F;var Profiler$1=G;var StrictMode$1=H;
var Suspense$1=I;var isAsyncMode$1=function(){return !1};var isConcurrentMode$1=function(){return !1};var isContextConsumer$1=function(a){return y$1(a)===h$1};var isContextProvider$1=function(a){return y$1(a)===g$1};var isElement$1=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$1};var isForwardRef$1=function(a){return y$1(a)===k$1};var isFragment$1=function(a){return y$1(a)===d$1};var isLazy$1=function(a){return y$1(a)===p$1};var isMemo$1=function(a){return y$1(a)===n$1};
var isPortal$1=function(a){return y$1(a)===c$1};var isProfiler$1=function(a){return y$1(a)===f$1};var isStrictMode$1=function(a){return y$1(a)===e$1};var isSuspense$1=function(a){return y$1(a)===l$1};var isValidElementType$1=function(a){return "string"===typeof a||"function"===typeof a||a===d$1||a===f$1||a===v$1||a===e$1||a===l$1||a===m$1||a===w$1||"object"===typeof a&&null!==a&&(a.$$typeof===p$1||a.$$typeof===n$1||a.$$typeof===g$1||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===u||a.$$typeof===q$1||a[0]===r$1)?!0:!1};
var typeOf$1=y$1;

var reactIs_production_min$1 = {
	ContextConsumer: ContextConsumer$1,
	ContextProvider: ContextProvider$1,
	Element: Element$2,
	ForwardRef: ForwardRef$1,
	Fragment: Fragment$1,
	Lazy: Lazy$1,
	Memo: Memo$1,
	Portal: Portal$1,
	Profiler: Profiler$1,
	StrictMode: StrictMode$1,
	Suspense: Suspense$1,
	isAsyncMode: isAsyncMode$1,
	isConcurrentMode: isConcurrentMode$1,
	isContextConsumer: isContextConsumer$1,
	isContextProvider: isContextProvider$1,
	isElement: isElement$1,
	isForwardRef: isForwardRef$1,
	isFragment: isFragment$1,
	isLazy: isLazy$1,
	isMemo: isMemo$1,
	isPortal: isPortal$1,
	isProfiler: isProfiler$1,
	isStrictMode: isStrictMode$1,
	isSuspense: isSuspense$1,
	isValidElementType: isValidElementType$1,
	typeOf: typeOf$1
};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development$1 = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs$1 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$1;
} else {
  module.exports = reactIs_development$1;
}
});

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof$1(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIs$1.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIs$1.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins$1 = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = _extends({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
createJss();

var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions = functionPlugin;

var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}

// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key$1 in jsCssMap) {
    if (key$1 + testProp in style) {
      js = key$1;
      css = jsCssMap[key$1];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (isBrowser) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1$1)) cache[computed[key$1$1]] = computed[key$1$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functions(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};

var ThemeContext = React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

function useTheme() {
  var theme = React__default.useContext(ThemeContext);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React__default.useContext(StylesContext);

  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof$1(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme() || defaultTheme;

    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);

    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__default.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames$1 = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames$1(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties(options, ["defaultTheme", "withTheme", "name"]);

    if (process.env.NODE_ENV !== 'production') {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (process.env.NODE_ENV !== 'production') {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = makeStyles(stylesOrCreator, _extends({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default.forwardRef(function WithStyles(props, ref) {
      props.classes;
          var innerRef = props.innerRef,
          other = _objectWithoutProperties(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__default.createElement(Component, _extends({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
    process.env.NODE_ENV !== "production" ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (process.env.NODE_ENV !== 'production') {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    hoistNonReactStatics_cjs(WithStyles, Component);

    if (process.env.NODE_ENV !== 'production') {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

var withStylesWithoutDefault = withStyles$1;

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys$1 = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys$1.indexOf(key) + 1;
    var upperbound = values[keys$1[endIndex]];

    if (endIndex === keys$1.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys$1.indexOf(end);

    if (endIndex === keys$1.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys$1[endIndex + 1]] === 'number' ? values[keys$1[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  var warnedOnce = false;

  function width(key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!warnedOnce) {
        warnedOnce = true;
        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", 'Use the `theme.breakpoints.values` instead.'].join('\n'));
      }
    }

    return values[key];
  }

  return _extends({
    keys: keys$1,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return _extends({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty({}, breakpoints.up('sm'), _extends({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

var common = {
  black: '#000',
  white: '#fff'
};

var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};

var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};

var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};

var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};

var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};

var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};

var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (process.env.NODE_ENV !== 'production') {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common.white,
    default: grey[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey[800],
    default: '#303030'
  },
  action: {
    active: common.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo[300],
    main: indigo[500],
    dark: indigo[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink.A200,
    main: pink.A400,
    dark: pink.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red[300],
    main: red[500],
    dark: red[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange[300],
    main: orange[500],
    dark: orange[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue[300],
    main: blue[500],
    dark: blue[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green[300],
    main: green[500],
    dark: green[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (process.env.NODE_ENV !== 'production') {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (process.env.NODE_ENV !== 'production') {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = deepmerge(_extends({
    // A collection of common colors.
    common: common,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var warnedOnce = false;

function roundWithDeprecationWarning(value) {
  if (process.env.NODE_ENV !== 'production') {
    if (!warnedOnce) {
      console.warn(['Material-UI: The `theme.typography.round` helper is deprecated.', 'Head to https://mui.com/r/migration-v4/#theme for a migration path.'].join('\n'));
      warnedOnce = true;
    }
  }

  return round(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];

var shape = {
  borderRadius: 4
};

var responsivePropType = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};

var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (process.env.NODE_ENV !== 'production') {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (process.env.NODE_ENV !== 'production') {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

process.env.NODE_ENV !== 'production' ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (process.env.NODE_ENV !== 'production') {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = _objectWithoutProperties(options, ["duration", "easing", "delay"]);

    if (process.env.NODE_ENV !== 'production') {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};

function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape,
    transitions: transitions,
    zIndex: zIndex
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  if (process.env.NODE_ENV !== 'production') {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://mui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var defaultTheme = createTheme();

function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends({
    defaultTheme: defaultTheme
  }, options));
}

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

var SIZE = 44;
var styles$5 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/React.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: _extends({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/React.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React.createElement("circle", {
    className: clsx(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
process.env.NODE_ENV !== "production" ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: chainPropTypes(PropTypes.oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;

    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }

    return null;
  })
} : void 0;
var CircularProgress$1 = withStyles(styles$5, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);

var _templateObject$F;
let globalCount;
const StyledSpinnerWrapper = styled.section(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  align-content: center;\n  color: ", ";\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n"])), PINE_100);
const LoadingSpinner = () => {
  globalCount = globalCount + 1 || 0;
  return /*#__PURE__*/React__default.createElement(StyledSpinnerWrapper, {
    "aria-label": "loading-".concat(globalCount)
  }, /*#__PURE__*/React__default.createElement(CircularProgress$1, {
    "aria-label": "spinner-".concat(globalCount),
    color: "inherit"
  }));
};

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});

var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

var $String = String;

var toString = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$1.RegExp;

var UNSUPPORTED_Y$1 = fails(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$1.RegExp;

var regexpUnsupportedDotAll = fails(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$1.RegExp;

var regexpUnsupportedNcg = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */







var getInternalState$1 = internalState.get;



var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = functionUncurryThis(''.charAt);
var indexOf = functionUncurryThis(''.indexOf);
var replace$1 = functionUncurryThis(''.replace);
var stringSlice$3 = functionUncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  functionCall(nativeExec, re1, 'a');
  functionCall(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState$1(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = functionCall(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = functionCall(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$1(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = functionCall(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      functionCall(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
};

// TODO: Remove from `core-js@4` since it's moved to entry points








var SPECIES$2 = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = functionUncurryThisClause(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = functionUncurryThisClause(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var charAt$2 = functionUncurryThis(''.charAt);
var charCodeAt = functionUncurryThis(''.charCodeAt);
var stringSlice$2 = functionUncurryThis(''.slice);

var createMethod$1 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$1(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$1(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var floor$3 = Math.floor;
var charAt = functionUncurryThis(''.charAt);
var replace = functionUncurryThis(''.replace);
var stringSlice$1 = functionUncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var $TypeError$4 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw $TypeError$4('RegExp#exec called on incompatible receiver');
};

var REPLACE = wellKnownSymbol('replace');
var max$1 = Math.max;
var min = Math.min;
var concat = functionUncurryThis([].concat);
var push$1 = functionUncurryThis([].push);
var stringIndexOf = functionUncurryThis(''.indexOf);
var stringSlice = functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? functionCall(replacer, searchValue, O, replaceValue)
        : functionCall(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        push$1(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max$1(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$1(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push$1(replacerArgs, namedCaptures);
          var replacement = toString(functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

// eslint-disable-next-line es/no-typed-arrays -- safe
var arrayBufferBasicDetection = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

var defineBuiltInAccessor = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, { setter: true });
  return objectDefineProperty.f(target, name, descriptor);
};

var enforceInternalState = internalState.enforce;
var getInternalState = internalState.get;
var Int8Array$3 = global$1.Int8Array;
var Int8ArrayPrototype$1 = Int8Array$3 && Int8Array$3.prototype;
var Uint8ClampedArray$1 = global$1.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray$1 && Uint8ClampedArray$1.prototype;
var TypedArray = Int8Array$3 && objectGetPrototypeOf(Int8Array$3);
var TypedArrayPrototype = Int8ArrayPrototype$1 && objectGetPrototypeOf(Int8ArrayPrototype$1);
var ObjectPrototype$1 = Object.prototype;
var TypeError$1 = global$1.TypeError;

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var NATIVE_ARRAY_BUFFER_VIEWS$1 = arrayBufferBasicDetection && !!objectSetPrototypeOf && classof(global$1.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;

var TypedArrayConstructorsList = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
};

var BigIntArrayConstructorsList = {
  BigInt64Array: 8,
  BigUint64Array: 8
};

var isView = function isView(it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return klass === 'DataView'
    || hasOwnProperty_1(TypedArrayConstructorsList, klass)
    || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var getTypedArrayConstructor = function (it) {
  var proto = objectGetPrototypeOf(it);
  if (!isObject(proto)) return;
  var state = getInternalState(proto);
  return (state && hasOwnProperty_1(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};

var isTypedArray = function (it) {
  if (!isObject(it)) return false;
  var klass = classof(it);
  return hasOwnProperty_1(TypedArrayConstructorsList, klass)
    || hasOwnProperty_1(BigIntArrayConstructorsList, klass);
};

var aTypedArray$3 = function (it) {
  if (isTypedArray(it)) return it;
  throw TypeError$1('Target is not a typed array');
};

var aTypedArrayConstructor$1 = function (C) {
  if (isCallable(C) && (!objectSetPrototypeOf || objectIsPrototypeOf(TypedArray, C))) return C;
  throw TypeError$1(tryToString(C) + ' is not a typed array constructor');
};

var exportTypedArrayMethod$3 = function (KEY, property, forced, options) {
  if (!descriptors) return;
  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
    var TypedArrayConstructor = global$1[ARRAY];
    if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor.prototype, KEY)) try {
      delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
      // old WebKit bug - some methods are non-configurable
      try {
        TypedArrayConstructor.prototype[KEY] = property;
      } catch (error2) { /* empty */ }
    }
  }
  if (!TypedArrayPrototype[KEY] || forced) {
    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
      : NATIVE_ARRAY_BUFFER_VIEWS$1 && Int8ArrayPrototype$1[KEY] || property, options);
  }
};

var exportTypedArrayStaticMethod = function (KEY, property, forced) {
  var ARRAY, TypedArrayConstructor;
  if (!descriptors) return;
  if (objectSetPrototypeOf) {
    if (forced) for (ARRAY in TypedArrayConstructorsList) {
      TypedArrayConstructor = global$1[ARRAY];
      if (TypedArrayConstructor && hasOwnProperty_1(TypedArrayConstructor, KEY)) try {
        delete TypedArrayConstructor[KEY];
      } catch (error) { /* empty */ }
    }
    if (!TypedArray[KEY] || forced) {
      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
      try {
        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS$1 && TypedArray[KEY] || property);
      } catch (error) { /* empty */ }
    } else return;
  }
  for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global$1[ARRAY];
    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
      defineBuiltIn(TypedArrayConstructor, KEY, property);
    }
  }
};

for (NAME in TypedArrayConstructorsList) {
  Constructor = global$1[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
  else NATIVE_ARRAY_BUFFER_VIEWS$1 = false;
}

for (NAME in BigIntArrayConstructorsList) {
  Constructor = global$1[NAME];
  Prototype = Constructor && Constructor.prototype;
  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}

// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!NATIVE_ARRAY_BUFFER_VIEWS$1 || !isCallable(TypedArray) || TypedArray === Function.prototype) {
  // eslint-disable-next-line no-shadow -- safe
  TypedArray = function TypedArray() {
    throw TypeError$1('Incorrect invocation');
  };
  if (NATIVE_ARRAY_BUFFER_VIEWS$1) for (NAME in TypedArrayConstructorsList) {
    if (global$1[NAME]) objectSetPrototypeOf(global$1[NAME], TypedArray);
  }
}

if (!NATIVE_ARRAY_BUFFER_VIEWS$1 || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype$1) {
  TypedArrayPrototype = TypedArray.prototype;
  if (NATIVE_ARRAY_BUFFER_VIEWS$1) for (NAME in TypedArrayConstructorsList) {
    if (global$1[NAME]) objectSetPrototypeOf(global$1[NAME].prototype, TypedArrayPrototype);
  }
}

// WebKit bug - one more object in Uint8ClampedArray prototype chain
if (NATIVE_ARRAY_BUFFER_VIEWS$1 && objectGetPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
  objectSetPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}

if (descriptors && !hasOwnProperty_1(TypedArrayPrototype, TO_STRING_TAG)) {
  TYPED_ARRAY_TAG_REQUIRED = true;
  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
    configurable: true,
    get: function () {
      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
    }
  });
  for (NAME in TypedArrayConstructorsList) if (global$1[NAME]) {
    createNonEnumerableProperty(global$1[NAME], TYPED_ARRAY_TAG, NAME);
  }
}

var arrayBufferViewCore = {
  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS$1,
  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
  aTypedArray: aTypedArray$3,
  aTypedArrayConstructor: aTypedArrayConstructor$1,
  exportTypedArrayMethod: exportTypedArrayMethod$3,
  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
  getTypedArrayConstructor: getTypedArrayConstructor,
  isView: isView,
  isTypedArray: isTypedArray,
  TypedArray: TypedArray,
  TypedArrayPrototype: TypedArrayPrototype
};

/* eslint-disable no-new -- required for testing */

var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;

var ArrayBuffer$1 = global$1.ArrayBuffer;
var Int8Array$2 = global$1.Int8Array;

var typedArrayConstructorsRequireWrappers = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
  Int8Array$2(1);
}) || !fails(function () {
  new Int8Array$2(-1);
}) || !checkCorrectnessOfIteration(function (iterable) {
  new Int8Array$2();
  new Int8Array$2(null);
  new Int8Array$2(1.5);
  new Int8Array$2(iterable);
}, true) || fails(function () {
  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
  return new Int8Array$2(new ArrayBuffer$1(2), 1, undefined).length !== 1;
});

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

var $TypeError$3 = TypeError;

var anInstance = function (it, Prototype) {
  if (objectIsPrototypeOf(Prototype, it)) return it;
  throw $TypeError$3('Incorrect invocation');
};

var $RangeError$2 = RangeError;

// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
var toIndex = function (it) {
  if (it === undefined) return 0;
  var number = toIntegerOrInfinity(it);
  var length = toLength(number);
  if (number !== length) throw $RangeError$2('Wrong length or index');
  return length;
};

// IEEE754 conversions based on https://github.com/feross/ieee754
var $Array$2 = Array;
var abs = Math.abs;
var pow = Math.pow;
var floor$2 = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;

var pack = function (number, mantissaLength, bytes) {
  var buffer = $Array$2(bytes);
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
  var index = 0;
  var exponent, mantissa, c;
  number = abs(number);
  // eslint-disable-next-line no-self-compare -- NaN check
  if (number != number || number === Infinity) {
    // eslint-disable-next-line no-self-compare -- NaN check
    mantissa = number != number ? 1 : 0;
    exponent = eMax;
  } else {
    exponent = floor$2(log(number) / LN2);
    c = pow(2, -exponent);
    if (number * c < 1) {
      exponent--;
      c *= 2;
    }
    if (exponent + eBias >= 1) {
      number += rt / c;
    } else {
      number += rt * pow(2, 1 - eBias);
    }
    if (number * c >= 2) {
      exponent++;
      c /= 2;
    }
    if (exponent + eBias >= eMax) {
      mantissa = 0;
      exponent = eMax;
    } else if (exponent + eBias >= 1) {
      mantissa = (number * c - 1) * pow(2, mantissaLength);
      exponent = exponent + eBias;
    } else {
      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
      exponent = 0;
    }
  }
  while (mantissaLength >= 8) {
    buffer[index++] = mantissa & 255;
    mantissa /= 256;
    mantissaLength -= 8;
  }
  exponent = exponent << mantissaLength | mantissa;
  exponentLength += mantissaLength;
  while (exponentLength > 0) {
    buffer[index++] = exponent & 255;
    exponent /= 256;
    exponentLength -= 8;
  }
  buffer[--index] |= sign * 128;
  return buffer;
};

var unpack = function (buffer, mantissaLength) {
  var bytes = buffer.length;
  var exponentLength = bytes * 8 - mantissaLength - 1;
  var eMax = (1 << exponentLength) - 1;
  var eBias = eMax >> 1;
  var nBits = exponentLength - 7;
  var index = bytes - 1;
  var sign = buffer[index--];
  var exponent = sign & 127;
  var mantissa;
  sign >>= 7;
  while (nBits > 0) {
    exponent = exponent * 256 + buffer[index--];
    nBits -= 8;
  }
  mantissa = exponent & (1 << -nBits) - 1;
  exponent >>= -nBits;
  nBits += mantissaLength;
  while (nBits > 0) {
    mantissa = mantissa * 256 + buffer[index--];
    nBits -= 8;
  }
  if (exponent === 0) {
    exponent = 1 - eBias;
  } else if (exponent === eMax) {
    return mantissa ? NaN : sign ? -Infinity : Infinity;
  } else {
    mantissa = mantissa + pow(2, mantissaLength);
    exponent = exponent - eBias;
  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
};

var ieee754 = {
  pack: pack,
  unpack: unpack
};

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

var createProperty = function (object, key, value) {
  var propertyKey = toPropertyKey$1(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var $Array$1 = Array;
var max = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array$1(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;





var PROPER_FUNCTION_NAME = functionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length';
var WRONG_INDEX = 'Wrong index';
var getInternalArrayBufferState = internalState.getterFor(ARRAY_BUFFER);
var getInternalDataViewState = internalState.getterFor(DATA_VIEW);
var setInternalState = internalState.set;
var NativeArrayBuffer = global$1[ARRAY_BUFFER];
var $ArrayBuffer = NativeArrayBuffer;
var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
var $DataView = global$1[DATA_VIEW];
var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
var ObjectPrototype = Object.prototype;
var Array$1 = global$1.Array;
var RangeError$2 = global$1.RangeError;
var fill = functionUncurryThis(arrayFill);
var reverse = functionUncurryThis([].reverse);

var packIEEE754 = ieee754.pack;
var unpackIEEE754 = ieee754.unpack;

var packInt8 = function (number) {
  return [number & 0xFF];
};

var packInt16 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF];
};

var packInt32 = function (number) {
  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
};

var unpackInt32 = function (buffer) {
  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};

var packFloat32 = function (number) {
  return packIEEE754(number, 23, 4);
};

var packFloat64 = function (number) {
  return packIEEE754(number, 52, 8);
};

var addGetter = function (Constructor, key, getInternalState) {
  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var get = function (view, count, index, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError$2(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = arraySliceSimple(bytes, start, start + count);
  return isLittleEndian ? pack : reverse(pack);
};

var set = function (view, count, index, conversion, value, isLittleEndian) {
  var intIndex = toIndex(index);
  var store = getInternalDataViewState(view);
  if (intIndex + count > store.byteLength) throw RangeError$2(WRONG_INDEX);
  var bytes = store.bytes;
  var start = intIndex + store.byteOffset;
  var pack = conversion(+value);
  for (var i = 0; i < count; i++) bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};

if (!arrayBufferBasicDetection) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, ArrayBufferPrototype);
    var byteLength = toIndex(length);
    setInternalState(this, {
      type: ARRAY_BUFFER,
      bytes: fill(Array$1(byteLength), 0),
      byteLength: byteLength
    });
    if (!descriptors) {
      this.byteLength = byteLength;
      this.detached = false;
    }
  };

  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, DataViewPrototype);
    anInstance(buffer, ArrayBufferPrototype);
    var bufferState = getInternalArrayBufferState(buffer);
    var bufferLength = bufferState.byteLength;
    var offset = toIntegerOrInfinity(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError$2('Wrong offset');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError$2(WRONG_LENGTH);
    setInternalState(this, {
      type: DATA_VIEW,
      buffer: buffer,
      byteLength: byteLength,
      byteOffset: offset,
      bytes: bufferState.bytes
    });
    if (!descriptors) {
      this.buffer = buffer;
      this.byteLength = byteLength;
      this.byteOffset = offset;
    }
  };

  DataViewPrototype = $DataView[PROTOTYPE];

  if (descriptors) {
    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
    addGetter($DataView, 'buffer', getInternalDataViewState);
    addGetter($DataView, 'byteLength', getInternalDataViewState);
    addGetter($DataView, 'byteOffset', getInternalDataViewState);
  }

  defineBuiltIns(DataViewPrototype, {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packInt8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
    }
  });
} else {
  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
  /* eslint-disable no-new -- required for testing */
  if (!fails(function () {
    NativeArrayBuffer(1);
  }) || !fails(function () {
    new NativeArrayBuffer(-1);
  }) || fails(function () {
    new NativeArrayBuffer();
    new NativeArrayBuffer(1.5);
    new NativeArrayBuffer(NaN);
    return NativeArrayBuffer.length != 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
  })) {
    /* eslint-enable no-new -- required for testing */
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, ArrayBufferPrototype);
      return new NativeArrayBuffer(toIndex(length));
    };

    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;

    for (var keys = getOwnPropertyNames(NativeArrayBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) {
        createNonEnumerableProperty($ArrayBuffer, key, NativeArrayBuffer[key]);
      }
    }

    ArrayBufferPrototype.constructor = $ArrayBuffer;
  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
  }

  // WebKit bug - the same parent prototype for typed arrays and data view
  if (objectSetPrototypeOf && objectGetPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
    objectSetPrototypeOf(DataViewPrototype, ObjectPrototype);
  }

  // iOS Safari 7.x bug
  var testView = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = functionUncurryThis(DataViewPrototype.setInt8);
  testView.setInt8(0, 2147483648);
  testView.setInt8(1, 2147483649);
  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8(this, byteOffset, value << 24 >> 24);
    }
  }, { unsafe: true });
}

setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);

var arrayBuffer = {
  ArrayBuffer: $ArrayBuffer,
  DataView: $DataView
};

var floor$1 = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es/no-number-isinteger -- safe
var isIntegralNumber = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor$1(it) === it;
};

var $RangeError$1 = RangeError;

var toPositiveInteger = function (it) {
  var result = toIntegerOrInfinity(it);
  if (result < 0) throw $RangeError$1("The argument can't be less than 0");
  return result;
};

var $RangeError = RangeError;

var toOffset = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw $RangeError('Wrong offset');
  return offset;
};

var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = functionUncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var $TypeError$2 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError$2(tryToString(argument) + ' is not a constructor');
};

var ITERATOR$1 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR$1)
    || getMethod(it, '@@iterator')
    || iterators[classof(it)];
};

var $TypeError$1 = TypeError;

var getIterator = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
  throw $TypeError$1(tryToString(argument) + ' is not iterable');
};

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

var isBigIntArray = function (it) {
  var klass = classof(it);
  return klass == 'BigInt64Array' || klass == 'BigUint64Array';
};

var $TypeError = TypeError;

// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
var toBigInt = function (argument) {
  var prim = toPrimitive$1(argument, 'number');
  if (typeof prim == 'number') throw $TypeError("Can't convert number to bigint");
  // eslint-disable-next-line es/no-bigint -- safe
  return BigInt(prim);
};

var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;


var typedArrayFrom = function from(source /* , mapfn, thisArg */) {
  var C = aConstructor(this);
  var O = toObject(source);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    O = [];
    while (!(step = functionCall(next, iterator)).done) {
      O.push(step.value);
    }
  }
  if (mapping && argumentsLength > 2) {
    mapfn = functionBindContext(mapfn, arguments[2]);
  }
  length = lengthOfArrayLike(O);
  result = new (aTypedArrayConstructor(C))(length);
  thisIsBigIntArray = isBigIntArray(result);
  for (i = 0; length > i; i++) {
    value = mapping ? mapfn(O[i], i) : O[i];
    // FF30- typed arrays doesn't properly convert objects to typed array values
    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
  }
  return result;
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(argument) {
  return classofRaw(argument) == 'Array';
};

var SPECIES$1 = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES$1];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var push = functionUncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};

var SPECIES = wellKnownSymbol('species');

var setSpecies = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (descriptors && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

var typedArrayConstructor = createCommonjsModule(function (module) {






















var getOwnPropertyNames = objectGetOwnPropertyNames.f;

var forEach = arrayIteration.forEach;







var getInternalState = internalState.get;
var setInternalState = internalState.set;
var enforceInternalState = internalState.enforce;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var round = Math.round;
var RangeError = global$1.RangeError;
var ArrayBuffer = arrayBuffer.ArrayBuffer;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataView = arrayBuffer.DataView;
var NATIVE_ARRAY_BUFFER_VIEWS = arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var TYPED_ARRAY_TAG = arrayBufferViewCore.TYPED_ARRAY_TAG;
var TypedArray = arrayBufferViewCore.TypedArray;
var TypedArrayPrototype = arrayBufferViewCore.TypedArrayPrototype;
var aTypedArrayConstructor = arrayBufferViewCore.aTypedArrayConstructor;
var isTypedArray = arrayBufferViewCore.isTypedArray;
var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
var WRONG_LENGTH = 'Wrong length';

var fromList = function (C, list) {
  aTypedArrayConstructor(C);
  var index = 0;
  var length = list.length;
  var result = new C(length);
  while (length > index) result[index] = list[index++];
  return result;
};

var addGetter = function (it, key) {
  defineBuiltInAccessor(it, key, {
    configurable: true,
    get: function () {
      return getInternalState(this)[key];
    }
  });
};

var isArrayBuffer = function (it) {
  var klass;
  return objectIsPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) == 'ArrayBuffer' || klass == 'SharedArrayBuffer';
};

var isTypedArrayIndex = function (target, key) {
  return isTypedArray(target)
    && !isSymbol(key)
    && key in target
    && isIntegralNumber(+key)
    && key >= 0;
};

var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
  key = toPropertyKey$1(key);
  return isTypedArrayIndex(target, key)
    ? createPropertyDescriptor(2, target[key])
    : nativeGetOwnPropertyDescriptor(target, key);
};

var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
  key = toPropertyKey$1(key);
  if (isTypedArrayIndex(target, key)
    && isObject(descriptor)
    && hasOwnProperty_1(descriptor, 'value')
    && !hasOwnProperty_1(descriptor, 'get')
    && !hasOwnProperty_1(descriptor, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !descriptor.configurable
    && (!hasOwnProperty_1(descriptor, 'writable') || descriptor.writable)
    && (!hasOwnProperty_1(descriptor, 'enumerable') || descriptor.enumerable)
  ) {
    target[key] = descriptor.value;
    return target;
  } return nativeDefineProperty(target, key, descriptor);
};

if (descriptors) {
  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
    objectGetOwnPropertyDescriptor.f = wrappedGetOwnPropertyDescriptor;
    objectDefineProperty.f = wrappedDefineProperty;
    addGetter(TypedArrayPrototype, 'buffer');
    addGetter(TypedArrayPrototype, 'byteOffset');
    addGetter(TypedArrayPrototype, 'byteLength');
    addGetter(TypedArrayPrototype, 'length');
  }

  _export({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
    defineProperty: wrappedDefineProperty
  });

  module.exports = function (TYPE, wrapper, CLAMPED) {
    var BYTES = TYPE.match(/\d+/)[0] / 8;
    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + TYPE;
    var SETTER = 'set' + TYPE;
    var NativeTypedArrayConstructor = global$1[CONSTRUCTOR_NAME];
    var TypedArrayConstructor = NativeTypedArrayConstructor;
    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
    var exported = {};

    var getter = function (that, index) {
      var data = getInternalState(that);
      return data.view[GETTER](index * BYTES + data.byteOffset, true);
    };

    var setter = function (that, index, value) {
      var data = getInternalState(that);
      if (CLAMPED) value = (value = round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
      data.view[SETTER](index * BYTES + data.byteOffset, value, true);
    };

    var addElement = function (that, index) {
      nativeDefineProperty(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };

    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
        anInstance(that, TypedArrayConstructorPrototype);
        var index = 0;
        var byteOffset = 0;
        var buffer, byteLength, length;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new ArrayBuffer(byteLength);
        } else if (isArrayBuffer(data)) {
          buffer = data;
          byteOffset = toOffset(offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - byteOffset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + byteOffset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (isTypedArray(data)) {
          return fromList(TypedArrayConstructor, data);
        } else {
          return functionCall(typedArrayFrom, TypedArrayConstructor, data);
        }
        setInternalState(that, {
          buffer: buffer,
          byteOffset: byteOffset,
          byteLength: byteLength,
          length: length,
          view: new DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });

      if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = objectCreate(TypedArrayPrototype);
    } else if (typedArrayConstructorsRequireWrappers) {
      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
        anInstance(dummy, TypedArrayConstructorPrototype);
        return inheritIfRequired(function () {
          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
          if (isArrayBuffer(data)) return $length !== undefined
            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
            : typedArrayOffset !== undefined
              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
              : new NativeTypedArrayConstructor(data);
          if (isTypedArray(data)) return fromList(TypedArrayConstructor, data);
          return functionCall(typedArrayFrom, TypedArrayConstructor, data);
        }(), dummy, TypedArrayConstructor);
      });

      if (objectSetPrototypeOf) objectSetPrototypeOf(TypedArrayConstructor, TypedArray);
      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
        if (!(key in TypedArrayConstructor)) {
          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
        }
      });
      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
    }

    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
    }

    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;

    if (TYPED_ARRAY_TAG) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
    }

    var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;

    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;

    _export({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
    }

    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
    }

    setSpecies(CONSTRUCTOR_NAME);
  };
} else module.exports = function () { /* empty */ };
});

// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
typedArrayConstructor('Uint8', function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

var aTypedArray$2 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$2 = arrayBufferViewCore.exportTypedArrayMethod;
var slice = functionUncurryThis(''.slice);

// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var CONVERSION_BUG = fails(function () {
  var count = 0;
  // eslint-disable-next-line es/no-typed-arrays -- safe
  new Int8Array(2).fill({ valueOf: function () { return count++; } });
  return count !== 1;
});

// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
exportTypedArrayMethod$2('fill', function fill(value /* , start, end */) {
  var length = arguments.length;
  aTypedArray$2(this);
  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
  return functionCall(arrayFill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, CONVERSION_BUG);

var RangeError$1 = global$1.RangeError;
var Int8Array$1 = global$1.Int8Array;
var Int8ArrayPrototype = Int8Array$1 && Int8Array$1.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray$1 = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod$1 = arrayBufferViewCore.exportTypedArrayMethod;

var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
  // eslint-disable-next-line es/no-typed-arrays -- required for testing
  var array = new Uint8ClampedArray(2);
  functionCall($set, array, { length: 1, 0: 3 }, 1);
  return array[1] !== 3;
});

// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
  var array = new Int8Array$1(2);
  array.set(1);
  array.set('2', 1);
  return array[0] !== 0 || array[1] !== 2;
});

// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
exportTypedArrayMethod$1('set', function set(arrayLike /* , offset */) {
  aTypedArray$1(this);
  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
  var src = toObject(arrayLike);
  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return functionCall($set, this, src, offset);
  var length = this.length;
  var len = lengthOfArrayLike(src);
  var index = 0;
  if (len + offset > length) throw RangeError$1('Wrong length');
  while (index < len) this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySliceSimple(array, 0, middle), comparefn),
    mergeSort(arraySliceSimple(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort = mergeSort;

var firefox = engineUserAgent.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var aTypedArray = arrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = arrayBufferViewCore.exportTypedArrayMethod;
var Uint16Array = global$1.Uint16Array;
var nativeSort = Uint16Array && functionUncurryThisClause(Uint16Array.prototype.sort);

// WebKit
var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
  nativeSort(new Uint16Array(2), null);
}) && fails(function () {
  nativeSort(new Uint16Array(2), {});
}));

var STABLE_SORT = !!nativeSort && !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 74;
  if (engineFfVersion) return engineFfVersion < 67;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 602;

  var array = new Uint16Array(516);
  var expected = Array(516);
  var index, mod;

  for (index = 0; index < 516; index++) {
    mod = index % 4;
    array[index] = 515 - index;
    expected[index] = index - 2 * mod + 3;
  }

  nativeSort(array, function (a, b) {
    return (a / 4 | 0) - (b / 4 | 0);
  });

  for (index = 0; index < 516; index++) {
    if (array[index] !== expected[index]) return true;
  }
});

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (y !== y) return -1;
    // eslint-disable-next-line no-self-compare -- NaN check
    if (x !== x) return 1;
    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
    return x > y;
  };
};

// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
exportTypedArrayMethod('sort', function sort(comparefn) {
  if (comparefn !== undefined) aCallable(comparefn);
  if (STABLE_SORT) return nativeSort(this, comparefn);

  return arraySort(aTypedArray(this), getSortCompare(comparefn));
}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);

// Used for testing and SSR.
const stubWebCrypto = {
  subtle: {
    digest: async (_, text) => crypto.createHash('sha512').update(text).digest()
  }
};

// Generate a hash of an experience/treatment key/value pair using the SHA-256 algorithm.
// Implementation cribbed from MDN documentation:
// https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
const digest = async treatment => {
  if (Object.keys(treatment).length > 1) {
    return '';
  }
  const webCrypto = typeof window !== 'undefined' ? window.crypto : stubWebCrypto;
  const encoder = typeof TextEncoder !== 'undefined' ? new TextEncoder() : new util.TextEncoder();
  const data = encoder.encode(JSON.stringify(treatment));
  const hashBuffer = await webCrypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
};
/**
 * Retrieve treatments from Split, hash each key/value pair, and
 * return an array of hashed values.
 *
 * Treatments return from Split in the form { [feature: string]: string }.
 */
const getHashedTreatments = async (client, activeSplits) => {
  const treatments = client === null || client === void 0 ? void 0 : client.getTreatments([...activeSplits]);
  const hashedTreatments = treatments ? Promise.all(activeSplits.map(async split => {
    const treatment = {
      [split]: treatments[split]
    };
    return await digest(treatment);
  })) : [];
  return hashedTreatments;
};

/**
 * Returns a number that can be used as an index into the array of hashed key/value
 * pairs stored in session storage.
 */
const getTreatmentIndex = (treatment, activeSplits) => {
  if (Object.keys(treatment).length > 1) {
    return -1;
  }
  return activeSplits.findIndex(split => split === Object.keys(treatment)[0]);
};

/**
 * Adds a previously unhashed treatment to an array of hashed treatments.
 * Only permits experiences that are listed in ACTIVE_SPLITS.
 */
const setHashedTreatment = async (hashedTreatments, treatment, activeSplits) => {
  const index = getTreatmentIndex(treatment, activeSplits);
  if (index > -1) {
    const hashedTreatment = await digest(treatment);
    hashedTreatments[index] = hashedTreatment;
  }
  return hashedTreatments;
};

/**
 * Checks if a treatment is in the array of hashed treatments.
 * Returns:
 *   false, if the treatment is not in the array of ACTIVE_SPLITS.
 *   false, if the hash of the treatment does not have a corresponding
 *     value in the data store.
 *   true, if the hash of the treatment DOES have a corresponding
 *     value in the data store.
 */
const checkTreatment = async (hashedTreatments, treatment, activeSplits) => {
  const index = getTreatmentIndex(treatment, activeSplits);
  if (index > -1) {
    const hashedTreatment = await digest(treatment);
    return hashedTreatments[index] === hashedTreatment;
  }
  return false;
};

const KEY = 'experience';
const initialState$6 = {
  data: [],
  isReady: false
};
const initialSplitExperienceContext = {
  isReady: false,
  activeSplits: [],
  setAllExperiences: async () => void 0,
  setExperience: async () => void 0,
  getExperience: async () => false
};
const SplitExperienceContext = /*#__PURE__*/createContext(initialSplitExperienceContext);

/**
 * Store the treatments in session storage, so they persist across page loads,
 * enabling the app to minimize the number of times it reaches out to Split.
 * Treatments are stored as hashed key/value pairs, to prevent enterprising
 * users from interfering with data collection by behaving unnaturally.
 */
const SplitExperienceProvider = _ref => {
  let {
    activeSplits,
    children
  } = _ref;
  const [{
    data: experienceData,
    isReady
  }, setExperienceState] = useSessionStorage(KEY, initialState$6);
  const setAllExperiences = async client => {
    const data = await getHashedTreatments(client, activeSplits);
    setExperienceState({
      data,
      isReady: true
    });
  };
  const setExperience = async treatment => {
    const newData = await setHashedTreatment(experienceData, treatment, activeSplits);
    setExperienceState({
      data: newData,
      isReady: isReady
    });
  };
  const getExperience = async treatment => {
    return await checkTreatment(experienceData, treatment, activeSplits);
  };
  return /*#__PURE__*/React__default.createElement(SplitExperienceContext.Provider, {
    value: {
      activeSplits,
      isReady,
      setAllExperiences,
      setExperience,
      getExperience
    }
  }, children);
};

/**
 * High-level wrapper component used to retrieve Split experience treatments
 * from session storage. It necessarily goes INSIDE both a SplitProvider and
 * a SplitExperience Provider. Ideally used once, at the level of Gatsby's
 * `wrapRootElement`. If that is not possible, this should be used at the top
 * of a Layout component (similar to the SEO component).
 */
const SplitWrapper = () => {
  const {
    client,
    isReady: clientIsReady
  } = useContext(SplitContext);
  const {
    isReady,
    activeSplits,
    setAllExperiences
  } = useContext(SplitExperienceContext);
  useEffect(() => {
    const setTreatments = async () => {
      if (clientIsReady) {
        await setAllExperiences(client);
      }
    };
    const splits = activeSplits.filter(Boolean);
    if (splits.length > 0 && !isReady) {
      setTreatments().catch(console.error);
    }
  }, [activeSplits, client, clientIsReady, isReady, setAllExperiences]);
  return /*#__PURE__*/React__default.createElement(Fragment$3, null);
};

/**
 * Initialize the Split configuration, and give children access to Split Context.
 */
const SplitProvider = _ref => {
  let {
    children
  } = _ref;
  const trackingInstance = useTrackingInstance();
  const splitUrl = process.env.GATSBY_SPLIT_URL || 'https://staging.split.ownup.com';
  const splitConfig = {
    core: {
      authorizationKey: process.env.GATSBY_SPLIT_API_KEY || 'qdjduua8u5orl12gguii27vam9g73rccr5lf',
      key: trackingInstance.getAnonymousId() || '',
      trafficType: 'Anonymous'
    },
    url(target) {
      const url = Object.getPrototypeOf(this).url.call(this, target);
      return url.replace('testImpressions', 'ti');
    },
    urls: {
      sdk: "".concat(splitUrl, "/sdk-api"),
      events: "".concat(splitUrl, "/events-api"),
      auth: "".concat(splitUrl, "/auth-api")
    }
  };
  return /*#__PURE__*/React__default.createElement(SplitFactory, {
    config: splitConfig
  }, children);
};

/**
 * Wrapper for SplitTreatment that assumes two possible treatments for a particular Split experiment.
 * Must be a child to a SplitProvider component, which should wrap the application, so it is only initialized once.
 * Treatments that use this component must have the Split experience added to ACTIVE_SPLITS.
 * @param experiment The name of the experiment.
 * @param treatmentName The name of one of the treatments. E,g, "on".
 * @param treatment The experience for treatmentName. E.g., what happens if treatmentName is "on".
 * @param otherTreatment The experience for the treatment not specified by treatmentName. E.g., what happens if treatmentName is "off".
 * @param defaultTreatment The experience to show before the treatmentName is known.
 * @param noDefault Option to show a spinner in lieu of a default treatment.
 */
const SplitBinaryTreatment = _ref2 => {
  let {
    experience,
    treatmentName,
    treatment,
    otherTreatment,
    defaultTreatment = otherTreatment,
    noDefault
  } = _ref2;
  const {
    isReady,
    getExperience,
    setExperience
  } = useContext(SplitExperienceContext);
  const [isBusy, setisBusy] = useState(true);
  const [treatmentMatch, setTreatmentMatch] = useState(false);
  useEffect(() => {
    const treatmentKey = {
      [experience]: treatmentName
    };
    const getValidatedTreatment = async () => await getExperience(treatmentKey);
    if (isReady) {
      getValidatedTreatment().then(result => {
        setTreatmentMatch(result);
        setisBusy(false);
      }).catch(console.error);
    }
  }, [experience, getExperience, isReady, treatmentName]);
  if (isBusy) {
    return noDefault ? /*#__PURE__*/React__default.createElement(LoadingSpinner, null) : defaultTreatment;
  }
  switch (treatmentMatch) {
    case -1:
      return /*#__PURE__*/React__default.createElement(SplitTreatments, {
        names: [experience]
      }, _ref3 => {
        let {
          treatments,
          isReady
        } = _ref3;
        if (!isReady) {
          if (noDefault) {
            return /*#__PURE__*/React__default.createElement(LoadingSpinner, null);
          }
        }
        setExperience({
          [experience]: treatments[experience].treatment
        }).catch(console.error);
        return treatments[experience].treatment === treatmentName ? treatment : otherTreatment;
      });
    case true:
      return treatment;
    case false:
      return otherTreatment;
    default:
      return noDefault ? /*#__PURE__*/React__default.createElement(LoadingSpinner, null) : defaultTreatment;
  }
};

const SingleValuePropWrapperStyle = createOwnUpStyle({
  display: 'contents',
  maxWidth: 'unset'
});
const SingleValuePropWrapper = createOwnUpComponent('section', SingleValuePropWrapperStyle);
const TextWrapperStyle = createOwnUpStyle({
  textAlign: 'center',
  marginBottom: '20px',
  variants: {
    primaryText: {
      marginBottom: '50px'
    }
  }
});
const TextWrapper = createOwnUpComponent(OwnUpBox, TextWrapperStyle);
const ImageWrapperStyle = createOwnUpStyle({
  width: '100%',
  margin: '30px auto 20px',
  textAlign: 'center',
  maxWidth: '240px'
});
const ImageWrapper = createOwnUpComponent(OwnUpBox, ImageWrapperStyle);
/**
 *
 * @param decorativeIcon indicates if image is purely decorative and should be ignored by assistive technology
 *
 */

const SingleValueProp = _ref => {
  let {
    Image,
    data: {
      catchphrase,
      text,
      label
    },
    metadata,
    decorativeIcon
  } = _ref;
  const renderedImage = Image && metadata && 'imageName' in Image ? /*#__PURE__*/React__default.createElement("img", {
    alt: decorativeIcon ? '' : metadata[Image.imageName].alt,
    src: Image.svg,
    height: Image.height
  }) : Image;
  return /*#__PURE__*/React__default.createElement(SingleValuePropWrapper, {
    "aria-label": label
  }, /*#__PURE__*/React__default.createElement(ImageWrapper, null, renderedImage), /*#__PURE__*/React__default.createElement(TextWrapper, {
    className: "catchphrase"
  }, /*#__PURE__*/React__default.createElement(Catchphrase, null, catchphrase)), /*#__PURE__*/React__default.createElement(TextWrapper, {
    variant: "primaryText",
    className: "primary-text"
  }, /*#__PURE__*/React__default.createElement(ResponsivePrimaryText, null, text)));
};

const ValuePropsWithHeaderWrapperStyle = createOwnUpStyle({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});
const ValuePropsWithHeaderWrapper = createOwnUpComponent(OwnUpBox, ValuePropsWithHeaderWrapperStyle);
const additionalTextStyle = createOwnUpStyle({
  textAlign: 'center',
  paddingBottom: '30px',
  maxWidth: '700px'
});
const AdditionalText = createOwnUpComponent(ResponsivePrimaryText, additionalTextStyle);
const ValuePropsWrapperStyle = _ref => {
  let {
    styleOverride
  } = _ref;
  const {
    variants,
    ...restStyleOverride
  } = styleOverride || {};
  return createOwnUpStyle({
    margin: 'auto',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridAutoFlow: 'column',
    gridTemplateRows: 'auto auto auto',
    alignItems: 'start',
    variants: {
      mediumAndDown: {
        gridTemplateColumns: '1fr',
        gridAutoFlow: 'row'
      },
      ...variants
    },
    ...restStyleOverride
  });
};
const ValuePropsWrapper = createOwnUpComponent(OwnUpBox, ValuePropsWrapperStyle);
// Component for the presentation of three value props (composed of header text, image, and descriptive text),
// which appear in one row or one column, depending on the screen size."
const ValueProps = _ref2 => {
  let {
    valueProps,
    metadata,
    header,
    ariaLabel,
    additionalText,
    style
  } = _ref2;
  return /*#__PURE__*/React__default.createElement("section", {
    "aria-label": ariaLabel
  }, /*#__PURE__*/React__default.createElement(ValuePropsWithHeaderWrapper, null, header ? /*#__PURE__*/React__default.createElement(ResponsiveSectionHeader, null, header) : null, additionalText ? /*#__PURE__*/React__default.createElement(AdditionalText, null, additionalText) : null, /*#__PURE__*/React__default.createElement(ValuePropsWrapper, {
    style: style
  }, valueProps.map((valueProp, i) => /*#__PURE__*/React__default.createElement(SingleValueProp, _extends$1({
    key: "value-prop-".concat(i)
  }, valueProp, {
    metadata: metadata
  }))))));
};

const swooshSVG = /*#__PURE__*/React__default.createElement("svg", {
  viewBox: "0 0 2021 157",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M1511.2 137.587C1775.51 165.951 2068.81 138.166 2321 90.336V0H1168.53H4V131.876C222.969 122.792 430.831 84.0638 650.497 78.1466C949.362 70.0968 1222.72 106.627 1511.2 137.587Z"
}));

const SwooshBoxStyling = _ref => {
  let {
    topColor,
    bottomColor
  } = _ref;
  return createOwnUpStyle({
    position: 'relative',
    top: 0,
    left: '-3px',
    display: 'inlineBlock',
    verticalAlign: 'middle',
    overflow: 'hidden',
    minWidth: '101vw',
    backgroundColor: bottomColor,
    '& svg': {
      fill: topColor
    },
    variants: {
      mediumAndUp: {
        left: '-6px'
      }
    }
  });
};
const SwooshDivider = _ref2 => {
  let {
    topColor,
    bottomColor,
    desktopMaxWidth,
    mobileLateralGutter
  } = _ref2;
  const SVGSwoosh = createOwnUpComponent(OwnUpBox, SwooshBoxStyling({
    topColor,
    bottomColor
  }));
  return /*#__PURE__*/React__default.createElement(FullWidthField, {
    backgroundColor: bottomColor,
    desktopMaxWidth: desktopMaxWidth,
    mobileLateralGutter: mobileLateralGutter
  }, /*#__PURE__*/React__default.createElement(SVGSwoosh, null, swooshSVG));
};

var img$2 = "data:image/svg+xml,%3csvg viewBox='0 0 13 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M11.9441 0.979718L4.97957 7.94422L0.999849 3.96451' stroke='%234BC98D' stroke-width='1.79078'/%3e%3c/svg%3e";

const Wrapper = createOwnUpComponent(OwnUpBox, {
  display: 'flex',
  flexDirection: 'column',
  padding: '72px 24px 100px',
  margin: 'auto',
  variants: {
    smallAndDown: {
      maxWidth: '327px'
    }
  }
});
const BulletWrapper = createOwnUpComponent(OwnUpBox, {
  display: 'flex',
  flexDirection: 'column',
  margin: '32px auto',
  variants: {
    inner: {
      flexDirection: 'row',
      alignItems: 'center',
      margin: 'unset',
      padding: '8px'
    }
  }
});
const ButtonWrapperStyle = createOwnUpStyle({
  display: 'flex',
  justifyContent: 'center',
  margin: '10px auto',
  width: '170px',
  variants: {
    smallAndDown: {
      width: '100%'
    }
  }
});
const ButtonWrapper = createOwnUpComponent(OwnUpBox, ButtonWrapperStyle);
const bullets = ['No hard credit checks', 'No spam, ever', 'No sales pressure, cost, or obligation'].map(text => /*#__PURE__*/React__default.createElement(BulletWrapper, {
  key: text,
  variant: "inner"
}, /*#__PURE__*/React__default.createElement("img", {
  src: img$2,
  height: "12px",
  style: {
    marginRight: '14px'
  },
  alt: ""
}), /*#__PURE__*/React__default.createElement(ParagraphTwoText, null, text)));
const ShopCTA = _ref => {
  let {
    desktopMaxWidth,
    mobileLateralGutter,
    onboarding
  } = _ref;
  return /*#__PURE__*/React__default.createElement(FullWidthField, {
    backgroundColor: colors.AQUA,
    desktopMaxWidth: desktopMaxWidth,
    mobileLateralGutter: mobileLateralGutter
  }, /*#__PURE__*/React__default.createElement(Wrapper, null, /*#__PURE__*/React__default.createElement(SubheadingSans, null, "Customers love shopping our marketplace"), /*#__PURE__*/React__default.createElement(BulletWrapper, null, bullets), /*#__PURE__*/React__default.createElement(ButtonWrapper, null, /*#__PURE__*/React__default.createElement(GetStartedLink, {
    onboarding: onboarding,
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(ShopCTAButton, null, "Get started")))));
};

var _templateObject$E, _templateObject2$l, _templateObject3$f;

// eslint-disable-next-line @typescript-eslint/naming-convention
const Section = styled.section(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: ", ";\n  ", " {\n    padding: ", ";\n  }\n  text-align: center;\n"])), WHITE_100, _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(8, 0, 6, 0);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(8, 0);
});
const LinksWrapper = styled.div(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: ", ";\n  margin-top: ", "px;\n  ", " {\n    flex-direction: row;\n  }\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(1, 0);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(2);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.breakpoints.up('md');
});
const GuideLink = styled.a(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n  color: ", ";\n  padding: ", ";\n  position: relative;\n  ", " {\n    padding: ", ";\n  }\n  :visited {\n    color: ", ";\n  }\n  :hover {\n    color: ", ";\n  }\n  &:not(:last-child)::after {\n    content: '';\n    height: 14px;\n    border-left: 1.5px solid ", ";\n    position: absolute;\n    right: -1px;\n    top: 5px;\n    display: none;\n    ", " {\n      display: block;\n    }\n  }\n"])), CHARCOAL_100, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(1, 2);
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.breakpoints.up('md');
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.spacing(0, 2);
}, CHARCOAL_100, ALOE_100, CHARCOAL_100, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.breakpoints.up('md');
});

const sectionName = 'Guides';
const GuidesSection = () => /*#__PURE__*/React__default.createElement(Section, {
  "aria-label": sectionName
}, /*#__PURE__*/React__default.createElement(OwnUpGridWrapper, null, /*#__PURE__*/React__default.createElement(OwnUpSmallSubheadlineMedium, {
  variant: 'h2'
}, "Guides:"), /*#__PURE__*/React__default.createElement(LinksWrapper, null, /*#__PURE__*/React__default.createElement(GuideLink, {
  href: "/learn/guide-buying-first-home/"
}, "First home loan"), /*#__PURE__*/React__default.createElement(GuideLink, {
  href: "/learn/how-to-find-mortgage-advisor/"
}, "Mortgage Advisors"), /*#__PURE__*/React__default.createElement(GuideLink, {
  href: "/learn/guide-to-mortgage-rate-comparison-shopping/"
}, "Mortgage Comparison"), /*#__PURE__*/React__default.createElement(GuideLink, {
  href: "/learn/mortgage-refinancing-101/"
}, "Refinance"))));

var _templateObject$D, _templateObject2$k, _templateObject3$e, _templateObject4$4;

// eslint-disable-next-line @typescript-eslint/naming-convention
styled.section(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: ", ";\n  ", " {\n    padding: ", ";\n  }\n  text-align: center;\n"])), SAGE_100, _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(8, 0, 6, 0);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(8, 0);
});
const FAQHeader = styled(OwnUpHeadlineBook)(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 28px;\n  line-height: 36px;\n  ", " {\n    font-size: 48px;\n    line-height: 56px;\n  }\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoints.up('md');
});
const StyledAccordionItem = styled(OwnUpFillAccordion)(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  text-align: left;\n  background-color: white;\n"])));
const MoreFaqsButtonLink = styled(Link$1)(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  ", " {\n    width: 100%;\n  }\n\n  // Spacing above button\n  ", " {\n    padding-top: ", "px;\n  }\n  ", " {\n    padding-top: ", "px;\n  }\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.breakpoints.only('xs');
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.breakpoints.up('xs');
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(4);
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.breakpoints.up('lg');
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.spacing(5);
});
const MoreFAQsButton = _ref10 => {
  let {
    href,
    text
  } = _ref10;
  return /*#__PURE__*/React__default.createElement(MoreFaqsButtonLink, {
    to: href,
    tabIndex: -1
  }, /*#__PURE__*/React__default.createElement(OwnUpFillButtonPrimary, null, text));
};

const FAQ = _ref => {
  let {
    title = 'FAQs',
    ctaUrl = '/faq',
    ctaText = 'More FAQs',
    questions
  } = _ref;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FAQHeader, {
    variant: 'h2'
  }, title), questions && questions.map(question => /*#__PURE__*/React__default.createElement(StyledAccordionItem, {
    key: "question-".concat(question.question),
    title: question.question
  }, question.answer)), ctaUrl ? /*#__PURE__*/React__default.createElement(MoreFAQsButton, {
    href: ctaUrl,
    text: ctaText
  }) : null);
};

const MoneyIcon = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M35 13C35 19.0751 30.0751 24 24 24C17.9249 24 13 19.0751 13 13C13 6.92487 17.9249 2 24 2C30.0751 2 35 6.92487 35 13Z",
  style: {
    fill: MINT_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 3C18.4772 3 14 7.47715 14 13C14 18.5228 18.4772 23 24 23C29.5228 23 34 18.5228 34 13C34 7.47715 29.5228 3 24 3ZM12 13C12 6.37258 17.3726 1 24 1C30.6274 1 36 6.37258 36 13C36 19.6274 30.6274 25 24 25C17.3726 25 12 19.6274 12 13Z",
  style: {
    fill: ALOE_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.9999 5.58331C24.5522 5.58331 24.9999 6.03103 24.9999 6.58331V7.25755C25.6177 7.40579 26.1901 7.68743 26.6615 8.07132C27.3813 8.65743 27.9166 9.53101 27.9166 10.5694C27.9166 11.1217 27.4689 11.5694 26.9166 11.5694C26.3643 11.5694 25.9166 11.1217 25.9166 10.5694C25.9166 10.2548 25.756 9.91313 25.3987 9.62221C25.04 9.33011 24.5342 9.13887 23.9999 9.13887C22.819 9.13887 22.0833 9.94934 22.0833 10.5694C22.0833 11.0346 22.2226 11.3517 22.4443 11.5596C22.6724 11.7734 23.1247 12 23.9999 12C25.206 12 26.2124 12.3132 26.9227 12.9776C27.64 13.6487 27.9166 14.548 27.9166 15.4305C27.9166 16.466 27.3804 17.3389 26.6624 17.9249C26.1913 18.3094 25.6187 18.5927 24.9999 18.7418V19.4166C24.9999 19.9689 24.5522 20.4166 23.9999 20.4166C23.4476 20.4166 22.9999 19.9689 22.9999 19.4166V18.7382C21.4595 18.3609 20.0833 17.1404 20.0833 15.4305C20.0833 14.8783 20.531 14.4305 21.0833 14.4305C21.6355 14.4305 22.0833 14.8783 22.0833 15.4305C22.0833 16.0444 22.8213 16.8611 23.9999 16.8611C24.0003 16.8611 24.0007 16.8611 24.0011 16.8611C24.5331 16.8608 25.0383 16.6688 25.3978 16.3754C25.757 16.0823 25.9166 15.74 25.9166 15.4305C25.9166 14.96 25.7765 14.6441 25.5563 14.4381C25.3291 14.2256 24.8771 14 23.9999 14C22.7918 14 21.7858 13.6837 21.0763 13.0185C20.3605 12.3474 20.0833 11.4491 20.0833 10.5694C20.0833 8.85162 21.4606 7.63656 22.9999 7.26119V6.58331C22.9999 6.03103 23.4476 5.58331 23.9999 5.58331Z",
  style: {
    fill: ALOE_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.1951 26.8593C40.397 26.0612 39.103 26.0612 38.3049 26.8593L30.6287 34.5355C29.691 35.4732 28.4192 36 27.0931 36H17.75C17.1977 36 16.75 35.5523 16.75 35C16.75 34.4477 17.1977 34 17.75 34H24.75C25.8546 34 26.75 33.1046 26.75 32C26.75 30.8954 25.8546 30 24.75 30H13.0637C11.2072 30 9.42672 30.7375 8.11396 32.0502L5.45711 34.7071C5.06658 35.0976 4.43342 35.0976 4.04289 34.7071C3.65237 34.3166 3.65237 33.6834 4.04289 33.2929L6.69975 30.636C8.38758 28.9482 10.6768 28 13.0637 28H24.75C26.9591 28 28.75 29.7908 28.75 32C28.75 32.6149 28.6113 33.1973 28.3634 33.7178C28.6767 33.5714 28.9652 33.3705 29.2145 33.1213L36.8907 25.4451C38.4698 23.866 41.0302 23.8659 42.6093 25.4451C44.16 26.9957 44.1921 29.4997 42.6817 31.0896L34.0233 40.2037C31.5689 42.7872 28.1617 44.25 24.5983 44.25H12.9136C11.1352 44.25 9.42341 44.9269 8.12599 46.1432L6.43394 47.7295C6.03103 48.1073 5.39819 48.0868 5.02046 47.6839C4.64273 47.281 4.66315 46.6482 5.06606 46.2705L6.75811 44.6842C8.42622 43.1203 10.627 42.25 12.9136 42.25H24.5983C27.6135 42.25 30.4965 41.0123 32.5733 38.8262L41.2317 29.7121C41.995 28.9086 41.9788 27.643 41.1951 26.8593Z",
  style: {
    fill: ALOE_100
  }
}));

const PurchaseIcon = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M45.899 20.1824L24.6282 3.00726C24.2617 2.7113 23.7383 2.71131 23.3718 3.00726L2.10101 20.1824C1.73417 20.4786 1.94362 21.0714 2.41512 21.0714H7.23077V44.5C7.23077 45.0523 7.67848 45.5 8.23077 45.5H17.4615C18.0138 45.5 18.4615 45.0523 18.4615 44.5V28.7857H29.5385V44.5C29.5385 45.0523 29.9862 45.5 30.5385 45.5H39.7692C40.3215 45.5 40.7692 45.0523 40.7692 44.5V21.0714H45.5849C46.0564 21.0714 46.2658 20.4786 45.899 20.1824Z",
  style: {
    fill: SAGE_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M24.6282 3.00726L25.2565 2.22923L25.2564 2.22923L24.6282 3.00726ZM45.899 20.1824L45.2708 20.9604V20.9604L45.899 20.1824ZM2.10101 20.1824L2.72924 20.9604H2.72924L2.10101 20.1824ZM23.3718 3.00726L24 3.78529V3.78529L23.3718 3.00726ZM7.23077 21.0714H8.23077V20.0714H7.23077V21.0714ZM40.7692 21.0714V20.0714H39.7692V21.0714H40.7692ZM29.5385 28.7857H30.5385C30.5385 28.2334 30.0907 27.7857 29.5385 27.7857V28.7857ZM18.4615 28.7857V27.7857C17.9093 27.7857 17.4615 28.2334 17.4615 28.7857H18.4615ZM24 3.78529L45.2708 20.9604L46.5272 19.4044L25.2565 2.22923L24 3.78529ZM2.72924 20.9604L24 3.78529L22.7435 2.22923L1.47279 19.4044L2.72924 20.9604ZM7.23077 20.0714H2.41512V22.0714H7.23077V20.0714ZM45.5849 20.0714H40.7692V22.0714H45.5849V20.0714ZM39.7692 21.0714V44.5H41.7692V21.0714H39.7692ZM8.23077 44.5V21.0714H6.23077V44.5H8.23077ZM17.4615 44.5H8.23077V46.5H17.4615V44.5ZM39.7692 44.5H30.5385V46.5H39.7692V44.5ZM30.5385 44.5V28.7857H28.5385V44.5H30.5385ZM29.5385 27.7857H18.4615V29.7857H29.5385V27.7857ZM17.4615 28.7857V44.5H19.4615V28.7857H17.4615ZM30.5385 44.5H28.5385C28.5385 45.6046 29.4339 46.5 30.5385 46.5V44.5ZM17.4615 46.5C18.5661 46.5 19.4615 45.6046 19.4615 44.5H17.4615V46.5ZM39.7692 44.5V46.5C40.8738 46.5 41.7692 45.6046 41.7692 44.5H39.7692ZM1.47279 19.4044C0.37225 20.293 1.0006 22.0714 2.41512 22.0714V20.0714C2.88663 20.0714 3.09608 20.6642 2.72924 20.9604L1.47279 19.4044ZM6.23077 44.5C6.23077 45.6046 7.1262 46.5 8.23077 46.5V44.5H8.23077H6.23077ZM45.2708 20.9604C44.9039 20.6642 45.1134 20.0714 45.5849 20.0714V22.0714C46.9994 22.0714 47.6278 20.293 46.5272 19.4044L45.2708 20.9604ZM25.2564 2.22923C24.5234 1.63732 23.4766 1.63732 22.7435 2.22923L24 3.78529L24 3.7853L25.2564 2.22923Z",
  style: {
    fill: ALOE_100
  }
}), /*#__PURE__*/React__default.createElement("circle", {
  cx: "32",
  cy: "12.5",
  r: "9",
  fill: "#B9DDCC",
  stroke: ALOE_100,
  strokeWidth: "2"
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33 8.75C33 8.19772 32.5523 7.75 32 7.75C31.4477 7.75 31 8.19772 31 8.75V11.25H28.5C27.9477 11.25 27.5 11.6977 27.5 12.25C27.5 12.8023 27.9477 13.25 28.5 13.25H31V15.75C31 16.3023 31.4477 16.75 32 16.75C32.5523 16.75 33 16.3023 33 15.75V13.25H35.5C36.0523 13.25 36.5 12.8023 36.5 12.25C36.5 11.6977 36.0523 11.25 35.5 11.25H33V8.75Z",
  style: {
    fill: ALOE_100
  }
}));

const SealIcon = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  d: "M21.4055 2.21091C22.9006 0.936858 25.0995 0.936857 26.5945 2.21091L30.362 5.42157C31.0027 5.96753 31.7992 6.29748 32.6383 6.36444L37.5726 6.7582C39.5306 6.91445 41.0855 8.46929 41.2417 10.4273L41.6355 15.3617C41.7025 16.2007 42.0324 16.9973 42.5784 17.6379L45.789 21.4055C47.0631 22.9005 47.0631 25.0994 45.789 26.5944L42.5784 30.3619C42.0324 31.0026 41.7025 31.7991 41.6355 32.6382L41.2417 37.5725C41.0855 39.5305 39.5306 41.0854 37.5726 41.2416L32.6383 41.6354C31.7992 41.7024 31.0027 42.0323 30.362 42.5783L26.5945 45.7889C25.0995 47.063 22.9006 47.063 21.4055 45.7889L17.638 42.5783C16.9974 42.0323 16.2008 41.7024 15.3617 41.6354L10.4274 41.2416C8.46939 41.0854 6.91454 39.5305 6.75829 37.5725L6.36453 32.6382C6.29757 31.7991 5.96762 31.0026 5.42166 30.3619L2.211 26.5944C0.93695 25.0994 0.936948 22.9005 2.211 21.4055L5.42166 17.6379C5.96762 16.9973 6.29757 16.2007 6.36453 15.3617L6.75829 10.4273C6.91454 8.4693 8.46938 6.91445 10.4274 6.7582L15.3617 6.36444C16.2008 6.29748 16.9974 5.96753 17.638 5.42157L21.4055 2.21091Z",
  style: {
    fill: MINT_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.0648 6.9438L25.2972 3.73314C24.5497 3.09611 23.4503 3.09611 22.7028 3.73314L18.9353 6.9438C17.9743 7.76274 16.7794 8.25766 15.5208 8.3581L10.5865 8.75186C9.6075 8.82999 8.83008 9.60741 8.75195 10.5864L8.35819 15.5207C8.25775 16.7793 7.76283 17.9742 6.94389 18.9352L3.73323 22.7027C3.09621 23.4502 3.09621 24.5496 3.73323 25.2972L6.94389 29.0647C7.76284 30.0257 8.25775 31.2205 8.35819 32.4791L8.75195 37.4134C8.83008 38.3924 9.6075 39.1699 10.5865 39.248L15.5208 39.6417C16.7794 39.7422 17.9743 40.2371 18.9353 41.056L22.7028 44.2667C23.4503 44.9037 24.5497 44.9037 25.2972 44.2667L29.0648 41.056C30.0258 40.2371 31.2206 39.7422 32.4792 39.6417L37.4135 39.248C38.3925 39.1699 39.1699 38.3924 39.2481 37.4134L39.6418 32.4791C39.7423 31.2205 40.2372 30.0257 41.0561 29.0647L44.2668 25.2972C44.9038 24.5496 44.9038 23.4502 44.2668 22.7027L41.0561 18.9352C40.2372 17.9742 39.7423 16.7793 39.6418 15.5207L39.2481 10.5864C39.1699 9.60741 38.3925 8.82999 37.4135 8.75186L32.4792 8.3581C31.2206 8.25766 30.0258 7.76274 29.0648 6.9438ZM26.5945 2.21091C25.0995 0.936857 22.9006 0.936858 21.4055 2.21091L17.638 5.42157C16.9974 5.96753 16.2008 6.29748 15.3617 6.36444L10.4274 6.7582C8.46938 6.91445 6.91454 8.4693 6.75829 10.4273L6.36453 15.3617C6.29757 16.2007 5.96762 16.9973 5.42166 17.6379L2.211 21.4055C0.936948 22.9005 0.93695 25.0994 2.211 26.5944L5.42166 30.3619C5.96762 31.0026 6.29757 31.7991 6.36453 32.6382L6.75829 37.5725C6.91454 39.5305 8.46939 41.0854 10.4274 41.2416L15.3617 41.6354C16.2008 41.7024 16.9974 42.0323 17.638 42.5783L21.4055 45.7889C22.9006 47.063 25.0995 47.063 26.5945 45.7889L30.362 42.5783C31.0027 42.0323 31.7992 41.7024 32.6383 41.6354L37.5726 41.2416C39.5306 41.0854 41.0855 39.5305 41.2417 37.5725L41.6355 32.6382C41.7025 31.7991 42.0324 31.0026 42.5784 30.3619L45.789 26.5944C47.0631 25.0994 47.0631 22.9005 45.789 21.4055L42.5784 17.6379C42.0324 16.9973 41.7025 16.2007 41.6355 15.3617L41.2417 10.4273C41.0855 8.46929 39.5306 6.91445 37.5726 6.7582L32.6383 6.36444C31.7992 6.29748 31.0027 5.96753 30.362 5.42157L26.5945 2.21091Z",
  style: {
    fill: ALOE_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M40 24C40 32.8366 32.8366 40 24 40C15.1634 40 8 32.8366 8 24C8 15.1634 15.1634 8 24 8C32.8366 8 40 15.1634 40 24Z",
  style: {
    fill: SAGE_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 38C31.732 38 38 31.732 38 24C38 16.268 31.732 10 24 10C16.268 10 10 16.268 10 24C10 31.732 16.268 38 24 38ZM24 40C32.8366 40 40 32.8366 40 24C40 15.1634 32.8366 8 24 8C15.1634 8 8 15.1634 8 24C8 32.8366 15.1634 40 24 40Z",
  style: {
    fill: ALOE_100
  }
}), /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.6775 18.2645C32.0837 18.6386 32.1097 19.2713 31.7355 19.6775L22.525 29.6775C22.338 29.8805 22.0753 29.9973 21.7993 30C21.5232 30.0027 21.2583 29.8911 21.0673 29.6917L16.2779 24.6917C15.8958 24.2929 15.9094 23.6599 16.3083 23.2779C16.7071 22.8958 17.3401 22.9094 17.7221 23.3083L21.7752 27.5395L30.2645 18.3225C30.6386 17.9163 31.2712 17.8903 31.6775 18.2645Z",
  style: {
    fill: ALOE_100
  }
}));

var _templateObject$C, _templateObject2$j, _templateObject3$d;
const SubtitleWrapper = styled(OwnUpBody)(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  margin: 0;\n"])));
const ExplanationModal = _ref => {
  let {
    open,
    onClose,
    title,
    description
  } = _ref;
  return /*#__PURE__*/React__default.createElement(OwnUpFloatingModal, {
    title: title,
    open: open,
    onClose: onClose
  }, description);
};
const SmallScreenContainer = styled.span(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n  ", " {\n    display: none;\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
});
const LargeScreenContainer = styled.span(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  ", " {\n    display: none;\n  }\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.breakpoints.down('sm');
});
const TooltipWrapper = _ref4 => {
  let {
    title,
    description
  } = _ref4;
  const [modalOpen, setModalOpen] = useState(false);
  const handleClick = useCallback(() => {
    setModalOpen(true);
  }, []);
  const closeModal = () => {
    console.log('closing');
    setModalOpen(false);
  };
  const smallScreenTooltip = useMemo(() => /*#__PURE__*/React__default.createElement(SmallScreenContainer, null, /*#__PURE__*/React__default.createElement(OwnUpTooltip, {
    onClick: handleClick,
    description: true,
    open: false
  }, /*#__PURE__*/React__default.createElement(OwnUpUnderlineTooltipTrigger, {
    className: "underline"
  }, title)), /*#__PURE__*/React__default.createElement(ExplanationModal, {
    open: modalOpen,
    onClose: closeModal,
    title: title,
    description: description
  })), [modalOpen, handleClick, title, description]);
  const largeScreenTooltip = useMemo(() => /*#__PURE__*/React__default.createElement(LargeScreenContainer, null, /*#__PURE__*/React__default.createElement(OwnUpTooltip, {
    description: description
  }, /*#__PURE__*/React__default.createElement(OwnUpUnderlineTooltipTrigger, {
    className: "underline"
  }, title))), [title, description]);
  return /*#__PURE__*/React__default.createElement(SubtitleWrapper, {
    variant: "body1"
  }, smallScreenTooltip, largeScreenTooltip);
};

var _templateObject$B, _templateObject2$i, _templateObject3$c;
const WidgetContainer = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  padding: 0;\n  background-color: ", ";\n  margin: 0 -", "px;\n  padding: ", ";\n  ", " {\n    margin: 0;\n    padding: ", ";\n    border-radius: ", ";\n  }\n"])), FOG_20, _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(5, 3);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.breakpoints.up('md');
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(4, 4);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(1, 1);
});
const WidgetHeader = styled(OwnUpHeadlineBook)(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n  padding-top: 0 !important;\n  font-size: 24px;\n  line-height: 32px;\n  ", " {\n    font-size: 32px;\n    line-height: 40px;\n  }\n"])), _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.breakpoints.up('sm');
});
const TooltipPadding = styled.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(3);
});

const WidgetWrapper = _ref => {
  let {
    title,
    description,
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(WidgetContainer, {
    className: "widget-container"
  }, /*#__PURE__*/React__default.createElement(WidgetHeader, {
    variant: "h3"
  }, title), /*#__PURE__*/React__default.createElement(TooltipPadding, null, /*#__PURE__*/React__default.createElement(TooltipWrapper, {
    title: "What does this calculator do?",
    description: description
  })), children);
};

let LoanTerms = /*#__PURE__*/function (LoanTerms) {
  LoanTerms["THIRTY"] = "THIRTY";
  LoanTerms["TWENTY"] = "TWENTY";
  LoanTerms["FIFTEEN"] = "FIFTEEN";
  return LoanTerms;
}({});

/* eslint-disable @typescript-eslint/naming-convention */
const creditTiers = {
  '740+': 740,
  '700-739': 700,
  '660-699': 660,
  '620-659': 620,
  '580-619': 580,
  '579 or less': 579
};
const interestRateToCreditTiers = {
  740: 6.625,
  700: 6.99,
  660: 7,
  620: 7,
  580: 7,
  579: 7
};
const loanTermsOptions = [{
  value: LoanTerms.THIRTY,
  title: '30 years fixed'
}, {
  value: LoanTerms.TWENTY,
  title: '20 years fixed'
}, {
  value: LoanTerms.FIFTEEN,
  title: '15 years fixed'
}];

/* eslint-disable @typescript-eslint/naming-convention */
const annualizedPercentFactor = 1200; // divide to turn rates expressed as a yearly percentage into a monthly decimal.
const minStretchingDTI = 0.3; // DTI above this is considered stretching
const maxStretchingDTI = 0.43; // DTI above this is considered aggressive
const maxAffordability = 0.5; // This is the highest number we'll show on the slider.
const sliderMinDTI = 0.2; // Target a DTI for the minimum value on the slider.
const sliderMaxRange = 600000; // Target a maximum range for the slider.
const fallbackDownPayment = 20000;
const fallbackAnnualIncome = 60000;
const conformingLoanLimit = 1149825;

/* eslint-disable @typescript-eslint/naming-convention */

let AffordabilityDataActionsTypes = /*#__PURE__*/function (AffordabilityDataActionsTypes) {
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["RESET_TO_DEFAULTS"] = 0] = "RESET_TO_DEFAULTS";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_ANNUAL_INCOME"] = 1] = "SET_ANNUAL_INCOME";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_TOTAL_MONTHLY_DEBT"] = 2] = "SET_TOTAL_MONTHLY_DEBT";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_DOWN_PAYMENT"] = 3] = "SET_DOWN_PAYMENT";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_PROPERTY_TAX_RATE"] = 4] = "SET_PROPERTY_TAX_RATE";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_HOA_FEES"] = 5] = "SET_HOA_FEES";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_CREDIT_SCORE"] = 6] = "SET_CREDIT_SCORE";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_INTEREST_RATE"] = 7] = "SET_INTEREST_RATE";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_SLIDER_VALUE"] = 8] = "SET_SLIDER_VALUE";
  AffordabilityDataActionsTypes[AffordabilityDataActionsTypes["SET_SHOW_FULL"] = 9] = "SET_SHOW_FULL";
  return AffordabilityDataActionsTypes;
}({});

// FROM: https://mortgage.archgroup.com/us-credit-union/rate-sheets/
// Use: Monthly/Annual/Split – Borrower/Lender Paid Rates
// Nationwide Monthly Premium Rates (Except AK, GA, HI, KS, LA, MO, NE, NM, NY, OH, PA, RI, SD, TX, VA, & WA)
// Rates Are Annualized so we need to divide them by 12 to get a monthly rate

const pmiTable = {
  [740]: [{
    pmiRate: 0.16,
    maxLTV: 0.85
  }, {
    pmiRate: 0.21,
    maxLTV: 0.9
  }, {
    pmiRate: 0.3,
    maxLTV: 0.95
  }, {
    pmiRate: 0.41,
    maxLTV: 0.97
  }],
  [700]: [{
    pmiRate: 0.18,
    maxLTV: 0.85
  }, {
    pmiRate: 0.27,
    maxLTV: 0.9
  }, {
    pmiRate: 0.4,
    maxLTV: 0.95
  }, {
    pmiRate: 0.53,
    maxLTV: 0.97
  }],
  [660]: [{
    pmiRate: 0.21,
    maxLTV: 0.85
  }, {
    pmiRate: 0.45,
    maxLTV: 0.9
  }, {
    pmiRate: 0.67,
    maxLTV: 0.95
  }, {
    pmiRate: 0.91,
    maxLTV: 0.97
  }],
  [620]: [{
    pmiRate: 0.35,
    maxLTV: 0.85
  }, {
    pmiRate: 0.54,
    maxLTV: 0.9
  }, {
    pmiRate: 0.9,
    maxLTV: 0.95
  }, {
    pmiRate: 1.08,
    maxLTV: 0.97
  }],
  [580]: [{
    pmiRate: 0.49,
    maxLTV: 0.85
  }, {
    pmiRate: 0.76,
    maxLTV: 0.9
  }, {
    pmiRate: 1.26,
    maxLTV: 0.95
  }, {
    pmiRate: 1.51,
    maxLTV: 0.97
  }],
  [579]: [{
    pmiRate: 0.49,
    maxLTV: 0.85
  }, {
    pmiRate: 0.76,
    maxLTV: 0.9
  }, {
    pmiRate: 1.26,
    maxLTV: 0.95
  }, {
    pmiRate: 1.51,
    maxLTV: 0.97
  }]
};

const getInsuranceCostModel = downPayment => [{
  presentValueFactor: 0,
  costOffset: 100,
  minPresentValue: 0,
  maxPresentValue: 400000 - downPayment
}, {
  presentValueFactor: 0,
  costOffset: 125,
  minPresentValue: 0,
  maxPresentValue: 600000 - downPayment
}, {
  presentValueFactor: 0,
  costOffset: 150,
  minPresentValue: 0,
  maxPresentValue: Number.POSITIVE_INFINITY
}];
const getPAndICostModel = initialRate => createPAndICostModel({
  initialRate,
  loanTerm: 30
});
const getPmiCostModel = (downPayment, creditScore) => [...pmiTable[creditScore].map(_ref => {
  let {
    pmiRate,
    maxLTV
  } = _ref;
  return {
    presentValueFactor: pmiRate / annualizedPercentFactor,
    costOffset: 0,
    minPresentValue: 0,
    maxPresentValue: Math.min(maxLTV * downPayment / (1 - maxLTV), conformingLoanLimit) // PMI not available on non-conforming loans
  };
}), {
  presentValueFactor: 0,
  costOffset: 0,
  minPresentValue: 0,
  maxPresentValue: 4 * downPayment // .8 LTV
}];

const getTaxesCostModel = (downPayment, taxRate) => {
  const fractionalTaxRate = taxRate / annualizedPercentFactor;
  return [{
    presentValueFactor: fractionalTaxRate,
    costOffset: downPayment * fractionalTaxRate,
    minPresentValue: 0,
    maxPresentValue: Number.POSITIVE_INFINITY
  }];
};
const getHoaFeesCostModel = hoaFees => [{
  presentValueFactor: 0,
  costOffset: hoaFees,
  minPresentValue: 0,
  maxPresentValue: Number.POSITIVE_INFINITY
}];
const getCostModels = state => ({
  insurance: getInsuranceCostModel(state.downPayment),
  pAndI: getPAndICostModel(state.interestRate),
  pmi: getPmiCostModel(state.downPayment, state.creditScore),
  taxes: getTaxesCostModel(state.downPayment, state.propertyTaxRate),
  hoaFees: getHoaFeesCostModel(state.hOAFees)
});

const createTargetDti = (state, monthlyIncome, dti) => {
  const costs = getCostModels(state);
  const targetDebt = monthlyIncome * dti;
  const targetMonthlyPayment = targetDebt - state.monthlyDebt;
  return computeMaxPresentValue({
    targetMonthlyPayment,
    costs
  });
};
const getMaxAffordability = (state, monthlyIncome) => createTargetDti(state, monthlyIncome, maxAffordability);
const getMinAffordability = (state, monthlyIncome) => {
  const max = getMaxAffordability(state, monthlyIncome);
  const twentyDTI = createTargetDti(state, monthlyIncome, sliderMinDTI);
  const ranged = max - sliderMaxRange;
  const lowerBound = Number.isNaN(twentyDTI) ? ranged : Math.min(twentyDTI, ranged);
  return Math.max(0, lowerBound);
};
// The Minimum loan size you can afford is 0 enforce that using Math.max
// We want to either target 20% DTI or a desired range based on which gives us the lower max bounds.
// This means that for people who have very little debt we'll show them a fixed range slider.
// For people with more debt we'll show them a range of 20 - 50 DTI.

const getAffordabilityRange = (state, monthlyIncome) => {
  return getMaxAffordability(state, monthlyIncome) - getMinAffordability(state, monthlyIncome);
};

const sliderGradient = (state, monthlyIncome) => {
  const range = getAffordabilityRange(state, monthlyIncome);
  const min = getMinAffordability(state, monthlyIncome);
  const stretchingMax = createTargetDti(state, monthlyIncome, maxStretchingDTI);
  const stretchingMin = createTargetDti(state, monthlyIncome, minStretchingDTI);
  const maxStretch = Number.isNaN(stretchingMax) ? 0 : Math.min(1, Math.max(0, (stretchingMax - min) / range));
  const maxAffordable = Number.isNaN(stretchingMin) ? 0 : Math.min(1, Math.max(0, (stretchingMin - min) / range));
  return {
    maxStretch,
    maxAffordable
  };
};

const initialState$5 = {
  annualIncome: 60000,
  monthlyDebt: 250,
  downPayment: 20000,
  propertyTaxRate: 1.2,
  hOAFees: 0,
  creditScore: creditTiers['740+'],
  interestRate: interestRateToCreditTiers[creditTiers['740+']],
  homePrice: 100800,
  monthlyPayment: 744,
  sliderValue: 0.3,
  showFull: false
};
function calculatorReducer$5(state, action) {
  switch (action.type) {
    case AffordabilityDataActionsTypes.RESET_TO_DEFAULTS:
      return {
        ...initialState$5,
        showFull: state.showFull
      };
    case AffordabilityDataActionsTypes.SET_ANNUAL_INCOME:
      return {
        ...state,
        annualIncome: action.payload
      };
    case AffordabilityDataActionsTypes.SET_TOTAL_MONTHLY_DEBT:
      return {
        ...state,
        monthlyDebt: action.payload
      };
    case AffordabilityDataActionsTypes.SET_DOWN_PAYMENT:
      return {
        ...state,
        downPayment: action.payload
      };
    case AffordabilityDataActionsTypes.SET_CREDIT_SCORE:
      return {
        ...state,
        creditScore: action.payload,
        interestRate: interestRateToCreditTiers[action.payload]
      };
    case AffordabilityDataActionsTypes.SET_HOA_FEES:
      return {
        ...state,
        hOAFees: action.payload
      };
    case AffordabilityDataActionsTypes.SET_INTEREST_RATE:
      return {
        ...state,
        interestRate: action.payload
      };
    case AffordabilityDataActionsTypes.SET_PROPERTY_TAX_RATE:
      return {
        ...state,
        propertyTaxRate: action.payload
      };
    case AffordabilityDataActionsTypes.SET_SLIDER_VALUE:
      return {
        ...state,
        sliderValue: action.payload
      };
    case AffordabilityDataActionsTypes.SET_SHOW_FULL:
      return {
        ...state,
        showFull: action.payload
      };
    default:
      throw new Error("Unhandled action type");
  }
}
const CalculatorContext = /*#__PURE__*/createContext({
  state: initialState$5,
  dispatch: () => null,
  getDownPayment: () => 0,
  getAnnualIncome: () => 0,
  getMonthlyIncome: () => 0,
  getSliderGradient: () => ({
    maxStretch: 0,
    maxAffordable: 0
  }),
  getPresentValue: () => 0,
  getHomePrice: () => 0,
  getMonthlyPayment: () => 0,
  getResultDTISelector: () => 0,
  getAffordability: () => 'Affordable',
  getDownPaymentPercentage: () => 0,
  getError: () => ''
});
const roundTo$1 = (value, percision) => Math.floor(value / percision) * percision;
function CalculatorProvider(_ref) {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(calculatorReducer$5, initialState$5);
  const getDownPayment = () => {
    var _state$downPayment;
    return (_state$downPayment = state.downPayment) !== null && _state$downPayment !== void 0 ? _state$downPayment : fallbackDownPayment;
  };
  const getDownPaymentPercentage = () => {
    const homePrice = getHomePrice();
    const downPayment = state.downPayment;
    return downPayment / homePrice;
  };
  const getAnnualIncome = () => {
    var _state$annualIncome;
    return (_state$annualIncome = state.annualIncome) !== null && _state$annualIncome !== void 0 ? _state$annualIncome : fallbackAnnualIncome;
  };
  const getMonthlyIncome = () => getAnnualIncome() / 12;
  const getSliderGradient = () => sliderGradient(state, getMonthlyIncome());
  const getPresentValue = () => {
    const min = getMinAffordability(state, getMonthlyIncome());
    const range = getAffordabilityRange(state, getMonthlyIncome());
    const percent = state.sliderValue;
    const presentValue = min + range * percent;
    if (range >= 1000000) {
      return roundTo$1(presentValue, 10000);
    }
    if (range >= 500000) {
      return roundTo$1(presentValue, 1000);
    }
    if (range >= 100000) {
      return roundTo$1(presentValue, 100);
    }
    if (range >= 10000) {
      return roundTo$1(presentValue, 10);
    }
    return roundTo$1(presentValue, 1);
  };
  const getHomePrice = () => getPresentValue() + getDownPayment();
  const getMonthlyPayment = () => Math.ceil(Object.values(computeCostModels({
    presentValue: getPresentValue(),
    costs: getCostModels(state)
  })).reduce((l, r) => l + r, 0));
  const getResultDTISelector = () => {
    const monthlyPayment = getMonthlyPayment();
    const monthlyDebt = state.monthlyDebt;
    const monthlyIncome = getMonthlyIncome();
    return (monthlyPayment + monthlyDebt) / monthlyIncome;
  };
  const getAffordability = () => {
    const dti = getResultDTISelector();
    if (dti < minStretchingDTI) {
      return 'Affordable';
    }
    if (dti <= maxStretchingDTI) {
      return 'Stretching';
    }
    return 'Aggressive';
  };
  const getError = () => {
    const homePrice = getHomePrice();
    const monthlyPayment = getMonthlyPayment();
    const monthlyDebt = state.monthlyDebt;
    const monthlyIncome = getMonthlyIncome();
    if (!Number.isNaN(homePrice) && !Number.isNaN(monthlyPayment)) {
      // If both homePrice and monthlyPayment are numbers, no error
      return '';
    }

    // Try to narrow down the cause to show a specific message
    // Comparing to maxStretchingDTI because the monthly payment factors in
    // and error will occur before reaching 50%
    if (monthlyDebt / monthlyIncome > maxStretchingDTI) {
      return "Your DTI is too high (>".concat(Math.round(maxAffordability * 100), "%) try adjusting your annual income or monthly debts.");
    }
    return "Your DTI is too high (>".concat(Math.round(maxAffordability * 100), "%) try adjusting your property tax and/or your HOA fees.");
  };
  const value = {
    state,
    dispatch,
    getDownPayment,
    getDownPaymentPercentage,
    getAnnualIncome,
    getMonthlyIncome,
    getSliderGradient,
    getPresentValue,
    getHomePrice,
    getMonthlyPayment,
    getResultDTISelector,
    getAffordability,
    getError
  };
  return /*#__PURE__*/React__default.createElement(CalculatorContext.Provider, {
    value: value
  }, children);
}
function useCalculator() {
  const context = useContext(CalculatorContext);
  if (context === undefined) {
    throw new Error('useCalculator must be used within a CalculatorProvider');
  }
  return context;
}

const RefreshIcon = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.5 1.5C5.90398 1.5 2.8975 4.03154 2.16866 7.41025C2.08131 7.81515 1.68227 8.07258 1.27737 7.98524C0.872471 7.8979 0.61504 7.49886 0.702384 7.09396C1.5771 3.03904 5.18277 0 9.5 0C12.9836 0 16.0039 1.97874 17.5 4.87327V3C17.5 2.58579 17.8358 2.25 18.25 2.25C18.6642 2.25 19 2.58579 19 3V7C19 7.41421 18.6642 7.75 18.25 7.75H14.25C13.8358 7.75 13.5 7.41421 13.5 7C13.5 6.58579 13.8358 6.25 14.25 6.25H16.48C15.3832 3.46824 12.6708 1.5 9.5 1.5ZM9.48536 16.5C13.0814 16.5 16.0879 13.9685 16.8167 10.5897C16.904 10.1848 17.3031 9.92742 17.708 10.0148C18.1129 10.1021 18.3703 10.5011 18.283 10.906C17.4083 14.961 13.8026 18 9.48536 18C6.01307 18 3.00107 16.0341 1.5 13.1549L1.5 15.25C1.5 15.6642 1.16421 16 0.75 16C0.335787 16 0 15.6642 0 15.25V11.25C0 10.8358 0.335787 10.5 0.750001 10.5L4.75 10.5C5.16421 10.5 5.5 10.8358 5.5 11.25C5.5 11.6642 5.16421 12 4.75 12H2.60918C3.76653 14.649 6.41041 16.5 9.48536 16.5Z",
  fill: CHARCOAL_100
}));

var _templateObject$A;
const StyledUnorderedList = styled.ul(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  margin-block: 0;\n  padding-inline-start: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(2);
});

/* eslint-disable @typescript-eslint/naming-convention */
const popularTermsMapping = {
  'DTI / (Debt to Income Ratio)': 'Your debt-to-income ratio (DTI) is all your monthly debt payments divided by your gross monthly income. This determines your borrowing risk from a lender’s perspective.',
  'Property taxes': 'Property tax is paid by an individual or entity on an owned property. Every property owner needs to pay property tax. Property taxes are based on the assessed value of real property.',
  'HOA fees': 'HOA fees are common in condominium and planned communities. These fees are paid directly to the homeowners association rather than to your lender.',
  'Homeowners insurance': 'Homeowners insurance provides you with financial protection in the event of a disaster or accident involving your home.',
  PMI: 'Private mortgage insurance (PMI) is a type of insurance that may be required by your mortgage lender if your down payment is less than 20 percent of your home’s purchase price. PMI protects the lender against losses if you default on your mortgage.',
  'Interest rate': 'The interest rate on your loan is a percentage of the loan amount that you pay the lender as the cost for borrowing money. We calculated this interest rate using real data similar to your situation to give you a realistic expectation for your home mortgage.'
};
/* eslint-enable @typescript-eslint/naming-convention */

const AnnualIncomeDetails = () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Your annual income includes more than your yearly salary."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "This amount includes the following:"), /*#__PURE__*/React__default.createElement(StyledUnorderedList, null, /*#__PURE__*/React__default.createElement("li", null, "Bonuses"), /*#__PURE__*/React__default.createElement("li", null, "Overtime"), /*#__PURE__*/React__default.createElement("li", null, "Tips or Commission")));
const TotalMonthlyDebtDetails = () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Add together every monthly payment you (and your co-borrower) make to calculate."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "This includes:"), /*#__PURE__*/React__default.createElement(StyledUnorderedList, null, /*#__PURE__*/React__default.createElement("li", null, "Minimum monthly required credit card payments"), /*#__PURE__*/React__default.createElement("li", null, "Car payments"), /*#__PURE__*/React__default.createElement("li", null, "Student loans"), /*#__PURE__*/React__default.createElement("li", null, "Alimony/child support payments")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "This does NOT include:"), /*#__PURE__*/React__default.createElement(StyledUnorderedList, null, /*#__PURE__*/React__default.createElement("li", null, "Credit card balances you pay off in full each month"), /*#__PURE__*/React__default.createElement("li", null, "Current home or rent payments"), /*#__PURE__*/React__default.createElement("li", null, "Utilities")));
const DownPaymentAmountDetails = () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Down payment on a house is the ", /*#__PURE__*/React__default.createElement("strong", null, "cash that the buyer pays upfront"), " in a real estate transaction. You should make sure to have enough cash left over for moving expenses and other fees."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Minimum down payment percentages will vary between different loan products.", ' '));
const DownPaymentPercent = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Down payment in percent of home price");
const PropertyTaxRateDetails = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, popularTermsMapping['Property taxes']);
const HOAFeesDetails = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, popularTermsMapping['HOA fees']);
const InterestRateDetails = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, popularTermsMapping['Interest rate']);
const CreditScoreDetails = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Your credit score is used to determine how likely you are to repay your debts on time. Your credit score will depend on your credit history, number of accounts open, number of late payments, and more. A higher credit score may result in a better interest rate.");
const LoanTermDetails = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Choose your loan term");
const HomePrice = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Enter the purchase price of the home you wish to buy. This is the total value of the property, before any down payment is subtracted. If you are not sure about the exact price, you can use the listing price or the price you are considering offering. This field is crucial for accurately determining your potential monthly mortgage payments, as it directly influences the loan amount you will need to finance your home purchase. By providing an accurate home price, our calculator can give you a clearer picture of what your financial commitments might look like, helping you to budget accordingly for your new home.");
const PropertyTaxAnnual = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Input the yearly property tax amount for the home you are interested in purchasing. Property tax rates vary by location and are often expressed as a percentage of the home value. This figure is essential for a comprehensive monthly payment calculation, as property taxes are typically paid alongside your mortgage in monthly installments. If you are uncertain about the property tax rate, you can look it up on your local tax assessor website or consult recent tax bills for similar properties in the area. Including an accurate annual property tax estimate helps ensure that the monthly payment calculated reflects the true cost of homeownership, covering all necessary outlays beyond just the mortgage itself.");
const HomeownersInsuranceMonthly = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Specify the monthly cost of the homeowners insurance policy for the property you intend to purchase. Homeowners insurance provides coverage for damage to your home, personal property, and liability protection against certain types of accidents on your property. This cost can vary based on the location, value of the home, and the coverage level you choose. Including the monthly insurance premium in your calculation is vital for an accurate estimate of your total monthly mortgage payment, as lenders typically require proof of insurance. If you are unsure of the cost, you can obtain a quote from an insurance provider or use an average rate for your area. Accurately inputting your expected monthly insurance expense ensures a more precise calculation of your overall monthly payment responsibilities.");
const HoaFeesMonthly = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Enter the monthly fee charged by the Homeowners Association (HOA) for the property you are looking to purchase. HOA fees are common in condominiums, townhomes, and planned communities, covering amenities and services like landscaping, communal area maintenance, and sometimes utilities or security. The amount can vary significantly based on the location, size of the property, and the range of services provided. Including the HOA fees in your calculation is crucial for understanding the full cost of homeownership, as these fees are mandatory for properties within an HOA-managed area. If you dont have this information, you can ask the seller, real estate agent, or contact the HOA directly. Providing an accurate estimate of your monthly HOA fees ensures a comprehensive view of your monthly housing expenses, beyond just the mortgage payment.");
const MonthlyRent = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Monthly Rent field represents the amount an individual currently pays or anticipates paying for rent each month. This value serves as a baseline for comparing the costs of renting versus purchasing a home over time. The calculator uses this amount to project future rental expenses, taking into account the expected annual increase in rent. This allows users to understand how their rental costs might escalate over the years and compare it against the financial implications of buying a home, including mortgage payments, interest, taxes, and home appreciation.");
const HowLongBeforeSelling = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The How long before selling field specifies the duration, in years, an individual plans to own a home before selling it. This timeframe is critical in calculating the financial viability of buying a home compared to renting. The calculator uses this duration to assess mortgage payments, home appreciation, tax implications, and other ownership costs over time. It provides insight into how the value of the home is expected to change, the equity that could be built, and the potential costs or savings involved in selling the property after the specified period. This information helps users to evaluate the long-term financial benefits or drawbacks of purchasing a home with an intention to sell within a predetermined timeframe.");
const ClosingCost = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Closing const field represents the closing costs associated with purchasing a home, expressed as a percentage of the home's purchase price. Closing costs typically include fees related to the mortgage, home inspection, appraisal, attorney, and other administrative expenses required to finalize the home purchase. This value is crucial for calculating the initial outlay required beyond the down payment when buying a home. It helps users understand the upfront costs involved in purchasing a property and how these costs impact the overall financial analysis of buying versus renting.");
const ExpectedAnnualRateIncrease = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Expected annual rent increase field denotes the anticipated yearly percentage increase in rent. This factor is essential for projecting the future cost of renting over time. By considering how rent might escalate annually, the calculator provides a more accurate comparison between the long-term costs of renting and the costs associated with buying and owning a home. Understanding the potential increase in rental expenses is vital for individuals to evaluate the financial implications of continuing to rent versus opting to purchase a home.");
const AnnualAppreciation = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The annualAppreciation field indicates the expected yearly percentage increase in the value of a home. This appreciation rate is a key component in determining the potential long-term gains from buying a property. As the home's value increases, so does the owner's equity in the property, which can significantly affect the financial comparison between renting and buying. The calculator uses this rate to estimate how much the property's value could grow over time, helping users assess the investment aspect of homeownership.");
const CurrentAnnualInterest = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Current annual interest field specifies the current interest rate of a mortgage loan on an annual basis. This rate is crucial for calculating the monthly mortgage payments and the total interest paid over the life of the loan. Understanding the interest rate helps borrowers gauge the cost of financing a home purchase and its impact on the overall cost of buying a home compared to renting.");
const IncomeTax = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Income tax field reflects the individual's income tax rate. This rate is used to calculate potential tax savings that homeowners may benefit from through deductions on mortgage interest and property taxes. The inclusion of the income tax rate in the calculator allows for a more comprehensive financial analysis, taking into account the tax implications of owning a home. It helps users understand how homeownership can affect their overall tax situation, influencing the rent versus buy decision.");
const ExtraPayment = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Extra Payment field allows users to enter any additional amount they plan to pay towards the principal of their mortgage each month, beyond the regular monthly payment. By specifying an extra payment amount, users can see how making these additional payments affects the total interest paid and the duration of the loan. This feature is invaluable for those looking to reduce their overall interest costs and pay off their mortgage earlier. It demonstrates the financial impact of accelerating mortgage payments, providing a clear picture of potential savings and the shortened loan term that can result from consistent extra payments.");
const MortgageAmount = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Mortgage Amount field is where users enter the principal amount of the mortgage they are considering. This figure represents the total amount of money being borrowed to purchase a property. By inputting the desired mortgage amount, users can calculate the expected monthly payments, the total interest to be paid over the term of the loan, and the overall cost of the mortgage. This field is essential for anyone looking to understand the financial commitment involved in obtaining a mortgage, allowing for accurate budget planning and financial forecasting for potential homebuyers.");
const HomeValue = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The estimated current market value of your property. If you\u2019re not sure of your home\u2019s value, consider using online valuation tools or getting a professional appraisal.");
const MortgageBalance = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The additional funds you\u2019d like to borrow above your existing mortgage balance. You can use this money for things like home improvements, debt consolidation, or other personal expenses.");
const CashOut = () => /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The estimated current market value of your property. If you\u2019re not sure of your home\u2019s value, consider using online valuation tools or getting a professional appraisal.");
const termsDetails = {
  /* eslint-disable @typescript-eslint/naming-convention */
  'Annual income total': /*#__PURE__*/React__default.createElement(AnnualIncomeDetails, null),
  'Total monthly debt': /*#__PURE__*/React__default.createElement(TotalMonthlyDebtDetails, null),
  'Down payment amount': /*#__PURE__*/React__default.createElement(DownPaymentAmountDetails, null),
  'Down payment percent': /*#__PURE__*/React__default.createElement(DownPaymentPercent, null),
  'Property tax rate': /*#__PURE__*/React__default.createElement(PropertyTaxRateDetails, null),
  'HOA fees': /*#__PURE__*/React__default.createElement(HOAFeesDetails, null),
  'Interest rate': /*#__PURE__*/React__default.createElement(InterestRateDetails, null),
  'Credit score': /*#__PURE__*/React__default.createElement(CreditScoreDetails, null),
  'Loan term': /*#__PURE__*/React__default.createElement(LoanTermDetails, null),
  'Home price': /*#__PURE__*/React__default.createElement(HomePrice, null),
  'Property tax annual': /*#__PURE__*/React__default.createElement(PropertyTaxAnnual, null),
  'Homeowners insurance monthly': /*#__PURE__*/React__default.createElement(HomeownersInsuranceMonthly, null),
  'Hoa fees monthly': /*#__PURE__*/React__default.createElement(HoaFeesMonthly, null),
  'Monthly rent': /*#__PURE__*/React__default.createElement(MonthlyRent, null),
  'How long before selling (years)': /*#__PURE__*/React__default.createElement(HowLongBeforeSelling, null),
  'Closing cost': /*#__PURE__*/React__default.createElement(ClosingCost, null),
  'Expected annual rent increase': /*#__PURE__*/React__default.createElement(ExpectedAnnualRateIncrease, null),
  'Annual appreciation': /*#__PURE__*/React__default.createElement(AnnualAppreciation, null),
  'Current annual interest': /*#__PURE__*/React__default.createElement(CurrentAnnualInterest, null),
  'Income tax': /*#__PURE__*/React__default.createElement(IncomeTax, null),
  'Extra monthly principle payment': /*#__PURE__*/React__default.createElement(ExtraPayment, null),
  'Mortgage amount': /*#__PURE__*/React__default.createElement(MortgageAmount, null),
  'Home value': /*#__PURE__*/React__default.createElement(HomeValue, null),
  'Mortgage Balance': /*#__PURE__*/React__default.createElement(MortgageBalance, null),
  'Cash-Out': /*#__PURE__*/React__default.createElement(CashOut, null)
  /* eslint-enable @typescript-eslint/naming-convention */
};

var _templateObject$z;
const StyledIcon = styled(OwnUpIconButton)(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  margin-left: ", "px;\n\n  ", " {\n    display: none;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(1);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
});
const LabelWithIcon = _ref3 => {
  let {
    label
  } = _ref3;
  const [openModal, setOpenModal] = useState(false);
  const handleClick = () => {
    setOpenModal(true);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBodyMedium, {
    variant: "body1"
  }, label, /*#__PURE__*/React__default.createElement(StyledIcon, {
    icon: /*#__PURE__*/React__default.createElement(MicroQuestionIcon, null),
    name: label,
    size: 1.125,
    onClick: handleClick
  })), /*#__PURE__*/React__default.createElement(OwnUpFloatingModal, {
    title: label,
    open: openModal,
    onClose: () => setOpenModal(false)
  }, termsDetails[label]));
};

var _templateObject$y;
const OptionWrapper$2 = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
});
const WidgetTextInput = _ref2 => {
  let {
    label,
    value,
    onChange,
    ...props
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(OptionWrapper$2, null, /*#__PURE__*/React__default.createElement(OwnUpNumberInput, _extends$1({}, props, {
    customInput: OwnUpTextInput,
    labelPosition: "outer",
    value: value,
    label: label,
    onChange: onChange,
    allowNegative: false,
    allowLeadingZeros: false
  })));
};

var _templateObject$x;
const OptionsInputWrapper = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
});
const WidgetOptionsInput = _ref2 => {
  let {
    label,
    value,
    options,
    onChange
  } = _ref2;
  const children = useMemo(() => options.map(option => /*#__PURE__*/React__default.createElement(OwnUpMenuItem, {
    key: option.value,
    value: "".concat(option.value)
  }, option.title)), [options]);
  return /*#__PURE__*/React__default.createElement(OptionsInputWrapper, null, /*#__PURE__*/React__default.createElement(OwnUpDropdown, {
    labelPosition: "outer",
    value: value,
    label: label,
    onChange: onChange
  }, children));
};

var _templateObject$w, _templateObject2$h, _templateObject3$b, _templateObject4$3, _templateObject5$1;
const AdvancedOptionsWrapper$2 = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(4);
});
const OptionWrapper$1 = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(3);
});
const RightAlignedOptionWrapper$3 = styled(OptionWrapper$1)(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n  text-align: right;\n"])));
const creditTiersOptions = Object.entries(creditTiers).map(_ref3 => {
  let [key, value] = _ref3;
  return {
    value: value,
    title: key
  };
});
const InterestDetailsWrapper = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(1.5);
});
const FullWidthSecondaryButton$2 = styled(OwnUpFillButtonSecondary)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const actionMapping$8 = {
  propertyTaxRate: AffordabilityDataActionsTypes.SET_PROPERTY_TAX_RATE,
  hOAFees: AffordabilityDataActionsTypes.SET_HOA_FEES,
  creditScore: AffordabilityDataActionsTypes.SET_CREDIT_SCORE,
  interestRate: AffordabilityDataActionsTypes.SET_INTEREST_RATE
};
const AdvancedOptionsComponent = _ref5 => {
  let {
    inputs,
    expanded,
    updateInputs,
    resetToDefaults,
    onChangeVisibility
  } = _ref5;
  const buttonIcon = () => expanded ? /*#__PURE__*/React__default.createElement(ChevronUpIcon, null) : /*#__PURE__*/React__default.createElement(ChevronDownIcon, null);
  const changeCalculatorVisibility = () => {
    const newVisibilityStatue = !expanded;
    onChangeVisibility(newVisibilityStatue);
  };
  return /*#__PURE__*/React__default.createElement(AdvancedOptionsWrapper$2, null, /*#__PURE__*/React__default.createElement(FullWidthSecondaryButton$2, {
    icon: buttonIcon,
    iconPosition: "right",
    onClick: changeCalculatorVisibility
  }, "Advanced options"), expanded && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Property tax rate"
    }),
    value: inputs.propertyTaxRate,
    onChange: e => updateInputs({
      inputTitle: 'propertyTaxRate',
      value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
    }),
    $leadingIcon: /*#__PURE__*/React__default.createElement(PercentIcon, null),
    decimalScale: 2,
    fixedDecimalScale: true
  }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "HOA fees"
    }),
    value: inputs.hOAFees,
    onChange: e => updateInputs({
      inputTitle: 'hOAFees',
      value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
    }),
    $leadingIcon: /*#__PURE__*/React__default.createElement(DollarIcon, null)
  }), /*#__PURE__*/React__default.createElement(WidgetOptionsInput, {
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Credit score"
    }),
    value: inputs.creditScore,
    options: creditTiersOptions,
    onChange: e => updateInputs({
      inputTitle: 'creditScore',
      value: Number(e.target.value)
    })
  }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Interest rate"
    }),
    value: inputs.interestRate,
    onChange: e => updateInputs({
      inputTitle: 'interestRate',
      value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
    }),
    $leadingIcon: /*#__PURE__*/React__default.createElement(PercentIcon, null),
    decimalScale: 3,
    fixedDecimalScale: true
  }), /*#__PURE__*/React__default.createElement(InterestDetailsWrapper, null, /*#__PURE__*/React__default.createElement(OwnUpDetail, null, "We've calculated the average interest rate for your scenario using current market conditions and Own Up customer data.")), /*#__PURE__*/React__default.createElement(RightAlignedOptionWrapper$3, null, /*#__PURE__*/React__default.createElement(OwnUpFillButtonSecondary, {
    icon: /*#__PURE__*/React__default.createElement(RefreshIcon, null),
    onClick: resetToDefaults
  }, "Return to defaults"))));
};
const AdvancedOptions = () => {
  const {
    state: {
      propertyTaxRate,
      hOAFees,
      creditScore,
      interestRate,
      showFull
    },
    dispatch
  } = useCalculator();
  const updateInputs = useCallback(newInputs => {
    const actionType = actionMapping$8[newInputs.inputTitle];
    if (actionType) {
      if (actionType === AffordabilityDataActionsTypes.SET_CREDIT_SCORE) {
        dispatch({
          type: actionType,
          payload: newInputs.value
        });
      } else {
        dispatch({
          type: actionType,
          payload: newInputs.value
        });
      }
    }
  }, [dispatch]);
  const resetToDefaults = useCallback(() => dispatch({
    type: AffordabilityDataActionsTypes.RESET_TO_DEFAULTS
  }), [dispatch]);
  const changeVisibility = useCallback(newVisibilityStatus => dispatch({
    type: AffordabilityDataActionsTypes.SET_SHOW_FULL,
    payload: newVisibilityStatus
  }), [dispatch]);
  return /*#__PURE__*/React__default.createElement(AdvancedOptionsComponent, {
    inputs: {
      propertyTaxRate,
      hOAFees,
      creditScore,
      interestRate
    },
    expanded: showFull,
    updateInputs: updateInputs,
    resetToDefaults: resetToDefaults,
    onChangeVisibility: changeVisibility
  });
};

const actionMapping$7 = {
  annualIncome: AffordabilityDataActionsTypes.SET_ANNUAL_INCOME,
  monthlyDebt: AffordabilityDataActionsTypes.SET_TOTAL_MONTHLY_DEBT,
  downPayment: AffordabilityDataActionsTypes.SET_DOWN_PAYMENT
};
const BasicInputsComponent$5 = _ref => {
  let {
    inputs,
    updateInputs,
    onClick
  } = _ref;
  const {
    annualIncome,
    monthlyDebt,
    downPayment
  } = inputs;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.createElement("div", {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Annual income total"
      }),
      value: annualIncome,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'annualIncome',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Total monthly debt"
      }),
      value: monthlyDebt,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'monthlyDebt',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Down payment amount"
      }),
      value: downPayment,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'downPayment',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }))
  );
};
const BasicInputs$4 = () => {
  const {
    state: {
      annualIncome,
      downPayment,
      monthlyDebt
    },
    dispatch
  } = useCalculator();
  const updateInputs = useCallback(inputs => {
    const actionType = actionMapping$7[inputs.inputTitle];
    if (actionType) {
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    }
  }, [dispatch]);
  const openAdvancedOptions = useCallback(() => {
    dispatch({
      type: AffordabilityDataActionsTypes.SET_SHOW_FULL,
      payload: true
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(BasicInputsComponent$5, {
    inputs: {
      downPayment,
      annualIncome,
      monthlyDebt
    },
    updateInputs: updateInputs,
    onClick: openAdvancedOptions
  });
};

var _templateObject$v;
const InputsWrapper$8 = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n  ", " {\n    row-gap: ", "px;\n    padding: ", "px;\n  }\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(4);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, WHITE_100, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(1, 1);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(2);
});
const Inputs$5 = () => /*#__PURE__*/React__default.createElement(InputsWrapper$8, null, /*#__PURE__*/React__default.createElement(BasicInputs$4, null), /*#__PURE__*/React__default.createElement(AdvancedOptions, null));

var img$1 = "data:image/svg+xml,%3csvg viewBox='0 0 20 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M5.62622 1L2.00016 5.07932L5.62622 9.15863' stroke='%23143F3D' stroke-width='2'/%3e %3cpath d='M14.0001 9.15869L17.6262 5.07937L14.0001 1.00006' stroke='%23143F3D' stroke-width='2'/%3e%3c/svg%3e";

var _templateObject$u;
const sliderOverrides$1 = {
  '& > div.override > div.override-track': {
    width: '100% !important' // Required to override default styling. Enables the track gradient to take up the entire width of the slider.
  },

  '& > div.override > div.override-mark': {
    position: 'relative',
    width: '100%',
    bottom: '32px',
    left: 0
  },
  '& > div.override > div.override-mark > span': {
    position: 'absolute'
  },
  '& > div.override > div.override-mark > span:first-child': {
    left: 'calc(0% + 40px) !important' // Required to override default styling. Sets the position for 'Affordable'.
  },

  '& > div.override > div.override-mark > span:last-child': {
    left: 'calc(100% - 40px) !important' // Required to override default styling. Sets the position for 'Aggressive'.
  },

  '& > div.override > div.override-handle:focus-visible': {
    boxShadow: "0 0 0 2px ".concat(ALOE_100, " !important"),
    // Required to override default styling. Sets the focus styling for the handle.
    outline: 'none'
  }
};
const WrapperWithOverrides$1 = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  margin: 15px auto -10px; // Half the height of the handle, less half the height of the track.\n  width: 100%;\n  ", "\n"])), sliderOverrides$1);
const Label = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
    variant: "body1"
  }, children);
};
const handleStyle$1 = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  border: "1px solid ".concat(FOG_100),
  textAlign: 'center',
  boxShadow: '0 1px 8px rgba(62, 83, 81, 0.16)',
  position: 'relative',
  top: '-35px',
  backgroundColor: 'white',
  backgroundImage: "url(".concat(img$1, ")"),
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: '20px',
  zIndex: Z_INDICES.DROPDOWN_OPTIONS // Somewhat arbitrarily chosen. Should sit below NAVBAR.
};

const trackStyle$1 = {
  height: '10px',
  top: '-10px',
  position: 'relative',
  borderRadius: '100px'
};
const railStyle$1 = {
  height: '10px',
  borderRadius: '100px',
  position: 'relative',
  zIndex: Z_INDICES.FORM_LABELS // Somewhat arbitrarily chosen. Should sit below NAVBAR and HANDLE.
};

// only display stretching label if there's enough room for it
const computeLabel = (stretchPoint, maxAffordable) => {
  const lowerBoundary = 25;
  const upperBoundary = 75;

  // Use this for all screen-sizes, so we don't have to rely on a hook to update the style after SSG.
  const mobileOffset = 13;
  if (stretchPoint < lowerBoundary + mobileOffset || stretchPoint > upperBoundary - mobileOffset) {
    return null;
  } else {
    return {
      [maxAffordable]: /*#__PURE__*/React__default.createElement(Label, null, "Stretching")
    };
  }
};
// rc-slider default behavior is for the rail to be full width while the track's width adjusts as the handle moves
// we need the opposite behavior in order for the color gradient image to maintain a full width
// this implementation creates that needed effect of the rail overlapping the track
// (combined with forcing the track width to be 100% in StyleOverride)
const SliderImpl$1 = /*#__PURE__*/React__default.memo(_ref => {
  let {
    sliderGradient: {
      maxAffordable,
      maxStretch
    },
    sliderValue,
    disabled,
    updateSliderValue
  } = _ref;
  const maxAffordablePercent = maxAffordable * 100;
  const maxStretchPercent = maxStretch * 100;
  const stretchPoint = (maxStretch + maxAffordable) / 2;
  const stretchingLabelPoint = (maxStretchPercent + maxAffordablePercent) / 2;
  const handleSliderChange = newSliderValue => {
    updateSliderValue(newSliderValue);
  };
  return /*#__PURE__*/React__default.createElement(WrapperWithOverrides$1, null, /*#__PURE__*/React__default.createElement(SliderComponent, {
    disabled: disabled,
    value: sliderValue,
    step: 0.02,
    min: 0,
    max: 1,
    marks: {
      [-1]: /*#__PURE__*/React__default.createElement(Label, null, maxStretch <= 0 ? 'Stretching' : 'Affordable'),
      ...(disabled ? null : computeLabel(stretchingLabelPoint, stretchPoint)),
      [2]: /*#__PURE__*/React__default.createElement(Label, null, maxAffordable >= 0.86 ? 'Stretching' : 'Aggressive')
    },
    handleStyle: handleStyle$1,
    trackStyle: {
      ...trackStyle$1,
      background: "linear-gradient(0.25turn, ".concat(PINE_100, ", ").concat(CACTUS_100, " ").concat(maxAffordablePercent, "%, ").concat(MANGO_100, ", ").concat(MANGO_100, ", ").concat(BERRY_100, " ").concat(maxStretchPercent, "%)")
    },
    railStyle: {
      ...railStyle$1,
      background: "linear-gradient(to right, transparent, transparent ".concat(sliderValue * 100, "%, ").concat(FOG_100, " ").concat(sliderValue * 100, "%)")
    },
    ariaLabelForHandle: "affordability slider",
    prefixCls: "override",
    onChange: v => {
      handleSliderChange(Number(v));
    }
  }));
});
SliderImpl$1.displayName = 'SliderComponent';
const Slider$1 = _ref2 => {
  let {
    disabled = false
  } = _ref2;
  const {
    state: {
      sliderValue
    },
    getSliderGradient,
    dispatch
  } = useCalculator();
  const sliderGradient = getSliderGradient();
  const updateSliderValue = useCallback(value => dispatch({
    type: AffordabilityDataActionsTypes.SET_SLIDER_VALUE,
    payload: value
  }), [dispatch]);
  return /*#__PURE__*/React__default.createElement(SliderImpl$1, {
    sliderGradient: sliderGradient,
    sliderValue: sliderValue,
    updateSliderValue: updateSliderValue,
    disabled: disabled
  });
};

var _templateObject$t;
const Container$7 = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  column-gap: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(1);
});
const TitleWithIcon = _ref2 => {
  let {
    Icon,
    title
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(Container$7, null, Icon, /*#__PURE__*/React__default.createElement(OwnUpLargeBodyMedium, {
    variant: "body1"
  }, title));
};

var _templateObject$s, _templateObject2$g;
const Container$6 = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n\n  ", " {\n    row-gap: ", "px;\n  }\n\n  filter: drop-shadow(4px 4px 8px ", ");\n  padding: ", ";\n\n  border-radius: ", ";\n  background-color: ", ";\n\n  flex: 1 1 auto;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(1);
}, CHARCOAL_5, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(4, 3);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(0, 0, 1, 1);
}, _ref6 => {
  let {
    backgroundColor
  } = _ref6;
  return backgroundColor;
});
const Body = styled.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(3);
});
const AffordabilityDetailTitleIcon = /*#__PURE__*/React__default.memo(
// eslint-disable-next-line react/prop-types
_ref8 => {
  let {
    affordability
  } = _ref8;
  const icons = {
    Affordable: /*#__PURE__*/React__default.createElement(SuccessDarkIcon, null),
    Stretching: /*#__PURE__*/React__default.createElement(WarningDarkIcon, null),
    Aggressive: /*#__PURE__*/React__default.createElement(ErrorDarkIcon, null)
  };
  return icons[affordability];
});
AffordabilityDetailTitleIcon.displayName = 'AffordabilityDetailTitleIcon';
const AffordabilityDetailTitle = /*#__PURE__*/React__default.memo(_ref9 => {
  let {
    affordability
  } = _ref9;
  return /*#__PURE__*/React__default.createElement(TitleWithIcon, {
    Icon: /*#__PURE__*/React__default.createElement(AffordabilityDetailTitleIcon, {
      affordability: affordability
    }),
    title: affordability
  });
});
AffordabilityDetailTitle.displayName = 'AffordabilityDetailTitle';
const AffordabilityBody = /*#__PURE__*/React__default.memo(_ref10 => {
  let {
    downPaymentPercentage,
    dti
  } = _ref10;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1",
    component: "span"
  }, "This scenario is", ' ', /*#__PURE__*/React__default.createElement(OwnUpBodyMedium, {
    variant: "body1",
    component: "span"
  }, "affordable"), "."), /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1"
  }, "Your current debt-to-income ratio is ", Math.round(dti * 100), "%, which is likely to be approved by lenders. Your down payment is ", Math.round(downPaymentPercentage * 100), "% of the total home price."));
});
AffordabilityBody.displayName = 'AffordabilityBody';
const StretchingBody = /*#__PURE__*/React__default.memo(_ref11 => {
  let {
    dti
  } = _ref11;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1",
    component: "span"
  }, "This scenario", ' ', /*#__PURE__*/React__default.createElement(OwnUpBodyMedium, {
    variant: "body1",
    component: "span"
  }, "may stretch your purchase power"), "."), /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1"
  }, "Your current debt-to-income ratio is ", Math.round(dti * 100), "%, pushing the limit of", ' ', Math.round(maxStretchingDTI * 100), "%."), /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1"
  }, "To improve your chances of pre-approval, consider paying down debts, increasing your down payment, or building up your credit score."));
});
StretchingBody.displayName = 'StretchingBody';
const AggressiveBody = /*#__PURE__*/React__default.memo(_ref12 => {
  let {
    dti
  } = _ref12;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1",
    component: "span"
  }, "Lenders are", ' ', /*#__PURE__*/React__default.createElement(OwnUpBodyMedium, {
    variant: "body1",
    component: "span"
  }, "unlikely to preapprove you"), ' ', "for this home price."), /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1"
  }, "Your current debt-to-income ratio is ", Math.round(dti * 100), "%, exceeding the limit of", ' ', Math.round(maxStretchingDTI * 100), "%."), /*#__PURE__*/React__default.createElement(OwnUpBody, {
    variant: "body1"
  }, "To improve your chances of pre-approval, consider paying down debts, increasing your down payment, or building up your credit score."));
});
AggressiveBody.displayName = 'AggressiveBody';
const BodyCopy = /*#__PURE__*/React__default.memo(_ref13 => {
  let {
    dti,
    affordability,
    downPaymentPercentage
  } = _ref13;
  switch (affordability) {
    case 'Affordable':
      return /*#__PURE__*/React__default.createElement(AffordabilityBody, {
        dti: dti,
        downPaymentPercentage: downPaymentPercentage
      });
    case 'Stretching':
      return /*#__PURE__*/React__default.createElement(StretchingBody, {
        dti: dti
      });
    case 'Aggressive':
      return /*#__PURE__*/React__default.createElement(AggressiveBody, {
        dti: dti
      });
  }
});
BodyCopy.displayName = 'BodyCopy';

const affordabilityColors = {
  Affordable: MOSS_50,
  Stretching: APRICOT_10,
  Aggressive: BERRY_10
};
const DetailImpl = _ref => {
  let {
    affordability,
    downPaymentPercentage,
    dti,
    error,
    children
  } = _ref;
  const affordabilityColor = !!error ? FOG_20 : affordabilityColors[affordability];
  return /*#__PURE__*/React__default.createElement(Container$6, {
    backgroundColor: affordabilityColor
  }, error ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpDefaultErrorNotification, {
    $hasIcon: true,
    title: "Error",
    description: error
  }), children) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AffordabilityDetailTitle, {
    affordability: affordability
  }), /*#__PURE__*/React__default.createElement(Body, null, /*#__PURE__*/React__default.createElement(BodyCopy, {
    affordability: affordability,
    downPaymentPercentage: downPaymentPercentage,
    dti: dti
  })), children));
};
const SummaryArticle$1 = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    getResultDTISelector,
    getAffordability,
    getDownPaymentPercentage,
    getError
  } = useCalculator();
  const affordability = getAffordability();
  const downPaymentPercentage = getDownPaymentPercentage();
  const dti = getResultDTISelector();
  const error = getError();
  return /*#__PURE__*/React__default.createElement(DetailImpl, {
    affordability: affordability,
    downPaymentPercentage: downPaymentPercentage,
    dti: dti,
    error: error
  }, children);
};

var _templateObject$r, _templateObject2$f;
const SummaryContainer$2 = styled.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", " {\n    column-gap: ", "px;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up('md');
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(8);
});
const SummaryItem$2 = styled.div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n\n  flex-basis: 50%;\n  ", " {\n    flex-basis: auto;\n  }\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(1);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoints.up('md');
});
const formatCurrency$3 = number => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}).format(number);
const displayNumber$2 = number => typeof number === 'number' && !Number.isNaN(number) ? formatCurrency$3(number) : '-';
const SummaryImpl$1 = _ref5 => {
  let {
    homePrice,
    monthlyPayment
  } = _ref5;
  return /*#__PURE__*/React__default.createElement(SummaryContainer$2, null, /*#__PURE__*/React__default.createElement(SummaryItem$2, null, /*#__PURE__*/React__default.createElement(OwnUpSmallSubheadlineMedium, {
    variant: "h2"
  }, displayNumber$2(homePrice)), /*#__PURE__*/React__default.createElement(OwnUpSmallBodyMedium, {
    variant: "body1"
  }, "Home price")), /*#__PURE__*/React__default.createElement(SummaryItem$2, null, /*#__PURE__*/React__default.createElement(OwnUpSmallSubheadlineMedium, {
    variant: "h2"
  }, displayNumber$2(monthlyPayment)), /*#__PURE__*/React__default.createElement(OwnUpSmallBodyMedium, {
    variant: "body1"
  }, "Monthly payment")));
};
const SummaryNumbers$1 = () => {
  const {
    getMonthlyPayment,
    getHomePrice
  } = useCalculator();
  return /*#__PURE__*/React__default.createElement(SummaryImpl$1, {
    homePrice: getHomePrice(),
    monthlyPayment: getMonthlyPayment()
  });
};

var _templateObject$q;
const Container$5 = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  background-color: ", ";\n  filter: drop-shadow(4px 4px 8px ", ");\n  border-radius: ", ";\n  padding: ", ";\n\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.background.default;
}, CHARCOAL_5, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(1, 1, 0, 0);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(5, 3);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(3);
});
const CalculationSummary$5 = () => {
  const {
    state: {
      showFull
    }
  } = useCalculator();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showFull && /*#__PURE__*/React__default.createElement(OwnUpThemeProvider, {
    theme: ownUpWhiteTheme
  }, /*#__PURE__*/React__default.createElement(OwnUpExtraSmallHeadlineMedium, {
    variant: "h2"
  }, "Your results"), /*#__PURE__*/React__default.createElement(Container$5, null, /*#__PURE__*/React__default.createElement(SummaryNumbers$1, null), /*#__PURE__*/React__default.createElement(Slider$1, null)), /*#__PURE__*/React__default.createElement(SummaryArticle$1, null)));
};

const description$4 = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "A home affordability calculator is a great place to start your home buying journey."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "This tool calculates how much home you can reasonably afford based on a lender\u2019s qualification for pre-approval.", ' '));
const AffordabilityCalculator = () => {
  return /*#__PURE__*/React__default.createElement(WidgetWrapper, {
    title: "Affordability Calculator",
    description: description$4
  }, /*#__PURE__*/React__default.createElement(CalculatorProvider, null, /*#__PURE__*/React__default.createElement(Inputs$5, null), /*#__PURE__*/React__default.createElement(CalculationSummary$5, null)));
};

/* eslint-disable abcsize/abcsize */
// validate data based on data and rules
function _validateInputData(data, rules) {
  const result = {
    error: false,
    data: data
  };
  for (const key in rules) {
    if (rules[key].isRequired && data[key] == undefined) {
      result.error = key + ' is required.';
      break;
    }
    if (rules[key].isNumber && (typeof data[key] != 'number' || isNaN(data[key]))) {
      result.error = key + ' must be a number.';
      break;
    }
    if (rules[key].isNotNegative && data[key] < 0) {
      result.error = key + ' must be a positive number.';
      break;
    }
    if (rules[key].isNotZero && data[key] == 0) {
      result.error = key + ' must be greater then 0.';
      break;
    }
    if (rules[key].isNotFloat && data[key] % 1 !== 0) {
      result.error = key + ' must be an integer value.';
      break;
    }
  }
  return result;
}

// calculates a monthly interest rate
function calculateMonthlyInterestPayment(monthlyInterestRate, remainingBalance) {
  return monthlyInterestRate * remainingBalance;
}

/*
 * Calculate monthly mortgage payments
 *	For a fixed rate Monthly Mortage:
 *	c - the montly mortgage payment
 *	r - the monthly interest rate, expressed as a decimal, not a percentage. Since the quoted yearly percentage rate is not a compounded rate, the monthly percentage rate is simply the yearly percentage rate divided by 12; dividing the monthly percentage rate by 100 gives r, the monthly rate expressed as a decimal.
 *	N - the number of monthly payments, called the loan's term, and
 *	P - the amount borrowed, known as the loan's principal.
 *	c =  [r * P * (1+r)^n )] / [(1 + r)^n - 1]
 *
 *	Returns raw value of monthly mortgage payment, used in other calculations
 */
function calculateMonthlyMortgagePayment(args) {
  const principal = args.loanAmount;
  const interestRate = args.interestRate == 0 ? 0 : args.interestRate / 100;
  const monthlyInterestRate = interestRate == 0 ? 0 : interestRate / 12;
  const numberOfMonthlyPayments = args.termInYears * 12;
  if (monthlyInterestRate === 0) {
    // If interest rate is 0, the payment is simply the principal divided by the number of payments
    return principal / numberOfMonthlyPayments;
  } else {
    // Standard mortgage formula calculation
    return monthlyInterestRate * principal * Math.pow(1 + monthlyInterestRate, numberOfMonthlyPayments) / (Math.pow(1 + monthlyInterestRate, numberOfMonthlyPayments) - 1);
  }
}
function formatResult(result) {
  return isNaN(parseFloat(result.toFixed(2))) ? 0 : parseFloat(result.toFixed(2));
}

/*
 *	To calculate Monthly Mortgage Payments pass in the following arguments :
 *	var args = {
 *		loanAmount (number) : the loan amount
 *		interestRate (number) : interest rate as an annual percentage ( will be converted into monthly percentage in calculations)
 *		termInYears (number) : the term in years ( will be converted to number of monthly payments in calculations)
 *	}
 *
 *	response will be a rounded number
 */
const monthlyMortgagePayments = function (args) {
  // validate our inputs first
  const inputData = _validateInputData(args, {
    loanAmount: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: false
    },
    interestRate: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    },
    termInYears: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: true
    }
  });
  if (inputData.error) {
    return {
      error: inputData.error
    };
  }

  // validate the input arguments
  return formatResult(calculateMonthlyMortgagePayment(args));
};

/* eslint-disable @typescript-eslint/naming-convention */

let DownPaymentDataActionsTypes = /*#__PURE__*/function (DownPaymentDataActionsTypes) {
  DownPaymentDataActionsTypes[DownPaymentDataActionsTypes["SET_DOWN_PAYMENT"] = 0] = "SET_DOWN_PAYMENT";
  DownPaymentDataActionsTypes[DownPaymentDataActionsTypes["SET_DOWN_PAYMENT_PERCENT"] = 1] = "SET_DOWN_PAYMENT_PERCENT";
  DownPaymentDataActionsTypes[DownPaymentDataActionsTypes["SET_INTEREST_RATE"] = 2] = "SET_INTEREST_RATE";
  DownPaymentDataActionsTypes[DownPaymentDataActionsTypes["SET_LOAN_TERM"] = 3] = "SET_LOAN_TERM";
  DownPaymentDataActionsTypes[DownPaymentDataActionsTypes["SET_SHOW_FULL"] = 4] = "SET_SHOW_FULL";
  return DownPaymentDataActionsTypes;
}({});

const initialState$4 = {
  downPayment: 20000,
  downPaymentPercent: 20,
  interestRate: 6.625,
  loanTerm: LoanTerms.THIRTY,
  showFull: false
};
const LoanTermToNumber$4 = {
  [LoanTerms.THIRTY]: 30,
  [LoanTerms.TWENTY]: 20,
  [LoanTerms.FIFTEEN]: 15
};
function calculatorReducer$4(state, action) {
  switch (action.type) {
    case DownPaymentDataActionsTypes.SET_DOWN_PAYMENT:
      return {
        ...state,
        downPayment: action.payload
      };
    case DownPaymentDataActionsTypes.SET_DOWN_PAYMENT_PERCENT:
      return {
        ...state,
        downPaymentPercent: action.payload
      };
    case DownPaymentDataActionsTypes.SET_INTEREST_RATE:
      return {
        ...state,
        interestRate: action.payload
      };
    case DownPaymentDataActionsTypes.SET_LOAN_TERM:
      return {
        ...state,
        loanTerm: action.payload
      };
    case DownPaymentDataActionsTypes.SET_SHOW_FULL:
      return {
        ...state,
        showFull: action.payload
      };
    default:
      throw new Error("Unhandled action type");
  }
}
const DownPaymentContext = /*#__PURE__*/createContext({
  state: initialState$4,
  dispatch: () => null,
  getHomePrice: () => 0,
  getMonthlyPayment: () => 0
});
function DownPaymentProvider(_ref) {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(calculatorReducer$4, initialState$4);
  const getHomePrice = () => state.downPayment / state.downPaymentPercent * 100;
  const getMonthlyPayment = () => {
    const calculationsResult = monthlyMortgagePayments({
      loanAmount: getHomePrice(),
      interestRate: state.interestRate,
      termInYears: LoanTermToNumber$4[state.loanTerm]
    });
    if (typeof calculationsResult === 'number') {
      return calculationsResult;
    } else {
      return 0;
    }
  };
  const value = {
    state,
    dispatch,
    getHomePrice,
    getMonthlyPayment
  };
  return /*#__PURE__*/React__default.createElement(DownPaymentContext.Provider, {
    value: value
  }, children);
}
function useDownPayment() {
  const context = useContext(DownPaymentContext);
  if (context === undefined) {
    throw new Error('useDownPayment must be used within a DownPaymentProvider');
  }
  return context;
}

const actionMapping$6 = {
  downPayment: DownPaymentDataActionsTypes.SET_DOWN_PAYMENT,
  interestRate: DownPaymentDataActionsTypes.SET_INTEREST_RATE,
  loanTerm: DownPaymentDataActionsTypes.SET_LOAN_TERM
};
const BasicInputsComponent$4 = _ref => {
  let {
    inputs,
    updateInputs,
    onClick
  } = _ref;
  const {
    downPayment,
    interestRate,
    loanTerm
  } = inputs;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.createElement("div", {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Down payment amount"
      }),
      value: downPayment,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'downPayment',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Interest rate"
      }),
      value: interestRate,
      onChange: e => updateInputs({
        inputTitle: 'interestRate',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      }),
      $leadingIcon: /*#__PURE__*/React__default.createElement(PercentIcon, null),
      decimalScale: 3,
      fixedDecimalScale: true
    }), /*#__PURE__*/React__default.createElement(WidgetOptionsInput, {
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Loan term"
      }),
      value: loanTerm,
      options: loanTermsOptions,
      onChange: e => updateInputs({
        inputTitle: 'loanTerm',
        value: e.target.value
      })
    }))
  );
};
const BasicInputs$3 = () => {
  const {
    state: {
      downPayment,
      interestRate,
      loanTerm
    },
    dispatch
  } = useDownPayment();
  const updateInputs = useCallback(inputs => {
    if (inputs.inputTitle === 'loanTerm') {
      const actionType = actionMapping$6[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    } else {
      const actionType = actionMapping$6[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    }
  }, [dispatch]);
  const openAdvancedOptions = useCallback(() => {
    dispatch({
      type: DownPaymentDataActionsTypes.SET_SHOW_FULL,
      payload: true
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(BasicInputsComponent$4, {
    inputs: {
      downPayment,
      interestRate,
      loanTerm
    },
    updateInputs: updateInputs,
    onClick: openAdvancedOptions
  });
};

var _templateObject$p;
const InputsWrapper$7 = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n  ", " {\n    row-gap: ", "px;\n    padding: ", "px;\n  }\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(4);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, WHITE_100, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(1, 1);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(2);
});
const Inputs$4 = () => /*#__PURE__*/React__default.createElement(InputsWrapper$7, null, /*#__PURE__*/React__default.createElement(BasicInputs$3, null));

var img = "data:image/svg+xml,%3csvg viewBox='0 0 20 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M5.62622 1L2.00016 5.07932L5.62622 9.15863' stroke='%23143F3D' stroke-width='2'/%3e %3cpath d='M14.0001 9.15869L17.6262 5.07937L14.0001 1.00006' stroke='%23143F3D' stroke-width='2'/%3e%3c/svg%3e";

var _templateObject$o;
const sliderOverrides = {
  '& > div.override > div.override-track': {
    width: '100% !important' // Required to override default styling. Enables the track gradient to take up the entire width of the slider.
  },

  '& > div.override > div.override-mark': {
    position: 'relative',
    width: '100%',
    bottom: '32px',
    left: 0
  },
  '& > div.override > div.override-mark > span': {
    position: 'absolute'
  },
  '& > div.override > div.override-mark > span:first-child': {
    left: 'calc(0% + 40px) !important' // Required to override default styling. Sets the position for 'Affordable'.
  },

  '& > div.override > div.override-mark > span:last-child': {
    left: 'calc(100% - 40px) !important' // Required to override default styling. Sets the position for 'Aggressive'.
  },

  '& > div.override > div.override-handle:focus-visible': {
    boxShadow: "0 0 0 2px ".concat(ALOE_100, " !important"),
    // Required to override default styling. Sets the focus styling for the handle.
    outline: 'none'
  }
};
const WrapperWithOverrides = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  margin: 15px auto -10px; // Half the height of the handle, less half the height of the track.\n  width: 100%;\n  ", "\n"])), sliderOverrides);
const handleStyle = {
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  border: "1px solid ".concat(FOG_100),
  textAlign: 'center',
  boxShadow: '0 1px 8px rgba(62, 83, 81, 0.16)',
  position: 'relative',
  top: '-35px',
  backgroundColor: 'white',
  backgroundImage: "url(".concat(img, ")"),
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  backgroundSize: '20px',
  zIndex: Z_INDICES.DROPDOWN_OPTIONS // Somewhat arbitrarily chosen. Should sit below NAVBAR.
};

const trackStyle = {
  height: '10px',
  top: '-10px',
  position: 'relative',
  borderRadius: '100px'
};
const railStyle = {
  height: '10px',
  borderRadius: '100px',
  position: 'relative',
  zIndex: Z_INDICES.FORM_LABELS // Somewhat arbitrarily chosen. Should sit below NAVBAR and HANDLE.
};

// rc-slider default behavior is for the rail to be full width while the track's width adjusts as the handle moves
// we need the opposite behavior in order for the color gradient image to maintain a full width
// this implementation creates that needed effect of the rail overlapping the track
// (combined with forcing the track width to be 100% in StyleOverride)
const SliderImpl = /*#__PURE__*/React__default.memo(_ref => {
  let {
    sliderValue,
    disabled,
    updateSliderValue
  } = _ref;
  // const maxAffordablePercent = maxAffordable * 100;
  // const maxStretchPercent = maxStretch * 100;
  // const stretchPoint = (maxStretch + maxAffordable) / 2;
  // const stretchingLabelPoint = (maxStretchPercent + maxAffordablePercent) / 2;

  const handleSliderChange = newSliderValue => {
    updateSliderValue(newSliderValue);
  };
  return /*#__PURE__*/React__default.createElement(WrapperWithOverrides, null, /*#__PURE__*/React__default.createElement(SliderComponent, {
    disabled: disabled,
    value: sliderValue,
    step: 1,
    min: 0,
    max: 100,
    handleStyle: handleStyle,
    trackStyle: {
      ...trackStyle,
      background: "".concat(PINE_100)
    },
    railStyle: {
      ...railStyle,
      background: "linear-gradient(to right, transparent, transparent ".concat(sliderValue, "%, ").concat(FOG_100, " ").concat(sliderValue, "%)")
    },
    ariaLabelForHandle: "down payment slider",
    prefixCls: "override",
    onChange: v => {
      handleSliderChange(Number(v));
    }
  }));
});
SliderImpl.displayName = 'SliderComponent';
const Slider = _ref2 => {
  let {
    disabled = false
  } = _ref2;
  const {
    state: {
      downPaymentPercent
    },
    dispatch
  } = useDownPayment();
  const updateSliderValue = useCallback(value => dispatch({
    type: DownPaymentDataActionsTypes.SET_DOWN_PAYMENT_PERCENT,
    payload: value
  }), [dispatch]);
  return /*#__PURE__*/React__default.createElement(SliderImpl, {
    sliderValue: downPaymentPercent,
    updateSliderValue: updateSliderValue,
    disabled: disabled
  });
};

var _templateObject$n, _templateObject2$e, _templateObject3$a;
const SummaryContainer$1 = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", " {\n    column-gap: ", "px;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up('md');
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(8);
});
const SummaryItem$1 = styled.div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n\n  flex-basis: 50%;\n  ", " {\n    flex-basis: auto;\n  }\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(1);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoints.up('md');
});
const ResultValue$2 = styled(OwnUpSmallSubheadlineMedium)(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  padding-top: 0 !important;\n"])));
const formatCurrency$2 = number => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}).format(number);
const displayNumber$1 = number => typeof number === 'number' && !Number.isNaN(number) ? formatCurrency$2(number) : '-';
const SummaryArticle = () => {
  const {
    getHomePrice,
    getMonthlyPayment
  } = useDownPayment();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SummaryContainer$1, null, /*#__PURE__*/React__default.createElement(SummaryItem$1, null, /*#__PURE__*/React__default.createElement(ResultValue$2, {
    variant: "h2"
  }, displayNumber$1(getHomePrice())), /*#__PURE__*/React__default.createElement(OwnUpSmallBodyMedium, {
    variant: "body1"
  }, "Home price")), /*#__PURE__*/React__default.createElement(SummaryItem$1, null, /*#__PURE__*/React__default.createElement(ResultValue$2, {
    variant: "h2"
  }, displayNumber$1(getMonthlyPayment())), /*#__PURE__*/React__default.createElement(OwnUpSmallBodyMedium, {
    variant: "body1"
  }, "Monthly payment"))));
};

var _templateObject$m, _templateObject2$d, _templateObject3$9;
const SummaryContainer = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", " {\n    column-gap: ", "px;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up('md');
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(8);
});
const SummaryItem = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n\n  flex-basis: 50%;\n  ", " {\n    flex-basis: auto;\n  }\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(1);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoints.up('md');
});
const ResultValue$1 = styled(OwnUpSmallSubheadlineMedium)(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  padding-top: 0 !important;\n"])));
const SummaryImpl = _ref5 => {
  let {
    downPaymentPercent
  } = _ref5;
  return /*#__PURE__*/React__default.createElement(SummaryContainer, null, /*#__PURE__*/React__default.createElement(SummaryItem, null, /*#__PURE__*/React__default.createElement(ResultValue$1, {
    variant: "h2"
  }, downPaymentPercent, "%"), /*#__PURE__*/React__default.createElement(OwnUpSmallBodyMedium, {
    variant: "body1"
  }, "Down payment")));
};
const SummaryNumbers = () => {
  const {
    state: {
      downPaymentPercent
    }
  } = useDownPayment();
  return /*#__PURE__*/React__default.createElement(SummaryImpl, {
    downPaymentPercent: downPaymentPercent
  });
};

var _templateObject$l;
const Container$4 = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n  background-color: ", ";\n  filter: drop-shadow(4px 4px 8px ", ");\n  border-radius: ", ";\n  padding: ", ";\n\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.background.default;
}, CHARCOAL_5, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(1, 1, 0, 0);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(5, 3);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(3);
});
const CalculationSummary$4 = () => {
  const {
    state: {
      showFull
    }
  } = useDownPayment();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showFull && /*#__PURE__*/React__default.createElement(OwnUpThemeProvider, {
    theme: ownUpWhiteTheme
  }, /*#__PURE__*/React__default.createElement(OwnUpExtraSmallHeadlineMedium, {
    variant: "h2"
  }, "Your results"), /*#__PURE__*/React__default.createElement(Container$4, null, /*#__PURE__*/React__default.createElement(SummaryNumbers, null), /*#__PURE__*/React__default.createElement(Slider, null), /*#__PURE__*/React__default.createElement(SummaryArticle, null))));
};

const description$3 = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Down Payment Calculator: Unlock Your Homeownership Journey"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Effortlessly compute your initial payment for a home purchase, helping you plan your budget and step closer to your dream home."));
const DownPaymentCalculator = () => {
  console.log('result: ', monthlyMortgagePayments({
    loanAmount: 200000,
    interestRate: 6.6,
    termInYears: 30
  }));
  return /*#__PURE__*/React__default.createElement(WidgetWrapper, {
    title: "Down payment Calculator",
    description: description$3
  }, /*#__PURE__*/React__default.createElement(DownPaymentProvider, null, /*#__PURE__*/React__default.createElement(Inputs$4, null), /*#__PURE__*/React__default.createElement(CalculationSummary$4, null)));
};

const calculateMonthlyPrincipalAndInterest = (loanAmount, monthlyInterestRate, loanTermMonths) => {
  return loanAmount * monthlyInterestRate / (1 - Math.pow(1 + monthlyInterestRate, -loanTermMonths));
};
function calculateMortgage(_ref) {
  let {
    homePrice,
    downPayment,
    loanTermYears,
    apr,
    propertyTaxAnnual,
    homeownersInsuranceMonthly,
    hoaFeesMonthly = 0
  } = _ref;
  const loanTermMonths = loanTermYears * 12;
  const loanAmount = homePrice - downPayment;
  const monthlyInterestRate = apr / 12 / 100;
  const monthlyPrincipalAndInterest = calculateMonthlyPrincipalAndInterest(loanAmount, monthlyInterestRate, loanTermMonths);
  const monthlyPropertyTaxes = propertyTaxAnnual / 12;
  const totalMonthlyPayment = monthlyPrincipalAndInterest + monthlyPropertyTaxes + homeownersInsuranceMonthly + hoaFeesMonthly;
  const totalPaid = totalMonthlyPayment * loanTermMonths;
  const totalInterest = totalPaid - loanAmount;
  return {
    monthlyPayment: parseFloat(totalMonthlyPayment.toFixed(2)),
    mortgageSize: loanAmount,
    totalInterest: parseFloat(totalInterest.toFixed(2)),
    totalPaid: parseFloat(totalPaid.toFixed(2)),
    monthlyPropertyTaxes,
    monthlyPrincipalAndInterest
  };
}

/* eslint-disable @typescript-eslint/naming-convention */

let MonthlyPaymentDataActionsTypes = /*#__PURE__*/function (MonthlyPaymentDataActionsTypes) {
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_HOME_PRICE"] = 0] = "SET_HOME_PRICE";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_DOWN_PAYMENT"] = 1] = "SET_DOWN_PAYMENT";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_DOWN_PAYMENT_PERCENT"] = 2] = "SET_DOWN_PAYMENT_PERCENT";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_LOAN_TERM"] = 3] = "SET_LOAN_TERM";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_INTEREST_RATE"] = 4] = "SET_INTEREST_RATE";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_PROPERTY_TAX_ANNUAL"] = 5] = "SET_PROPERTY_TAX_ANNUAL";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_HOMEOWNTERS_INSURANCE_MONTHLY"] = 6] = "SET_HOMEOWNTERS_INSURANCE_MONTHLY";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_HOA_FEES_MONTHLY"] = 7] = "SET_HOA_FEES_MONTHLY";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_SHOW_FULL"] = 8] = "SET_SHOW_FULL";
  MonthlyPaymentDataActionsTypes[MonthlyPaymentDataActionsTypes["SET_DEFAULTS"] = 9] = "SET_DEFAULTS";
  return MonthlyPaymentDataActionsTypes;
}({});

function setHomePrice$2(state, payload) {
  return {
    ...state,
    homePrice: payload,
    downPaymentPercent: state.downPayment / payload * 100
  };
}
function setDownPayment$1(state, payload) {
  return {
    ...state,
    downPayment: payload,
    downPaymentPercent: payload / state.homePrice * 100
  };
}
function setDownPaymentPercent$1(state, payload) {
  return {
    ...state,
    downPaymentPercent: payload,
    downPayment: state.homePrice * (payload / 100)
  };
}
function setLoanTerm$3(state, payload) {
  return {
    ...state,
    loanTerm: payload
  };
}
function setInterestRate$2(state, payload) {
  return {
    ...state,
    interestRate: payload
  };
}
function setPropertyTaxAnnual$1(state, payload) {
  return {
    ...state,
    propertyTaxAnnual: payload
  };
}
function setHomeownersInsuranceMonthly$1(state, payload) {
  return {
    ...state,
    homeownersInsuranceMonthly: payload
  };
}
function setHoaFeesMonthly$1(state, payload) {
  return {
    ...state,
    hoaFeesMonthly: payload
  };
}
function setShowFull$2(state, payload) {
  return {
    ...state,
    showFull: payload
  };
}
function setDefaults$3(state, initialState) {
  return {
    ...initialState,
    showFull: true
  };
}

const initialState$3 = {
  homePrice: 250000,
  downPayment: 50000,
  downPaymentPercent: 20,
  loanTerm: LoanTerms.THIRTY,
  interestRate: interestRateToCreditTiers[creditTiers['740+']],
  propertyTaxAnnual: 3000,
  homeownersInsuranceMonthly: 100,
  hoaFeesMonthly: 0,
  showFull: false
};
const LoanTermToNumber$3 = {
  [LoanTerms.THIRTY]: 30,
  [LoanTerms.TWENTY]: 20,
  [LoanTerms.FIFTEEN]: 15
};

// eslint-disable-next-line abcsize/abcsize
function calculatorReducer$3(state, action) {
  switch (action.type) {
    case MonthlyPaymentDataActionsTypes.SET_HOME_PRICE:
      return setHomePrice$2(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_DOWN_PAYMENT:
      return setDownPayment$1(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_DOWN_PAYMENT_PERCENT:
      return setDownPaymentPercent$1(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_LOAN_TERM:
      return setLoanTerm$3(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_INTEREST_RATE:
      return setInterestRate$2(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_PROPERTY_TAX_ANNUAL:
      return setPropertyTaxAnnual$1(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_HOMEOWNTERS_INSURANCE_MONTHLY:
      return setHomeownersInsuranceMonthly$1(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_HOA_FEES_MONTHLY:
      return setHoaFeesMonthly$1(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_SHOW_FULL:
      return setShowFull$2(state, action.payload);
    case MonthlyPaymentDataActionsTypes.SET_DEFAULTS:
      return setDefaults$3(state, initialState$3);
    default:
      throw new Error("Unhandled action type");
  }
}
const MonthlyPaymentContext = /*#__PURE__*/createContext({
  state: initialState$3,
  dispatch: () => null,
  getMonthlyPayment: () => 0,
  getPropertyTaxesMonthly: () => 0,
  getMonthlyPrincipalAndInterest: () => 0,
  getMortgageSize: () => 0,
  getMortgageInterest: () => 0,
  getTotalMortgagePaind: () => 0
});
function MonthlyPaymentProvider(_ref) {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(calculatorReducer$3, initialState$3);
  const {
    monthlyPayment,
    mortgageSize,
    totalInterest,
    totalPaid,
    monthlyPropertyTaxes,
    monthlyPrincipalAndInterest
  } = calculateMortgage({
    homePrice: state.homePrice,
    downPayment: state.downPayment,
    loanTermYears: LoanTermToNumber$3[state.loanTerm],
    apr: state.interestRate,
    propertyTaxAnnual: state.propertyTaxAnnual,
    homeownersInsuranceMonthly: state.homeownersInsuranceMonthly,
    hoaFeesMonthly: state.hoaFeesMonthly
  });
  const getMonthlyPayment = () => monthlyPayment;
  const getPropertyTaxesMonthly = () => monthlyPropertyTaxes;
  const getMonthlyPrincipalAndInterest = () => monthlyPrincipalAndInterest;
  const getMortgageSize = () => mortgageSize;
  const getMortgageInterest = () => totalInterest;
  const getTotalMortgagePaind = () => totalPaid;
  const value = {
    state,
    dispatch,
    getMonthlyPayment,
    getPropertyTaxesMonthly,
    getMonthlyPrincipalAndInterest,
    getMortgageSize,
    getMortgageInterest,
    getTotalMortgagePaind
  };
  return /*#__PURE__*/React__default.createElement(MonthlyPaymentContext.Provider, {
    value: value
  }, children);
}
function useMonthlyPayment() {
  const context = useContext(MonthlyPaymentContext);
  if (context === undefined) {
    throw new Error('useMonthlyPayment must be used within a MonthlyPaymentProvider');
  }
  return context;
}

var _templateObject$k, _templateObject2$c, _templateObject3$8;
const AdvancedOptionsWrapper$1 = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(4);
});
const FullWidthSecondaryButton$1 = styled(OwnUpFillButtonSecondary)(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const RightAlignedOptionWrapper$2 = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  text-align: right;\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(3);
});
const actionMapping$5 = {
  propertyTaxAnnual: MonthlyPaymentDataActionsTypes.SET_PROPERTY_TAX_ANNUAL,
  homeownersInsuranceMonthly: MonthlyPaymentDataActionsTypes.SET_HOMEOWNTERS_INSURANCE_MONTHLY,
  hoaFeesMonthly: MonthlyPaymentDataActionsTypes.SET_HOA_FEES_MONTHLY
};
const AdvancedInputsComponent$2 = _ref3 => {
  let {
    inputs,
    updateInputs,
    resetToDefaults
  } = _ref3;
  const {
    propertyTaxAnnual,
    homeownersInsuranceMonthly,
    hoaFeesMonthly
  } = inputs;
  const [inputsVisible, setInputsVisible] = useState(false);
  const buttonIcon = () => inputsVisible ? /*#__PURE__*/React__default.createElement(ChevronUpIcon, null) : /*#__PURE__*/React__default.createElement(ChevronDownIcon, null);
  const changeCalculatorVisibility = () => {
    setInputsVisible(!inputsVisible);
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.createElement(AdvancedOptionsWrapper$1, null, /*#__PURE__*/React__default.createElement(FullWidthSecondaryButton$1, {
      icon: buttonIcon,
      iconPosition: "right",
      onClick: changeCalculatorVisibility
    }, "Advanced options"), inputsVisible && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Property tax annual"
      }),
      value: propertyTaxAnnual,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'propertyTaxAnnual',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Homeowners insurance monthly"
      }),
      value: homeownersInsuranceMonthly,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 3,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'homeownersInsuranceMonthly',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Hoa fees monthly"
      }),
      value: hoaFeesMonthly,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 3,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'hoaFeesMonthly',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(RightAlignedOptionWrapper$2, null, /*#__PURE__*/React__default.createElement(OwnUpFillButtonSecondary, {
      icon: /*#__PURE__*/React__default.createElement(RefreshIcon, null),
      onClick: resetToDefaults
    }, "Return to defaults"))))
  );
};
const AdvancedInputs$1 = () => {
  const {
    state: {
      propertyTaxAnnual,
      homeownersInsuranceMonthly,
      hoaFeesMonthly
    },
    dispatch
  } = useMonthlyPayment();
  const updateInputs = useCallback(inputs => {
    const actionType = actionMapping$5[inputs.inputTitle];
    dispatch({
      type: actionType,
      payload: inputs.value
    });
  }, [dispatch]);
  const resetToDefaults = () => {
    dispatch({
      type: MonthlyPaymentDataActionsTypes.SET_DEFAULTS
    });
  };
  return /*#__PURE__*/React__default.createElement(AdvancedInputsComponent$2, {
    inputs: {
      propertyTaxAnnual,
      homeownersInsuranceMonthly,
      hoaFeesMonthly
    },
    updateInputs: updateInputs,
    resetToDefaults: resetToDefaults
  });
};

var _templateObject$j, _templateObject2$b, _templateObject3$7;
const actionMapping$4 = {
  homePrice: MonthlyPaymentDataActionsTypes.SET_HOME_PRICE,
  downPayment: MonthlyPaymentDataActionsTypes.SET_DOWN_PAYMENT,
  downPaymentPercent: MonthlyPaymentDataActionsTypes.SET_DOWN_PAYMENT_PERCENT,
  loanTerm: MonthlyPaymentDataActionsTypes.SET_LOAN_TERM,
  interestRate: MonthlyPaymentDataActionsTypes.SET_INTEREST_RATE
};
const DownPaymentInputs$1 = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  display: flex;\n"])));
const DownPaymentInput$1 = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  width: 60%;\n  ", " {\n    width: 67%;\n    label {\n      width: unset;\n    }\n  }\n  label {\n    width: 80vw;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up(350);
});
const DownPaymentPercentInput$1 = styled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  width: 40%;\n  margin-top: 20px;\n  input {\n    padding-right: 0;\n  }\n  ", " {\n    width: 33%;\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up(350);
});
const BasicInputsComponent$3 = _ref3 => {
  let {
    inputs,
    updateInputs,
    onClick
  } = _ref3;
  const {
    homePrice,
    downPayment,
    downPaymentPercent,
    loanTerm,
    interestRate
  } = inputs;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.createElement("div", {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Home price"
      }),
      value: homePrice,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'homePrice',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(DownPaymentInputs$1, null, /*#__PURE__*/React__default.createElement(DownPaymentInput$1, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Down payment amount"
      }),
      value: downPayment,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'downPayment',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    })), /*#__PURE__*/React__default.createElement(DownPaymentPercentInput$1, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
      value: downPaymentPercent,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'downPaymentPercent',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }))), /*#__PURE__*/React__default.createElement(WidgetOptionsInput, {
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Loan term"
      }),
      value: loanTerm,
      options: loanTermsOptions,
      onChange: e => updateInputs({
        inputTitle: 'loanTerm',
        value: e.target.value
      })
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Interest rate"
      }),
      value: interestRate,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 3,
      fixedDecimalScale: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'interestRate',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }))
  );
};
const BasicInputs$2 = () => {
  const {
    state: {
      homePrice,
      downPayment,
      downPaymentPercent,
      loanTerm,
      interestRate
    },
    dispatch
  } = useMonthlyPayment();
  const updateInputs = useCallback(inputs => {
    if (inputs.inputTitle === 'loanTerm') {
      const actionType = actionMapping$4[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    } else {
      const actionType = actionMapping$4[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    }
  }, [dispatch]);
  const openAdvancedOptions = useCallback(() => {
    dispatch({
      type: MonthlyPaymentDataActionsTypes.SET_SHOW_FULL,
      payload: true
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(BasicInputsComponent$3, {
    inputs: {
      homePrice,
      downPayment,
      downPaymentPercent,
      loanTerm,
      interestRate
    },
    updateInputs: updateInputs,
    onClick: openAdvancedOptions
  });
};

var _templateObject$i;
const InputsWrapper$6 = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n  ", " {\n    row-gap: ", "px;\n    padding: ", "px;\n  }\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(4);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, WHITE_100, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(1, 1);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(2);
});
const Inputs$3 = () => /*#__PURE__*/React__default.createElement(InputsWrapper$6, null, /*#__PURE__*/React__default.createElement(BasicInputs$2, null), /*#__PURE__*/React__default.createElement(AdvancedInputs$1, null));

const formatCurrency$1 = number => new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}).format(number);
const displayNumber = number => typeof number === 'number' && !Number.isNaN(number) ? formatCurrency$1(number) : '-';

var _templateObject$h, _templateObject2$a;
const ValueColor = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  background-color: ", ";\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n  margin-right: 12px;\n"])), _ref => {
  let {
    color
  } = _ref;
  return color;
});
const LegendItem = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 24px;\n"])));
const MonthlyPaymentChartLegend = props => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LegendItem, null, /*#__PURE__*/React__default.createElement(ValueColor, {
    color: "#1F8E87"
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, "Principal & Interest"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, displayNumber(props.principalAndInterest))))), /*#__PURE__*/React__default.createElement(LegendItem, null, /*#__PURE__*/React__default.createElement(ValueColor, {
    color: "#1E4C49"
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, "Property Taxes"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, displayNumber(props.propertyTaxes))))), /*#__PURE__*/React__default.createElement(LegendItem, null, /*#__PURE__*/React__default.createElement(ValueColor, {
    color: "#B9DDCC"
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, "Homeowners Insurance"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, displayNumber(props.homeownersInsurance))))), /*#__PURE__*/React__default.createElement(LegendItem, null, /*#__PURE__*/React__default.createElement(ValueColor, {
    color: "#DBDFE2"
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, "Hoa fees"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("strong", null, displayNumber(props.hoaFeesMonthly))))));
};

var _templateObject$g;
const HeaderWrapper$1 = styled(OwnUpSmallSubheadlineMedium)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  padding-top: 0 !important;\n  margin-bottom: 8px !important;\n"])));
const MonthlyPayment = () => {
  const {
    state: {
      loanTerm
    },
    getMonthlyPayment
  } = useMonthlyPayment();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(HeaderWrapper$1, {
    variant: "h2"
  }, displayNumber(getMonthlyPayment())), /*#__PURE__*/React__default.createElement(OwnUpSmallBodyMedium, {
    variant: "body1"
  }, "Monthly payment for ", LoanTermToNumber$3[loanTerm], " years"));
};

const COLORS = ['#1F8E87', '#1E4C49', '#B9DDCC', '#DBDFE2'];
const renderActiveShape = props => {
  const {
    cx,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload
  } = props;
  return /*#__PURE__*/React__default.createElement("g", null, /*#__PURE__*/React__default.createElement("text", {
    x: cx,
    y: cy,
    dy: 8,
    textAnchor: "middle",
    fill: "#000000",
    fontWeight: 'bold'
  }, displayNumber(payload.value)), /*#__PURE__*/React__default.createElement(Sector, {
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius + 3,
    startAngle: startAngle,
    endAngle: endAngle,
    fill: fill,
    cornerRadius: 5
  }));
};
const renderInnerCircle = () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("radialGradient", {
  id: "grayGradient",
  cx: "50%",
  cy: "50%",
  r: "50%",
  fx: "50%",
  fy: "50%"
}, /*#__PURE__*/React__default.createElement("stop", {
  offset: "0",
  stopColor: "#888888",
  stopOpacity: "1"
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: "70%",
  stopColor: "#888888",
  stopOpacity: "1"
}), /*#__PURE__*/React__default.createElement("stop", {
  offset: "100%",
  stopColor: "#f0f0f0",
  stopOpacity: "0.3"
}))), /*#__PURE__*/React__default.createElement("circle", {
  cx: "50%",
  cy: "50%",
  r: 68,
  stroke: "url(#grayGradient)",
  strokeWidth: "13",
  fill: "none"
}));
const MonthlyPaymentPieChart = props => {
  const data = [{
    name: 'Principal & Interest',
    value: props.principalAndInterest
  }, {
    name: 'Property Taxes',
    value: props.propertyTaxes
  }, {
    name: 'Homeowners Insurance',
    value: props.homeownersInsurance
  }, {
    name: 'Hoa fees monthly',
    value: props.hoaFeesMonthly
  }];
  const [activeSector, setActiveSector] = useState(1);
  const onMouseEnterHandler = (_, index) => {
    setActiveSector(index);
  };
  const onMouseLeaveHandler = () => {
    setActiveSector(-1);
  };
  const renderLable = () => /*#__PURE__*/React__default.createElement("text", {
    x: "50%",
    y: "50%",
    dy: 8,
    textAnchor: "middle",
    fill: "#000000",
    fontWeight: 'bold'
  }, displayNumber(props.monthlyPayment));
  return /*#__PURE__*/React__default.createElement(PieChart, {
    width: 250,
    height: 250
  }, /*#__PURE__*/React__default.createElement(Pie, {
    activeIndex: activeSector,
    activeShape: renderActiveShape,
    onMouseEnter: onMouseEnterHandler,
    onMouseLeave: onMouseLeaveHandler,
    label: activeSector === -1 ? renderLable : false,
    data: data,
    cx: "50%",
    cy: "50%",
    labelLine: false,
    innerRadius: 80,
    outerRadius: 120,
    cornerRadius: 5,
    paddingAngle: 1,
    fill: "#8884d8",
    dataKey: "value"
  }, data.map((entry, index) => /*#__PURE__*/React__default.createElement(Cell, {
    key: "cell-".concat(index),
    fill: COLORS[index % COLORS.length],
    style: {
      outline: 'none'
    }
  }))), renderInnerCircle());
};

var _templateObject$f, _templateObject2$9, _templateObject3$6, _templateObject4$2;
const Container$3 = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  background-color: ", ";\n  filter: drop-shadow(4px 4px 8px ", ");\n  border-radius: ", ";\n  padding: ", ";\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.background.default;
}, CHARCOAL_5, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(1, 1, 0, 0);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(3, 3);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
});
const ChartWithLegendWrapper = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-top: ", "px;\n  ", " {\n    flex-direction: column;\n  }\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(4);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.breakpoints.down('md');
});
const ChartWrapper = styled.div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  flex: 1;\n  ", " {\n    margin-bottom: ", "px;\n  }\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.breakpoints.down('md');
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.spacing(4);
});
const LegendWrapper = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  flex: 1;\n  ", " {\n    align-self: flex-start;\n  }\n"])), _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.breakpoints.down('md');
});
const CalculationSummary$3 = () => {
  const {
    state: {
      showFull,
      homeownersInsuranceMonthly,
      hoaFeesMonthly
    },
    getMonthlyPayment,
    getMonthlyPrincipalAndInterest,
    getPropertyTaxesMonthly
  } = useMonthlyPayment();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showFull && /*#__PURE__*/React__default.createElement(OwnUpThemeProvider, {
    theme: ownUpWhiteTheme
  }, /*#__PURE__*/React__default.createElement(OwnUpExtraSmallHeadlineMedium, {
    variant: "h2"
  }, "Your results"), /*#__PURE__*/React__default.createElement(Container$3, null, /*#__PURE__*/React__default.createElement(MonthlyPayment, null), /*#__PURE__*/React__default.createElement(ChartWithLegendWrapper, null, /*#__PURE__*/React__default.createElement(ChartWrapper, null, /*#__PURE__*/React__default.createElement(MonthlyPaymentPieChart, {
    monthlyPayment: getMonthlyPayment(),
    principalAndInterest: getMonthlyPrincipalAndInterest(),
    propertyTaxes: getPropertyTaxesMonthly(),
    homeownersInsurance: homeownersInsuranceMonthly,
    hoaFeesMonthly: hoaFeesMonthly
  })), /*#__PURE__*/React__default.createElement(LegendWrapper, null, /*#__PURE__*/React__default.createElement(MonthlyPaymentChartLegend, {
    principalAndInterest: getMonthlyPrincipalAndInterest(),
    propertyTaxes: getPropertyTaxesMonthly(),
    homeownersInsurance: homeownersInsuranceMonthly,
    hoaFeesMonthly: hoaFeesMonthly
  }))))));
};

const description$2 = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Monthly Payment Calculator: Effortlessly Estimate Your Loan Repayments"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Introducing our Monthly Payment Calculator \u2013 your go-to tool for simplifying the complex calculations of loan repayments. Whether you're planning to finance a new home, car, or any significant purchase, our calculator provides you with a clear breakdown of your monthly obligations. By inputting your loan amount, interest rate, and loan term, you'll instantly receive an accurate estimate of your monthly payment. This tool is designed to help you make informed financial decisions, allowing you to budget effectively and plan for the future with confidence. Use our Monthly Payment Calculator today to take the first step towards financial clarity and stability.", ' '));
const MonthlyPaymentCalculator = () => {
  return /*#__PURE__*/React__default.createElement(WidgetWrapper, {
    title: "Monthly payment Calculator",
    description: description$2
  }, /*#__PURE__*/React__default.createElement(MonthlyPaymentProvider, null, /*#__PURE__*/React__default.createElement(Inputs$3, null), /*#__PURE__*/React__default.createElement(CalculationSummary$3, null)));
};

/* eslint-disable max-lines-per-function */
/*
 *	To calculate the comparison of rent vs buying of a mortgage pass in the following arguments :
 *	var args = {
 *		monthlyRent (number) : (number)
 *		purchasePrice (number) : (number)
 *		downPayment (number) :  (number) ( will be converted into monthly percentage in calculations)
 *		interestRate (number) : interest rate as an annual percentage ( will be converted into  percentage in calculations)
 *		termInYears (number) :  the term in years ( will be converted to number of monthly payments in calculations)
 *		howLongBeforeSelling (number) : (number) the number of years before selling,
 *		incomeTaxRate (number) :  ( will be converted into percentage in calculations)
 *		expectedAnnualRentIncrease (number) : annual percentage that rent will increase
 *		closingCosts (number) : percentage of mortgage amount that you pay,
 *		annualAppreciation (number) : percentage value of home will increase annually,
 *	}
 *	response : an object
 *	var response = {
 *		currentValueOfHome : (number),
 *		totalOwedToBank : (number),
 *		equityOnHome : (number),
 *		savingWhenRenting : (number),
 *		transactionalCosts : (number),
 *		netCostOfOwnership : (number),
 *		moneySavedByBuying : (number)
 *	};
 */
const compareBuyOrRent = function (args) {
  // validate our inputs first
  const inputData = _validateInputData(args, {
    monthlyRent: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: false
    },
    purchasePrice: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: false
    },
    downPayment: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    },
    interestRate: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    },
    termInYears: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: true
    },
    howLongBeforeSelling: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: true
    },
    incomeTaxRate: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    },
    expectedAnnualRentIncrease: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    },
    closingCosts: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    },
    annualAppreciation: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    }
  });
  if (inputData.error) {
    return {
      error: inputData.error
    };
  }

  // initalize rent info
  let monthlyRent = args.monthlyRent;
  const expectedAnnualRentIncrease = args.expectedAnnualRentIncrease;

  // initialize purchase info
  const purchasePrice = args.purchasePrice;
  // downpayment is % * purchase price
  const downPayment = args.downPayment / 100 * purchasePrice;
  // remaining balance if down payment is initialize
  let remainingBalance = purchasePrice - downPayment;
  const interestRate = args.interestRate;
  const termInYears = args.termInYears;

  // initialize closing costs(input is percentage) * remaining balance
  const closingCosts = args.closingCosts / 100 * remainingBalance;

  // initialize home ownership info
  const yearsBeforeSelling = args.howLongBeforeSelling;
  const incomeTax = args.incomeTaxRate;
  const annualAppreciation = args.annualAppreciation;
  const monthlyMortgagePayment = calculateMonthlyMortgagePayment({
    loanAmount: remainingBalance,
    interestRate: interestRate,
    termInYears: termInYears
  });
  // initialize some metrics
  let totalInterest = 0;
  let totalPrincipalPayment = 0;
  let totalTaxSavings = 0;
  // initalize total appreciation ( value of home)
  let totalAppreciation = purchasePrice;
  // initialize total cost of renting at 0
  let totalCostOfRenting = 0;
  // initialize total cost of buying with the down payment
  let totalCostOfBuying = downPayment;
  // calculate monthly breakdown for each year before selling
  for (let j = 0; j < yearsBeforeSelling; j++) {
    // total cost of renting = sum of the year totals of monthly rent
    totalCostOfRenting += monthlyRent * 12;
    // apply the annual rent increase on the monthly rent
    monthlyRent += monthlyRent * (expectedAnnualRentIncrease / 100);
    // total appreciation ( value of home) = total appreciaton  + (total appreciation * monthly appreciation rate)
    totalAppreciation += totalAppreciation * (annualAppreciation / 100);
    // calculate the monthly principal payments, interest, tax savings and remaining balance after payments made
    for (let i = 0; i < 12; i++) {
      const monthlyInterestPayment = calculateMonthlyInterestPayment(interestRate / 100 / 12, remainingBalance);
      let monthlyPrincipalPayment = monthlyMortgagePayment - monthlyInterestPayment;
      if (remainingBalance - monthlyPrincipalPayment >= 0) {
        if (remainingBalance >= monthlyPrincipalPayment) {
          remainingBalance -= monthlyPrincipalPayment;
        }
      } else {
        monthlyPrincipalPayment = remainingBalance;
        remainingBalance -= monthlyPrincipalPayment;
      }

      // sum monthly principal payment
      totalPrincipalPayment += monthlyPrincipalPayment;
      // sum monthly interest
      totalInterest += monthlyInterestPayment;
      // sum up tax
      totalTaxSavings += monthlyInterestPayment * (incomeTax / 100);
    }
  }
  // total cost of buying = (sum of annual costs of buying) + (sum of costs of selling)
  totalCostOfBuying += totalPrincipalPayment + totalInterest - totalTaxSavings + (remainingBalance + closingCosts);
  // equity on home = total appreciation - remaining balance
  const equityOnHome = totalAppreciation - remainingBalance;
  // net cost of buying = total appreciation - total cost of buying
  const netCostOfBuying = totalCostOfBuying - totalAppreciation;
  // build the response
  const response = {
    currentValueOfHome: formatResult(totalAppreciation),
    totalOwedToBank: formatResult(remainingBalance),
    equityOnHome: formatResult(equityOnHome),
    netCostOfBuying: formatResult(netCostOfBuying),
    netCostOfRenting: formatResult(totalCostOfRenting),
    benefitOfBuying: formatResult(totalCostOfRenting - netCostOfBuying)
  };
  return response;
};

/* eslint-disable @typescript-eslint/naming-convention */

let RentOrBuyActionTypes = /*#__PURE__*/function (RentOrBuyActionTypes) {
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_MONTHLY_RENT"] = 0] = "SET_MONTHLY_RENT";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_EXPECTED_ANNUAL_RENT_INCREASE"] = 1] = "SET_EXPECTED_ANNUAL_RENT_INCREASE";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_HOME_PRICE"] = 2] = "SET_HOME_PRICE";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_DOWN_PAYMENT"] = 3] = "SET_DOWN_PAYMENT";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_DOWN_PAYMENT_PERCENT"] = 4] = "SET_DOWN_PAYMENT_PERCENT";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_CLOSING_COST_PERCENT"] = 5] = "SET_CLOSING_COST_PERCENT";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_INTEREST_RATE"] = 6] = "SET_INTEREST_RATE";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_LOAN_TERM"] = 7] = "SET_LOAN_TERM";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_ANNUAL_APPRECIATION"] = 8] = "SET_ANNUAL_APPRECIATION";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_HOW_LONG_BEFORE_SELLING"] = 9] = "SET_HOW_LONG_BEFORE_SELLING";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_CURRENT_ANNUAL_INTEREST"] = 10] = "SET_CURRENT_ANNUAL_INTEREST";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_INCOME_TAX"] = 11] = "SET_INCOME_TAX";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_SHOW_FULL"] = 12] = "SET_SHOW_FULL";
  RentOrBuyActionTypes[RentOrBuyActionTypes["SET_DEFAULTS"] = 13] = "SET_DEFAULTS";
  return RentOrBuyActionTypes;
}({});

function setMonthlyRent(state, payload) {
  return {
    ...state,
    monthlyRent: payload
  };
}
function setExpectedAnnualRentIncrease(state, payload) {
  return {
    ...state,
    expectedAnnualRentIncrease: payload
  };
}
function setHomePrice$1(state, payload) {
  return {
    ...state,
    homePrice: payload,
    downPaymentPercent: state.downPayment / payload * 100
  };
}
function setDownPayment(state, payload) {
  return {
    ...state,
    downPayment: payload,
    downPaymentPercent: payload / state.homePrice * 100
  };
}
function setDownPaymentPercent(state, payload) {
  return {
    ...state,
    downPaymentPercent: payload,
    downPayment: state.homePrice * (payload / 100)
  };
}
function setClosingCostPercent(state, payload) {
  return {
    ...state,
    closingCostPercent: payload
  };
}
function setInterestRate$1(state, payload) {
  return {
    ...state,
    interestRate: payload
  };
}
function setLoanTerm$2(state, payload) {
  return {
    ...state,
    loanTerm: payload
  };
}
function setAnnualAppreciation(state, payload) {
  return {
    ...state,
    annualAppreciation: payload
  };
}
function setHowLongBeforeSelling(state, payload) {
  return {
    ...state,
    howLongBeforeSelling: payload
  };
}
function setCurrentAnnualInterest(state, payload) {
  return {
    ...state,
    currentAnnualInterest: payload
  };
}
function setIncomeTax(state, payload) {
  return {
    ...state,
    incomeTax: payload
  };
}
function setShowFull$1(state, payload) {
  return {
    ...state,
    showFull: payload
  };
}
function setDefaults$2(state, initialState) {
  return {
    ...initialState,
    showFull: true
  };
}

const initialState$2 = {
  monthlyRent: 800,
  expectedAnnualRentIncrease: 5,
  homePrice: 200000,
  downPayment: 10000,
  downPaymentPercent: 5,
  closingCostPercent: 1.5,
  interestRate: 6,
  loanTerm: LoanTerms.THIRTY,
  annualAppreciation: 3,
  howLongBeforeSelling: 10,
  currentAnnualInterest: 3,
  incomeTax: 28,
  showFull: false
};
const LoanTermToNumber$2 = {
  [LoanTerms.THIRTY]: 30,
  [LoanTerms.TWENTY]: 20,
  [LoanTerms.FIFTEEN]: 15
};

// eslint-disable-next-line abcsize/abcsize
function calculatorReducer$2(state, action) {
  switch (action.type) {
    case RentOrBuyActionTypes.SET_MONTHLY_RENT:
      return setMonthlyRent(state, action.payload);
    case RentOrBuyActionTypes.SET_EXPECTED_ANNUAL_RENT_INCREASE:
      return setExpectedAnnualRentIncrease(state, action.payload);
    case RentOrBuyActionTypes.SET_HOME_PRICE:
      return setHomePrice$1(state, action.payload);
    case RentOrBuyActionTypes.SET_DOWN_PAYMENT:
      return setDownPayment(state, action.payload);
    case RentOrBuyActionTypes.SET_DOWN_PAYMENT_PERCENT:
      return setDownPaymentPercent(state, action.payload);
    case RentOrBuyActionTypes.SET_CLOSING_COST_PERCENT:
      return setClosingCostPercent(state, action.payload);
    case RentOrBuyActionTypes.SET_INTEREST_RATE:
      return setInterestRate$1(state, action.payload);
    case RentOrBuyActionTypes.SET_LOAN_TERM:
      return setLoanTerm$2(state, action.payload);
    case RentOrBuyActionTypes.SET_ANNUAL_APPRECIATION:
      return setAnnualAppreciation(state, action.payload);
    case RentOrBuyActionTypes.SET_HOW_LONG_BEFORE_SELLING:
      return setHowLongBeforeSelling(state, action.payload);
    case RentOrBuyActionTypes.SET_CURRENT_ANNUAL_INTEREST:
      return setCurrentAnnualInterest(state, action.payload);
    case RentOrBuyActionTypes.SET_INCOME_TAX:
      return setIncomeTax(state, action.payload);
    case RentOrBuyActionTypes.SET_SHOW_FULL:
      return setShowFull$1(state, action.payload);
    case RentOrBuyActionTypes.SET_DEFAULTS:
      return setDefaults$2(state, initialState$2);
    default:
      throw new Error("Unhandled action type");
  }
}
const RentOrBuyContext = /*#__PURE__*/createContext({
  state: initialState$2,
  dispatch: () => null,
  getCurrentValueOfHome: () => 0,
  getTotalOwedToBank: () => 0,
  getEquityOnHome: () => 0,
  getNetCostOfBuying: () => 0,
  getNetCostOfRenting: () => 0,
  getBenefitOfBuying: () => 0
});
const useComparisonResult = state => {
  const result = compareBuyOrRent({
    monthlyRent: state.monthlyRent,
    purchasePrice: state.homePrice,
    downPayment: state.downPaymentPercent,
    interestRate: state.interestRate,
    termInYears: LoanTermToNumber$2[state.loanTerm],
    howLongBeforeSelling: state.howLongBeforeSelling,
    incomeTaxRate: state.incomeTax,
    expectedAnnualRentIncrease: state.expectedAnnualRentIncrease,
    closingCosts: state.closingCostPercent,
    annualAppreciation: state.annualAppreciation
  });
  let getCurrentValueOfHome = () => 0;
  let getTotalOwedToBank = () => 0;
  let getEquityOnHome = () => 0;
  let getNetCostOfBuying = () => 0;
  let getNetCostOfRenting = () => 0;
  let getBenefitOfBuying = () => 0;
  if (!('error' in result)) {
    const {
      currentValueOfHome,
      totalOwedToBank,
      equityOnHome,
      netCostOfBuying,
      netCostOfRenting,
      benefitOfBuying
    } = result;
    getCurrentValueOfHome = () => currentValueOfHome;
    getTotalOwedToBank = () => totalOwedToBank;
    getEquityOnHome = () => equityOnHome;
    getNetCostOfBuying = () => netCostOfBuying;
    getNetCostOfRenting = () => netCostOfRenting;
    getBenefitOfBuying = () => benefitOfBuying;
  } else {
    console.log('calculation error: ', result.error);
  }
  return {
    getCurrentValueOfHome,
    getTotalOwedToBank,
    getEquityOnHome,
    getNetCostOfBuying,
    getNetCostOfRenting,
    getBenefitOfBuying
  };
};
function RentOrBuyProvider(_ref) {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(calculatorReducer$2, initialState$2);
  const {
    getCurrentValueOfHome,
    getTotalOwedToBank,
    getEquityOnHome,
    getNetCostOfBuying,
    getNetCostOfRenting,
    getBenefitOfBuying
  } = useComparisonResult(state);
  const value = {
    state,
    dispatch,
    getCurrentValueOfHome,
    getTotalOwedToBank,
    getEquityOnHome,
    getNetCostOfBuying,
    getNetCostOfRenting,
    getBenefitOfBuying
  };
  return /*#__PURE__*/React__default.createElement(RentOrBuyContext.Provider, {
    value: value
  }, children);
}
function useRentOrBuy() {
  const context = useContext(RentOrBuyContext);
  if (context === undefined) {
    throw new Error('useRentOrBuy must be used within a RentOrBuyProvider');
  }
  return context;
}

var _templateObject$e, _templateObject2$8, _templateObject3$5;
const AdvancedOptionsWrapper = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(4);
});
const FullWidthSecondaryButton = styled(OwnUpFillButtonSecondary)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const RightAlignedOptionWrapper$1 = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  text-align: right;\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(3);
});
const actionMapping$3 = {
  closingCostPercent: RentOrBuyActionTypes.SET_CLOSING_COST_PERCENT,
  expectedAnnualRentIncrease: RentOrBuyActionTypes.SET_EXPECTED_ANNUAL_RENT_INCREASE,
  annualAppreciation: RentOrBuyActionTypes.SET_ANNUAL_APPRECIATION,
  currentAnnualInterest: RentOrBuyActionTypes.SET_CURRENT_ANNUAL_INTEREST,
  incomeTax: RentOrBuyActionTypes.SET_INCOME_TAX
};
const handleNumberInput$1 = (event, fieldName, updateInputs) => updateInputs({
  inputTitle: fieldName,
  value: Number(event.target.value.replace(/[^0-9.-]/g, ''))
});
const AdvancedInputsComponent$1 = _ref3 => {
  let {
    inputs,
    updateInputs,
    resetToDefaults
  } = _ref3;
  const {
    closingCostPercent,
    expectedAnnualRentIncrease,
    annualAppreciation,
    currentAnnualInterest,
    incomeTax
  } = inputs;
  const [inputsVisible, setInputsVisible] = useState(false);
  const buttonIcon = () => inputsVisible ? /*#__PURE__*/React__default.createElement(ChevronUpIcon, null) : /*#__PURE__*/React__default.createElement(ChevronDownIcon, null);
  const changeCalculatorVisibility = () => {
    setInputsVisible(!inputsVisible);
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.createElement(AdvancedOptionsWrapper, null, /*#__PURE__*/React__default.createElement(FullWidthSecondaryButton, {
      icon: buttonIcon,
      iconPosition: "right",
      onClick: changeCalculatorVisibility
    }, "Advanced options"), inputsVisible && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Closing cost"
      }),
      value: closingCostPercent,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 2,
      allowNegative: false,
      fixedDecimalScale: true,
      onChange: e => handleNumberInput$1(e, 'closingCostPercent', updateInputs)
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Expected annual rent increase"
      }),
      value: expectedAnnualRentIncrease,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 1,
      allowNegative: false,
      fixedDecimalScale: true,
      onChange: e => handleNumberInput$1(e, 'expectedAnnualRentIncrease', updateInputs)
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Annual appreciation"
      }),
      value: annualAppreciation,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 1,
      allowNegative: false,
      fixedDecimalScale: true,
      onChange: e => handleNumberInput$1(e, 'annualAppreciation', updateInputs)
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Current annual interest"
      }),
      value: currentAnnualInterest,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 1,
      allowNegative: false,
      fixedDecimalScale: true,
      onChange: e => handleNumberInput$1(e, 'currentAnnualInterest', updateInputs)
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Income tax"
      }),
      value: incomeTax,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 1,
      allowNegative: false,
      fixedDecimalScale: true,
      onChange: e => handleNumberInput$1(e, 'incomeTax', updateInputs)
    }), /*#__PURE__*/React__default.createElement(RightAlignedOptionWrapper$1, null, /*#__PURE__*/React__default.createElement(OwnUpFillButtonSecondary, {
      icon: /*#__PURE__*/React__default.createElement(RefreshIcon, null),
      onClick: resetToDefaults
    }, "Return to defaults"))))
  );
};
const AdvancedInputs = () => {
  const {
    state: {
      closingCostPercent,
      expectedAnnualRentIncrease,
      annualAppreciation,
      currentAnnualInterest,
      incomeTax
    },
    dispatch
  } = useRentOrBuy();
  const updateInputs = useCallback(inputs => {
    dispatch({
      type: actionMapping$3[inputs.inputTitle],
      payload: inputs.value
    });
  }, [dispatch]);
  const resetToDefaults = () => {
    dispatch({
      type: RentOrBuyActionTypes.SET_DEFAULTS
    });
  };
  return /*#__PURE__*/React__default.createElement(AdvancedInputsComponent$1, {
    inputs: {
      closingCostPercent,
      expectedAnnualRentIncrease,
      annualAppreciation,
      currentAnnualInterest,
      incomeTax
    },
    updateInputs: updateInputs,
    resetToDefaults: resetToDefaults
  });
};

var _templateObject$d, _templateObject2$7, _templateObject3$4;
const actionMapping$2 = {
  monthlyRent: RentOrBuyActionTypes.SET_MONTHLY_RENT,
  homePrice: RentOrBuyActionTypes.SET_HOME_PRICE,
  downPayment: RentOrBuyActionTypes.SET_DOWN_PAYMENT,
  downPaymentPercent: RentOrBuyActionTypes.SET_DOWN_PAYMENT_PERCENT,
  interestRate: RentOrBuyActionTypes.SET_INTEREST_RATE,
  loanTerm: RentOrBuyActionTypes.SET_LOAN_TERM,
  howLongBeforeSelling: RentOrBuyActionTypes.SET_HOW_LONG_BEFORE_SELLING
};
const DownPaymentInputsWrapper = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  display: flex;\n"])));
const DownPaymentInput = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  width: 60%;\n  ", " {\n    width: 67%;\n    label {\n      width: unset;\n    }\n  }\n  label {\n    width: 80vw;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up(350);
});
const DownPaymentPercentInput = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  width: 40%;\n  margin-top: 20px;\n  input {\n    padding-right: 0;\n  }\n  ", " {\n    width: 33%;\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up(350);
});
const handleNumberInput = (event, fieldName, updateInputs) => updateInputs({
  inputTitle: fieldName,
  value: Number(event.target.value.replace(/[^0-9.-]/g, ''))
});
const DownPaymentInputs = _ref3 => {
  let {
    downPayment,
    downPaymentPercent,
    updateInputs
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(DownPaymentInputsWrapper, null, /*#__PURE__*/React__default.createElement(DownPaymentInput, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Down payment amount"
    }),
    value: downPayment,
    labelPosition: "outer",
    $leadingIcon: DollarIcon(),
    decimalScale: 0,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => handleNumberInput(e, 'downPayment', updateInputs)
  })), /*#__PURE__*/React__default.createElement(DownPaymentPercentInput, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null),
    value: downPaymentPercent,
    labelPosition: "outer",
    $leadingIcon: PercentIcon(),
    decimalScale: 0,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => handleNumberInput(e, 'downPaymentPercent', updateInputs)
  })));
};
const BasicInputsComponent$2 = _ref4 => {
  let {
    inputs,
    updateInputs,
    onClick
  } = _ref4;
  const {
    monthlyRent,
    homePrice,
    downPayment,
    downPaymentPercent,
    loanTerm,
    interestRate,
    howLongBeforeSelling
  } = inputs;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.createElement("div", {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Monthly rent"
      }),
      value: monthlyRent,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => handleNumberInput(e, 'monthlyRent', updateInputs)
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Home price"
      }),
      value: homePrice,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => handleNumberInput(e, 'homePrice', updateInputs)
    }), /*#__PURE__*/React__default.createElement(DownPaymentInputs, {
      downPayment: downPayment,
      downPaymentPercent: downPaymentPercent,
      updateInputs: updateInputs
    }), /*#__PURE__*/React__default.createElement(WidgetOptionsInput, {
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Loan term"
      }),
      value: loanTerm,
      options: loanTermsOptions,
      onChange: e => updateInputs({
        inputTitle: 'loanTerm',
        value: e.target.value
      })
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Interest rate"
      }),
      value: interestRate,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 3,
      fixedDecimalScale: true,
      allowNegative: false,
      onChange: e => handleNumberInput(e, 'interestRate', updateInputs)
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "How long before selling (years)"
      }),
      value: howLongBeforeSelling,
      labelPosition: "outer",
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => handleNumberInput(e, 'howLongBeforeSelling', updateInputs)
    }))
  );
};
const BasicInputs$1 = () => {
  const {
    state: {
      monthlyRent,
      homePrice,
      downPayment,
      downPaymentPercent,
      loanTerm,
      interestRate,
      howLongBeforeSelling
    },
    dispatch
  } = useRentOrBuy();
  const updateInputs = useCallback(inputs => {
    if (inputs.inputTitle === 'loanTerm') {
      const actionType = actionMapping$2[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    } else {
      const actionType = actionMapping$2[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    }
  }, [dispatch]);
  const openAdvancedOptions = useCallback(() => {
    dispatch({
      type: RentOrBuyActionTypes.SET_SHOW_FULL,
      payload: true
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(BasicInputsComponent$2, {
    inputs: {
      monthlyRent,
      homePrice,
      downPayment,
      downPaymentPercent,
      loanTerm,
      interestRate,
      howLongBeforeSelling
    },
    updateInputs: updateInputs,
    onClick: openAdvancedOptions
  });
};

var _templateObject$c;
const InputsWrapper$5 = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  row-gap: ", "px;\n  ", " {\n    row-gap: ", "px;\n    padding: ", "px;\n  }\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(4);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, WHITE_100, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(1, 1);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(2);
});
const Inputs$2 = () => /*#__PURE__*/React__default.createElement(InputsWrapper$5, null, /*#__PURE__*/React__default.createElement(BasicInputs$1, null), /*#__PURE__*/React__default.createElement(AdvancedInputs, null));

/**
 * @ignore - internal component.
 */

var TableContext = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  TableContext.displayName = 'TableContext';
}

var styles$4 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': _extends({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var defaultComponent$3 = 'table';
var Table = /*#__PURE__*/React.forwardRef(function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent$3 : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'normal' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = _objectWithoutProperties(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = React.useMemo(function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/React.createElement(TableContext.Provider, {
    value: table
  }, /*#__PURE__*/React.createElement(Component, _extends({
    role: Component === defaultComponent$3 ? null : 'table',
    ref: ref,
    className: clsx(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
process.env.NODE_ENV !== "production" ? Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   * `default` is deprecated, use `normal` instead.
   */
  padding: chainPropTypes(PropTypes.oneOf(['normal', 'checkbox', 'none', 'default']), function (props) {
    if (props.padding === 'default') {
      return new Error('Material-UI: padding="default" was renamed to padding="normal" for consistency.');
    }

    return null;
  }),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: PropTypes.bool
} : void 0;
var Table$1 = withStyles(styles$4, {
  name: 'MuiTable'
})(Table);

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = React.createContext();

if (process.env.NODE_ENV !== 'production') {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

var styles$3 = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2$1 = {
  variant: 'body'
};
var defaultComponent$2 = 'tbody';
var TableBody = /*#__PURE__*/React.forwardRef(function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent$2 : _props$component,
      other = _objectWithoutProperties(props, ["classes", "className", "component"]);

  return /*#__PURE__*/React.createElement(Tablelvl2Context.Provider, {
    value: tablelvl2$1
  }, /*#__PURE__*/React.createElement(Component, _extends({
    className: clsx(classes.root, className),
    ref: ref,
    role: Component === defaultComponent$2 ? null : 'rowgroup'
  }, other)));
});
process.env.NODE_ENV !== "production" ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
var TableBody$1 = withStyles(styles$3, {
  name: 'MuiTableBody'
})(TableBody);

var styles$2 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? lighten(alpha(theme.palette.divider, 1), 0.88) : darken(alpha(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = /*#__PURE__*/React.forwardRef(function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = _objectWithoutProperties(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = React.useContext(TableContext);
  var tablelvl2 = React.useContext(Tablelvl2Context);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: clsx(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(capitalize(align))], padding !== 'normal' && classes["padding".concat(capitalize(padding))], size !== 'medium' && classes["size".concat(capitalize(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
process.env.NODE_ENV !== "production" ? TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The table cell contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`normal`).
   * `default` is deprecated, use `normal` instead.
   */
  padding: chainPropTypes(PropTypes.oneOf(['normal', 'checkbox', 'none', 'default']), function (props) {
    if (props.padding === 'default') {
      return new Error('Material-UI: padding="default" was renamed to padding="normal" for consistency.');
    }

    return null;
  }),

  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['body', 'footer', 'head'])
} : void 0;
var TableCell$1 = withStyles(styles$2, {
  name: 'MuiTableCell'
})(TableCell);

var styles$1 = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var tablelvl2 = {
  variant: 'head'
};
var defaultComponent$1 = 'thead';
var TableHead = /*#__PURE__*/React.forwardRef(function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent$1 : _props$component,
      other = _objectWithoutProperties(props, ["classes", "className", "component"]);

  return /*#__PURE__*/React.createElement(Tablelvl2Context.Provider, {
    value: tablelvl2
  }, /*#__PURE__*/React.createElement(Component, _extends({
    className: clsx(classes.root, className),
    ref: ref,
    role: Component === defaultComponent$1 ? null : 'rowgroup'
  }, other)));
});
process.env.NODE_ENV !== "production" ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
var TableHead$1 = withStyles(styles$1, {
  name: 'MuiTableHead'
})(TableHead);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = /*#__PURE__*/React.forwardRef(function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = _objectWithoutProperties(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = React.useContext(Tablelvl2Context);
  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref,
    className: clsx(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === defaultComponent ? null : 'row'
  }, other));
});
process.env.NODE_ENV !== "production" ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: PropTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool
} : void 0;
var TableRow$1 = withStyles(styles, {
  name: 'MuiTableRow'
})(TableRow);

var _templateObject$b, _templateObject2$6, _templateObject3$3;
const ResultPlate$2 = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  margin-top: ", ";\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid ", ";\n  thead {\n    background-color: ", ";\n  }\n  th:not(:last-child) {\n    border-right: 1px solid ", ";\n  }\n  th {\n    border-bottom: 1px solid ", ";\n  }\n  td {\n    border-style: none;\n  }\n  td:not(:last-child) {\n    border-right: 1px solid ", ";\n  }\n  td:first-child {\n    background-color: ", ";\n    ", " {\n      background-color: white;\n    }\n  }\n  tr:not(:last-child) {\n    border-bottom: 1px solid ", ";\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return "".concat(theme.spacing(3), "px");
}, MINT_100, SAGE_100, MINT_100, MINT_100, MINT_100, SAGE_100, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
}, MINT_100);
const MobileTable = styled.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  display: block;\n  ", " {\n    display: none;\n  }\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.breakpoints.up('md');
});
const DesktopTable = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: block;\n  }\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoints.up('md');
});
const CalculationTableResult = () => {
  const {
    getCurrentValueOfHome,
    getTotalOwedToBank,
    getEquityOnHome,
    getNetCostOfBuying,
    getNetCostOfRenting,
    getBenefitOfBuying
  } = useRentOrBuy();
  const data = [{
    label: 'Value of Home at Selling',
    value: getCurrentValueOfHome()
  }, {
    label: 'Total Owed to Bank at Selling',
    value: getTotalOwedToBank()
  }, {
    label: 'Equity on Home at Selling',
    value: getEquityOnHome()
  }, {
    label: 'Cost of Buying',
    value: getNetCostOfBuying()
  }, {
    label: 'Cost of Renting',
    value: getNetCostOfRenting()
  }, {
    label: 'Benefits of Buying',
    value: getBenefitOfBuying()
  }];
  const renderTableRow = function () {
    let isDesktop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return isDesktop ? /*#__PURE__*/React__default.createElement(TableRow$1, null, data.map((item, index) => /*#__PURE__*/React__default.createElement(TableCell$1, {
      key: index
    }, displayNumber(item.value)))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, data.map((item, index) => /*#__PURE__*/React__default.createElement(TableRow$1, {
      key: index
    }, /*#__PURE__*/React__default.createElement(TableCell$1, null, item.label), /*#__PURE__*/React__default.createElement(TableCell$1, null, displayNumber(item.value)))));
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MobileTable, null, /*#__PURE__*/React__default.createElement(ResultPlate$2, null, /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small",
    "aria-label": "a dense table"
  }, /*#__PURE__*/React__default.createElement(TableBody$1, null, renderTableRow())))), /*#__PURE__*/React__default.createElement(DesktopTable, null, /*#__PURE__*/React__default.createElement(ResultPlate$2, null, /*#__PURE__*/React__default.createElement(Table$1, {
    size: "small",
    "aria-label": "a dense table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, data.map((item, index) => /*#__PURE__*/React__default.createElement(TableCell$1, {
    key: index
  }, item.label)))), /*#__PURE__*/React__default.createElement(TableBody$1, null, renderTableRow(true))))));
};

var _templateObject$a, _templateObject2$5;
const HeaderWrapper = styled(OwnUpSmallSubheadlineMedium)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  padding-top: 0 !important;\n  margin-bottom: 8px !important;\n"])));
const ResultPlate$1 = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 8px;\n  padding: 16px;\n"])), SAGE_100);
const MainCalculationResult = () => {
  const {
    state: {
      loanTerm,
      howLongBeforeSelling
    },
    getBenefitOfBuying
  } = useRentOrBuy();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ResultPlate$1, null, /*#__PURE__*/React__default.createElement(HeaderWrapper, {
    variant: "h2"
  }, "After ", howLongBeforeSelling, " years, opting for a ", LoanTermToNumber$2[loanTerm], " year mortgage to purchase a home yields financial benefits amounting to", ' ', displayNumber(getBenefitOfBuying()), ".")));
};

var _templateObject$9;
const Container$2 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  filter: drop-shadow(4px 4px 8px ", ");\n  border-radius: ", ";\n  padding: ", ";\n  ", " {\n    padding: ", ";\n  }\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.background.default;
}, CHARCOAL_5, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(1, 1, 0, 0);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(2, 2);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.breakpoints.up('md');
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(3, 3);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(3);
});
const CalculationSummary$2 = () => {
  const {
    state: {
      showFull
    }
  } = useRentOrBuy();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showFull && /*#__PURE__*/React__default.createElement(OwnUpThemeProvider, {
    theme: ownUpWhiteTheme
  }, /*#__PURE__*/React__default.createElement(OwnUpExtraSmallHeadlineMedium, {
    variant: "h2"
  }, "Your results"), /*#__PURE__*/React__default.createElement(Container$2, null, /*#__PURE__*/React__default.createElement(MainCalculationResult, null), /*#__PURE__*/React__default.createElement(CalculationTableResult, null))));
};

const description$1 = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Rent vs. Buy Mortgage Calculator: Analyzing Housing Decisions"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "This module calculates the potential benefits of buying a home as opposed to renting a home based on various given parameters. Returns a break down of the various costs of both buying vs renting, and a final value of money saved by buying. This final value may be negative to indicate a benefit of renting rather than buying.", ' '));
const RentOrBuyCalculator = () => {
  return /*#__PURE__*/React__default.createElement(WidgetWrapper, {
    title: "Rent or Buy Calculator",
    description: description$1
  }, /*#__PURE__*/React__default.createElement(RentOrBuyProvider, null, /*#__PURE__*/React__default.createElement(Inputs$2, null), /*#__PURE__*/React__default.createElement(CalculationSummary$2, null)));
};

/* eslint-disable max-lines-per-function */
/*
 *	To calculate Monthly Mortgage Payments With Extra Monthly Payments  pass in the following arguments :
 *	var args = {
 *		loanAmount (number) : the loan amount
 *		interestRate (number) : interest rate as an annual percentage ( will be converted into monthly percentage in calculations)
 *		termInYears (number) : the term in years ( will be converted to number of monthly payments in calculations)
 *		extraPaymentAmount (number) : the amount to add to each monthly mortgage payment
 *	}
 *
 *	response : an object
 *	var response = {
 *		withExtraPayment : {
 *			totalMonthlyPayment :  (number),
 *			interestRate : (number),
 *			term : (number),
 *			totalCost : (number),
 *			payments : (array of objects) [{
 *	        	annualInterestPayment: (number),
 *	        	annualPrincipalPayment: (number),
 *	        	balance: (number),
 *	        	monthlyBreakdown: [(array of objects)]
 *	  		}]
 *		},
 *		withoutExtraPayment : {
 *			totalMonthlyPayment : (number),
 *			interestRate : (number),
 *			term : (number),
 *			totalCost : (number)
 *		}
 *	}
 */
const monthlyMortgagePaymentsWithExtraPayments = function (args) {
  // validate our inputs first
  const inputData = _validateInputData(args, {
    loanAmount: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: false
    },
    interestRate: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    },
    termInYears: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: true,
      isNotFloat: true
    },
    extraPaymentAmount: {
      isRequired: true,
      isNumber: true,
      isNotNegative: true,
      isNotZero: false,
      isNotFloat: false
    }
  });
  if (inputData.error) {
    return {
      error: inputData.error
    };
  }

  // set some working data.
  const monthlyInterestRate = args.interestRate / 100 / 12;
  const numberOfMonthlyPayments = args.termInYears * 12;
  const extraPaymentAmount = args.extraPaymentAmount;
  const monthlyMortgagePayment = calculateMonthlyMortgagePayment({
    loanAmount: args.loanAmount,
    interestRate: args.interestRate,
    termInYears: args.termInYears
  });
  let remainingBalance = args.loanAmount;
  let totalCostWithoutExtraPayments = 0;
  let totalMonthlyPaymentWithoutExtraPayments = monthlyMortgagePayment;
  // calculate monthly payment without extra payments breakdowns against the number of monthly payments
  for (let i = 0; i <= numberOfMonthlyPayments; i++) {
    const monthlyInterestPayment = calculateMonthlyInterestPayment(monthlyInterestRate, remainingBalance);
    const monthlyPrincipalPayment = monthlyMortgagePayment - monthlyInterestPayment;
    // if the total monthly payment is no longer less than remaining balance, then we are at our last payment
    if (remainingBalance - monthlyPrincipalPayment >= 0) {
      if (remainingBalance >= totalMonthlyPaymentWithoutExtraPayments) {
        remainingBalance -= monthlyPrincipalPayment;
      }
    } else {
      totalMonthlyPaymentWithoutExtraPayments = remainingBalance;
      remainingBalance -= totalMonthlyPaymentWithoutExtraPayments;
    }
    // as long as remaining balance is greater than zero, lets keep adding it up
    if (remainingBalance > 0) {
      totalCostWithoutExtraPayments += monthlyMortgagePayment;
    }
  }
  // initialize the total montlh payment
  let totalMonthlyPayment = monthlyMortgagePayment + extraPaymentAmount;

  // reset that remaining balance to calculate payments with extra payments
  remainingBalance = args.loanAmount;
  // initialize monthly payments breakdown array
  const monthlyPayments = [];
  // calculate monthly payment with extra payments breakdowns against the number of monthly payments
  for (let i = 0; i < numberOfMonthlyPayments; i++) {
    const monthlyInterestPayment = calculateMonthlyInterestPayment(monthlyInterestRate, remainingBalance);
    const monthlyPrincipalPayment = monthlyMortgagePayment - monthlyInterestPayment + extraPaymentAmount;
    // if the total monthly payment is no longer less than remaining balance, then we are at our last payment
    if (remainingBalance - monthlyPrincipalPayment >= 0) {
      if (remainingBalance >= totalMonthlyPayment) {
        remainingBalance -= monthlyPrincipalPayment;
      } else {
        remainingBalance = 0;
      }
    } else {
      totalMonthlyPayment = remainingBalance;
      remainingBalance -= totalMonthlyPayment;
    }
    // as long as remaining balance is greater than zero, lets store those in our monthly payment array
    // full monthly payment array
    monthlyPayments.push({
      monthlyPayment: formatResult(monthlyMortgagePayment + extraPaymentAmount),
      principalPayment: formatResult(monthlyPrincipalPayment),
      interestPayment: formatResult(monthlyInterestPayment),
      balance: formatResult(remainingBalance)
    });
    if (remainingBalance <= 0) {
      break;
    }
  }

  // initialize annual breakdown array
  const annualPayments = [];
  // separate monthly payments into years
  for (let j = 0; j < Math.ceil(monthlyPayments.length); j += 12) {
    annualPayments.push(monthlyPayments.slice(j, j + 12));
  }
  // intialize array to join annual and monthly payment breakdowns
  const payments = [];
  // set the annual remaining balance as the loan amount to calculate the annual remaining balance breakdown
  let annualRemainingBalance = args.loanAmount;
  // sum up totals for each year
  for (let k = 0; k < annualPayments.length; k++) {
    // reset annual interest and principal payments for th year
    let annualInterestPayment = 0;
    let annualPrincipalPayment = 0;
    // add up the payments of the year
    for (let x = 0; x < annualPayments[k].length; x++) {
      annualInterestPayment += annualPayments[k][x].interestPayment;
      annualPrincipalPayment += annualPayments[k][x].principalPayment;
    }
    if (annualRemainingBalance - annualPrincipalPayment >= 0) {
      if (annualRemainingBalance >= annualPrincipalPayment) {
        annualRemainingBalance -= annualPrincipalPayment;
      }
    } else {
      annualPrincipalPayment = annualRemainingBalance;
      annualRemainingBalance -= annualPrincipalPayment;
    }
    payments.push({
      annualInterestPayment: formatResult(annualInterestPayment),
      annualPrincipalPayment: formatResult(annualPrincipalPayment),
      balance: formatResult(annualRemainingBalance),
      monthlyBreakdown: annualPayments[k]
    });
  }
  // build response object
  const response = {
    withExtraPayment: {
      totalMonthlyPayment: formatResult(monthlyMortgagePayment + extraPaymentAmount),
      interestRate: args.interestRate,
      term: args.termInYears,
      totalCost: formatResult(monthlyPayments.length * (monthlyMortgagePayment + extraPaymentAmount)),
      payments: payments
    },
    withoutExtraPayment: {
      totalMonthlyPayment: formatResult(monthlyMortgagePayment),
      interestRate: args.interestRate,
      term: args.termInYears,
      totalCost: formatResult(totalCostWithoutExtraPayments)
    }
  };
  return response;
};

/* eslint-disable @typescript-eslint/naming-convention */

let ABComparisonDataActionsTypes = /*#__PURE__*/function (ABComparisonDataActionsTypes) {
  ABComparisonDataActionsTypes[ABComparisonDataActionsTypes["SET_LOAN_AMOUNT"] = 0] = "SET_LOAN_AMOUNT";
  ABComparisonDataActionsTypes[ABComparisonDataActionsTypes["SET_LOAN_TERM"] = 1] = "SET_LOAN_TERM";
  ABComparisonDataActionsTypes[ABComparisonDataActionsTypes["SET_INTEREST_RATE"] = 2] = "SET_INTEREST_RATE";
  ABComparisonDataActionsTypes[ABComparisonDataActionsTypes["SET_EXTRA_PAYMENT"] = 3] = "SET_EXTRA_PAYMENT";
  ABComparisonDataActionsTypes[ABComparisonDataActionsTypes["SET_SHOW_FULL"] = 4] = "SET_SHOW_FULL";
  ABComparisonDataActionsTypes[ABComparisonDataActionsTypes["SET_DEFAULTS"] = 5] = "SET_DEFAULTS";
  return ABComparisonDataActionsTypes;
}({});

function setLoanAmount(state, payload) {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      loanAmount: payload.value
    }
  };
}
function setLoanTerm$1(state, payload) {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      loanTerm: payload.value
    }
  };
}
function setInterestRate(state, payload) {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      interestRate: payload.value
    }
  };
}
function setExtraPayment(state, payload) {
  return {
    ...state,
    [payload.variant]: {
      ...state[payload.variant],
      extraPayment: payload.value
    }
  };
}
function setShowFull(state, payload) {
  return {
    ...state,
    showFull: payload
  };
}
function setDefaults$1(state, initialState) {
  return {
    ...initialState,
    showFull: true
  };
}

const initialState$1 = {
  A: {
    loanAmount: 250000,
    loanTerm: LoanTerms.THIRTY,
    interestRate: 6.725,
    extraPayment: 0
  },
  B: {
    loanAmount: 250000,
    loanTerm: LoanTerms.FIFTEEN,
    interestRate: 6.725,
    extraPayment: 0
  },
  showFull: false
};
const LoanTermToNumber$1 = {
  [LoanTerms.THIRTY]: 30,
  [LoanTerms.TWENTY]: 20,
  [LoanTerms.FIFTEEN]: 15
};

// eslint-disable-next-line abcsize/abcsize
function calculatorReducer$1(state, action) {
  switch (action.type) {
    case ABComparisonDataActionsTypes.SET_LOAN_AMOUNT:
      return setLoanAmount(state, action.payload);
    case ABComparisonDataActionsTypes.SET_LOAN_TERM:
      return setLoanTerm$1(state, action.payload);
    case ABComparisonDataActionsTypes.SET_INTEREST_RATE:
      return setInterestRate(state, action.payload);
    case ABComparisonDataActionsTypes.SET_EXTRA_PAYMENT:
      return setExtraPayment(state, action.payload);
    case ABComparisonDataActionsTypes.SET_SHOW_FULL:
      return setShowFull(state, action.payload);
    case ABComparisonDataActionsTypes.SET_DEFAULTS:
      return setDefaults$1(state, initialState$1);
    default:
      throw new Error("Unhandled action type");
  }
}
const ABComparisonContext = /*#__PURE__*/createContext({
  state: initialState$1,
  dispatch: () => null,
  getMonthlyPayment: () => ({
    A: 0,
    B: 0
  }),
  getTotalCost: () => ({
    A: 0,
    B: 0
  }),
  getTotalTerm: () => ({
    A: 0,
    B: 0
  }),
  getPayments: () => null
});
function ABComparisonProvider(_ref) {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(calculatorReducer$1, initialState$1);
  const resultVariantA = monthlyMortgagePaymentsWithExtraPayments({
    loanAmount: state.A.loanAmount,
    interestRate: state.A.interestRate,
    termInYears: LoanTermToNumber$1[state.A.loanTerm],
    extraPaymentAmount: state.A.extraPayment
  });
  const resultVariantB = monthlyMortgagePaymentsWithExtraPayments({
    loanAmount: state.B.loanAmount,
    interestRate: state.B.interestRate,
    termInYears: LoanTermToNumber$1[state.B.loanTerm],
    extraPaymentAmount: state.B.extraPayment
  });
  let getMonthlyPayment = () => ({
    A: 0,
    B: 0
  });
  let getTotalCost = () => ({
    A: 0,
    B: 0
  });
  let getTotalTerm = () => ({
    A: 0,
    B: 0
  });
  let getPayments = () => null;
  if (!('error' in resultVariantA) && !('error' in resultVariantB)) {
    getMonthlyPayment = () => ({
      A: resultVariantA.withExtraPayment.totalMonthlyPayment,
      B: resultVariantB.withExtraPayment.totalMonthlyPayment
    });
    getTotalCost = () => ({
      A: resultVariantA.withExtraPayment.totalCost,
      B: resultVariantB.withExtraPayment.totalCost
    });
    getTotalTerm = () => {
      var _resultVariantA$withE, _resultVariantB$withE;
      return {
        A: (_resultVariantA$withE = resultVariantA.withExtraPayment.payments) === null || _resultVariantA$withE === void 0 ? void 0 : _resultVariantA$withE.length,
        B: (_resultVariantB$withE = resultVariantB.withExtraPayment.payments) === null || _resultVariantB$withE === void 0 ? void 0 : _resultVariantB$withE.length
      };
    };
    getPayments = () => ({
      A: resultVariantA.withExtraPayment.payments,
      B: resultVariantB.withExtraPayment.payments
    });
  } else {
    console.log('calculation error');
  }
  const value = {
    state,
    dispatch,
    getMonthlyPayment,
    getTotalCost,
    getTotalTerm,
    getPayments
  };
  return /*#__PURE__*/React__default.createElement(ABComparisonContext.Provider, {
    value: value
  }, children);
}
function useABComparison() {
  const context = useContext(ABComparisonContext);
  if (context === undefined) {
    throw new Error('useABComparison must be used within a ABComparisonProvider');
  }
  return context;
}

var _templateObject$8, _templateObject2$4;
const actionMapping$1 = {
  loanAmount: ABComparisonDataActionsTypes.SET_LOAN_AMOUNT,
  loanTerm: ABComparisonDataActionsTypes.SET_LOAN_TERM,
  interestRate: ABComparisonDataActionsTypes.SET_INTEREST_RATE,
  extraPayment: ABComparisonDataActionsTypes.SET_EXTRA_PAYMENT
};
const InputsHeader = styled(OwnUpSmallSubheadlineMedium)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  padding-top: 0 !important;\n"])));
const InputsWrapper$4 = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up('md');
});
const BasicInputsComponent$1 = _ref2 => {
  let {
    inputs,
    variant,
    updateInputs,
    onClick
  } = _ref2;
  const {
    loanAmount,
    loanTerm,
    interestRate,
    extraPayment
  } = inputs;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React__default.createElement(InputsWrapper$4, {
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(InputsHeader, {
      variant: "h4"
    }, "Option ", variant), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Mortgage amount"
      }),
      value: loanAmount,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'loanAmount',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(WidgetOptionsInput, {
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Loan term"
      }),
      value: loanTerm,
      options: loanTermsOptions,
      onChange: e => updateInputs({
        inputTitle: 'loanTerm',
        value: e.target.value
      })
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Interest rate"
      }),
      value: interestRate,
      labelPosition: "outer",
      $leadingIcon: PercentIcon(),
      decimalScale: 3,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'interestRate',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
      customInput: OwnUpTextInput,
      label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
        label: "Extra monthly principle payment"
      }),
      value: extraPayment,
      labelPosition: "outer",
      $leadingIcon: DollarIcon(),
      decimalScale: 0,
      allowNegative: false,
      thousandSeparator: true,
      onChange: e => {
        updateInputs({
          inputTitle: 'extraPayment',
          value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
        });
      }
    }))
  );
};
const BasicInputs = _ref3 => {
  let {
    variant
  } = _ref3;
  const {
    state: {
      [variant]: {
        loanAmount,
        loanTerm,
        interestRate,
        extraPayment
      }
    },
    dispatch
  } = useABComparison();
  const updateInputs = useCallback(inputs => {
    if (inputs.inputTitle === 'loanTerm') {
      const actionType = actionMapping$1[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: {
          value: inputs.value,
          variant
        }
      });
    } else {
      const actionType = actionMapping$1[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: {
          value: inputs.value,
          variant
        }
      });
    }
  }, [dispatch, variant]);
  const openAdvancedOptions = useCallback(() => {
    dispatch({
      type: ABComparisonDataActionsTypes.SET_SHOW_FULL,
      payload: true
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(BasicInputsComponent$1, {
    inputs: {
      loanAmount,
      loanTerm,
      interestRate,
      extraPayment
    },
    variant: variant,
    updateInputs: updateInputs,
    onClick: openAdvancedOptions
  });
};

var _templateObject$7, _templateObject2$3;
const InputsWrapper$3 = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  row-gap: ", "px;\n  column-gap: ", "px;\n  ", " {\n    padding: ", "px;\n    flex-direction: row;\n  }\n  background-color: ", ";\n  border-radius: ", ";\n  padding: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(4);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(9);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.breakpoints.up('md');
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, WHITE_100, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(1, 1);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(2);
});
const RightAlignedOptionWrapper = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  text-align: right;\n  background-color: ", ";\n  padding: ", "px;\n  ", " {\n    padding: ", "px;\n    padding-top: 0;\n  }\n"])), WHITE_100, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing(2);
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.breakpoints.up('md');
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.spacing(3);
});
const Inputs$1 = () => {
  const {
    dispatch
  } = useABComparison();
  const returnToDefaults = () => dispatch({
    type: ABComparisonDataActionsTypes.SET_DEFAULTS
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputsWrapper$3, null, /*#__PURE__*/React__default.createElement(BasicInputs, {
    variant: "A"
  }), /*#__PURE__*/React__default.createElement(BasicInputs, {
    variant: "B"
  })), /*#__PURE__*/React__default.createElement(RightAlignedOptionWrapper, null, /*#__PURE__*/React__default.createElement(OwnUpFillButtonSecondary, {
    icon: /*#__PURE__*/React__default.createElement(RefreshIcon, null),
    onClick: returnToDefaults
  }, "Return to defaults")));
};

const formatCurrency = tickItem => {
  if (tickItem >= 1e6) {
    return "$".concat((tickItem / 1e6).toFixed(0), "M");
  } else if (tickItem >= 1e3) {
    return "$".concat((tickItem / 1e3).toFixed(0), "k");
  } else {
    return "$".concat(tickItem);
  }
};
const fieldToLabel = {
  totalPayedA: 'Total Paid A',
  totalPayedB: 'Total Paid B'
};
const CustomTooltip = _ref => {
  let {
    active,
    payload,
    label
  } = _ref;
  if (active && payload && payload.length) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        backgroundColor: '#fff',
        padding: '5px',
        border: '1px solid #ccc'
      }
    }, /*#__PURE__*/React__default.createElement("strong", {
      className: "label"
    }, "Year: ".concat(label)), /*#__PURE__*/React__default.createElement("div", null, "".concat(fieldToLabel[payload[0].name], ": ").concat(displayNumber(payload[0].value))), payload[1] && /*#__PURE__*/React__default.createElement("div", null, "".concat(fieldToLabel[payload[1].name], ": ").concat(displayNumber(payload[1].value))));
  }
  return null;
};
const MortgageLineChart = _ref2 => {
  let {
    dataSet1,
    dataSet2
  } = _ref2;
  const monthlyPayment1 = dataSet1[0].monthlyBreakdown[0].monthlyPayment;
  const monthlyPayment2 = dataSet2[0].monthlyBreakdown[0].monthlyPayment;
  const maxDays = Math.max(dataSet1.length, dataSet2.length);
  const data = [{
    year: "0",
    totalPayedA: 0,
    totalPayedB: 0
  }];
  for (let index = 0; index < maxDays; index++) {
    data.push({
      year: "".concat(index + 1),
      totalPayedA: index < dataSet1.length ? monthlyPayment1 * 12 * index + monthlyPayment1 * dataSet1[index].monthlyBreakdown.length : null,
      totalPayedB: index < dataSet2.length ? monthlyPayment2 * 12 * index + monthlyPayment2 * dataSet2[index].monthlyBreakdown.length : null
    });
  }
  return /*#__PURE__*/React__default.createElement(ResponsiveContainer, {
    width: "100%",
    height: 300
  }, /*#__PURE__*/React__default.createElement(LineChart, {
    data: data,
    margin: {
      top: 5,
      bottom: 5
    }
  }, /*#__PURE__*/React__default.createElement(XAxis, {
    dataKey: "year",
    tickCount: 5,
    tickLine: false,
    tickMargin: 14,
    height: 54,
    tickFormatter: (value, index) => index % 5 === 0 ? value : ''
  }), /*#__PURE__*/React__default.createElement(YAxis, {
    tickFormatter: value => formatCurrency(value)
  }), /*#__PURE__*/React__default.createElement(Tooltip, {
    content: /*#__PURE__*/React__default.createElement(CustomTooltip, null)
  }), /*#__PURE__*/React__default.createElement(Line, {
    type: "monotone",
    dataKey: "totalPayedA",
    stroke: PINE_100,
    dot: false,
    strokeWidth: 2
  }), /*#__PURE__*/React__default.createElement(Line, {
    type: "monotone",
    dataKey: "totalPayedB",
    stroke: MINT_100,
    dot: false,
    strokeWidth: 2
  })));
};

var _templateObject$6, _templateObject2$2, _templateObject3$2, _templateObject4$1;
const ResultPlate = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  ", " {\n    width: 50%;\n  }\n  background-color: ", ";\n  border-radius: 8px;\n  padding: ", ";\n  row-gap: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up('md');
}, MOSS_100, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(3, 2);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(3);
});
const PlateRow = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n"])), FOG_100);
const ResultPlateTitle = styled(OwnUpSmallSubheadlineMedium)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  padding-top: 0 !important;\n"])));
const VariantColor = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n  background-color: ", ";\n  margin-right: ", "px;\n  display: inline-block;\n  margin-bottom: 2px;\n"])), props => props.variant === 'A' ? PINE_100 : MINT_100, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(1);
});
const SummaryPlate = _ref5 => {
  let {
    variant
  } = _ref5;
  const {
    getMonthlyPayment,
    getTotalCost,
    getTotalTerm
  } = useABComparison();
  return /*#__PURE__*/React__default.createElement(ResultPlate, null, /*#__PURE__*/React__default.createElement(PlateRow, null, /*#__PURE__*/React__default.createElement(ResultPlateTitle, {
    variant: "h4"
  }, /*#__PURE__*/React__default.createElement(VariantColor, {
    variant: variant
  }), "Option ", variant)), /*#__PURE__*/React__default.createElement(PlateRow, null, /*#__PURE__*/React__default.createElement("div", null, "Loan term"), /*#__PURE__*/React__default.createElement("strong", null, getTotalTerm()[variant], " years")), /*#__PURE__*/React__default.createElement(PlateRow, null, /*#__PURE__*/React__default.createElement("div", null, "Monthly payment"), /*#__PURE__*/React__default.createElement("strong", null, displayNumber(getMonthlyPayment()[variant]))), /*#__PURE__*/React__default.createElement(PlateRow, null, /*#__PURE__*/React__default.createElement("div", null, "Total cost"), /*#__PURE__*/React__default.createElement("strong", null, displayNumber(getTotalCost()[variant]))));
};

var _templateObject$5;
const Container$1 = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  row-gap: ", "px;\n  column-gap: ", "px;\n  ", " {\n    padding: ", "px;\n    flex-direction: row;\n  }\n  background-color: ", ";\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(4);
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(9);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.breakpoints.up('md');
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(3);
}, WHITE_100, _ref5 => {
  let {
    theme,
    marginTop
  } = _ref5;
  return marginTop ? marginTop : theme.spacing(5);
});
const CalculationSummary$1 = () => {
  const {
    state: {
      showFull
    },
    getPayments
  } = useABComparison();
  let A = [];
  let B = [];
  const payments = getPayments();
  if (payments) {
    A = payments.A;
    B = payments.B;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showFull && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, payments !== null && /*#__PURE__*/React__default.createElement(Container$1, null, /*#__PURE__*/React__default.createElement(MortgageLineChart, {
    dataSet1: A,
    dataSet2: B
  })), /*#__PURE__*/React__default.createElement(Container$1, {
    marginTop: "0"
  }, /*#__PURE__*/React__default.createElement(SummaryPlate, {
    variant: "A"
  }), /*#__PURE__*/React__default.createElement(SummaryPlate, {
    variant: "B"
  }))));
};

const description = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "Fixed-rate loan comparison calculator"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(OwnUpSmallBody, {
  variant: "body1"
}, "The Fixed-rate loan comparison calculator is designed to help users evaluate and contrast the monthly payments and overall costs of different mortgage scenarios. By inputting values such as loan amount, loan term, interest rate, and any extra payments, users can easily compare two mortgage options side-by-side. This tool is perfect for those considering refinancing, purchasing a home, or exploring ways to accelerate their mortgage payoff. The calculator provides a detailed breakdown of monthly payments and the total cost over the life of the loan, enabling users to make informed decisions based on their financial goals. Whether you're a first-time homebuyer or an experienced property investor, this calculator simplifies complex mortgage comparisons into clear, actionable insights.", ' '));
const ABComparisonCalculator = () => {
  return /*#__PURE__*/React__default.createElement(WidgetWrapper, {
    title: "Fixed-rate loan comparison Calculator",
    description: description
  }, /*#__PURE__*/React__default.createElement(ABComparisonProvider, null, /*#__PURE__*/React__default.createElement(Inputs$1, null), /*#__PURE__*/React__default.createElement(CalculationSummary$1, null)));
};

/* eslint-disable @typescript-eslint/naming-convention */

let RefinanceDataActionsTypes = /*#__PURE__*/function (RefinanceDataActionsTypes) {
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_HOME_PRICE"] = 0] = "SET_HOME_PRICE";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_MORTGAGE_BALANCE"] = 1] = "SET_MORTGAGE_BALANCE";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_CASH_OUT"] = 2] = "SET_CASH_OUT";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_LOAN_TERM"] = 3] = "SET_LOAN_TERM";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_APR"] = 4] = "SET_APR";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_PROPERTY_TAXES_ANNUAL"] = 5] = "SET_PROPERTY_TAXES_ANNUAL";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_HOMEOWNERS_INSURANCE_MONTHLY"] = 6] = "SET_HOMEOWNERS_INSURANCE_MONTHLY";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_HOA_FEES_MONTHLY"] = 7] = "SET_HOA_FEES_MONTHLY";
  RefinanceDataActionsTypes[RefinanceDataActionsTypes["SET_DEFAULTS"] = 8] = "SET_DEFAULTS";
  return RefinanceDataActionsTypes;
}({});

function setHomePrice(state, payload) {
  return {
    ...state,
    homePrice: payload
  };
}
function setMortgageBalance(state, payload) {
  return {
    ...state,
    mortgageBalance: payload
  };
}
function setCashOut(state, payload) {
  return {
    ...state,
    cashOut: payload
  };
}
function setLoanTerm(state, payload) {
  return {
    ...state,
    loanTerm: payload
  };
}
function setApr(state, payload) {
  return {
    ...state,
    apr: payload
  };
}
function setPropertyTaxAnnual(state, payload) {
  return {
    ...state,
    propertyTaxAnnual: payload
  };
}
function setHomeownersInsuranceMonthly(state, payload) {
  return {
    ...state,
    homeownersInsuranceMonthly: payload
  };
}
function setHoaFeesMonthly(state, payload) {
  return {
    ...state,
    hoaFeesMonthly: payload
  };
}
function setDefaults(state, initialState) {
  return {
    ...initialState
  };
}

const initialState = {
  homePrice: 250000,
  mortgageBalance: 200000,
  cashOut: 0,
  loanTerm: LoanTerms.THIRTY,
  apr: interestRateToCreditTiers[creditTiers['740+']],
  propertyTaxAnnual: 0,
  homeownersInsuranceMonthly: 0,
  hoaFeesMonthly: 0
};
const LoanTermToNumber = {
  [LoanTerms.THIRTY]: 30,
  [LoanTerms.TWENTY]: 20,
  [LoanTerms.FIFTEEN]: 15
};

// eslint-disable-next-line abcsize/abcsize
function calculatorReducer(state, action) {
  switch (action.type) {
    case RefinanceDataActionsTypes.SET_HOME_PRICE:
      return setHomePrice(state, action.payload);
    case RefinanceDataActionsTypes.SET_MORTGAGE_BALANCE:
      return setMortgageBalance(state, action.payload);
    case RefinanceDataActionsTypes.SET_CASH_OUT:
      return setCashOut(state, action.payload);
    case RefinanceDataActionsTypes.SET_LOAN_TERM:
      return setLoanTerm(state, action.payload);
    case RefinanceDataActionsTypes.SET_APR:
      return setApr(state, action.payload);
    case RefinanceDataActionsTypes.SET_PROPERTY_TAXES_ANNUAL:
      return setPropertyTaxAnnual(state, action.payload);
    case RefinanceDataActionsTypes.SET_HOMEOWNERS_INSURANCE_MONTHLY:
      return setHomeownersInsuranceMonthly(state, action.payload);
    case RefinanceDataActionsTypes.SET_HOA_FEES_MONTHLY:
      return setHoaFeesMonthly(state, action.payload);
    case RefinanceDataActionsTypes.SET_DEFAULTS:
      return setDefaults(state, initialState);
    default:
      throw new Error("Unhandled action type");
  }
}
const RefinanceContext = /*#__PURE__*/createContext({
  state: initialState,
  dispatch: () => null,
  getMonthlyPayment: () => 0,
  getNewLoanBalance: () => 0,
  getLTV: () => 0
});
const roundTo = (value, percision) => Math.floor(value / percision) * percision;
function RefinanceProvider(_ref) {
  let {
    children
  } = _ref;
  const [state, dispatch] = useReducer(calculatorReducer, initialState);
  const {
    monthlyPayment
  } = calculateMortgage({
    homePrice: state.homePrice + state.cashOut,
    downPayment: state.homePrice - state.mortgageBalance,
    loanTermYears: LoanTermToNumber[state.loanTerm],
    apr: state.apr,
    propertyTaxAnnual: state.propertyTaxAnnual,
    homeownersInsuranceMonthly: state.homeownersInsuranceMonthly,
    hoaFeesMonthly: state.hoaFeesMonthly
  });
  const getMonthlyPayment = () => monthlyPayment;
  const getNewLoanBalance = () => state.mortgageBalance + state.cashOut;
  const getLTV = () => roundTo((state.mortgageBalance + state.cashOut) / state.homePrice * 100, 1);
  const value = {
    state,
    dispatch,
    getMonthlyPayment,
    getNewLoanBalance,
    getLTV
  };
  return /*#__PURE__*/React__default.createElement(RefinanceContext.Provider, {
    value: value
  }, children);
}
function useRefinance() {
  const context = useContext(RefinanceContext);
  if (context === undefined) {
    throw new Error('useRefinance must be used within a RefinanceProvider');
  }
  return context;
}

var _templateObject$4;
const InputsWrapper$2 = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: block;\n  ", " {\n    display: flex;\n    gap: ", "px;\n    & > * {\n      flex: 1;\n      input,\n      .MuiInputBase-root,\n      .MuiSelect-root {\n        background-color: white;\n      }\n    }\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up('md');
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(3);
});
const AdvancedInputsComponent = _ref3 => {
  let {
    inputs,
    updateInputs
  } = _ref3;
  const {
    apr,
    propertyTaxAnnual,
    homeownersInsuranceMonthly,
    hoaFeesMonthly
  } = inputs;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputsWrapper$2, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Interest rate"
    }),
    value: apr,
    color: "secondary",
    labelPosition: "outer",
    $leadingIcon: PercentIcon(),
    decimalScale: 0,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => {
      updateInputs({
        inputTitle: 'apr',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      });
    }
  }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Property tax annual"
    }),
    value: propertyTaxAnnual,
    labelPosition: "outer",
    $leadingIcon: DollarIcon(),
    decimalScale: 0,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => {
      updateInputs({
        inputTitle: 'propertyTaxAnnual',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      });
    }
  }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Homeowners insurance monthly"
    }),
    value: homeownersInsuranceMonthly,
    labelPosition: "outer",
    $leadingIcon: DollarIcon(),
    decimalScale: 3,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => {
      updateInputs({
        inputTitle: 'homeownersInsuranceMonthly',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      });
    }
  }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Hoa fees monthly"
    }),
    value: hoaFeesMonthly,
    labelPosition: "outer",
    $leadingIcon: DollarIcon(),
    decimalScale: 3,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => {
      updateInputs({
        inputTitle: 'hoaFeesMonthly',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      });
    }
  })));
};

var _templateObject$3;
const InputsWrapper$1 = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: block;\n  ", " {\n    display: flex;\n    gap: ", "px;\n    & > * {\n      flex: 1;\n      input,\n      .MuiInputBase-root,\n      .MuiSelect-root {\n        background-color: white;\n      }\n    }\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.breakpoints.up('md');
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(3);
});
const BasicInputsComponent = _ref3 => {
  let {
    inputs,
    updateInputs,
    getLTV
  } = _ref3;
  const {
    homePrice,
    mortgageBalance,
    cashOut,
    loanTerm
  } = inputs;
  const LTV = getLTV();
  const shotLTVError = LTV > 80;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(InputsWrapper$1, null, /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Home value"
    }),
    value: homePrice,
    color: "secondary",
    labelPosition: "outer",
    $leadingIcon: DollarIcon(),
    decimalScale: 0,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => {
      updateInputs({
        inputTitle: 'homePrice',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      });
    }
  }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Mortgage Balance"
    }),
    value: mortgageBalance,
    labelPosition: "outer",
    $leadingIcon: DollarIcon(),
    decimalScale: 0,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => {
      updateInputs({
        inputTitle: 'mortgageBalance',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      });
    }
  }), /*#__PURE__*/React__default.createElement(WidgetTextInput, {
    customInput: OwnUpTextInput,
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Cash-Out"
    }),
    value: cashOut,
    labelPosition: "outer",
    $leadingIcon: DollarIcon(),
    decimalScale: 0,
    allowNegative: false,
    thousandSeparator: true,
    onChange: e => {
      updateInputs({
        inputTitle: 'cashOut',
        value: Number(e.target.value.replace(/[^0-9.-]/g, ''))
      });
    }
  }), /*#__PURE__*/React__default.createElement(WidgetOptionsInput, {
    label: /*#__PURE__*/React__default.createElement(LabelWithIcon, {
      label: "Loan term"
    }),
    value: loanTerm,
    options: loanTermsOptions,
    onChange: e => updateInputs({
      inputTitle: 'loanTerm',
      value: e.target.value
    })
  })), shotLTVError && /*#__PURE__*/React__default.createElement(OwnUpDefaultErrorNotification, {
    $hasIcon: true,
    title: "Error",
    description: "Sorry, you may not be able to cash out ".concat(displayNumber(cashOut), ". Cash-out refinance requires a maximum combined loan-to-value (CLTV) of %").concat(getLTV(), ". Try changing your cash out amount.")
  }));
};

var _templateObject$2, _templateObject2$1, _templateObject3$1;
const OptionWrapper = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(3);
});
const ButtonsWrapper = styled(OptionWrapper)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 16px;\n  ", " {\n    flex-direction: unset;\n    margin-bottom: 0;\n  }\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.breakpoints.up('md');
});
const AdvancedOptionsButton = styled(OwnUpFillButtonSecondary)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  background-color: ", ";\n"])), MINT_100);
const actionMapping = {
  homePrice: RefinanceDataActionsTypes.SET_HOME_PRICE,
  mortgageBalance: RefinanceDataActionsTypes.SET_MORTGAGE_BALANCE,
  cashOut: RefinanceDataActionsTypes.SET_CASH_OUT,
  loanTerm: RefinanceDataActionsTypes.SET_LOAN_TERM
};
const advancedActionMapping = {
  apr: RefinanceDataActionsTypes.SET_APR,
  propertyTaxAnnual: RefinanceDataActionsTypes.SET_PROPERTY_TAXES_ANNUAL,
  homeownersInsuranceMonthly: RefinanceDataActionsTypes.SET_HOMEOWNERS_INSURANCE_MONTHLY,
  hoaFeesMonthly: RefinanceDataActionsTypes.SET_HOA_FEES_MONTHLY
};
const ActionButtons = _ref3 => {
  let {
    showAdvanced,
    resetToDefaults,
    onToggleAdvanced
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(ButtonsWrapper, null, /*#__PURE__*/React__default.createElement(AdvancedOptionsButton, {
    icon: showAdvanced ? /*#__PURE__*/React__default.createElement(ChevronUpIcon, null) : /*#__PURE__*/React__default.createElement(ChevronDownIcon, null),
    onClick: onToggleAdvanced,
    iconPosition: "right"
  }, "Advanced option"), /*#__PURE__*/React__default.createElement(OwnUpFillButtonSecondary, {
    icon: /*#__PURE__*/React__default.createElement(RefreshIcon, null),
    onClick: resetToDefaults
  }, "Return to defaults"));
};
const RefinanceInputs = () => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const {
    state: {
      homePrice,
      mortgageBalance,
      cashOut,
      loanTerm,
      apr,
      propertyTaxAnnual,
      homeownersInsuranceMonthly,
      hoaFeesMonthly
    },
    getLTV,
    dispatch
  } = useRefinance();
  const updateInputs = useCallback(inputs => {
    if (inputs.inputTitle === 'loanTerm') {
      const actionType = actionMapping[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    } else {
      const actionType = actionMapping[inputs.inputTitle];
      dispatch({
        type: actionType,
        payload: inputs.value
      });
    }
  }, [dispatch]);
  const updateAdvancedInputs = useCallback(inputs => {
    const actionType = advancedActionMapping[inputs.inputTitle];
    dispatch({
      type: actionType,
      payload: inputs.value
    });
  }, [dispatch]);
  const resetToDefaults = useCallback(() => dispatch({
    type: RefinanceDataActionsTypes.SET_DEFAULTS
  }), [dispatch]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BasicInputsComponent, {
    inputs: {
      homePrice,
      mortgageBalance,
      cashOut,
      loanTerm
    },
    updateInputs: updateInputs,
    resetToDefaults: resetToDefaults,
    getLTV: getLTV
  }), showAdvanced && /*#__PURE__*/React__default.createElement(AdvancedInputsComponent, {
    inputs: {
      apr,
      propertyTaxAnnual,
      homeownersInsuranceMonthly,
      hoaFeesMonthly
    },
    updateInputs: updateAdvancedInputs
  }), /*#__PURE__*/React__default.createElement(ActionButtons, {
    showAdvanced: showAdvanced,
    resetToDefaults: resetToDefaults,
    onToggleAdvanced: () => setShowAdvanced(!showAdvanced)
  }));
};

var _templateObject$1;
const InputsWrapper = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  border-radius: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.spacing(1, 1);
});
const Inputs = () => /*#__PURE__*/React__default.createElement(InputsWrapper, null, /*#__PURE__*/React__default.createElement(RefinanceInputs, null));

const RightArrowIcon = () => /*#__PURE__*/React__default.createElement("svg", {
  width: "37",
  height: "24",
  viewBox: "0 0 37 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.5612 0.438852C24.9754 -0.146935 24.0257 -0.146935 23.4399 0.438852C22.8541 1.02464 22.8541 1.97439 23.4399 2.56017L31.3798 10.5H2C1.17157 10.5 0.5 11.1716 0.5 12C0.5 12.8285 1.17157 13.5 2 13.5H31.3798L23.4399 21.4399C22.8541 22.0257 22.8541 22.9755 23.4399 23.5612C24.0257 24.147 24.9754 24.147 25.5612 23.5612L36.0617 13.0607C36.6475 12.4749 36.6475 11.5252 36.0617 10.9394L25.5612 0.438852Z",
  fill: "white"
}));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
const Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  filter: drop-shadow(4px 4px 8px ", ");\n  border-radius: ", ";\n  padding: ", ";\n  margin-top: ", "px;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.palette.background.default;
}, CHARCOAL_5, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.spacing(1, 1, 0, 0);
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.spacing(3, 3);
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.spacing(4);
});
const ResultValues = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: ", "px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: ", "px;\n  ", " {\n    text-align: left;\n    flex-direction: row;\n    gap: ", "px;\n    & > * {\n      flex: 1;\n    }\n  }\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.spacing(5);
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.spacing(3);
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.breakpoints.up('md');
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.spacing(3);
});
const ResultButtonsWrapper = styled(GetStartedLink)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  gap: 4px;\n  margin: 16px 0;\n  .ou-icon {\n    margin: 18px 16px;\n  }\n  svg {\n    width: 36px;\n    height: 24px;\n    path {\n      fill: white;\n    }\n  }\n  ", " {\n    button .MuiTypography-body1 {\n      margin: 8px 16px;\n      margin-left: 16px;\n      font-size: 14px;\n    }\n  }\n"])), _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.breakpoints.down('sm');
});
const ButtonResultValue = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 24px;\n  line-height: 42px;\n"])));
const ResultsHeader = styled(WidgetHeader)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  text-align: center;\n  margin-top: ", "px;\n  font-size: 24px;\n  line-height: 32px;\n"])), _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.spacing(6);
});
const ResultValue = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 24px;\n  line-height: 32px;\n  margin-bottom: 9px;\n"])));
const ResultMainValue = styled(ResultValue)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: bold;\n  color: ", ";\n"])), ALOE_100);
const ResultTitle = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 20px;\n  color: ", ";\n"])), SLATE_100);
const ResultOffers = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column-reverse;\n  ", " {\n    flex-direction: initial;\n    gap: ", "px;\n  }\n"])), _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.breakpoints.up('md');
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.spacing(3);
});
const LTVWrapper = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: ", "px;\n  ", " {\n    justify-content: initial;\n    gap: ", "px;\n  }\n"])), _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.spacing(1);
}, _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.breakpoints.up('md');
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.spacing(3);
});
const LTVValue = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 32px;\n  color: ", ";\n"])), ALOE_100);
const ViewFreeOffersButton = styled(OwnUpFillButtonSecondary)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  min-width: 220px;\n  ", " {\n    margin-top: 0;\n  }\n"])), _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.spacing(3);
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.breakpoints.up('md');
});
const CalculationSummary = _ref18 => {
  let {
    onboarding,
    url
  } = _ref18;
  const {
    getMonthlyPayment,
    getNewLoanBalance,
    getLTV,
    state
  } = useRefinance();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(OwnUpThemeProvider, {
    theme: ownUpWhiteTheme
  }, /*#__PURE__*/React__default.createElement(ResultButtonsWrapper, {
    onboarding: onboarding,
    url: url
  }, /*#__PURE__*/React__default.createElement(OwnUpFillButtonPrimary, null, "View offers with similar payments", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(ButtonResultValue, null, displayNumber(getMonthlyPayment()))), /*#__PURE__*/React__default.createElement(OwnUpFillButtonPrimary, {
    icon: /*#__PURE__*/React__default.createElement(RightArrowIcon, null)
  })), /*#__PURE__*/React__default.createElement(ResultsHeader, {
    variant: "h3"
  }, "New loan details"), /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(ResultValues, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ResultMainValue, null, displayNumber(getMonthlyPayment())), /*#__PURE__*/React__default.createElement(ResultTitle, null, "Monthly Payment")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ResultValue, null, displayNumber(state.homePrice)), /*#__PURE__*/React__default.createElement(ResultTitle, null, "Home value")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ResultValue, null, displayNumber(getNewLoanBalance())), /*#__PURE__*/React__default.createElement(ResultTitle, null, "New loan balance")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ResultValue, null, displayNumber(state.cashOut)), /*#__PURE__*/React__default.createElement(ResultTitle, null, "Cash Out"))), /*#__PURE__*/React__default.createElement(ResultOffers, null, /*#__PURE__*/React__default.createElement(ViewFreeOffersButton, {
    icon: /*#__PURE__*/React__default.createElement(ArrowRightIcon, null),
    iconPosition: "right"
  }, "View Free Offers"), /*#__PURE__*/React__default.createElement(LTVWrapper, null, /*#__PURE__*/React__default.createElement(LTVValue, null, "Loan-to-value is at ", getLTV(), "%\xA0"), /*#__PURE__*/React__default.createElement("div", null, "This may qualify you for cash-out."))))));
};

const RefinanceCalculator = _ref => {
  let {
    onboarding,
    url
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(RefinanceProvider, null, /*#__PURE__*/React__default.createElement(Inputs, null), /*#__PURE__*/React__default.createElement(CalculationSummary, {
    onboarding: onboarding,
    url: url
  })));
};

export { ABComparisonCalculator, AffordabilityCalculator, AltSectionHeader, BoldPrimaryText, BreadCrumbs, Catchphrase, DesktopHeaderButton, DownPaymentCalculator, ErrorText, FAQ, Footer, FooterLandingExternalNavLink, FooterLandingInternalNavLink, FullWidthField, GetStartedFloatButton, GetStartedLink, GuidesSection, Header, Highlight, HighlightAlt, HomePageLink, IconMultiple, ImageWithContent, LandingFooter, LightHeader, LoadingSpinner, MoneyIcon, MonthlyPaymentCalculator, NavBar, ONBOARDING_PROD, ONBOARDING_STAGING, OverlineText, PageTitle, ParagraphText, ParagraphTwoText, PrimaryText, PurchaseIcon, RefinanceCalculator, RentOrBuyCalculator, ResponsiveCatchphrase, ResponsivePrimaryText, ResponsivePrimaryTextStyle, ResponsiveSectionHeader, ScrollingCTAButton, SealIcon, SectionHeader, SectionHeaderStyle, ShopCTA, ShopCTAButton, ShopCTAButtonStyle, SingleValueProp, SlideOutMenuButton, SplitBinaryTreatment, SplitExperienceContext, SplitExperienceProvider, SplitProvider, SplitWrapper, StyledNavLink, Subheading, SubheadingSans, SwooshDivider, Text, TrueButtonWrapper, TrueButtonWrapperStyle, UnderlinedLink, UnderlinedLinkInternal, ValueProps, WWW_PROD, WWW_STAGING, breakpoints, buildMediaQueries, colors, composeLink, dummyTrackingEvent, getPrimaryLinks, getSecondaryLinks, getSocialLinks, getStyledNavLinks, mergeTrackingEvents, normalizeElement, onboardingConverter, useScrollPosition, useSessionStorage, wwwConverter };
//# sourceMappingURL=index.mjs.map
